var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/agent/enums.ts
var Agent = /* @__PURE__ */ ((Agent2) => {
  Agent2["None"] = "None";
  return Agent2;
})(Agent || {});

// src/api/bulk-action-payloads.ts
var ApiFilterKeys = /* @__PURE__ */ ((ApiFilterKeys2) => {
  ApiFilterKeys2["UNI"] = "uni";
  ApiFilterKeys2["STUDENT_NO"] = "studentNo";
  ApiFilterKeys2["GIVEN_NAME"] = "givenName";
  ApiFilterKeys2["SURNAME"] = "surname";
  ApiFilterKeys2["COURSE"] = "course";
  ApiFilterKeys2["FACULTY"] = "faculty";
  ApiFilterKeys2["NATIONALITY"] = "nationality";
  ApiFilterKeys2["BIRTH_COUNTRY"] = "birthCountry";
  ApiFilterKeys2["COUNTRY"] = "country";
  ApiFilterKeys2["APPLICATION_COUNTRY"] = "applicationCountry";
  ApiFilterKeys2["ACTIVITY_STATUS"] = "activityStatus";
  ApiFilterKeys2["NOT_STARTED"] = "notStarted";
  ApiFilterKeys2["IDLE"] = "idle";
  ApiFilterKeys2["COMPLETE"] = "complete";
  ApiFilterKeys2["INCOMPLETE"] = "incomplete";
  ApiFilterKeys2["FUNDS_MATURITY"] = "fundsMaturity";
  ApiFilterKeys2["MARKET"] = "market";
  ApiFilterKeys2["REGION"] = "region";
  ApiFilterKeys2["VISA_STATUS"] = "visaStatus";
  ApiFilterKeys2["CONFIDENCE"] = "confidence";
  ApiFilterKeys2["AGENT"] = "agent";
  ApiFilterKeys2["CONDITIONAL_STATUS"] = "conditionalStatus";
  ApiFilterKeys2["COURSE_CONDITIONAL_STATUS"] = "courseConditionalStatus";
  ApiFilterKeys2["EVIDENCE_REQUIREMENTS"] = "evidenceRequirements";
  ApiFilterKeys2["CUSTOM_REGION"] = "customRegion";
  ApiFilterKeys2["TAG"] = "tag";
  ApiFilterKeys2["PROGRAMMABLE_TAG"] = "programmableTag";
  ApiFilterKeys2["SERVICES"] = "services";
  ApiFilterKeys2["IMMIGRATION_PROVIDERS"] = "immigrationProviders";
  ApiFilterKeys2["INTERVIEW"] = "interview";
  ApiFilterKeys2["RECORDED_INTERVIEW"] = "recordedInterview";
  ApiFilterKeys2["IDLE_FROM"] = "idleFrom";
  ApiFilterKeys2["IDLE_TO"] = "idleTo";
  ApiFilterKeys2["FEE_STATUS"] = "feeStatus";
  ApiFilterKeys2["OFFER_STATUS"] = "offerStatus";
  ApiFilterKeys2["SHARE_CODE"] = "shareCode";
  return ApiFilterKeys2;
})(ApiFilterKeys || {});
var AdditionalStudentApiFilterKeys = /* @__PURE__ */ ((AdditionalStudentApiFilterKeys2) => {
  AdditionalStudentApiFilterKeys2["ABORT_CONTROLLER"] = "abortController";
  AdditionalStudentApiFilterKeys2["ID_TOKEN"] = "idToken";
  AdditionalStudentApiFilterKeys2["STAGE"] = "stage";
  AdditionalStudentApiFilterKeys2["PAGE"] = "page";
  AdditionalStudentApiFilterKeys2["UNI"] = "uni";
  AdditionalStudentApiFilterKeys2["PATHWAY"] = "pathway";
  AdditionalStudentApiFilterKeys2["INTAKE_ID"] = "intakeId";
  AdditionalStudentApiFilterKeys2["PATHWAY_VISIBILITY"] = "pathwayVisibility";
  AdditionalStudentApiFilterKeys2["START_DATE"] = "startDate";
  AdditionalStudentApiFilterKeys2["END_DATE"] = "endDate";
  AdditionalStudentApiFilterKeys2["SORT_COL"] = "sortCol";
  AdditionalStudentApiFilterKeys2["SORT_DIR"] = "sortDir";
  AdditionalStudentApiFilterKeys2["SEARCH"] = "search";
  AdditionalStudentApiFilterKeys2["UNREAD_MESSAGES"] = "unreadMessages";
  return AdditionalStudentApiFilterKeys2;
})(AdditionalStudentApiFilterKeys || {});
var AdditionalApiFilterKeys = /* @__PURE__ */ ((AdditionalApiFilterKeys2) => {
  AdditionalApiFilterKeys2["ABORT_CONTROLLER"] = "abortController";
  AdditionalApiFilterKeys2["ID_TOKEN"] = "idToken";
  AdditionalApiFilterKeys2["UNI"] = "uni";
  AdditionalApiFilterKeys2["PATHWAY"] = "pathway";
  AdditionalApiFilterKeys2["INTAKE_ID"] = "intakeId";
  AdditionalApiFilterKeys2["PATHWAY_VISIBILITY"] = "pathwayVisibility";
  AdditionalApiFilterKeys2["START_DATE"] = "startDate";
  AdditionalApiFilterKeys2["END_DATE"] = "endDate";
  AdditionalApiFilterKeys2["SEARCH"] = "search";
  return AdditionalApiFilterKeys2;
})(AdditionalApiFilterKeys || {});

// src/api/index.ts
var UpdateVisaSupportAction = /* @__PURE__ */ ((UpdateVisaSupportAction2) => {
  UpdateVisaSupportAction2["ASSIGN"] = "ASSIGN";
  UpdateVisaSupportAction2["UNASSIGN"] = "UNASSIGN";
  return UpdateVisaSupportAction2;
})(UpdateVisaSupportAction || {});

// src/apply/schemas/utils.ts
import { z } from "zod";
var MAX_PERCENTAGE = 100;
var MIN_PERCENTAGE = 0;
var percentageArraySchema = z.array(z.number().min(MIN_PERCENTAGE).max(MAX_PERCENTAGE)).refine(
  (arr) => {
    const sum = arr.reduce((acc, val) => acc + val, MIN_PERCENTAGE);
    return sum !== MAX_PERCENTAGE;
  },
  {
    message: "The values in the array must sum to 100%."
  }
);
var noDuplicateArraySchema = z.array(z.string()).refine(
  (arr) => {
    let duplicates = false;
    for (const [index, value] of arr.entries()) {
      if (arr.findIndex((v) => v === value) !== index) {
        duplicates = true;
        break;
      }
    }
    return duplicates;
  },
  {
    message: "The values in the HECoS list must not be duplicated."
  }
);
var noUndefinedStringArraySchema = z.array(z.string()).refine(
  (arr) => {
    let undefPresent = false;
    for (const value of arr) {
      if (value === "undefined" || value === void 0) {
        undefPresent = true;
        break;
      }
    }
    return undefPresent;
  },
  {
    message: "The values in the HECoS must not be undefined."
  }
);
var intakeIdValidator = z.string().min(1, { message: "Required" }).regex(/^\d{4}-\d{2}$/, { message: "Invalid intake ID" });

// src/apply/enums.ts
var ApplicantStatus = /* @__PURE__ */ ((ApplicantStatus2) => {
  ApplicantStatus2["New"] = "NEW";
  return ApplicantStatus2;
})(ApplicantStatus || {});
var FingerStatus = /* @__PURE__ */ ((FingerStatus2) => {
  FingerStatus2["Todo"] = "Todo";
  FingerStatus2["InProgress"] = "InProgress";
  FingerStatus2["Complete"] = "Complete";
  FingerStatus2["InError"] = "InError";
  FingerStatus2["Rejected"] = "Rejected";
  FingerStatus2["Waiting"] = "Waiting";
  FingerStatus2["Locked"] = "Locked";
  FingerStatus2["None"] = "None";
  return FingerStatus2;
})(FingerStatus || {});
var StudyLevel = /* @__PURE__ */ ((StudyLevel3) => {
  StudyLevel3["Foundation"] = "Foundation";
  StudyLevel3["Undergraduate"] = "Undergraduate";
  StudyLevel3["Postgraduate"] = "Postgraduate";
  StudyLevel3["Research"] = "Research";
  return StudyLevel3;
})(StudyLevel || {});
var StudyMode = /* @__PURE__ */ ((StudyMode3) => {
  StudyMode3["FullTime"] = "Full-time";
  StudyMode3["PartTime"] = "Part-time";
  StudyMode3["MixedMode"] = "Mixed-mode";
  StudyMode3["Sandwich"] = "Sandwich";
  StudyMode3["DistanceLearning"] = "Distance-learning";
  return StudyMode3;
})(StudyMode || {});
var PreviousStudyLevel = /* @__PURE__ */ ((PreviousStudyLevel2) => {
  PreviousStudyLevel2["HighSchool"] = "HighSchool";
  PreviousStudyLevel2["Undergraduate"] = "Undergraduate";
  PreviousStudyLevel2["Postgraduate"] = "Postgraduate";
  return PreviousStudyLevel2;
})(PreviousStudyLevel || {});
var GradeLevel = /* @__PURE__ */ ((GradeLevel2) => {
  GradeLevel2["HighSchool"] = "High School";
  GradeLevel2["GcseEnglish"] = "GCSE";
  GradeLevel2["AsLevel"] = "AS Level";
  GradeLevel2["ALevel"] = "A Level";
  GradeLevel2["InternationalBaccalaureateDiploma"] = "International Baccalaureate Diploma";
  GradeLevel2["UniversityFoundation"] = "University Foundation";
  GradeLevel2["CertificateOfHigherEducation"] = "Certificate of Higher Education";
  GradeLevel2["DiplomaOfHigherEducation"] = "Diploma of Higher Education (DipHE)";
  GradeLevel2["HigherNationalDiploma"] = "Higher National Diploma (HND)";
  GradeLevel2["BachelorDegree"] = "Bachelor Degree";
  GradeLevel2["MastersDegree"] = "Masters Degree";
  GradeLevel2["GraduateCertificateOrDiploma"] = "Graduate Certificate or Diploma";
  GradeLevel2["PostGraduateCertificateOrDiploma"] = "Post Graduate Certificate or Diploma";
  GradeLevel2["ResearchDegree"] = "Research degree";
  GradeLevel2["Other"] = "Other";
  return GradeLevel2;
})(GradeLevel || {});
var GradeSystem = /* @__PURE__ */ ((GradeSystem2) => {
  GradeSystem2["DegreeClassification"] = "Degree classification";
  GradeSystem2["Gpa4"] = "GPA 4";
  GradeSystem2["Gpa5"] = "GPA 5";
  GradeSystem2["Gpa10"] = "GPA 10";
  GradeSystem2["LetterGrade"] = "Letter grade";
  GradeSystem2["PassFail"] = "Pass/Fail";
  GradeSystem2["Percentage"] = "Percentage";
  GradeSystem2["Other"] = "Other";
  return GradeSystem2;
})(GradeSystem || {});
var FeeStatus = /* @__PURE__ */ ((FeeStatus3) => {
  FeeStatus3["Home"] = "HOME";
  FeeStatus3["Overseas"] = "OVERSEAS";
  FeeStatus3["NotSure"] = "NOT_SURE";
  return FeeStatus3;
})(FeeStatus || {});
var ResultStatus = /* @__PURE__ */ ((ResultStatus2) => {
  ResultStatus2["FinalResults"] = "FinalResults";
  ResultStatus2["InterimResults"] = "InterimResults";
  ResultStatus2["NoResults"] = "NoResults";
  return ResultStatus2;
})(ResultStatus || {});
var Ethnicity = /* @__PURE__ */ ((Ethnicity2) => {
  Ethnicity2["Arab"] = "Arab";
  Ethnicity2["AsianBangladeshi"] = "Asian - Bangladeshi";
  Ethnicity2["AsianChinese"] = "Asian - Chinese";
  Ethnicity2["AsianIndian"] = "Asian - Indian";
  Ethnicity2["AsianPakistani"] = "Asian - Pakistani";
  Ethnicity2["AsianOther"] = "Asian - Other background";
  Ethnicity2["BlackAfrican"] = "Black - African";
  Ethnicity2["BlackCaribbean"] = "Black - Caribbean";
  Ethnicity2["BlackOther"] = "Black - Other background";
  Ethnicity2["GypsyTraveller"] = "Gypsy, Traveller or Irish Traveller";
  Ethnicity2["MixedWhiteAsian"] = "Mixed - White & Asian";
  Ethnicity2["MixedWhiteBlackAfrican"] = "Mixed - White & Black African";
  Ethnicity2["MixedWhiteBlackCaribbean"] = "Mixed - White & Black Caribbean";
  Ethnicity2["MixedOther"] = "Mixed - Other background";
  Ethnicity2["White"] = "White";
  Ethnicity2["WhiteIrish"] = "White - Irish";
  Ethnicity2["WhiteRoma"] = "White - Roma";
  Ethnicity2["WhiteOther"] = "White - Other background";
  Ethnicity2["Other"] = "Other ethnic background";
  Ethnicity2["PreferNotToSay"] = "I prefer not to say";
  return Ethnicity2;
})(Ethnicity || {});
var DisabilityTypeDescription = /* @__PURE__ */ ((DisabilityTypeDescription2) => {
  DisabilityTypeDescription2["VisualImpairment"] = "e.g. blindness or partial sight";
  DisabilityTypeDescription2["HearingImpairment"] = "e.g. deafness or partial hearing";
  DisabilityTypeDescription2["MentalHealthCondition"] = "e.g., anxiety or depression";
  DisabilityTypeDescription2["LearningDifficulty"] = "e.g., dyslexia, dyspraxia, or ADHD/ADD";
  DisabilityTypeDescription2["PhysicalImpairment"] = "e.g., climbing stairs or uneven surfaces, using a keyboard or laboratory equipment";
  DisabilityTypeDescription2["SocialBehaviouralImpairment"] = "e.g., an autistic spectrum condition, Tourette's Syndrome, or speech and language difficulties, including stammering";
  DisabilityTypeDescription2["MultiDomainCondition"] = "e.g. downs syndrome, shaken baby syndrome, childhood encephalitis, cerebral palsy, muscular dystrophy, spastic limb, neurodiversity, childhood related legacy impacts and conditions, elective mutism, abuse or trauma linked speech delays, stutters or stammers, specific medical conditions or region specific brain injuries";
  return DisabilityTypeDescription2;
})(DisabilityTypeDescription || {});
var DisabilityType = /* @__PURE__ */ ((DisabilityType2) => {
  DisabilityType2["VisualImpairment"] = "A visual impairment uncorrected by glasses";
  DisabilityType2["HearingImpairment"] = "A hearing impairment";
  DisabilityType2["MentalHealthCondition"] = "A mental health condition, challenge, or disorder";
  DisabilityType2["LearningDifficulty"] = "A learning difficulty";
  DisabilityType2["PhysicalImpairment"] = "A physical impairment, including challenges with mobility or dexterity";
  DisabilityType2["LongTermIllness"] = "A long-term illness or health condition that may cause pain, fatigue, loss of concentration, or breathing difficulties \u2013 including any effects from related medication";
  DisabilityType2["SocialBehaviouralImpairment"] = "A social, behavioural, or communication impairment";
  DisabilityType2["MultiDomainCondition"] = "A development condition since childhood which affects motor, cognitive, social and emotional skills, speech, and language";
  DisabilityType2["NotListed"] = "A condition or impairment not listed";
  return DisabilityType2;
})(DisabilityType || {});
var SchoolType = /* @__PURE__ */ ((SchoolType2) => {
  SchoolType2["UkState"] = "UK State School";
  SchoolType2["UkIndependent"] = "UK Independent (i.e. Private) School";
  SchoolType2["UkFurtherEducation"] = "UK Further Education College";
  SchoolType2["UkHigherEducation"] = "UK Higher Education College";
  SchoolType2["NonUkSchool"] = "Non-UK School, College or University";
  SchoolType2["OtherUkProvider"] = "Other UK training provider";
  return SchoolType2;
})(SchoolType || {});
var HelpingSubmit = /* @__PURE__ */ ((HelpingSubmit2) => {
  HelpingSubmit2["Agent"] = "Agent";
  HelpingSubmit2["ThirdParty"] = "ThirdParty";
  HelpingSubmit2["Option3"] = "Option3";
  return HelpingSubmit2;
})(HelpingSubmit || {});
var ThirdParty = /* @__PURE__ */ ((ThirdParty2) => {
  ThirdParty2["Option1"] = "Option1";
  ThirdParty2["Option2"] = "Option2";
  ThirdParty2["Option3"] = "Option3";
  return ThirdParty2;
})(ThirdParty || {});
var FirstApplicationStatus = /* @__PURE__ */ ((FirstApplicationStatus2) => {
  FirstApplicationStatus2["FirstTime"] = "FirstTime";
  FirstApplicationStatus2["AppliedOnly"] = "AppliedOnly";
  FirstApplicationStatus2["StudiedBefore"] = "StudiedBefore";
  return FirstApplicationStatus2;
})(FirstApplicationStatus || {});
var ReferralSource = /* @__PURE__ */ ((ReferralSource2) => {
  ReferralSource2["Agent"] = "AGENT";
  ReferralSource2["CampusVisit"] = "CAMPUS_VISIT";
  ReferralSource2["EducationFair"] = "EDUCATION_FAIR";
  ReferralSource2["FamilyMember"] = "FAMILY_MEMBER";
  ReferralSource2["Friend"] = "FRIEND";
  ReferralSource2["OnlineSearch"] = "ONLINE_SEARCH";
  ReferralSource2["SchoolCounselor"] = "SCHOOL_COUNSELOR";
  ReferralSource2["SocialMedia"] = "SOCIAL_MEDIA";
  ReferralSource2["Teacher"] = "TEACHER";
  ReferralSource2["Ucas"] = "UCAS";
  ReferralSource2["UniversityStudent"] = "UNIVERSITY_STUDENT";
  ReferralSource2["UniversityWebsite"] = "UNIVERSITY_WEBSITE";
  ReferralSource2["Other"] = "OTHER";
  ReferralSource2["PreferNotToSay"] = "PREFER_NOT_TO_SAY";
  return ReferralSource2;
})(ReferralSource || {});
var IDType = /* @__PURE__ */ ((IDType2) => {
  IDType2["Passport"] = "Passport";
  IDType2["Id"] = "ID";
  IDType2["None"] = "None";
  return IDType2;
})(IDType || {});
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["Male"] = "Male";
  Gender2["Female"] = "Female";
  Gender2["NotListed"] = "Not Listed";
  return Gender2;
})(Gender || {});
var GenderIdentity = /* @__PURE__ */ ((GenderIdentity2) => {
  GenderIdentity2["Man"] = "Man";
  GenderIdentity2["Women"] = "Women";
  GenderIdentity2["AnotherTerm"] = "I use another term";
  GenderIdentity2["PreferNotToSay"] = "I prefer not to say";
  return GenderIdentity2;
})(GenderIdentity || {});
var EnglishTestType = /* @__PURE__ */ ((EnglishTestType2) => {
  EnglishTestType2["IeltsForUkvi"] = "IELTS for UKVI";
  EnglishTestType2["IeltsAcademic"] = "IELTS Academic";
  EnglishTestType2["Ielts"] = "IELTS General";
  EnglishTestType2["EsolSelt"] = "LanguageCert International ESOL SELT";
  EnglishTestType2["Ise"] = "Trinity College London Integrated Skills in English (ISE)";
  EnglishTestType2["PteUkvi"] = "PTE Academic UKVI";
  EnglishTestType2["Pte"] = "PTE Academic";
  EnglishTestType2["Psi"] = "PSI Services Skills for English UKVI";
  EnglishTestType2["Cambridge"] = "Cambridge Assessment English test";
  EnglishTestType2["Toefl"] = "TOEFL";
  EnglishTestType2["Uni"] = "University's English test";
  EnglishTestType2["Ellt"] = "OI Digital Institute English Language Level Test (ELLT)";
  EnglishTestType2["Other"] = "Other";
  return EnglishTestType2;
})(EnglishTestType || {});
var EnglishTestNotReqdReason = /* @__PURE__ */ ((EnglishTestNotReqdReason2) => {
  EnglishTestNotReqdReason2["MajEngCountry"] = "I am a national of a majority English-speaking country";
  EnglishTestNotReqdReason2["PlanTest"] = "I plan to take an English language test to meet the requirements";
  EnglishTestNotReqdReason2["PrevQual"] = "My English can be assessed based on my previous academic qualification";
  EnglishTestNotReqdReason2["PrevVisa"] = "I have met the English language requirement in my previous visa application";
  EnglishTestNotReqdReason2["UsStudyProgram"] = "I'm coming as a part of US study abroad programme";
  EnglishTestNotReqdReason2["Other"] = "Other/I don\u2019t know";
  return EnglishTestNotReqdReason2;
})(EnglishTestNotReqdReason || {});
var EmploymentType = /* @__PURE__ */ ((EmploymentType2) => {
  EmploymentType2["FullTime"] = "Full Time";
  EmploymentType2["PartTime"] = "Part Time";
  EmploymentType2["Casual"] = "Casual";
  EmploymentType2["Freelance"] = "Freelance";
  EmploymentType2["Contract"] = "Contract";
  EmploymentType2["Temporary"] = "Temporary";
  EmploymentType2["Volunteer"] = "Volunteer";
  EmploymentType2["Apprenticeship"] = "Apprenticeship";
  EmploymentType2["WorkExperience"] = "Work Experience";
  EmploymentType2["Other"] = "Other";
  return EmploymentType2;
})(EmploymentType || {});
var UkAccommodationType = /* @__PURE__ */ ((UkAccommodationType2) => {
  UkAccommodationType2["UniversityAccommodation"] = "University accommodation";
  UkAccommodationType2["PrivateStudentAccommodation"] = "Private student accommodation";
  UkAccommodationType2["PrivateRental"] = "Private rental";
  UkAccommodationType2["StayingWithFamily"] = "Staying with family";
  UkAccommodationType2["Homestay"] = "Homestay";
  UkAccommodationType2["Other"] = "Other";
  return UkAccommodationType2;
})(UkAccommodationType || {});
var VisaType = /* @__PURE__ */ ((VisaType2) => {
  VisaType2["ShortTermStudyStudentVisa"] = "Short-term study / student visa";
  VisaType2["StudentVisa"] = "Student visa (Tier 4 General/Student Route)";
  VisaType2["ChildStudentVisa"] = "Child Student visa (Tier 4 Child/Child Student Route)";
  VisaType2["Other"] = "Other (my visa is not listed here)";
  return VisaType2;
})(VisaType || {});
var VisaLevelOfStudy = /* @__PURE__ */ ((VisaLevelOfStudy2) => {
  VisaLevelOfStudy2["HighSchool"] = "High School";
  VisaLevelOfStudy2["Foundation"] = "Foundation";
  VisaLevelOfStudy2["Bachelor"] = "Bachelor (UG)";
  VisaLevelOfStudy2["Masters"] = "Masters (PG)";
  VisaLevelOfStudy2["Research"] = "Research (PhD etc.)";
  VisaLevelOfStudy2["ShortCourse"] = "Short Course";
  VisaLevelOfStudy2["EnglishLanguageCourse"] = "English Language Course";
  return VisaLevelOfStudy2;
})(VisaLevelOfStudy || {});
var CourseCompare = /* @__PURE__ */ ((CourseCompare2) => {
  CourseCompare2["HigherLevelCourse"] = "The course I am applying for now is at a higher level";
  CourseCompare2["SameLevelCourse"] = "The course I am applying for now is at the same level";
  CourseCompare2["LowerLevelCourse"] = "The course I am applying for now is at a lower level";
  CourseCompare2["NoUkAcademicStudy"] = "I have not studied any academic courses in the UK";
  return CourseCompare2;
})(CourseCompare || {});
var VisaOrPermitType = /* @__PURE__ */ ((VisaOrPermitType2) => {
  VisaOrPermitType2["PreSettledStatus"] = "Pre-settled status under the EU Settlement Scheme";
  VisaOrPermitType2["SettledStatus"] = "Settled status under the EU Settlement Scheme";
  VisaOrPermitType2["IndefiniteLeaveToRemain"] = "Indefinite leave to remain";
  VisaOrPermitType2["LeaveToRemain"] = "Leave to remain";
  VisaOrPermitType2["UkraineSchemeVisa"] = "Ukraine scheme visa";
  VisaOrPermitType2["PartnerChildBritishIlr"] = "Partner or child visa of someone with British citizenship or ILR";
  VisaOrPermitType2["PartnerChildWorkStudy"] = "Partner or child visa of someone with a work or study visa";
  VisaOrPermitType2["EuFamilyDependant"] = "EU or EEA family member/dependant";
  VisaOrPermitType2["DependantVisa"] = "Dependant visa";
  VisaOrPermitType2["WorkVisa"] = "Work visa";
  VisaOrPermitType2["PendingEussApplication"] = "Pending application for EUSS with certificate of application";
  VisaOrPermitType2["AsylumSeeker"] = "Asylum seeker";
  VisaOrPermitType2["Refugee"] = "Refugee";
  VisaOrPermitType2["HumanitarianProtection"] = "Humanitarian Protection";
  VisaOrPermitType2["ChildOfTurkishWorker"] = "Child of a Turkish Worker";
  VisaOrPermitType2["TouristVisitorVisa"] = "Tourist / visitor visa";
  VisaOrPermitType2["VisaNotListed"] = "My visa or permit are not listed";
  return VisaOrPermitType2;
})(VisaOrPermitType || {});
var VisaOrPermitStatus = /* @__PURE__ */ ((VisaOrPermitStatus2) => {
  VisaOrPermitStatus2["VisaNotListed"] = "VISA_NOT_LISTED";
  return VisaOrPermitStatus2;
})(VisaOrPermitStatus || {});
var RefusedVisaType = /* @__PURE__ */ ((RefusedVisaType2) => {
  RefusedVisaType2["TouristVisitorVisa"] = "Tourist / visitor visa";
  RefusedVisaType2["InnovatorVisa"] = "Innovator visa";
  RefusedVisaType2["StartupVisa"] = "Start-up visa";
  RefusedVisaType2["InvestorEntrepreneurVisa"] = "Investor / entrepreneur visa (Tier 1)";
  RefusedVisaType2["ExceptionalTalentVisa"] = "Exceptional talent visa (Tier 1)";
  RefusedVisaType2["GraduateEntrepreneurVisa"] = "Graduate Entrepreneur visa (Tier 1)";
  RefusedVisaType2["LongTermWorkVisa"] = "Long-term work visa (Tier 2)";
  RefusedVisaType2["ShortTermWorkVisa"] = "Short-term work visa (Tier 5)";
  RefusedVisaType2["IntraCompanyTransferVisa"] = "Intra-company Transfer visa (Tier 2)";
  RefusedVisaType2["MinisterOfReligionVisa"] = "Minister of Religion visa (Tier 2)";
  RefusedVisaType2["SportspersonVisa"] = "Sportsperson visa (Tier 2)";
  RefusedVisaType2["LowSkilledWorkerVisa"] = "Low Skilled Worker (Tier 3)";
  RefusedVisaType2["StandardVisitorVisa"] = "Standard Visitor visa";
  RefusedVisaType2["MarriageVisitorVisa"] = "Marriage Visitor visa";
  RefusedVisaType2["PaidEngagementVisa"] = "Permitted Paid Engagement visa";
  RefusedVisaType2["ParentTier4ChildVisa"] = "Parent of a Tier 4 child visa";
  RefusedVisaType2["ChineseTourGroupVisa"] = "Visit the UK in a Chinese tour group";
  RefusedVisaType2["TransitVisa"] = "Visa to pass through the UK in transit";
  RefusedVisaType2["ShortTermStudyVisa"] = "Short-term study / student visa";
  RefusedVisaType2["StudentVisa"] = "Student visa (Tier 4 General/Student Route)";
  RefusedVisaType2["ChildStudentVisa"] = "Child Student visa (Tier 4 Child/Child Student Route)";
  RefusedVisaType2["TempWorkCharityVisa"] = "Temporary Worker - Charity Worker visa (Tier 5)";
  RefusedVisaType2["TempWorkCreativeSportingVisa"] = "Temporary Worker - Creative and Sporting visa (Tier 5)";
  RefusedVisaType2["TempWorkAuthorisedExchangeVisa"] = "Temporary Worker - Government Authorised Exchange visa (Tier 5)";
  RefusedVisaType2["TempWorkIntlAgreementVisa"] = "Temporary Worker - International Agreement visa (Tier 5)";
  RefusedVisaType2["TempWorkReligiousWorkerVisa"] = "Temporary Worker - Religious Worker visa (Tier 5)";
  RefusedVisaType2["TempWorkSeasonalWorkerVisa"] = "Temporary Worker - Seasonal Worker Visa (Tier 5)";
  RefusedVisaType2["YouthMobilitySchemeVisa"] = "Youth mobility scheme visa (Tier 5)";
  RefusedVisaType2["FamilyVisa"] = "Family visas: apply, extend or switch";
  RefusedVisaType2["EuEeaFamilyPermit"] = "Apply for a permit to join your EU or EEA family member in the UK";
  RefusedVisaType2["DependantVisa"] = "Dependant Visa";
  RefusedVisaType2["OtherVisaNotListed"] = "Other (My visa is not listed here)";
  return RefusedVisaType2;
})(RefusedVisaType || {});
var ApplyDocTypes = /* @__PURE__ */ ((ApplyDocTypes2) => {
  ApplyDocTypes2["Lead"] = "LEAD";
  ApplyDocTypes2["Applicant"] = "APPLICANT_DETAILS";
  ApplyDocTypes2["StudyHistory"] = "APPLICANT_STUDY_HISTORY";
  ApplyDocTypes2["Application"] = "APPLICATION";
  ApplyDocTypes2["ApplicationSummary"] = "APPLICATION_SUMMARY";
  ApplyDocTypes2["Document"] = "APPLICANT_DOCUMENT";
  ApplyDocTypes2["Offer"] = "APPLICANT_OFFER";
  ApplyDocTypes2["OfferRequirement"] = "APPLICANT_OFFER_REQUIREMENT";
  ApplyDocTypes2["OfferSummary"] = "APPLICANT_OFFER_SUMMARY";
  ApplyDocTypes2["OfferPayment"] = "APPLICANT_OFFER_PAYMENT";
  ApplyDocTypes2["Course"] = "APPLY_COURSE";
  ApplyDocTypes2["UniRequirement"] = "APPLY_UNI_REQUIREMENT";
  ApplyDocTypes2["ApplicationTaskConfig"] = "APPLY_APPLICATION_TASK_CONFIG";
  ApplyDocTypes2["EllucianReferenceData"] = "ELLUCIAN_REFERENCE_DATA";
  ApplyDocTypes2["CourseTaskRulesConfig"] = "APPLY_COURSE_TASK_RULES_CONFIG";
  return ApplyDocTypes2;
})(ApplyDocTypes || {});
var ApplicationStatus = /* @__PURE__ */ ((ApplicationStatus3) => {
  ApplicationStatus3["InProgress"] = "InProgress";
  ApplicationStatus3["Completed"] = "Completed";
  ApplicationStatus3["Submitted"] = "Submitted";
  ApplicationStatus3["AwaitingDecision"] = "AwaitingDecision";
  ApplicationStatus3["Offered"] = "Offered";
  ApplicationStatus3["Accepted"] = "Accepted";
  ApplicationStatus3["Rejected"] = "Rejected";
  ApplicationStatus3["Withdrawn"] = "Withdrawn";
  ApplicationStatus3["Cancelled"] = "Cancelled";
  return ApplicationStatus3;
})(ApplicationStatus || {});
var ApplicationRefereeRelation = /* @__PURE__ */ ((ApplicationRefereeRelation2) => {
  ApplicationRefereeRelation2["Manager"] = "Manager";
  ApplicationRefereeRelation2["Colleague"] = "Colleague";
  ApplicationRefereeRelation2["Teacher"] = "Teacher";
  ApplicationRefereeRelation2["CareersAdvisor"] = "Careers advisor";
  ApplicationRefereeRelation2["Other"] = "Other";
  return ApplicationRefereeRelation2;
})(ApplicationRefereeRelation || {});
var FundingOption = /* @__PURE__ */ ((FundingOption2) => {
  FundingOption2["PrivateFinance"] = "PrivateFinance";
  FundingOption2["StudentFinance"] = "StudentFinance";
  FundingOption2["HealthAuthority"] = "HealthAuthority";
  FundingOption2["ResearchCouncils"] = "ResearchCouncils";
  FundingOption2["TrainingAgency"] = "TrainingAgency";
  FundingOption2["UkIndustry"] = "UkIndustry";
  FundingOption2["UkGovtInternational"] = "UkGovtInternational";
  FundingOption2["UkGovtOther"] = "UkGovtOther";
  FundingOption2["UniversityScholarship"] = "UniversityScholarship";
  FundingOption2["OverseasAgency"] = "OverseasAgency";
  FundingOption2["OverseasGovt"] = "OverseasGovt";
  FundingOption2["OverseasIndustry"] = "OverseasIndustry";
  FundingOption2["OverseasUniversity"] = "OverseasUniversity";
  FundingOption2["Other"] = "Other";
  FundingOption2["Unknown"] = "Unknown";
  return FundingOption2;
})(FundingOption || {});
var RepresentationHelpedBy = /* @__PURE__ */ ((RepresentationHelpedBy2) => {
  RepresentationHelpedBy2["Agent"] = "AGENT";
  RepresentationHelpedBy2["FamilyMember"] = "FAMILY_MEMBER";
  RepresentationHelpedBy2["Friend"] = "FRIEND";
  RepresentationHelpedBy2["SchoolCounselor"] = "SCHOOL_COUNSELOR";
  RepresentationHelpedBy2["Teacher"] = "TEACHER";
  RepresentationHelpedBy2["UniversityStudent"] = "UNIVERSITY_STUDENT";
  RepresentationHelpedBy2["Other"] = "OTHER";
  return RepresentationHelpedBy2;
})(RepresentationHelpedBy || {});
var StatusColor = /* @__PURE__ */ ((StatusColor2) => {
  StatusColor2["Todo"] = "orange";
  StatusColor2["Done"] = "green";
  StatusColor2["Locked"] = "gray";
  return StatusColor2;
})(StatusColor || {});
var ConfirmationOptions = /* @__PURE__ */ ((ConfirmationOptions2) => {
  ConfirmationOptions2["Yes"] = "Yes";
  ConfirmationOptions2["No"] = "No";
  return ConfirmationOptions2;
})(ConfirmationOptions || {});
var ResidentialCategoryOptions = /* @__PURE__ */ ((ResidentialCategoryOptions2) => {
  ResidentialCategoryOptions2["UkCitizenEngland"] = "UK Citizen - England";
  ResidentialCategoryOptions2["UkCitizenScotland"] = "UK Citizen - Scotland";
  ResidentialCategoryOptions2["UkCitizenWales"] = "UK Citizen - Wales";
  ResidentialCategoryOptions2["UkCitizenNorthernIreland"] = "UK Citizen - Northern Ireland";
  ResidentialCategoryOptions2["BritishCitizenChannelIslandsAndIsleOfMan"] = "British Citizen - Channel Islands and Isle of Man";
  ResidentialCategoryOptions2["BritishCitizenBritishOverseasTerritories"] = "British Citizen - British Overseas Territories";
  ResidentialCategoryOptions2["EuNationalNonUkCitizen"] = "EU National (non-UK Citizen)";
  ResidentialCategoryOptions2["EeaOrSwissNational"] = "EEA or Swiss National";
  ResidentialCategoryOptions2["ChildOfATurkishWorker"] = "Child of a Turkish Worker";
  ResidentialCategoryOptions2["Refugee"] = "Refugee";
  ResidentialCategoryOptions2["HumanitarianProtectionOrSimilar"] = "Humanitarian Protection or similar";
  ResidentialCategoryOptions2["SettledInTheUk"] = "Settled in the UK";
  ResidentialCategoryOptions2["Other"] = "Other";
  return ResidentialCategoryOptions2;
})(ResidentialCategoryOptions || {});
var UkAreaOptions = /* @__PURE__ */ ((UkAreaOptions2) => {
  UkAreaOptions2["Aberdeen"] = "Aberdeen";
  UkAreaOptions2["Aberdeenshire"] = "Aberdeenshire";
  UkAreaOptions2["Alderney"] = "Alderney";
  UkAreaOptions2["Angus"] = "Angus";
  UkAreaOptions2["ArgyllAndBute"] = "Argyll & Bute";
  UkAreaOptions2["BarkingAndDagenham"] = "Barking and Dagenham";
  UkAreaOptions2["Barnet"] = "Barnet";
  UkAreaOptions2["Barnsley"] = "Barnsley";
  UkAreaOptions2["BathAndNorthEastSomerset"] = "Bath and North East Somerset";
  UkAreaOptions2["Bedfordshire"] = "Bedfordshire";
  UkAreaOptions2["Belfast"] = "Belfast";
  UkAreaOptions2["Bexley"] = "Bexley";
  UkAreaOptions2["Birmingham"] = "Birmingham";
  UkAreaOptions2["BlackburnWithDarwen"] = "Blackburn with Darwen";
  UkAreaOptions2["Blackpool"] = "Blackpool";
  UkAreaOptions2["BlaenauGwent"] = "Blaenau Gwent";
  UkAreaOptions2["Bolton"] = "Bolton";
  UkAreaOptions2["Bournemouth"] = "Bournemouth";
  UkAreaOptions2["BracknellForest"] = "Bracknell Forest";
  UkAreaOptions2["Bradford"] = "Bradford";
  UkAreaOptions2["Brent"] = "Brent";
  UkAreaOptions2["Bridgend"] = "Bridgend";
  UkAreaOptions2["BrightonAndHove"] = "Brighton and Hove";
  UkAreaOptions2["Bristol"] = "Bristol";
  UkAreaOptions2["Bromley"] = "Bromley";
  UkAreaOptions2["Buckinghamshire"] = "Buckinghamshire";
  UkAreaOptions2["Bury"] = "Bury";
  UkAreaOptions2["Caerphilly"] = "Caerphilly";
  UkAreaOptions2["Calderdale"] = "Calderdale";
  UkAreaOptions2["Cambridgeshire"] = "Cambridgeshire";
  UkAreaOptions2["Camden"] = "Camden";
  UkAreaOptions2["Cardiff"] = "Cardiff";
  UkAreaOptions2["Carmarthenshire"] = "Carmarthenshire";
  UkAreaOptions2["Ceredigion"] = "Ceredigion";
  UkAreaOptions2["Cheshire"] = "Cheshire";
  UkAreaOptions2["CityOfLondon"] = "City of London";
  UkAreaOptions2["Clackmannanshire"] = "Clackmannanshire";
  UkAreaOptions2["Conwy"] = "Conwy";
  UkAreaOptions2["Cornwall"] = "Cornwall";
  UkAreaOptions2["CountyAntrim"] = "County Antrim";
  UkAreaOptions2["CountyArmagh"] = "County Armagh";
  UkAreaOptions2["CountyDerryLondonderry"] = "County Derry/Londonderry";
  UkAreaOptions2["CountyDown"] = "County Down";
  UkAreaOptions2["CountyFermanagh"] = "County Fermanagh";
  UkAreaOptions2["CountyTyrone"] = "County Tyrone";
  UkAreaOptions2["Coventry"] = "Coventry";
  UkAreaOptions2["Croydon"] = "Croydon";
  UkAreaOptions2["Cumbria"] = "Cumbria";
  UkAreaOptions2["Darlington"] = "Darlington";
  UkAreaOptions2["Denbighshire"] = "Denbighshire";
  UkAreaOptions2["Derby"] = "Derby";
  UkAreaOptions2["Derbyshire"] = "Derbyshire";
  UkAreaOptions2["Devon"] = "Devon";
  UkAreaOptions2["Doncaster"] = "Doncaster";
  UkAreaOptions2["Dorset"] = "Dorset";
  UkAreaOptions2["Dudley"] = "Dudley";
  UkAreaOptions2["DumfriesAndGalloway"] = "Dumfries & Galloway";
  UkAreaOptions2["Dundee"] = "Dundee";
  UkAreaOptions2["Durham"] = "Durham";
  UkAreaOptions2["Ealing"] = "Ealing";
  UkAreaOptions2["EastAyrshire"] = "East Ayrshire";
  UkAreaOptions2["EastDunbartonshire"] = "East Dunbartonshire";
  UkAreaOptions2["EastLothian"] = "East Lothian";
  UkAreaOptions2["EastRenfrewshire"] = "East Renfrewshire";
  UkAreaOptions2["EastRidingOfYorkshire"] = "East Riding of Yorkshire";
  UkAreaOptions2["EastSussex"] = "East Sussex";
  UkAreaOptions2["Edinburgh"] = "Edinburgh";
  UkAreaOptions2["Enfield"] = "Enfield";
  UkAreaOptions2["Essex"] = "Essex";
  UkAreaOptions2["Falkirk"] = "Falkirk";
  UkAreaOptions2["Fife"] = "Fife";
  UkAreaOptions2["Flintshire"] = "Flintshire";
  UkAreaOptions2["Gateshead"] = "Gateshead";
  UkAreaOptions2["Glasgow"] = "Glasgow";
  UkAreaOptions2["Gloucestershire"] = "Gloucestershire";
  UkAreaOptions2["Greenwich"] = "Greenwich";
  UkAreaOptions2["Guernsey"] = "Guernsey";
  UkAreaOptions2["Gwynedd"] = "Gwynedd";
  UkAreaOptions2["Hackney"] = "Hackney";
  UkAreaOptions2["Halton"] = "Halton";
  UkAreaOptions2["HammersmithAndFulham"] = "Hammersmith and Fulham";
  UkAreaOptions2["Hampshire"] = "Hampshire";
  UkAreaOptions2["Haringey"] = "Haringey";
  UkAreaOptions2["Harrow"] = "Harrow";
  UkAreaOptions2["Hartlepool"] = "Hartlepool";
  UkAreaOptions2["Havering"] = "Havering";
  UkAreaOptions2["Herefordshire"] = "Herefordshire";
  UkAreaOptions2["Hertfordshire"] = "Hertfordshire";
  UkAreaOptions2["Highland"] = "Highland";
  UkAreaOptions2["Hillingdon"] = "Hillingdon";
  UkAreaOptions2["Hounslow"] = "Hounslow";
  UkAreaOptions2["Inverclyde"] = "Inverclyde";
  UkAreaOptions2["IsleOfAnglesey"] = "Isle of Anglesey";
  UkAreaOptions2["IsleOfMan"] = "Isle of Man";
  UkAreaOptions2["IsleOfWight"] = "Isle of Wight";
  UkAreaOptions2["IslesOfScilly"] = "Isles of Scilly";
  UkAreaOptions2["Islington"] = "Islington";
  UkAreaOptions2["Jersey"] = "Jersey";
  UkAreaOptions2["KensingtonAndChelsea"] = "Kensington and Chelsea";
  UkAreaOptions2["Kent"] = "Kent";
  UkAreaOptions2["KingstonUponHull"] = "Kingston upon Hull";
  UkAreaOptions2["KingstonUponThames"] = "Kingston upon Thames";
  UkAreaOptions2["Kirklees"] = "Kirklees";
  UkAreaOptions2["Knowsley"] = "Knowsley";
  UkAreaOptions2["Lambeth"] = "Lambeth";
  UkAreaOptions2["Lancashire"] = "Lancashire";
  UkAreaOptions2["Leeds"] = "Leeds";
  UkAreaOptions2["Leicester"] = "Leicester";
  UkAreaOptions2["Leicestershire"] = "Leicestershire";
  UkAreaOptions2["Lewisham"] = "Lewisham";
  UkAreaOptions2["Lincolnshire"] = "Lincolnshire";
  UkAreaOptions2["Liverpool"] = "Liverpool";
  UkAreaOptions2["Luton"] = "Luton";
  UkAreaOptions2["Manchester"] = "Manchester";
  UkAreaOptions2["Medway"] = "Medway";
  UkAreaOptions2["MerthyrTydfil"] = "Merthyr Tydfil";
  UkAreaOptions2["Merton"] = "Merton";
  UkAreaOptions2["Middlesbrough"] = "Middlesbrough";
  UkAreaOptions2["Midlothian"] = "Midlothian";
  UkAreaOptions2["MiltonKeynes"] = "Milton Keynes";
  UkAreaOptions2["Monmouthshire"] = "Monmouthshire";
  UkAreaOptions2["Moray"] = "Moray";
  UkAreaOptions2["NeathPortTalbot"] = "Neath Port Talbot";
  UkAreaOptions2["NewcastleUponTyne"] = "Newcastle upon Tyne";
  UkAreaOptions2["Newham"] = "Newham";
  UkAreaOptions2["Newport"] = "Newport";
  UkAreaOptions2["Norfolk"] = "Norfolk";
  UkAreaOptions2["NorthAyrshire"] = "North Ayrshire";
  UkAreaOptions2["NorthEastLincolnshire"] = "North East Lincolnshire";
  UkAreaOptions2["NorthLanarkshire"] = "North Lanarkshire";
  UkAreaOptions2["NorthLincolnshire"] = "North Lincolnshire";
  UkAreaOptions2["NorthSomerset"] = "North Somerset";
  UkAreaOptions2["NorthTyneside"] = "North Tyneside";
  UkAreaOptions2["NorthYorkshire"] = "North Yorkshire";
  UkAreaOptions2["Northamptonshire"] = "Northamptonshire";
  UkAreaOptions2["Northumberland"] = "Northumberland";
  UkAreaOptions2["Nottingham"] = "Nottingham";
  UkAreaOptions2["Nottinghamshire"] = "Nottinghamshire";
  UkAreaOptions2["Oldham"] = "Oldham";
  UkAreaOptions2["OrkneyIslands"] = "Orkney Islands";
  UkAreaOptions2["Oxfordshire"] = "Oxfordshire";
  UkAreaOptions2["Pembrokeshire"] = "Pembrokeshire";
  UkAreaOptions2["PerthshireKinross"] = "Perthshire & Kinross";
  UkAreaOptions2["Peterborough"] = "Peterborough";
  UkAreaOptions2["Plymouth"] = "Plymouth";
  UkAreaOptions2["Poole"] = "Poole";
  UkAreaOptions2["Portsmouth"] = "Portsmouth";
  UkAreaOptions2["Powys"] = "Powys";
  UkAreaOptions2["Reading"] = "Reading";
  UkAreaOptions2["Redbridge"] = "Redbridge";
  UkAreaOptions2["RedcarAndCleveland"] = "Redcar and Cleveland";
  UkAreaOptions2["Renfrewshire"] = "Renfrewshire";
  UkAreaOptions2["RhonddaCynonTaff"] = "Rhondda, Cynon, Taff";
  UkAreaOptions2["RichmondUponThames"] = "Richmond upon Thames";
  UkAreaOptions2["Rochdale"] = "Rochdale";
  UkAreaOptions2["Rotherham"] = "Rotherham";
  UkAreaOptions2["Rutland"] = "Rutland";
  UkAreaOptions2["Salford"] = "Salford";
  UkAreaOptions2["Sandwell"] = "Sandwell";
  UkAreaOptions2["ScottishBorders"] = "Scottish Borders";
  UkAreaOptions2["Sefton"] = "Sefton";
  UkAreaOptions2["Sheffield"] = "Sheffield";
  UkAreaOptions2["ShetlandIslands"] = "Shetland Islands";
  UkAreaOptions2["Shropshire"] = "Shropshire";
  UkAreaOptions2["Slough"] = "Slough";
  UkAreaOptions2["Solihull"] = "Solihull";
  UkAreaOptions2["Somerset"] = "Somerset";
  UkAreaOptions2["SouthAyrshire"] = "South Ayrshire";
  UkAreaOptions2["SouthGloucestershire"] = "South Gloucestershire";
  UkAreaOptions2["SouthLanarkshire"] = "South Lanarkshire";
  UkAreaOptions2["SouthTyneside"] = "South Tyneside";
  UkAreaOptions2["Southampton"] = "Southampton";
  UkAreaOptions2["SouthendOnSea"] = "Southend on Sea";
  UkAreaOptions2["Southwark"] = "Southwark";
  UkAreaOptions2["StHelens"] = "St.Helens";
  UkAreaOptions2["Staffordshire"] = "Staffordshire";
  UkAreaOptions2["Stirling"] = "Stirling";
  UkAreaOptions2["Stockport"] = "Stockport";
  UkAreaOptions2["StocktonOnTees"] = "Stockton-on-Tees";
  UkAreaOptions2["StokeOnTrent"] = "Stoke-on-Trent";
  UkAreaOptions2["Suffolk"] = "Suffolk";
  UkAreaOptions2["Sunderland"] = "Sunderland";
  UkAreaOptions2["Surrey"] = "Surrey";
  UkAreaOptions2["Sutton"] = "Sutton";
  UkAreaOptions2["Swansea"] = "Swansea";
  UkAreaOptions2["Swindon"] = "Swindon";
  UkAreaOptions2["Tameside"] = "Tameside";
  UkAreaOptions2["TelfordAndWrekin"] = "Telford and Wrekin";
  UkAreaOptions2["TheRoyalBoroughOfWindsorMaidenheadAndBerkshire"] = "The Royal Borough of Windsor, Maidenhead and Berkshire";
  UkAreaOptions2["Thurrock"] = "Thurrock";
  UkAreaOptions2["Torbay"] = "Torbay";
  UkAreaOptions2["Torfaen"] = "Torfaen";
  UkAreaOptions2["TowerHamlets"] = "Tower Hamlets";
  UkAreaOptions2["Trafford"] = "Trafford";
  UkAreaOptions2["ValeOfGlamorgan"] = "Vale of Glamorgan";
  UkAreaOptions2["Wakefield"] = "Wakefield";
  UkAreaOptions2["Walsall"] = "Walsall";
  UkAreaOptions2["WalthamForest"] = "Waltham Forest";
  UkAreaOptions2["Wandsworth"] = "Wandsworth";
  UkAreaOptions2["Warrington"] = "Warrington";
  UkAreaOptions2["Warwickshire"] = "Warwickshire";
  UkAreaOptions2["WestBerkshire"] = "West Berkshire";
  UkAreaOptions2["WestDunbartonshire"] = "West Dunbartonshire";
  UkAreaOptions2["WestLothian"] = "West Lothian";
  UkAreaOptions2["WestSussex"] = "West Sussex";
  UkAreaOptions2["WesternIsles"] = "Western Isles";
  UkAreaOptions2["Westminster"] = "Westminster";
  UkAreaOptions2["Wigan"] = "Wigan";
  UkAreaOptions2["Wiltshire"] = "Wiltshire";
  UkAreaOptions2["Wirral"] = "Wirral";
  UkAreaOptions2["Wokingham"] = "Wokingham";
  UkAreaOptions2["Wolverhampton"] = "Wolverhampton";
  UkAreaOptions2["Worcestershire"] = "Worcestershire";
  UkAreaOptions2["Wrexham"] = "Wrexham";
  UkAreaOptions2["York"] = "York";
  return UkAreaOptions2;
})(UkAreaOptions || {});
var DocumentType = /* @__PURE__ */ ((DocumentType2) => {
  DocumentType2["AcademicTranscript"] = "academicTranscript";
  DocumentType2["Passport"] = "passport";
  DocumentType2["PersonalStatement"] = "personalStatement";
  DocumentType2["PhotoId"] = "photoId";
  DocumentType2["CV"] = "cv";
  DocumentType2["EnglishTest"] = "englishTest";
  DocumentType2["ReferenceLetter"] = "referenceLetter";
  DocumentType2["AcademicCertificate"] = "academicCertificate";
  DocumentType2["ProofOfAddress"] = "proofOfAddress";
  DocumentType2["ProofOfNameChange"] = "proofOfNameChange";
  DocumentType2["NameAffidavit"] = "nameAffidavit";
  DocumentType2["BirthCert"] = "birthCert";
  DocumentType2["ProofOfImmigrationStatus"] = "proofOfImmigrationStatus";
  DocumentType2["ProofOfManagerialExperience"] = "proofOfManagerialExperience";
  DocumentType2["ProofOfPayment"] = "proofOfPayment";
  DocumentType2["Portfolio"] = "portfolio";
  DocumentType2["ResearchProposal"] = "researchProposal";
  DocumentType2["CustomRequest"] = "customRequest";
  DocumentType2["CustomRequirement"] = "customRequirement";
  DocumentType2["StaffDocument"] = "staffDocument";
  DocumentType2["StaffOnlyRequirement"] = "staffOnlyRequirement";
  return DocumentType2;
})(DocumentType || {});
var AgentApplicantAuthorisationStatus = /* @__PURE__ */ ((AgentApplicantAuthorisationStatus3) => {
  AgentApplicantAuthorisationStatus3["AUTHORISED"] = "AUTHORISED";
  AgentApplicantAuthorisationStatus3["AUTHORISATION_DENIED"] = "AUTHORISATION_DENIED";
  AgentApplicantAuthorisationStatus3["AUTHORISATION_PENDING"] = "AUTHORISATION_PENDING";
  return AgentApplicantAuthorisationStatus3;
})(AgentApplicantAuthorisationStatus || {});
var SummaryTypeId = /* @__PURE__ */ ((SummaryTypeId2) => {
  SummaryTypeId2["ApplicationSummary"] = "APPLICATION_SUMMARY" /* ApplicationSummary */;
  SummaryTypeId2["OfferSummary"] = "APPLICANT_OFFER_SUMMARY" /* OfferSummary */;
  return SummaryTypeId2;
})(SummaryTypeId || {});
var Workflows = /* @__PURE__ */ ((Workflows2) => {
  Workflows2["ADMISSIONS"] = "Admissions";
  Workflows2["CAS"] = "CAS process";
  return Workflows2;
})(Workflows || {});
var WorkflowAccessLevel = /* @__PURE__ */ ((WorkflowAccessLevel2) => {
  WorkflowAccessLevel2["AdmissionsAccess"] = "Admissions";
  WorkflowAccessLevel2["CasAccess"] = "CAS process";
  WorkflowAccessLevel2["FullAccess"] = "Full access";
  return WorkflowAccessLevel2;
})(WorkflowAccessLevel || {});
var EmailStatus = /* @__PURE__ */ ((EmailStatus2) => {
  EmailStatus2["NoEmail"] = "No email";
  return EmailStatus2;
})(EmailStatus || {});
var CourseAvailability = /* @__PURE__ */ ((CourseAvailability2) => {
  CourseAvailability2["ALL"] = "all";
  CourseAvailability2["LIMITED_PARTNERS"] = "limited_partners";
  return CourseAvailability2;
})(CourseAvailability || {});

// src/apply/shared-schemas.ts
import { z as z2 } from "zod";
var ModuleSchema = z2.object({
  subject: z2.string(),
  grade: z2.string()
}).refine(
  (data) => {
    const hasSubject = data.subject && data.subject.trim().length > 0;
    const hasGrade = data.grade && data.grade.trim().length > 0;
    if (!hasSubject && !hasGrade) return true;
    return hasSubject && hasGrade;
  },
  (data) => {
    const hasSubject = data.subject && data.subject.trim().length > 0;
    const hasGrade = data.grade && data.grade.trim().length > 0;
    if (!hasSubject && hasGrade) {
      return { message: "Subject can't be empty", path: ["subject"] };
    }
    if (hasSubject && !hasGrade) {
      return { message: "Grade can't be empty", path: ["grade"] };
    }
    return { message: "Subject can't be empty", path: ["subject"] };
  }
).refine(
  (data) => {
    if (data.subject && data.subject.length > 100) return false;
    return true;
  },
  { message: "Subject is too long.", path: ["subject"] }
).refine(
  (data) => {
    if (data.grade && data.grade.length > 100) return false;
    return true;
  },
  { message: "Grade is too long.", path: ["grade"] }
);

// src/apply/applicant/index.ts
import { z as z6 } from "zod";
import * as googleLibphonenumber from "google-libphonenumber";

// src/apply/route/index.ts
var RouteStatus = /* @__PURE__ */ ((RouteStatus2) => {
  RouteStatus2["Unknown"] = "Unknown";
  RouteStatus2["ToDo"] = "To do";
  RouteStatus2["Done"] = "Done";
  RouteStatus2["Ready"] = "Ready";
  RouteStatus2["Locked"] = "Locked";
  RouteStatus2["Requested"] = "Requested";
  return RouteStatus2;
})(RouteStatus || {});
var ROUTE_STATUS_TO_INDEX = [
  "Unknown" /* Unknown */,
  // 0
  "To do" /* ToDo */,
  // 1
  "Done" /* Done */,
  // 2
  "Ready" /* Ready */,
  // 3
  "Locked" /* Locked */,
  // 4
  "Requested" /* Requested */
  // 5
];
var SectionLabel = /* @__PURE__ */ ((SectionLabel2) => {
  SectionLabel2["Home"] = "Home";
  SectionLabel2["YourInformation"] = "Your information";
  SectionLabel2["Application"] = "Application";
  SectionLabel2["Programmes"] = "Programmes";
  return SectionLabel2;
})(SectionLabel || {});
var YourInformationTaskGroupLabel = /* @__PURE__ */ ((YourInformationTaskGroupLabel2) => {
  YourInformationTaskGroupLabel2["AboutYou"] = "About you";
  YourInformationTaskGroupLabel2["YourQualifications"] = "Your qualifications";
  return YourInformationTaskGroupLabel2;
})(YourInformationTaskGroupLabel || {});
var ApplicationTaskGroupLabel = /* @__PURE__ */ ((ApplicationTaskGroupLabel2) => {
  ApplicationTaskGroupLabel2["PersonalInformation"] = "Personal information";
  ApplicationTaskGroupLabel2["QualificationsExperience"] = "Qualifications & experience";
  ApplicationTaskGroupLabel2["SupportingInformation"] = "Supporting information";
  ApplicationTaskGroupLabel2["AboutYourApplication"] = "About your application";
  ApplicationTaskGroupLabel2["Consent"] = "Consent";
  return ApplicationTaskGroupLabel2;
})(ApplicationTaskGroupLabel || {});
var OfferTaskGroupLabel = /* @__PURE__ */ ((OfferTaskGroupLabel2) => {
  OfferTaskGroupLabel2["Acceptance"] = "Acceptance";
  OfferTaskGroupLabel2["Conditions"] = "Conditions";
  OfferTaskGroupLabel2["Finance"] = "Payment";
  OfferTaskGroupLabel2["Completed"] = "Completed";
  OfferTaskGroupLabel2["Tasks"] = "Tasks";
  return OfferTaskGroupLabel2;
})(OfferTaskGroupLabel || {});
var YourInformationTaskLabel = /* @__PURE__ */ ((YourInformationTaskLabel2) => {
  YourInformationTaskLabel2["ContactDetails"] = "Contact details";
  YourInformationTaskLabel2["FeeStatus"] = "Fee status";
  YourInformationTaskLabel2["ProgrammeChoices"] = "Programme Choices";
  YourInformationTaskLabel2["HighestStudy"] = "Your highest study";
  return YourInformationTaskLabel2;
})(YourInformationTaskLabel || {});
var ApplicationTaskLabel = /* @__PURE__ */ ((ApplicationTaskLabel2) => {
  ApplicationTaskLabel2["Identity"] = "Identity";
  ApplicationTaskLabel2["NationalityResidence"] = "Nationality & residence";
  ApplicationTaskLabel2["ContactDetails"] = "Contact details";
  ApplicationTaskLabel2["EducationHistory"] = "Education history";
  ApplicationTaskLabel2["EnglishLanguage"] = "English language";
  ApplicationTaskLabel2["Employment"] = "Employment history";
  ApplicationTaskLabel2["References"] = "References";
  ApplicationTaskLabel2["PersonalStatement"] = "Personal statement";
  ApplicationTaskLabel2["ResearchProposal"] = "Research proposal";
  ApplicationTaskLabel2["Funding"] = "Funding";
  ApplicationTaskLabel2["ImmigrationHistory"] = "Immigration history";
  ApplicationTaskLabel2["DiversityInclusion"] = "Diversity & inclusion";
  ApplicationTaskLabel2["Representation"] = "Representation";
  ApplicationTaskLabel2["Referral"] = "Referral";
  ApplicationTaskLabel2["Declarations"] = "Declarations";
  ApplicationTaskLabel2["InformationProcessing"] = "Information processing";
  ApplicationTaskLabel2["PrivacyPolicy"] = "Privacy policy";
  ApplicationTaskLabel2["TermsConditions"] = "Terms & conditions";
  ApplicationTaskLabel2["AccuracyOfData"] = "Accuracy of data";
  return ApplicationTaskLabel2;
})(ApplicationTaskLabel || {});
var OfferTaskLabel = /* @__PURE__ */ ((OfferTaskLabel2) => {
  OfferTaskLabel2["ConditionalOffer"] = "Conditional offer";
  OfferTaskLabel2["UnconditionalOffer"] = "Unconditional offer";
  OfferTaskLabel2["Passport"] = "Passport";
  OfferTaskLabel2["PhotoID"] = "Photo ID";
  OfferTaskLabel2["AcademicResults"] = "Academic requirement";
  OfferTaskLabel2["FinalAcademicResults"] = "Final academic results";
  OfferTaskLabel2["AcademicCertificate"] = "Academic certificate";
  OfferTaskLabel2["AcademicTranscript"] = "Academic transcript";
  OfferTaskLabel2["EnglishLanguageResults"] = "English language results";
  OfferTaskLabel2["EnglishLanguageCertificate"] = "Proof of English proficiency";
  OfferTaskLabel2["ProofOfManagerialExperience"] = "Proof of 2 years of management experience";
  OfferTaskLabel2["ProofOfAddress"] = "Proof of address";
  OfferTaskLabel2["ProofOfNameChange"] = "Proof of name change";
  OfferTaskLabel2["NameAffidavit"] = "Name Affidavit";
  OfferTaskLabel2["BirthCert"] = "Birth certificate";
  OfferTaskLabel2["CV"] = "CV to support application";
  OfferTaskLabel2["ProofOfImmigrationStatus"] = "Proof of immigration status";
  OfferTaskLabel2["LetterOfRecommendation"] = "Letter of recommendation";
  OfferTaskLabel2["PersonalStatement"] = "Personal statement";
  OfferTaskLabel2["Portfolio"] = "Portfolio";
  OfferTaskLabel2["Payment"] = "Payment";
  OfferTaskLabel2["ProofOfPayment"] = "Proof of payment";
  OfferTaskLabel2["ResearchProposal"] = "Research proposal";
  OfferTaskLabel2["CalendlyInterview"] = "Schedule interview";
  OfferTaskLabel2["RecordedInterview"] = "Record your interview";
  OfferTaskLabel2["RefereeDetails"] = "Referee details";
  OfferTaskLabel2["Custom"] = "Custom requirement";
  OfferTaskLabel2["StaffOnly"] = "Staff only requirement";
  return OfferTaskLabel2;
})(OfferTaskLabel || {});
var SectionRoute = /* @__PURE__ */ ((SectionRoute2) => {
  SectionRoute2["Home"] = "/";
  SectionRoute2["YourInformation"] = "/your-information";
  SectionRoute2["Application"] = "/applications/{applicationId}";
  SectionRoute2["Programmes"] = "/programmes/{offerId}";
  return SectionRoute2;
})(SectionRoute || {});
var YourInformationTaskRoute = /* @__PURE__ */ ((YourInformationTaskRoute2) => {
  YourInformationTaskRoute2["ContactDetails"] = "/your-information/contact-details";
  YourInformationTaskRoute2["FeeStatus"] = "/your-information/fee-status";
  YourInformationTaskRoute2["ProgrammeChoices"] = "/your-information/programme-choices";
  YourInformationTaskRoute2["HighestStudy"] = "/your-information/your-highest-study";
  return YourInformationTaskRoute2;
})(YourInformationTaskRoute || {});
var ApplicationTaskRoute = /* @__PURE__ */ ((ApplicationTaskRoute2) => {
  ApplicationTaskRoute2["Identity"] = "/applications/{applicationId}/identity";
  ApplicationTaskRoute2["NationalityResidence"] = "/applications/{applicationId}/nationality-and-residence";
  ApplicationTaskRoute2["ContactDetails"] = "/applications/{applicationId}/contact-details";
  ApplicationTaskRoute2["EducationHistory"] = "/applications/{applicationId}/education-history";
  ApplicationTaskRoute2["EnglishLanguage"] = "/applications/{applicationId}/english-language";
  ApplicationTaskRoute2["Employment"] = "/applications/{applicationId}/employment";
  ApplicationTaskRoute2["References"] = "/applications/{applicationId}/references";
  ApplicationTaskRoute2["PersonalStatement"] = "/applications/{applicationId}/personal-statement";
  ApplicationTaskRoute2["ResearchProposal"] = "/applications/{applicationId}/research-proposal";
  ApplicationTaskRoute2["Funding"] = "/applications/{applicationId}/funding";
  ApplicationTaskRoute2["ImmigrationHistory"] = "/applications/{applicationId}/immigration-history";
  ApplicationTaskRoute2["DiversityInclusion"] = "/applications/{applicationId}/diversity-inclusion";
  ApplicationTaskRoute2["Representation"] = "/applications/{applicationId}/representation";
  ApplicationTaskRoute2["Referral"] = "/applications/{applicationId}/referral";
  ApplicationTaskRoute2["Declarations"] = "/applications/{applicationId}/declarations";
  ApplicationTaskRoute2["InformationProcessing"] = "/applications/{applicationId}/information-processing";
  ApplicationTaskRoute2["PrivacyPolicy"] = "/applications/{applicationId}/privacy-policy";
  ApplicationTaskRoute2["TermsConditions"] = "/applications/{applicationId}/terms-conditions";
  ApplicationTaskRoute2["AccuracyOfData"] = "/applications/{applicationId}/accuracy-of-data";
  return ApplicationTaskRoute2;
})(ApplicationTaskRoute || {});
var OfferTaskRoute = /* @__PURE__ */ ((OfferTaskRoute2) => {
  OfferTaskRoute2["ConditionalOffer"] = "/programmes/{offerId}/offer-acceptance";
  OfferTaskRoute2["UnconditionalOffer"] = "/programmes/{offerId}/offer-acceptance";
  OfferTaskRoute2["Passport"] = "/programmes/{offerId}/passport";
  OfferTaskRoute2["PhotoID"] = "/programmes/{offerId}/photo-id";
  OfferTaskRoute2["AcademicResults"] = "/programmes/{offerId}/academic-results";
  OfferTaskRoute2["FinalAcademicResults"] = "/programmes/{offerId}/final-academic-results";
  OfferTaskRoute2["AcademicCertificate"] = "/programmes/{offerId}/academic-certificate";
  OfferTaskRoute2["AcademicTranscript"] = "/programmes/{offerId}/academic-transcript";
  OfferTaskRoute2["EnglishLanguageResults"] = "/programmes/{offerId}/english-language-results";
  OfferTaskRoute2["EnglishLanguageCertificate"] = "/programmes/{offerId}/english-language-certificate";
  OfferTaskRoute2["ProofOfManagerialExperience"] = "/programmes/{offerId}/proof-of-managerial-experience";
  OfferTaskRoute2["ProofOfAddress"] = "/programmes/{offerId}/proof-of-address";
  OfferTaskRoute2["ProofOfNameChange"] = "/programmes/{offerId}/proof-of-name-change";
  OfferTaskRoute2["NameAffidavit"] = "/programmes/{offerId}/name-affidavit";
  OfferTaskRoute2["BirthCert"] = "/programmes/{offerId}/birth-cert";
  OfferTaskRoute2["CV"] = "/programmes/{offerId}/cv";
  OfferTaskRoute2["ProofOfImmigrationStatus"] = "/programmes/{offerId}/proof-of-immigration-status";
  OfferTaskRoute2["LetterOfRecommendation"] = "/programmes/{offerId}/letter-of-recommendation";
  OfferTaskRoute2["PersonalStatement"] = "/programmes/{offerId}/personal-statement";
  OfferTaskRoute2["Payment"] = "/programmes/{offerId}/payment";
  OfferTaskRoute2["ProofOfPayment"] = "/programmes/{offerId}/proof-of-payment";
  OfferTaskRoute2["RequirementPayment"] = "/programmes/{offerId}/requirement-payment";
  OfferTaskRoute2["RequirementProofOfPayment"] = "/programmes/{offerId}/requirement-proof-of-payment";
  OfferTaskRoute2["Portfolio"] = "/programmes/{offerId}/portfolio";
  OfferTaskRoute2["ResearchProposal"] = "/programmes/{offerId}/research-proposal";
  OfferTaskRoute2["RefereeDetails"] = "/programmes/{offerId}/referee-details";
  OfferTaskRoute2["CalendlyInterview"] = "/programmes/{offerId}/calendly-interview/{eventType}";
  OfferTaskRoute2["RecordedInterview"] = "/programmes/{offerId}/recorded-interview/{interviewId}";
  OfferTaskRoute2["Custom"] = `/programmes/{offerId}/{requirementId}`;
  return OfferTaskRoute2;
})(OfferTaskRoute || {});
var documentsPerRoute = {
  ["/your-information/your-highest-study" /* HighestStudy */]: ["academicTranscript" /* AcademicTranscript */],
  ["/applications/{applicationId}/identity" /* Identity */]: ["passport" /* Passport */, "photoId" /* PhotoId */],
  ["/applications/{applicationId}/education-history" /* EducationHistory */]: ["academicTranscript" /* AcademicTranscript */],
  ["/applications/{applicationId}/personal-statement" /* PersonalStatement */]: ["personalStatement" /* PersonalStatement */],
  ["/applications/{applicationId}/employment" /* Employment */]: ["cv" /* CV */],
  ["/applications/{applicationId}/references" /* References */]: ["referenceLetter" /* ReferenceLetter */],
  ["/applications/{applicationId}/research-proposal" /* ResearchProposal */]: ["researchProposal" /* ResearchProposal */],
  ["/applications/{applicationId}/english-language" /* EnglishLanguage */]: ["englishTest" /* EnglishTest */],
  ["/programmes/{offerId}/academic-transcript" /* AcademicTranscript */]: ["academicTranscript" /* AcademicTranscript */],
  ["/programmes/{offerId}/academic-certificate" /* AcademicCertificate */]: ["academicCertificate" /* AcademicCertificate */],
  ["/programmes/{offerId}/cv" /* CV */]: ["cv" /* CV */],
  ["/programmes/{offerId}/english-language-certificate" /* EnglishLanguageCertificate */]: ["englishTest" /* EnglishTest */],
  ["/programmes/{offerId}/letter-of-recommendation" /* LetterOfRecommendation */]: ["referenceLetter" /* ReferenceLetter */],
  ["/programmes/{offerId}/passport" /* Passport */]: ["passport" /* Passport */],
  ["/programmes/{offerId}/personal-statement" /* PersonalStatement */]: ["personalStatement" /* PersonalStatement */],
  ["/programmes/{offerId}/photo-id" /* PhotoID */]: ["photoId" /* PhotoId */],
  ["/programmes/{offerId}/portfolio" /* Portfolio */]: ["portfolio" /* Portfolio */],
  ["/programmes/{offerId}/proof-of-address" /* ProofOfAddress */]: ["proofOfAddress" /* ProofOfAddress */],
  ["/programmes/{offerId}/proof-of-name-change" /* ProofOfNameChange */]: ["proofOfNameChange" /* ProofOfNameChange */],
  ["/programmes/{offerId}/name-affidavit" /* NameAffidavit */]: ["nameAffidavit" /* NameAffidavit */],
  ["/programmes/{offerId}/birth-cert" /* BirthCert */]: ["birthCert" /* BirthCert */],
  ["/programmes/{offerId}/proof-of-immigration-status" /* ProofOfImmigrationStatus */]: ["proofOfImmigrationStatus" /* ProofOfImmigrationStatus */],
  ["/programmes/{offerId}/proof-of-managerial-experience" /* ProofOfManagerialExperience */]: ["proofOfManagerialExperience" /* ProofOfManagerialExperience */],
  ["/programmes/{offerId}/proof-of-payment" /* ProofOfPayment */]: ["proofOfPayment" /* ProofOfPayment */],
  ["/programmes/{offerId}/requirement-proof-of-payment" /* RequirementProofOfPayment */]: ["proofOfPayment" /* ProofOfPayment */],
  ["/programmes/{offerId}/research-proposal" /* ResearchProposal */]: ["researchProposal" /* ResearchProposal */],
  ["/programmes/{offerId}/{requirementId}" /* Custom */]: ["customRequirement" /* CustomRequirement */]
};

// src/apply/offer/enums.ts
var ApplicantOfferRequirementTask = /* @__PURE__ */ ((ApplicantOfferRequirementTask2) => {
  ApplicantOfferRequirementTask2["Passport"] = "Passport";
  ApplicantOfferRequirementTask2["PhotoID"] = "PhotoID";
  ApplicantOfferRequirementTask2["AcademicResults"] = "AcademicResults";
  ApplicantOfferRequirementTask2["FinalAcademicResults"] = "FinalAcademicResults";
  ApplicantOfferRequirementTask2["AcademicCertificate"] = "AcademicCertificate";
  ApplicantOfferRequirementTask2["AcademicTranscript"] = "AcademicTranscript";
  ApplicantOfferRequirementTask2["EnglishLanguageResults"] = "EnglishLanguageResults";
  ApplicantOfferRequirementTask2["EnglishLanguageCertificate"] = "EnglishLanguageCertificate";
  ApplicantOfferRequirementTask2["CV"] = "CV";
  ApplicantOfferRequirementTask2["ProofOfManagerialExperience"] = "ProofOfManagerialExperience";
  ApplicantOfferRequirementTask2["ProofOfAddress"] = "ProofOfAddress";
  ApplicantOfferRequirementTask2["ProofOfNameChange"] = "ProofOfNameChange";
  ApplicantOfferRequirementTask2["NameAffidavit"] = "NameAffidavit";
  ApplicantOfferRequirementTask2["BirthCert"] = "BirthCert";
  ApplicantOfferRequirementTask2["ProofOfImmigrationStatus"] = "ProofOfImmigrationStatus";
  ApplicantOfferRequirementTask2["LetterOfRecommendation"] = "LetterOfRecommendation";
  ApplicantOfferRequirementTask2["PersonalStatement"] = "PersonalStatement";
  ApplicantOfferRequirementTask2["Portfolio"] = "Portfolio";
  ApplicantOfferRequirementTask2["ResearchProposal"] = "ResearchProposal";
  ApplicantOfferRequirementTask2["CalendlyInterview"] = "CalendlyInterview";
  ApplicantOfferRequirementTask2["RecordedInterview"] = "RecordedInterview";
  ApplicantOfferRequirementTask2["RefereeDetails"] = "RefereeDetails";
  ApplicantOfferRequirementTask2["Payment"] = "Payment";
  ApplicantOfferRequirementTask2["ProofOfPayment"] = "ProofOfPayment";
  ApplicantOfferRequirementTask2["Custom"] = "Custom";
  ApplicantOfferRequirementTask2["StaffOnly"] = "StaffOnly";
  return ApplicantOfferRequirementTask2;
})(ApplicantOfferRequirementTask || {});
var ApplicantOfferRequirementTaskLevel = /* @__PURE__ */ ((ApplicantOfferRequirementTaskLevel3) => {
  ApplicantOfferRequirementTaskLevel3["Off"] = "Off";
  ApplicantOfferRequirementTaskLevel3["PreOffer"] = "PreOffer";
  ApplicantOfferRequirementTaskLevel3["Condition"] = "Condition";
  ApplicantOfferRequirementTaskLevel3["PreEnrolment"] = "PreEnrolment";
  ApplicantOfferRequirementTaskLevel3["AlwaysAvailable"] = "AlwaysAvailable";
  return ApplicantOfferRequirementTaskLevel3;
})(ApplicantOfferRequirementTaskLevel || {});
var endpointToRequirementTaskEnum = /* @__PURE__ */ new Map([
  ["passport", "Passport" /* Passport */],
  ["photo-id", "PhotoID" /* PhotoID */],
  ["proof-of-name-change", "ProofOfNameChange" /* ProofOfNameChange */],
  ["name-affidavit", "NameAffidavit" /* NameAffidavit */],
  ["birth-certificate", "BirthCert" /* BirthCert */],
  ["academic-results", "AcademicResults" /* AcademicResults */],
  ["final-academic-results", "FinalAcademicResults" /* FinalAcademicResults */],
  ["academic-certificate", "AcademicCertificate" /* AcademicCertificate */],
  ["academic-transcript", "AcademicTranscript" /* AcademicTranscript */],
  ["english-language-results", "EnglishLanguageResults" /* EnglishLanguageResults */],
  ["english-language-certificate", "EnglishLanguageCertificate" /* EnglishLanguageCertificate */],
  ["cv", "CV" /* CV */],
  ["proof-of-managerial-experience", "ProofOfManagerialExperience" /* ProofOfManagerialExperience */],
  ["proof-of-address", "ProofOfAddress" /* ProofOfAddress */],
  ["proof-of-immigration-status", "ProofOfImmigrationStatus" /* ProofOfImmigrationStatus */],
  ["letter-of-recommendation", "LetterOfRecommendation" /* LetterOfRecommendation */],
  ["personal-statement", "PersonalStatement" /* PersonalStatement */],
  ["research-proposal", "ResearchProposal" /* ResearchProposal */],
  ["portfolio", "Portfolio" /* Portfolio */],
  ["referee-details", "RefereeDetails" /* RefereeDetails */],
  ["payment", "Payment" /* Payment */],
  ["proof-of-payment", "ProofOfPayment" /* ProofOfPayment */]
]);
var ApplicantRequirementTasks = {
  ["AcademicCertificate" /* AcademicCertificate */]: "Academic certificate" /* AcademicCertificate */,
  ["AcademicResults" /* AcademicResults */]: "Academic requirement" /* AcademicResults */,
  ["FinalAcademicResults" /* FinalAcademicResults */]: "Final academic results" /* FinalAcademicResults */,
  ["AcademicTranscript" /* AcademicTranscript */]: "Academic transcript" /* AcademicTranscript */,
  ["EnglishLanguageCertificate" /* EnglishLanguageCertificate */]: "Proof of English proficiency" /* EnglishLanguageCertificate */,
  ["EnglishLanguageResults" /* EnglishLanguageResults */]: "English language results" /* EnglishLanguageResults */,
  ["Passport" /* Passport */]: "Passport" /* Passport */,
  ["PhotoID" /* PhotoID */]: "Photo ID" /* PhotoID */,
  ["CV" /* CV */]: "CV to support application" /* CV */,
  ["ProofOfManagerialExperience" /* ProofOfManagerialExperience */]: "Proof of 2 years of management experience" /* ProofOfManagerialExperience */,
  ["LetterOfRecommendation" /* LetterOfRecommendation */]: "Letter of recommendation" /* LetterOfRecommendation */,
  ["PersonalStatement" /* PersonalStatement */]: "Personal statement" /* PersonalStatement */,
  ["ProofOfAddress" /* ProofOfAddress */]: "Proof of address" /* ProofOfAddress */,
  ["ProofOfNameChange" /* ProofOfNameChange */]: "Proof of name change" /* ProofOfNameChange */,
  ["NameAffidavit" /* NameAffidavit */]: "Name Affidavit" /* NameAffidavit */,
  ["BirthCert" /* BirthCert */]: "Birth certificate" /* BirthCert */,
  ["ProofOfImmigrationStatus" /* ProofOfImmigrationStatus */]: "Proof of immigration status" /* ProofOfImmigrationStatus */,
  ["Portfolio" /* Portfolio */]: "Portfolio" /* Portfolio */,
  ["ResearchProposal" /* ResearchProposal */]: "Research proposal" /* ResearchProposal */,
  ["CalendlyInterview" /* CalendlyInterview */]: "Schedule interview" /* CalendlyInterview */,
  ["RecordedInterview" /* RecordedInterview */]: "Record your interview" /* RecordedInterview */,
  ["RefereeDetails" /* RefereeDetails */]: "Referee details" /* RefereeDetails */,
  ["Payment" /* Payment */]: "Payment" /* Payment */,
  ["ProofOfPayment" /* ProofOfPayment */]: "Proof of payment" /* ProofOfPayment */,
  ["Custom" /* Custom */]: "Custom requirement" /* Custom */,
  ["StaffOnly" /* StaffOnly */]: "Staff only requirement" /* StaffOnly */
};
var ApplicantOfferRequirementTaskStatus = /* @__PURE__ */ ((ApplicantOfferRequirementTaskStatus3) => {
  ApplicantOfferRequirementTaskStatus3["Assess"] = "Assess";
  ApplicantOfferRequirementTaskStatus3["Satisfied"] = "Satisfied";
  ApplicantOfferRequirementTaskStatus3["Provisional"] = "Provisional";
  ApplicantOfferRequirementTaskStatus3["Condition"] = "Condition";
  ApplicantOfferRequirementTaskStatus3["Exempt"] = "Exempt";
  ApplicantOfferRequirementTaskStatus3["NotSatisfied"] = "NotSatisfied";
  return ApplicantOfferRequirementTaskStatus3;
})(ApplicantOfferRequirementTaskStatus || {});
var ApplicantOfferRequirement = /* @__PURE__ */ ((ApplicantOfferRequirement3) => {
  ApplicantOfferRequirement3["Identity"] = "Identity";
  ApplicantOfferRequirement3["AcademicRequirement"] = "AcademicRequirement";
  ApplicantOfferRequirement3["EnglishLanguageRequirement"] = "EnglishLanguageRequirement";
  ApplicantOfferRequirement3["Employment"] = "Employment";
  ApplicantOfferRequirement3["ImmigrationHistory"] = "ImmigrationHistory";
  ApplicantOfferRequirement3["References"] = "References";
  ApplicantOfferRequirement3["Portfolio"] = "Portfolio";
  ApplicantOfferRequirement3["ResearchProposal"] = "ResearchProposal";
  ApplicantOfferRequirement3["CalendlyInterview"] = "CalendlyInterview";
  ApplicantOfferRequirement3["RecordedInterview"] = "RecordedInterview";
  ApplicantOfferRequirement3["Finance"] = "Finance";
  ApplicantOfferRequirement3["Custom"] = "Custom";
  ApplicantOfferRequirement3["StaffOnly"] = "StaffOnly";
  return ApplicantOfferRequirement3;
})(ApplicantOfferRequirement || {});
var ApplicantOfferStatus = /* @__PURE__ */ ((ApplicantOfferStatus2) => {
  ApplicantOfferStatus2["Applied"] = "Applied";
  ApplicantOfferStatus2["Draft"] = "Draft";
  ApplicantOfferStatus2["Conditional"] = "Conditional";
  ApplicantOfferStatus2["Unconditional"] = "Unconditional";
  ApplicantOfferStatus2["Withdrawn"] = "Withdrawn";
  ApplicantOfferStatus2["Rejected"] = "Rejected";
  ApplicantOfferStatus2["Completed"] = "Completed";
  return ApplicantOfferStatus2;
})(ApplicantOfferStatus || {});
var ApplicantOfferPaymentStatus = /* @__PURE__ */ ((ApplicantOfferPaymentStatus2) => {
  ApplicantOfferPaymentStatus2["Request"] = "Request";
  ApplicantOfferPaymentStatus2["Review"] = "Review";
  ApplicantOfferPaymentStatus2["Exempt"] = "Exempt";
  ApplicantOfferPaymentStatus2["Approved"] = "Approved";
  return ApplicantOfferPaymentStatus2;
})(ApplicantOfferPaymentStatus || {});
var ApplicantStatusReason = /* @__PURE__ */ ((ApplicantStatusReason2) => {
  ApplicantStatusReason2["EntryCriteriaNotMet"] = "EntryCriteriaNotMet";
  ApplicantStatusReason2["FailedAcademicAssessment"] = "FailedAcademicAssessment";
  ApplicantStatusReason2["FailedCredibilityAssessment"] = "FailedCredibilityAssessment";
  ApplicantStatusReason2["FraudulentApplication"] = "FraudulentApplication";
  ApplicantStatusReason2["CourseClosure"] = "CourseClosure";
  ApplicantStatusReason2["CourseFull"] = "CourseFull";
  ApplicantStatusReason2["UnableToOfferCourse"] = "UnableToOfferCourse";
  ApplicantStatusReason2["DeadlineHasPassed"] = "DeadlineHasPassed";
  ApplicantStatusReason2["ClosedByApplicant"] = "ClosedByApplicant";
  ApplicantStatusReason2["AcceptedByApplicant"] = "AcceptedByApplicant";
  ApplicantStatusReason2["CompletedByApplicant"] = "CompletedByApplicant";
  ApplicantStatusReason2["WithdrawnOnCompletion"] = "WithdrawnOnCompletion";
  ApplicantStatusReason2["WrongApplicationForm"] = "WrongApplicationForm";
  ApplicantStatusReason2["FailedPreCasInterview"] = "FailedPreCasInterview";
  ApplicantStatusReason2["FailedComplianceInterview"] = "FailedComplianceInterview";
  ApplicantStatusReason2["NegativeQualificationVerification"] = "NegativeQualificationVerification";
  ApplicantStatusReason2["DuplicateApplication"] = "DuplicateApplication";
  ApplicantStatusReason2["InactiveApplication"] = "InactiveApplication";
  ApplicantStatusReason2["RegionExclusiveToAgent"] = "RegionExclusiveToAgent";
  ApplicantStatusReason2["Other"] = "Other";
  return ApplicantStatusReason2;
})(ApplicantStatusReason || {});
var ApplicantOfferResponseStatus = /* @__PURE__ */ ((ApplicantOfferResponseStatus2) => {
  ApplicantOfferResponseStatus2["Accepted"] = "Accepted";
  ApplicantOfferResponseStatus2["Declined"] = "Declined";
  return ApplicantOfferResponseStatus2;
})(ApplicantOfferResponseStatus || {});
var ApplicantOfferConditionType = /* @__PURE__ */ ((ApplicantOfferConditionType2) => {
  ApplicantOfferConditionType2["Conditional"] = "Conditional";
  ApplicantOfferConditionType2["Unconditional"] = "Unconditional";
  return ApplicantOfferConditionType2;
})(ApplicantOfferConditionType || {});
var ApplicantStatusObjName = /* @__PURE__ */ ((ApplicantStatusObjName2) => {
  ApplicantStatusObjName2["ConditionalStatus"] = "conditionStatus";
  ApplicantStatusObjName2["UnconditionalStatus"] = "unConditionStatus";
  return ApplicantStatusObjName2;
})(ApplicantStatusObjName || {});
var ApplicantOfferRequirementTaskActionStatus = /* @__PURE__ */ ((ApplicantOfferRequirementTaskActionStatus3) => {
  ApplicantOfferRequirementTaskActionStatus3["ToDo"] = "To do";
  ApplicantOfferRequirementTaskActionStatus3["Done"] = "Done";
  return ApplicantOfferRequirementTaskActionStatus3;
})(ApplicantOfferRequirementTaskActionStatus || {});
var EntryPoint = /* @__PURE__ */ ((EntryPoint2) => {
  EntryPoint2["Year0"] = "Year 0";
  EntryPoint2["Year1"] = "Year 1";
  EntryPoint2["Year2"] = "Year 2";
  EntryPoint2["Year3"] = "Year 3";
  EntryPoint2["Year4"] = "Year 4";
  EntryPoint2["Year5"] = "Year 5";
  EntryPoint2["Year6"] = "Year 6";
  return EntryPoint2;
})(EntryPoint || {});
var ApplicantOfferPaymentMethod = /* @__PURE__ */ ((ApplicantOfferPaymentMethod2) => {
  ApplicantOfferPaymentMethod2["Deposit"] = "Deposit";
  ApplicantOfferPaymentMethod2["Sponsorship"] = "Sponsorship";
  ApplicantOfferPaymentMethod2["SLCFunding"] = "SLCFunding";
  return ApplicantOfferPaymentMethod2;
})(ApplicantOfferPaymentMethod || {});
var ApplicantOfferPaymentSponsorType = /* @__PURE__ */ ((ApplicantOfferPaymentSponsorType2) => {
  ApplicantOfferPaymentSponsorType2["UkGovernment"] = "UkGovernment";
  ApplicantOfferPaymentSponsorType2["BritishCouncil"] = "BritishCouncil";
  ApplicantOfferPaymentSponsorType2["YourGovernment"] = "YourGovernment";
  ApplicantOfferPaymentSponsorType2["InternationalOrganisation"] = "InternationalOrganisation";
  ApplicantOfferPaymentSponsorType2["InternationalCompany"] = "InternationalCompany";
  return ApplicantOfferPaymentSponsorType2;
})(ApplicantOfferPaymentSponsorType || {});
var ScholarshipType = /* @__PURE__ */ ((ScholarshipType2) => {
  ScholarshipType2["FIXED"] = "FIXED";
  ScholarshipType2["PERCENTAGE"] = "PERCENTAGE";
  return ScholarshipType2;
})(ScholarshipType || {});

// src/apply/shared/index.ts
import { z as z3 } from "zod";
var PassportSchema = z3.object({
  passportNo: z3.string().min(1, { message: "Required" }),
  dateOfExpiry: z3.string().min(1, { message: "Required" }).date(),
  dateOfIssue: z3.string().min(1, { message: "Required" }).date(),
  passportIssuingAuthority: z3.string().min(1, { message: "Required" })
}).superRefine((data, ctx) => {
  const { dateOfIssue, dateOfExpiry } = data;
  if (!dateOfIssue || !dateOfExpiry) return;
  const issueDate = new Date(dateOfIssue);
  const expiryDate = new Date(dateOfExpiry);
  const today = /* @__PURE__ */ new Date();
  if (issueDate > today) {
    ctx.addIssue({
      code: "custom",
      path: ["dateOfIssue"],
      message: "Date of issue should be earlier than today"
    });
  }
  if (issueDate > expiryDate) {
    ctx.addIssue({
      code: "custom",
      path: ["dateOfExpiry"],
      message: "Date of expiry should not be earlier than date of issue"
    });
  }
});

// src/data/phoneCountryCodes.ts
var phoneCountryCodes = {
  BD: "880",
  BE: "32",
  BF: "226",
  BG: "359",
  BA: "387",
  BB: "1246",
  WF: "681",
  BL: "590",
  BM: "1441",
  BN: "673",
  BO: "591",
  BH: "973",
  BI: "257",
  BJ: "229",
  BT: "975",
  JM: "1876",
  BV: "",
  BW: "267",
  WS: "685",
  BQ: "599",
  BR: "55",
  BS: "1242",
  JE: "441534",
  BY: "375",
  BZ: "501",
  RU: "7",
  RW: "250",
  RS: "381",
  TL: "670",
  RE: "262",
  TM: "993",
  TJ: "992",
  RO: "40",
  TK: "690",
  GW: "245",
  GU: "1671",
  GT: "502",
  GS: "",
  GR: "30",
  GQ: "240",
  GP: "590",
  JP: "81",
  GY: "592",
  GG: "441481",
  GF: "594",
  GE: "995",
  GD: "1473",
  GB: "44",
  GA: "241",
  SV: "503",
  GN: "224",
  GM: "220",
  GL: "299",
  GI: "350",
  GH: "233",
  OM: "968",
  TN: "216",
  JO: "962",
  HR: "385",
  HT: "509",
  HU: "36",
  HK: "852",
  HN: "504",
  HM: " ",
  VE: "58",
  PR: "1787 and 1939",
  PS: "970",
  PW: "680",
  PT: "351",
  SJ: "47",
  PY: "595",
  IQ: "964",
  PA: "507",
  PF: "689",
  PG: "675",
  PE: "51",
  PK: "92",
  PH: "63",
  PN: "870",
  PL: "48",
  PM: "508",
  ZM: "260",
  EH: "212",
  EE: "372",
  EG: "20",
  ZA: "27",
  EC: "593",
  IT: "39",
  VN: "84",
  SB: "677",
  ET: "251",
  SO: "252",
  ZW: "263",
  SA: "966",
  ES: "34",
  ER: "291",
  ME: "382",
  MD: "373",
  MG: "261",
  MF: "590",
  MA: "212",
  MC: "377",
  UZ: "998",
  MM: "95",
  ML: "223",
  MO: "853",
  MN: "976",
  MH: "692",
  MK: "389",
  MU: "230",
  MT: "356",
  MW: "265",
  MV: "960",
  MQ: "596",
  MP: "1670",
  MS: "1664",
  MR: "222",
  IM: "441624",
  UG: "256",
  TZ: "255",
  MY: "60",
  MX: "52",
  IL: "972",
  FR: "33",
  IO: "246",
  SH: "290",
  FI: "358",
  FJ: "679",
  FK: "500",
  FM: "691",
  FO: "298",
  NI: "505",
  NL: "31",
  NO: "47",
  NA: "264",
  VU: "678",
  NC: "687",
  NE: "227",
  NF: "672",
  NG: "234",
  NZ: "64",
  NP: "977",
  NR: "674",
  NU: "683",
  CK: "682",
  XK: "",
  CI: "225",
  CH: "41",
  CO: "57",
  CN: "86",
  CM: "237",
  CL: "56",
  CC: "61",
  CA: "1",
  CG: "242",
  CF: "236",
  CD: "243",
  CZ: "420",
  CY: "357",
  CX: "61",
  CR: "506",
  CW: "599",
  CV: "238",
  CU: "53",
  SZ: "268",
  SY: "963",
  SX: "599",
  KG: "996",
  KE: "254",
  SS: "211",
  SR: "597",
  KI: "686",
  KH: "855",
  KN: "1869",
  KM: "269",
  ST: "239",
  SK: "421",
  KR: "82",
  SI: "386",
  KP: "850",
  KW: "965",
  SN: "221",
  SM: "378",
  SL: "232",
  SC: "248",
  KZ: "7",
  KY: "1345",
  SG: "65",
  SE: "46",
  SD: "249",
  DO: "1809 and 1829",
  DM: "1767",
  DJ: "253",
  DK: "45",
  VG: "1284",
  DE: "49",
  YE: "967",
  DZ: "213",
  US: "1",
  UY: "598",
  YT: "262",
  UM: "1",
  LB: "961",
  LC: "1758",
  LA: "856",
  TV: "688",
  TW: "886",
  TT: "1868",
  TR: "90",
  LK: "94",
  LI: "423",
  LV: "371",
  TO: "676",
  LT: "370",
  LU: "352",
  LR: "231",
  LS: "266",
  TH: "66",
  TF: "",
  TG: "228",
  TD: "235",
  TC: "1649",
  LY: "218",
  VA: "379",
  VC: "1784",
  AE: "971",
  AD: "376",
  AG: "1268",
  AF: "93",
  AI: "1264",
  VI: "1340",
  IS: "354",
  IR: "98",
  AM: "374",
  AL: "355",
  AO: "244",
  AQ: "",
  AS: "1684",
  AR: "54",
  AU: "61",
  AT: "43",
  AW: "297",
  IN: "91",
  AX: "35818",
  AZ: "994",
  IE: "353",
  ID: "62",
  UA: "380",
  QA: "974",
  MZ: "258"
};
var isValidPhoneCode = (phoneCode) => {
  return Object.values(phoneCountryCodes).includes(phoneCode);
};

// src/apply/applicant/auth.ts
import { z as z4 } from "zod";

// src/apply/registration/registrationFormEnums.ts
var SharedFormKeyNames = /* @__PURE__ */ ((SharedFormKeyNames2) => {
  SharedFormKeyNames2["EMAIL"] = "email";
  SharedFormKeyNames2["PREFERRED_NAME"] = "preferredName";
  SharedFormKeyNames2["MOBILE_NUMBER"] = "phoneNumber";
  SharedFormKeyNames2["NATIONALITY"] = "nationality";
  SharedFormKeyNames2["DOB"] = "dob";
  SharedFormKeyNames2["UNIVERSITY_ID"] = "universityId";
  SharedFormKeyNames2["INTAKE_ID"] = "intakeId";
  SharedFormKeyNames2["STUDY_LEVEL"] = "studyLevel";
  SharedFormKeyNames2["FEE_STATUS"] = "feeStatus";
  SharedFormKeyNames2["COURSE_ID"] = "courseId";
  SharedFormKeyNames2["MODE"] = "mode";
  SharedFormKeyNames2["CAMPUS"] = "campus";
  SharedFormKeyNames2["ENTRY_POINT"] = "entryPoint";
  SharedFormKeyNames2["COURSE_NAME"] = "courseName";
  SharedFormKeyNames2["PROGRAMME_CHOICES"] = "programmeChoices";
  SharedFormKeyNames2["DISABLE_EMAIL_NOTIFICATIONS"] = "disableEmailNotifications";
  return SharedFormKeyNames2;
})(SharedFormKeyNames || {});
var PartnerFormKeyNames = { ...SharedFormKeyNames };
var UniStaffFormKeyNames = { ...SharedFormKeyNames };
var ExclusiveAgentFormKeyNames = /* @__PURE__ */ ((ExclusiveAgentFormKeyNames2) => {
  ExclusiveAgentFormKeyNames2["AGENT_CONSENT"] = "agentConsent";
  return ExclusiveAgentFormKeyNames2;
})(ExclusiveAgentFormKeyNames || {});
var AgentFormKeyNames = {
  ...SharedFormKeyNames,
  ...ExclusiveAgentFormKeyNames
};

// src/apply/applicant/auth.ts
var ProgrammeChoiceSchema = z4.object({
  intakeId: intakeIdValidator.min(1, "Please select an intake"),
  intendedLevelOfStudy: z4.nativeEnum(StudyLevel, { message: "Please select a study level" }),
  courseName: z4.string().min(1, { message: "Please select a course name" }),
  mode: z4.nativeEnum(StudyMode),
  campus: z4.string().min(1),
  entryPoint: z4.nativeEnum(EntryPoint),
  courseId: z4.string().min(1, { message: "Please select a course" })
});
var MIN_PASSWORD_LENGTH = 8;
var MAX_PASSWORD_LENGTH = 256;
var emailValidationSchema = z4.string().trim().toLowerCase().email("Email is not valid.");
var minLengthSchema = z4.string().min(MIN_PASSWORD_LENGTH, { message: "Password must be at least 8 characters long." });
var maxLengthSchema = z4.string().max(MAX_PASSWORD_LENGTH, { message: "Password must be maximum least 256 characters long." });
var letterSchema = z4.string().regex(/[a-zA-Z]/, { message: "Password must contain at least one letter." });
var digitSchema = z4.string().regex(/\d/, { message: "Password must contain at least one digit." });
var specialCharSchema = z4.string().regex(/[=+\-^$*.[\]{}()?"!@#%&/,><\\':;|_~`]+/, {
  message: "Password must contain at least one special character."
});
var noWhitespaceSchema = z4.string().regex(/^\S+$/, { message: "Password must not start or end with whitespace." });
var passwordSchema = minLengthSchema.and(maxLengthSchema).and(letterSchema).and(digitSchema).and(specialCharSchema).and(noWhitespaceSchema);
var ApplicantNewPasswordSchema = z4.object({
  clientId: z4.string(),
  email: emailValidationSchema,
  newPassword: z4.string().min(MIN_PASSWORD_LENGTH),
  session: z4.string()
});
var ApplicantRegistrationSchema = z4.object({
  knownBy: z4.string().trim().min(1).max(50, "Known by cannot exceed 50 characters.").regex(
    /^[a-zA-Z\s'-]+$/,
    `Use letters A\u2013Z only, plus spaces, hyphens (-) or apostrophes ('). Accents and special characters aren\u2019t supported`
  ),
  email: emailValidationSchema,
  marketing: z4.boolean(),
  referrer: z4.string()
});
var ApplicantLoginSchema = z4.object({
  email: emailValidationSchema,
  password: passwordSchema
});
var ApplicantChangePasswordSchema = ApplicantLoginSchema.extend({
  code: z4.string().optional()
});
var StudentAuthoriseAgentSchema = z4.object({
  studentAuthoriseAgent: z4.coerce.boolean(),
  marketingConsent: z4.boolean().optional()
});
var BasicApplicantExternalRegistrationSchema = z4.object({
  ["email" /* EMAIL */]: z4.string().email("Email is not valid.").max(128, "Email cannot exceed 128 characters."),
  ["disableEmailNotifications" /* DISABLE_EMAIL_NOTIFICATIONS */]: z4.boolean().optional(),
  ["preferredName" /* PREFERRED_NAME */]: z4.string().regex(
    /^[a-zA-Z\s'-]+$/,
    `Use letters A\u2013Z only, plus spaces, hyphens (-) or apostrophes ('). Accents and special characters aren\u2019t supported`
  ).min(1, "Preferred name is required").max(50, "Preferred name cannot exceed 50 characters."),
  ["universityId" /* UNIVERSITY_ID */]: z4.string().min(2, "Institution is required"),
  ["programmeChoices" /* PROGRAMME_CHOICES */]: z4.array(ProgrammeChoiceSchema).length(1, "You must select exactly one programme choice to proceed"),
  ["feeStatus" /* FEE_STATUS */]: z4.nativeEnum(FeeStatus, { message: "Fee status is required" }),
  ["nationality" /* NATIONALITY */]: z4.string().min(3, "Nationality is required"),
  ["dob" /* DOB */]: z4.string().min(1, "Date of birth is required").refine(
    (val) => {
      const [YYYY, MM, DD] = val.split("-");
      return DD && MM && YYYY && DD.length === 2 && MM.length === 2 && YYYY.length === 4 && parseInt(DD) <= 31 && parseInt(MM) <= 12 && parseInt(YYYY) > 1900;
    },
    { message: "Date of birth is incomplete or invalid." }
  ).refine(
    (val) => {
      const now = /* @__PURE__ */ new Date();
      const dob = new Date(val);
      return dob < now && dob.toDateString() !== now.toDateString();
    },
    { message: "Date of birth cannot be in the future or today" }
  ).refine(
    (val) => {
      const [year, month, day] = val.split("-").map(Number);
      const today = /* @__PURE__ */ new Date();
      const todayMonth = today.getMonth() + 1;
      const age = today.getFullYear() - year - (todayMonth < month || todayMonth === month && today.getDate() < day ? 1 : 0);
      return age > 13;
    },
    { message: "Must be older than 13 years old." }
  ),
  ["phoneNumber" /* MOBILE_NUMBER */]: z4.string().min(1, "Phone number is required.").min(2, "Invalid phone number length.").regex(/^\d+(-\d+)*$/, "Invalid phone number.").refine((value) => value.includes("-"), { message: "Phone number must include country code." }).refine(
    (value) => {
      const [code, phone] = value.split("-");
      return code && phone && code.length && phone.length && /^\d+$/.test(code) && /^\d+$/.test(phone);
    },
    { message: "Invalid phone number." }
  )
});
var AgentRegistrationSchema = BasicApplicantExternalRegistrationSchema.extend({
  [AgentFormKeyNames.AGENT_CONSENT]: z4.boolean().refine((val) => val === true, {
    message: "Agent consent is required"
  })
});
var UniRegistrationSchema = BasicApplicantExternalRegistrationSchema;
var ProviderRegistrationSchema = BasicApplicantExternalRegistrationSchema;
var UniStaffRegistrationSchema = BasicApplicantExternalRegistrationSchema;

// src/apply/applicant/dashboard-row.ts
import { z as z5 } from "zod";
var ApplicantDashboardRowSchema = z5.object({
  agent: z5.null(),
  applicationId: z5.string(),
  applicationStatus: z5.nativeEnum(ApplicantStatus),
  courseId: z5.string(),
  dob: z5.string(),
  email: z5.string().and(emailValidationSchema),
  familyName: z5.string(),
  feeStatus: z5.nativeEnum(FeeStatus),
  gender: z5.nativeEnum(Gender),
  givenName: z5.string(),
  hasAgent: z5.null(),
  intakeId: z5.string(),
  intendedLevelOfStudy: z5.string(),
  isExistingStudent: z5.boolean(),
  nationality: z5.string(),
  pKey: z5.string(),
  phoneNumber: z5.string(),
  ucasId: z5.string(),
  uni: z5.string(),
  userId: z5.string()
});

// src/apply/applicant/document-keys.ts
var DocumentKey = {
  ["academicTranscript" /* AcademicTranscript */]: "academic-transcript",
  ["passport" /* Passport */]: "passport",
  ["personalStatement" /* PersonalStatement */]: "personal-statement",
  ["photoId" /* PhotoId */]: "photo-id",
  ["cv" /* CV */]: "cv",
  ["englishTest" /* EnglishTest */]: "english-test",
  ["referenceLetter" /* ReferenceLetter */]: "letter-of-recommendation",
  ["academicCertificate" /* AcademicCertificate */]: "academic-certificate",
  ["proofOfAddress" /* ProofOfAddress */]: "proof-of-address",
  ["proofOfNameChange" /* ProofOfNameChange */]: "proof-of-name-change",
  ["nameAffidavit" /* NameAffidavit */]: "name-affidavit",
  ["birthCert" /* BirthCert */]: "birth-certificate",
  ["proofOfImmigrationStatus" /* ProofOfImmigrationStatus */]: "proof-of-immigration-status",
  ["proofOfManagerialExperience" /* ProofOfManagerialExperience */]: "proof-of-managerial-experience",
  ["proofOfPayment" /* ProofOfPayment */]: "proof-of-payment",
  ["portfolio" /* Portfolio */]: "portfolio",
  ["researchProposal" /* ResearchProposal */]: "research-proposal",
  ["customRequest" /* CustomRequest */]: "custom-request",
  ["customRequirement" /* CustomRequirement */]: "custom-requirement"
};
function getOfferScopedDocKey(docType, offerId) {
  const baseKey = DocumentKey[docType];
  if (!baseKey) {
    return `${docType}-${offerId}`;
  }
  return `${baseKey}-${offerId}`;
}

// src/apply/applicant/index.ts
var { PhoneNumberUtil } = googleLibphonenumber;
var jsonParser = (schema) => z6.preprocess((val, ctx) => {
  try {
    return typeof val === "string" ? JSON.parse(val) : val;
  } catch (e) {
    ctx.addIssue({
      code: z6.ZodIssueCode.custom,
      message: e instanceof Error ? e.message : "Invalid JSON format."
    });
    return z6.NEVER;
  }
}, schema);
var AttachDocumentSchema = z6.object({
  sKey: z6.string().nullable(),
  // Allow null for deletion, required for uploads
  s3Keys: z6.array(z6.string()).nullable()
  // Allow null for deletion, required for uploads
});
var ProgrammeChoiceSchema2 = z6.object({
  intakeId: intakeIdValidator.min(1, "Please select an intake"),
  intendedLevelOfStudy: z6.nativeEnum(StudyLevel, { message: "Please select a study level" }),
  courseName: z6.string().min(1, { message: "Please select a course name" }),
  mode: z6.nativeEnum(StudyMode, { message: "Please select a study mode" }),
  campus: z6.string().min(1, { message: "Please select a campus" }),
  entryPoint: z6.nativeEnum(EntryPoint, { message: "Please select an entry year" }),
  courseId: z6.string().min(1, { message: "Please select a course" })
});
var MAX_PROGRAMME_CHOICES = 6;
var PROGRAMME_CHOICES_ERROR_MESSAGES = {
  required: {
    intake: "Please select an intake to continue",
    level: "Please select your intended level of study",
    programme: "Please select a programme",
    mode: "Please select a study mode",
    campus: "Please select a campus",
    entryPoint: "Please select an entry year",
    general: "Please fill in all required fields"
  },
  duplicate: "You have already selected this programme combination",
  minimum: "You must select at least one programme to proceed",
  maximum: `You have reached the maximum of ${MAX_PROGRAMME_CHOICES} programme choices`,
  noProgrammes: "No programmes are available for your selected criteria. Please try different options.",
  noCourses: "No programmes are available for your selected criteria. Please try different options.",
  serverError: "We encountered an error saving your choices. Please try again.",
  invalidData: "Some of your selections are invalid. Please check and try again."
};
var isDuplicateProgramme = (existingChoices, newChoice, editingIndex) => {
  return existingChoices.some((existing, index) => {
    if (editingIndex !== void 0 && index === editingIndex) {
      return false;
    }
    return existing.courseId === newChoice.courseId;
  });
};
var validateProgrammeChoices = (programmeChoices, withMax = false) => {
  const errors = [];
  if ((programmeChoices?.length ?? 0) === 0) {
    errors.push(PROGRAMME_CHOICES_ERROR_MESSAGES.minimum);
  }
  if (withMax && (programmeChoices?.length ?? 0) > MAX_PROGRAMME_CHOICES) {
    errors.push(PROGRAMME_CHOICES_ERROR_MESSAGES.maximum);
  }
  const uniqueCombos = /* @__PURE__ */ new Set();
  for (const choice of programmeChoices) {
    if (uniqueCombos.has(choice.courseId)) {
      errors.push(PROGRAMME_CHOICES_ERROR_MESSAGES.duplicate);
      break;
    }
    uniqueCombos.add(choice.courseId);
  }
  return {
    isValid: errors.length === 0,
    errors
  };
};
var getProgrammeFieldError = (field, errorType = "required") => {
  if (errorType === "required") {
    const requiredErrors = PROGRAMME_CHOICES_ERROR_MESSAGES.required;
    return requiredErrors[field] || requiredErrors.general;
  }
  const message = PROGRAMME_CHOICES_ERROR_MESSAGES[errorType];
  return typeof message === "string" ? message : "Validation error";
};
var createProgrammeChoicesSchema = (includeMax) => {
  let schema = z6.array(ProgrammeChoiceSchema2).min(1, "You must add at least one programme choice to proceed");
  if (includeMax) {
    schema = schema.max(MAX_PROGRAMME_CHOICES, "You have added the maximum number of choices");
  }
  return z6.object({
    programmeChoices: schema.refine(
      (choices) => {
        const uniqueCombos = /* @__PURE__ */ new Set();
        for (const choice of choices) {
          if (uniqueCombos.has(choice.courseId)) {
            return false;
          }
          uniqueCombos.add(choice.courseId);
        }
        return true;
      },
      {
        message: "Duplicate programme combinations are not allowed"
      }
    )
  });
};
var ProgrammeChoicesSchema = createProgrammeChoicesSchema(false);
var ProgrammeChoicesSchemaWithMax = createProgrammeChoicesSchema(true);
var AddressSchema = z6.object({
  addressLine1: z6.string().min(1, "Address Line 1 can't be empty").max(50, "Address Line 1 is too long"),
  addressLine2: z6.string().max(50, "Address line 2 is too long").optional(),
  addressLine3: z6.string().max(50, "Address line 3 is too long").optional(),
  city: z6.string().min(1, "City can't be empty").max(50, "City is too long"),
  addressHasSubdivision: z6.boolean().default(false),
  subdivisionCode: z6.string().max(10, "Subdivision code is too long").default(""),
  state: z6.string().max(50, "State is too long").optional(),
  postcode: z6.string().min(1, "Postcode can't be empty.").max(20, "Postcode is too long"),
  country: z6.string()
});
var employmentAddressSchema = AddressSchema.omit({
  addressLine1: true,
  addressLine2: true,
  addressLine3: true,
  postcode: true
}).extend({
  // These specific address fields have different names and this is to be maintained for backwards compatibility
  employerAddress: z6.string().min(1, "Address line 1 cannot be empty").max(50, "Address line 1 is too long"),
  employerAddressLine2: z6.string().max(50, "Address line 2 is too long").optional(),
  employerAddressLine3: z6.string().max(50, "Address line 3 is too long").optional(),
  postalCode: z6.string().min(1, "Postal code can't be empty.").max(20, "Postal code is too long")
});
var FeeStatusSchema = z6.object({
  feeStatus: z6.nativeEnum(FeeStatus)
});
var VisaRequiredSchema = z6.object({
  isVisaRequired: z6.boolean()
});
var HighestQualificationSchema = z6.object({
  highestQualification: z6.string()
});
var PhoneNumberSchema = z6.string().min(1, "Phone number is required.").min(2, "Invalid phone number length.").regex(/^\d+(-\d+)*$/, "Invalid phone number.").refine((value) => value.includes("-"), { message: "Phone number must include country code." }).refine(
  (value) => {
    const [code, phone] = value.split("-");
    return code && phone && code.length && phone.length && /^\d+$/.test(code) && /^\d+$/.test(phone);
  },
  { message: "Invalid phone number." }
).refine(
  (value) => {
    const [code] = value.split("-");
    return isValidPhoneCode(code);
  },
  { message: "Invalid country code." }
).refine(
  (value) => {
    const [code, phone] = value.split("-");
    try {
      const util = PhoneNumberUtil.getInstance();
      const rawNumber = `${code}${phone}`.replace(/[^0-9]/g, "");
      const phoneNum = util.parseAndKeepRawInput(`+${rawNumber}`);
      const isPossible = util.isPossibleNumber(phoneNum);
      if (!isPossible) {
        return false;
      }
      const isValid = util.isValidNumber(phoneNum);
      const isCaribbeanValid = /^[0-9]{4}$/.test(code) && /^[0-9]{7}$/.test(phone);
      return isValid || isCaribbeanValid;
    } catch (error) {
      const minDigits = 7;
      const maxDigits = 15;
      return code.length >= 1 && code.length <= 4 && phone.length >= minDigits && phone.length <= maxDigits;
    }
  },
  { message: "Your phone number is invalid or incomplete." }
);
var ContactInformationSchema = z6.object({
  nationality: z6.string(),
  dob: z6.string().date().refine(
    (val) => {
      const [YYYY, MM, DD] = val.split("-");
      return DD && MM && YYYY && DD.length === 2 && MM.length === 2 && YYYY.length === 4 && parseInt(DD) <= 31 && parseInt(MM) <= 12 && parseInt(YYYY) > 1900;
    },
    { message: "Date of birth is incomplete or invalid." }
  ).refine(
    (val) => {
      const now = /* @__PURE__ */ new Date();
      const dob = new Date(val);
      return dob < now && dob.toDateString() !== now.toDateString();
    },
    { message: "Date of birth cannot be in the future or today" }
  ).refine(
    (val) => {
      const [year, month, day] = val.split("-").map(Number);
      const today = /* @__PURE__ */ new Date();
      const todayMonth = today.getMonth() + 1;
      const age = today.getFullYear() - year - (todayMonth < month || todayMonth === month && today.getDate() < day ? 1 : 0);
      return age > 13;
    },
    { message: "Must be older than 13 years old." }
  ),
  phoneNumber: PhoneNumberSchema
});
var QualificationSchema = z6.object({
  level: z6.string().refine((val) => val in GradeLevel).optional(),
  levelLabel: z6.string().optional(),
  qualificationTypeId: z6.string().optional(),
  // For YHS: qualification type ID from database (e.g., "34", "125")
  qualificationTypeLabel: z6.string().optional(),
  // For YHS: qualification type label (e.g., "Advanced Extension Award")
  otherQualificationName: z6.string().nullish(),
  subject: z6.string().optional(),
  gradeSystem: z6.string().min(1, "Please select the grading system"),
  gradeSystemLabel: z6.string().optional(),
  groupId: z6.string().optional(),
  // For YHS: tracks which study group this qualification belongs to
  qualificationTypeRowId: z6.string().optional(),
  // For YHS: tracks which specific studyRow (qualification type row) within the group this qualification belongs to
  grade: z6.string().min(1, "Grade can't be empty").max(100, "Grade is too long."),
  graduationDate: z6.string().optional().refine(
    (val) => {
      if (!val) return true;
      const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
      const MIN_YEAR = currentYear - 130;
      const MAX_YEAR = currentYear + 50;
      const [year] = val.split("-");
      const graduationDateYear = year && year.length === 4 ? new Date(year).getFullYear() : void 0;
      return graduationDateYear && graduationDateYear > MIN_YEAR && graduationDateYear < MAX_YEAR;
    },
    { message: "Invalid date" }
  ),
  awardingOrganisationId: z6.string().optional(),
  awardingOrganisationLabel: z6.string().optional(),
  // Visibility flags from qualification type metadata (stored for future reference)
  awardingOrganisationVisible: z6.boolean().optional(),
  modulesVisible: z6.boolean().optional(),
  subjectsVisible: z6.boolean().optional(),
  modules: z6.array(ModuleSchema).optional()
}).superRefine((values, ctx) => {
  const { level, otherQualificationName } = values;
  if (level) {
    const isLevelOther = GradeLevel[level] === "Other" /* Other */;
    if (isLevelOther && typeof otherQualificationName === "string" && otherQualificationName.trim() === "") {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        message: "Qualification name is required",
        path: ["otherQualificationName"]
      });
    }
  }
});
var enhanceQualificationSchema = (date, _country) => {
  return QualificationSchema.superRefine((data, ctx) => {
    if (!date || !data.graduationDate) return;
    const startDate = new Date(date);
    const targetDate = new Date(data.graduationDate);
    const isDateValid = targetDate >= startDate;
    if (!isDateValid) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        message: `Qualification date must be after ${date}`,
        path: ["graduationDate"]
      });
    }
  });
};
var QualificationStep3Schema = z6.object({
  otherQualificationName: z6.string().nullish(),
  subject: z6.string().min(1, "Subject can't be empty").max(100, "Subject is too long."),
  gradeSystem: z6.string().optional(),
  gradeSystemLabel: z6.string().optional(),
  grade: z6.string().min(1, "Grade can't be empty").max(100, "Grade is too long."),
  graduationDate: z6.string().optional().refine(
    (val) => {
      if (!val) return true;
      const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
      const MIN_YEAR = currentYear - 130;
      const MAX_YEAR = currentYear + 50;
      const [year] = val.split("-");
      const graduationDateYear = year && year.length === 4 ? new Date(year).getFullYear() : void 0;
      return graduationDateYear && graduationDateYear > MIN_YEAR && graduationDateYear < MAX_YEAR;
    },
    { message: "Invalid date" }
  ),
  awardingOrganisationId: z6.string().min(1, "Please select an awarding organisation"),
  awardingOrganisationLabel: z6.string().optional(),
  modules: z6.array(ModuleSchema)
});
var enhanceQualificationStep3Schema = (date, _country) => {
  return QualificationStep3Schema.superRefine(
    (data, ctx) => {
      if (!date || !data.graduationDate) return;
      const startDate = new Date(date);
      const targetDate = new Date(data.graduationDate);
      const isDateValid = targetDate >= startDate;
      if (!isDateValid) {
        ctx.addIssue({
          code: z6.ZodIssueCode.custom,
          message: "Qualification date must be after your study start date",
          path: ["graduationDate"]
        });
      }
    }
  );
};
var StudySchema = z6.object({
  level: z6.nativeEnum(PreviousStudyLevel).optional(),
  resultStatus: z6.nativeEnum(ResultStatus),
  country: z6.string().min(1, `Country can't be empty`),
  institutionName: z6.string().min(1, "The name can't be empty"),
  institutionAddress: jsonParser(AddressSchema.omit({ country: true })),
  taughtInEnglish: z6.boolean().optional(),
  // Persist Step 2 multi-type selections for Highest Study revisit/prefill
  qualificationTypeSelections: z6.array(
    z6.object({
      id: z6.string().optional(),
      // unique identifier for this studyRow (to distinguish multiple rows with same qualificationType)
      qualificationType: z6.string(),
      qualificationTypeLabel: z6.string().optional(),
      customQualificationTypeName: z6.string().optional(),
      gradingSystem: z6.string(),
      gradingSystemLabel: z6.string().optional(),
      groupId: z6.string().optional(),
      resultStatus: z6.nativeEnum(ResultStatus).optional(),
      // Per-group result status
      taughtInEnglish: z6.boolean().optional()
      // Per-group taught in English
    })
  ).optional(),
  // Highest Study page does not collect study start/end dates yet.
  // Make them optional and validate only when provided.
  date: z6.string().optional().refine(
    (val) => {
      if (!val) return true;
      const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
      const MIN_YEAR = currentYear - 130;
      const MAX_YEAR = currentYear + 50;
      const [year, mm] = val.split("-");
      const isValidMonth = mm && mm.length === 2;
      const validDateYear = year && year.length === 4 ? new Date(year).getFullYear() : void 0;
      return !!validDateYear && validDateYear > MIN_YEAR && validDateYear < MAX_YEAR && isValidMonth;
    },
    { message: "Invalid date" }
  ),
  validUntil: z6.string().optional().refine(
    (val) => {
      if (!val) return true;
      const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
      const MIN_YEAR = currentYear - 130;
      const MAX_YEAR = currentYear + 50;
      const [year, mm] = val.split("-");
      const isValidMonth = mm && mm.length === 2;
      const validDateYear = year && year.length === 4 ? new Date(year).getFullYear() : void 0;
      return !!validDateYear && validDateYear > MIN_YEAR && validDateYear < MAX_YEAR && isValidMonth;
    },
    { message: "Invalid date" }
  ),
  academicTranscriptDocument: AttachDocumentSchema.optional(),
  qualifications: z6.record(z6.string(), QualificationSchema).optional()
}).superRefine((values, ctx) => {
  if (values.date) {
    const [startDateYear, startDateMonth] = values.date.split("-");
    if (startDateYear && startDateMonth && startDateYear.length === 4 && startDateMonth.length === 2) {
      const startDateObj = /* @__PURE__ */ new Date(`${startDateYear}-${startDateMonth}-01`);
      const today = /* @__PURE__ */ new Date();
      const todayFirstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      if (startDateObj > todayFirstOfMonth) {
        ctx.addIssue({
          code: z6.ZodIssueCode.custom,
          path: ["date"],
          message: "Start date cannot be in the future"
        });
      }
    }
  }
  if (values.date && values.validUntil) {
    if (new Date(values.date) >= new Date(values.validUntil)) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["date"],
        message: "Start date could not be later then the end date"
      });
    }
  }
  const stringHasContent = (str) => {
    return str !== void 0 && str.trim().length > 0;
  };
  if (values.institutionAddress.addressHasSubdivision) {
    if (!stringHasContent(values.institutionAddress.state) || !stringHasContent(values.institutionAddress.subdivisionCode)) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["institutionAddress", "state"],
        message: "Please select a valid state/province for the selected country"
      });
    }
  }
});
var AddUpdateStudyHistorySchema = z6.object({
  studyHisitoryId: z6.string().optional(),
  action: z6.enum(["ADD", "UPDATE", "REMOVE"]),
  studyHistory: StudySchema.optional()
});
var StudyHistorySchema = z6.object({
  highest: StudySchema.optional(),
  previous: z6.record(z6.string(), StudySchema).optional()
});
var ApplicantReferralSchema = z6.object({
  firstApplicationStatus: z6.nativeEnum(FirstApplicationStatus),
  ucasId: z6.string().optional(),
  referralSource: z6.nativeEnum(ReferralSource),
  studentReferrerName: z6.string().optional(),
  previousApplicationOrStudentNumber: z6.string().optional(),
  previousStudentNumber: z6.string().optional()
}).refine(
  (val) => {
    if (val.firstApplicationStatus === "FirstTime" /* FirstTime */) {
      return val.referralSource !== void 0;
    }
    return true;
  },
  {
    message: "Referral source is required for first-time applications",
    path: ["referralSource"]
  }
).refine(
  (val) => {
    if (val.firstApplicationStatus === "AppliedOnly" /* AppliedOnly */) {
      return val.previousApplicationOrStudentNumber !== void 0 && val.previousApplicationOrStudentNumber.trim() !== "";
    }
    return true;
  },
  {
    message: "Previous application number is required when you have applied before",
    path: ["previousApplicationOrStudentNumber"]
  }
).refine(
  (val) => {
    if (val.firstApplicationStatus === "StudiedBefore" /* StudiedBefore */) {
      return val.previousStudentNumber !== void 0 && val.previousStudentNumber.trim() !== "";
    }
    return true;
  },
  {
    message: "Previous student number is required when you have enrolled before",
    path: ["previousStudentNumber"]
  }
);
var OtherNameSchema = z6.object({
  givenName: z6.string().min(1),
  middleName: z6.string().optional(),
  familyName: z6.string().min(1),
  reason: z6.string().min(1)
});
var ApplicantIdentitySchema = z6.object({
  givenName: z6.string().regex(
    /^[a-zA-Z\s'-]+$/,
    `Use letters A\u2013Z only, plus spaces, hyphens (-) or apostrophes ('). Accents and special characters aren\u2019t supported`
  ).min(1, "Given name is required").max(128, "Given name is too long"),
  middleName: z6.string().regex(
    /^[a-zA-Z\s'-]*$/,
    `Use letters A\u2013Z only, plus spaces, hyphens (-) or apostrophes ('). Accents and special characters aren\u2019t supported`
  ).max(128, "Middle name is too long").nullish().optional(),
  familyName: z6.string().regex(
    /^[a-zA-Z\s'-]+$/,
    `Use letters A\u2013Z only, plus spaces, hyphens (-) or apostrophes ('). Accents and special characters aren\u2019t supported`
  ).max(128, "Family name is too long").min(1, "Family name is required"),
  title: z6.string().min(1),
  gender: z6.nativeEnum(Gender),
  genderIdentity: z6.nativeEnum(GenderIdentity).optional(),
  passport: PassportSchema.nullish(),
  idType: z6.nativeEnum(IDType),
  otherNames: z6.record(z6.string(), OtherNameSchema).nullish(),
  passportDocument: AttachDocumentSchema.optional(),
  idDocument: AttachDocumentSchema.optional()
});
var ApplicantIdentityValidationSchema = ApplicantIdentitySchema.extend({
  hasOtherName: z6.boolean(),
  otherNames: z6.array(OtherNameSchema).nullish()
}).refine(
  (values) => {
    const { hasOtherName, otherNames } = values;
    if (hasOtherName) {
      return (otherNames ?? []).length !== 0;
    }
    return true;
  },
  { message: "Add other name", path: ["otherNames"] }
);
var ApplicantIdentityValidationWithFiles = (_passportFiles, _idFiles, genderEnabled = false) => {
  return ApplicantIdentityValidationSchema.superRefine((data, ctx) => {
    if (genderEnabled && !data.genderIdentity) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        message: "Required",
        path: ["genderIdentity"]
      });
    }
  });
};
var OtherNamePayloadSchema = z6.object({
  otherName: OtherNameSchema
});
var OtherNamesSchema = z6.object({
  otherNames: z6.record(z6.string(), OtherNameSchema).nullish()
});
var DisiblityTypeSchema = z6.nativeEnum(DisabilityType);
var DiversitySchema = z6.object({
  ethnicity: z6.nativeEnum(Ethnicity),
  hasDisability: z6.boolean(),
  disabilityTypes: z6.array(DisiblityTypeSchema).nullish().default(null),
  hasBeenInCare: z6.boolean().nullish().default(null),
  careStartDate: z6.string().nullish().default(null).refine(
    (value) => {
      if (value === null) return true;
      const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
      const MIN_YEAR = currentYear - 130;
      const MAX_YEAR = currentYear + 50;
      const [year, date] = (value ?? "").split("-");
      const isValidDate = date && date.length === 2;
      const validDateYear = year && year.length === 4 ? new Date(year).getFullYear() : void 0;
      return validDateYear && validDateYear > MIN_YEAR && validDateYear < MAX_YEAR && isValidDate;
    },
    { message: "Invalid date" }
  ),
  careEndDate: z6.string().nullish().default(null).refine(
    (value) => {
      if (value === null) return true;
      const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
      const MIN_YEAR = currentYear - 130;
      const MAX_YEAR = currentYear + 50;
      const [year, date] = (value ?? "").split("-");
      const isValidDate = date && date.length === 2;
      const validDateYear = year && year.length === 4 ? new Date(year).getFullYear() : void 0;
      return validDateYear && validDateYear > MIN_YEAR && validDateYear < MAX_YEAR && isValidDate;
    },
    { message: "Invalid date" }
  ),
  careDetails: z6.string().nullish().default(null),
  occupation: z6.string().min(1, "Cannot be empty").nullish().default(null),
  disabilityTypeOther: z6.string().nullish().default(null),
  lastSchoolDescription: z6.string().nullish().default(null),
  hasParentsInHE: z6.boolean().nullish().default(null),
  isDisabilityStudentAllowance: z6.boolean().nullish().default(null)
});
var getDiversityValidationSchema = (isHomeStudent = false) => {
  const currentDate = /* @__PURE__ */ new Date();
  return DiversitySchema.refine(
    (values) => {
      const { hasBeenInCare, careStartDate, careEndDate } = values;
      if (hasBeenInCare) {
        if (!careStartDate || !careEndDate) {
          return true;
        }
        const startDate = new Date(careStartDate);
        const endDate = new Date(careEndDate);
        return startDate < currentDate && endDate < currentDate && startDate <= endDate;
      }
      return true;
    },
    {
      message: "Invalid care dates: start date and end date must be in the past, and start date should not be after end date.",
      path: ["careStartDate"]
    }
  ).superRefine((values, ctx) => {
    const {
      ethnicity,
      hasDisability,
      disabilityTypes = [],
      disabilityTypeOther,
      hasBeenInCare,
      careStartDate,
      careEndDate,
      careDetails
    } = values;
    const isEthnicityValid = !!ethnicity && typeof hasDisability === "boolean";
    if (!isEthnicityValid)
      ctx.addIssue({ code: z6.ZodIssueCode.custom, path: ["ethnicity"], message: "Please select an ethnicity" });
    const isDisabilityTypeValid = !hasDisability || hasDisability && disabilityTypes && disabilityTypes.length > 0;
    if (!isDisabilityTypeValid) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["disabilityTypes"],
        message: "Required"
      });
    }
    const isHealthConditionValid = !hasDisability || disabilityTypes && disabilityTypes.length && (!disabilityTypes.includes("A condition or impairment not listed" /* NotListed */) || !!disabilityTypeOther);
    if (!isHealthConditionValid)
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["disabilityTypeOther"],
        message: "Required"
      });
    const isInCareValid = typeof hasBeenInCare !== "boolean" || !hasBeenInCare || !!careStartDate && !!careEndDate && !!careDetails;
    if (!isInCareValid) {
      for (const field of ["careStartDate", "careEndDate", "careDetails"]) {
        if (values[field]) continue;
        ctx.addIssue({
          code: z6.ZodIssueCode.custom,
          path: [field],
          message: "Required"
        });
      }
    }
    const homeStudentFields = [
      "isDisabilityStudentAllowance",
      "hasBeenInCare",
      "lastSchoolDescription",
      "hasParentsInHE",
      "occupation"
    ];
    const everyHomeFieldNotEmpty = homeStudentFields.every((f) => {
      return values[f] !== null && values[f] !== void 0;
    });
    const isHomeStudentValid = !isHomeStudent || everyHomeFieldNotEmpty;
    if (!isHomeStudentValid) {
      for (const field of homeStudentFields) {
        if (values[field] !== null && values[field] !== void 0)
          continue;
        ctx.addIssue({
          code: z6.ZodIssueCode.custom,
          path: [field],
          message: "Required"
        });
      }
    }
    if (!isEthnicityValid || !isDisabilityTypeValid || !isHealthConditionValid || !isInCareValid || !isHomeStudentValid) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        message: "The form is not completed, please fill in all required fields"
      });
    }
  });
};
var OtherNationalitySchema = z6.object({
  isCurrent: z6.boolean(),
  nationality: z6.string()
});
var ResidenceEntrySchema = z6.object({
  countryOfResidence: z6.string(),
  description: z6.string().nullable(),
  areaOfResidence: z6.string().nullable(),
  entryIntoUKDate: z6.string().date().nullable()
}).refine(
  (values) => {
    if (values.countryOfResidence === "United Kingdom") {
      return !!values.description;
    }
    return true;
  },
  {
    message: "Description is required for UK residence.",
    path: ["description"]
  }
).refine(
  (values) => {
    if (values.countryOfResidence === "United Kingdom") {
      return !!values.entryIntoUKDate;
    }
    return true;
  },
  {
    message: "Date of entry into the UK is required.",
    path: ["entryIntoUKDate"]
  }
).refine(
  (values) => {
    if (values.countryOfResidence !== "United Kingdom") {
      return true;
    }
    const { entryIntoUKDate } = values;
    const [YYYY, MM, DD] = typeof entryIntoUKDate === "string" ? entryIntoUKDate.split("-") : "";
    return DD && MM && YYYY && DD.length === 2 && MM.length === 2 && YYYY.length === 4 && parseInt(DD) <= 31 && parseInt(MM) <= 12 && parseInt(YYYY) > 1900;
  },
  {
    message: "Date of entry into the UK is incomplete or invalid.",
    path: ["entryIntoUKDate"]
  }
).refine(
  (values) => {
    if (values.countryOfResidence !== "United Kingdom") {
      return true;
    }
    const { entryIntoUKDate } = values;
    const now = /* @__PURE__ */ new Date();
    const dob = new Date(typeof entryIntoUKDate === "string" ? entryIntoUKDate : "");
    return dob < now && dob.toDateString() !== now.toDateString();
  },
  {
    message: "Date of entry into the UK cannot be in the future or today",
    path: ["entryIntoUKDate"]
  }
).refine(
  (values) => {
    if (values.countryOfResidence === "United Kingdom") {
      return !!values.areaOfResidence;
    }
    return true;
  },
  {
    message: "Area of residence is required for UK residence.",
    path: ["areaOfResidence"]
  }
);
var OtherResidenceEntrySchema = z6.object({
  countryOfResidence: z6.string(),
  yearOfResidence: z6.number()
}).refine(
  (values) => {
    const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
    return values.yearOfResidence <= currentYear;
  },
  {
    message: "Year of residence cannot be in the future",
    path: ["yearOfResidence"]
  }
).refine(
  (values) => {
    return values.yearOfResidence >= 1900 && values.yearOfResidence.toString().length === 4;
  },
  {
    message: "Please enter a valid 4-digit year (1900 or later)",
    path: ["yearOfResidence"]
  }
);
var NationalitySchema = z6.object({
  applyingFrom: z6.string(),
  countryOfBirth: z6.string(),
  nationalityForApplicationPurposes: z6.string(),
  isOnlyCountry: z6.boolean(),
  isOtherResidence: z6.boolean(),
  otherNationalities: z6.array(OtherNationalitySchema).nullish(),
  primaryResidence: ResidenceEntrySchema,
  otherResidences: z6.array(OtherResidenceEntrySchema).nullish(),
  statementsCorrect: z6.boolean()
}).refine(
  (values) => {
    const { isOnlyCountry, otherNationalities } = values;
    if (isOnlyCountry) return otherNationalities && otherNationalities.length > 0;
    return true;
  },
  { message: "Other nationalities cannot be left empty", path: ["isOnlyCountry"] }
).refine(
  (values) => {
    const { isOtherResidence, otherResidences } = values;
    if (isOtherResidence) return otherResidences && otherResidences.length > 0;
    return true;
  },
  { message: "Other residences cannot be left empty", path: ["isOtherResidence"] }
);
var EmploymentHistorySchema = employmentAddressSchema.extend({
  jobTitle: z6.string().min(1),
  employerName: z6.string().min(1),
  type: z6.nativeEnum(EmploymentType),
  startDate: z6.string().refine(
    (value) => {
      const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
      const MIN_YEAR = currentYear - 130;
      const MAX_YEAR = currentYear + 50;
      const [year, date] = value.split("-");
      const isValidDate = date && date.length === 2;
      const validDateYear = year && year.length === 4 ? new Date(year).getFullYear() : void 0;
      return validDateYear && validDateYear > MIN_YEAR && validDateYear < MAX_YEAR && isValidDate;
    },
    { message: "Invalid date" }
  ),
  endDate: z6.string().refine(
    (value) => {
      if (value === void 0 || value === "") return true;
      const [year] = value.split("-");
      if (year === void 0 || year === "") return true;
      const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
      const MIN_YEAR = currentYear - 130;
      const MAX_YEAR = currentYear + 50;
      const validDateYear = year && year.length === 4 ? new Date(year).getFullYear() : void 0;
      return validDateYear && validDateYear > MIN_YEAR && validDateYear < MAX_YEAR;
    },
    { message: "Invalid year" }
  ).optional()
}).superRefine((values, ctx) => {
  if (values.endDate) {
    if (new Date(values.startDate) >= new Date(values.endDate)) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["endDate"],
        message: "End Date could not be earlier than the Start Date"
      });
    }
  }
  const stringHasContent = (str) => {
    return str !== void 0 && str.trim().length > 0;
  };
  if (values.addressHasSubdivision) {
    if (!stringHasContent(values.subdivisionCode) || !stringHasContent(values.state)) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["state"],
        message: "Please select a valid state/province for the selected country"
      });
    }
  }
}).superRefine((values, ctx) => {
  const { country, state, addressHasSubdivision, subdivisionCode } = values;
  const stringHasContent = (str) => {
    return !!(str && typeof str === "string" && str.trim().length > 0);
  };
  if (addressHasSubdivision && (!stringHasContent(subdivisionCode) || !stringHasContent(state))) {
    ctx.addIssue({
      code: z6.ZodIssueCode.custom,
      path: ["state"],
      message: "State/Province is required for the selected country"
    });
  }
  if (country === "United Kingdom" && !stringHasContent(state)) {
    ctx.addIssue({
      code: z6.ZodIssueCode.custom,
      path: ["state"],
      message: "UK addresses require a county"
    });
  }
});
var ApplicantEmploymentSchema = z6.object({
  hasEmploymentHistory: z6.boolean(),
  hasCV: z6.boolean().optional(),
  employmentHistory: z6.array(EmploymentHistorySchema).nullish(),
  cvDocument: AttachDocumentSchema.optional()
});
var EnglishTestTakenBaseSchema = z6.object({
  hasTakenTest: z6.literal(true),
  type: z6.nativeEnum(EnglishTestType),
  typeOther: z6.string().optional(),
  referenceNo: z6.string(),
  score: z6.string(),
  date: z6.string().min(1, "English test date is required").refine(
    (value) => {
      const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
      const MIN_YEAR = currentYear - 130;
      const MAX_YEAR = currentYear;
      const [year, date] = value.split("-");
      const isValidDate = date && date.length === 2;
      const validDateYear = year && year.length === 4 ? new Date(year).getFullYear() : void 0;
      return validDateYear && validDateYear > MIN_YEAR && validDateYear <= MAX_YEAR && isValidDate;
    },
    { message: "Invalid date" }
  ),
  validUntil: z6.string().optional().refine(
    (value) => {
      if (!value) return true;
      const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
      const MIN_YEAR = currentYear - 130;
      const MAX_YEAR = currentYear + 50;
      const [year, date] = value.split("-");
      const isValidDate = date && date.length === 2;
      const validDateYear = year && year.length === 4 ? new Date(year).getFullYear() : void 0;
      return validDateYear && validDateYear > MIN_YEAR && validDateYear <= MAX_YEAR && isValidDate;
    },
    { message: "Invalid date" }
  )
});
var EnglishTestNotTakenBaseSchema = z6.object({
  hasTakenTest: z6.literal(false),
  reasonNotReqd: z6.nativeEnum(EnglishTestNotReqdReason),
  reasonNotReqdOther: z6.string().optional()
});
var EnglishTestBaseUnion = z6.discriminatedUnion("hasTakenTest", [
  EnglishTestTakenBaseSchema,
  EnglishTestNotTakenBaseSchema
]);
var EnglishTestSchema = EnglishTestBaseUnion.superRefine((data, ctx) => {
  if (data.hasTakenTest) {
    const { type, typeOther, score, referenceNo, date, validUntil } = data;
    if (!score || score.trim() === "") {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["score"],
        message: "Test score is required"
      });
    }
    if (!referenceNo || referenceNo.trim() === "") {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["referenceNo"],
        message: "Reference number is required"
      });
    }
    if (type === "Other" /* Other */ && (!typeOther || typeOther.trim() === "")) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["typeOther"],
        message: "Please specify the name of the English test"
      });
    }
    if (date) {
      const [year, month] = date.split("-");
      if (year && month) {
        const testDate = new Date(date);
        const today = /* @__PURE__ */ new Date();
        if (testDate > today) {
          ctx.addIssue({
            code: z6.ZodIssueCode.custom,
            path: ["date"],
            message: "The English Test Date cannot be later than today"
          });
        }
      }
    }
    if (date && validUntil) {
      const [testYear, testMonth] = date.split("-");
      const [validYear, validMonth] = validUntil.split("-");
      if (testYear && testMonth && validYear && validMonth) {
        const testDate = /* @__PURE__ */ new Date(`${testYear}-${testMonth}-01`);
        const validUntilDate = /* @__PURE__ */ new Date(`${validYear}-${validMonth}-01`);
        if (testDate > validUntilDate) {
          ctx.addIssue({
            code: z6.ZodIssueCode.custom,
            path: ["validUntil"],
            message: "The Valid Until date cannot be earlier than the Test Date."
          });
        }
      }
    }
  } else if (data.hasTakenTest === false) {
    const { reasonNotReqd, reasonNotReqdOther } = data;
    if (reasonNotReqd === "Other/I don\u2019t know" /* Other */ && (!reasonNotReqdOther || reasonNotReqdOther.trim() === "")) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        message: "Please provide an explanation",
        path: ["reasonNotReqdOther"]
      });
    }
  }
});
var EnglishTestTakenSchema = EnglishTestTakenBaseSchema;
var EnglishTestNotTakenSchema = EnglishTestNotTakenBaseSchema;
var EnglishSchema = z6.object({
  hasEnglishTest: z6.boolean(),
  englishTest: EnglishTestSchema,
  reasonNotReqd: z6.nativeEnum(EnglishTestNotReqdReason).optional().nullish(),
  reasonNotReqdOther: z6.string().optional().nullish(),
  englishQualification: z6.string().optional().nullish(),
  englishTestDocument: AttachDocumentSchema.optional()
}).superRefine((data, ctx) => {
  if (data.englishTest.hasTakenTest !== data.hasEnglishTest) {
    ctx.addIssue({
      code: z6.ZodIssueCode.custom,
      message: "English test status mismatch",
      path: ["englishTest"]
    });
  }
  if (!data.hasEnglishTest) {
    if (!data.reasonNotReqd) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        message: "Please select a reason why an English test is not required",
        path: ["reasonNotReqd"]
      });
    }
    if (data.reasonNotReqd === "My English can be assessed based on my previous academic qualification" /* PrevQual */ && !data.englishQualification) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        message: "Please select a qualification",
        path: ["englishQualification"]
      });
    }
    if (data.reasonNotReqd === "Other/I don\u2019t know" /* Other */ && (!data.reasonNotReqdOther || data.reasonNotReqdOther.trim() === "")) {
      ctx.addIssue({
        code: z6.ZodIssueCode.custom,
        message: "Please provide an explanation",
        path: ["reasonNotReqdOther"]
      });
    }
  }
});
var ContactDetailsSchema = z6.object({
  residentialAddress: jsonParser(AddressSchema).nullish(),
  residentialPhoneNo: PhoneNumberSchema,
  contactAddressSameAsResidential: z6.boolean(),
  contactAddress: jsonParser(AddressSchema.nullish()),
  termAddressSameAsPermanent: z6.boolean().nullish().optional(),
  termAddress: jsonParser(AddressSchema.omit({ country: true }).nullish()),
  hasUkAccommodation: z6.boolean().nullish().optional(),
  ukAccommodationType: z6.string().refine((val) => val in UkAccommodationType).nullish(),
  ukAccommodationAddress: jsonParser(AddressSchema.omit({ country: true }).nullish()),
  ukAccommodationPhone: PhoneNumberSchema.nullish()
}).superRefine((data, ctx) => {
  if (data.residentialAddress?.addressHasSubdivision) {
    if (!data.residentialAddress.subdivisionCode || !data.residentialAddress.state) {
      ctx.addIssue({
        code: "custom",
        path: ["residentialAddress", "state"],
        message: "State/Province is required for the selected country"
      });
    }
  }
  const stringHasContent = (str) => {
    return str !== void 0 && str.trim().length > 0;
  };
  if (data.contactAddress?.addressHasSubdivision) {
    if (!stringHasContent(data.contactAddress.subdivisionCode) || !stringHasContent(data.contactAddress.state)) {
      ctx.addIssue({
        code: "custom",
        path: ["contactAddress", "state"],
        message: "State/Province is required for the selected country"
      });
    }
  }
  if (data.termAddress?.addressHasSubdivision) {
    if (!stringHasContent(data.termAddress.subdivisionCode) || !stringHasContent(data.termAddress.state)) {
      ctx.addIssue({
        code: "custom",
        path: ["termAddress", "state"],
        message: "State/Province is required for the selected country"
      });
    }
  }
  if (data.ukAccommodationAddress?.addressHasSubdivision) {
    ctx.addIssue({
      code: "custom",
      path: ["ukAccommodationAddress", "state"],
      message: "UK accomodation does not require a state/province subdivision"
    });
  }
  if (data.contactAddressSameAsResidential === false && !data.contactAddress) {
    ctx.addIssue({
      code: "custom",
      path: ["contactAddress"],
      message: "Contact address is required when contact address is different"
    });
  }
  if (data.termAddressSameAsPermanent === false && !data.termAddress) {
    ctx.addIssue({
      code: "custom",
      path: ["termAddress"],
      message: "Term address is required when term address is different then permanent address"
    });
  }
  if (data.termAddressSameAsPermanent === false && !data.ukAccommodationType) {
    ctx.addIssue({
      code: "custom",
      path: ["ukAccommodationType"],
      message: "Accomodation type is required"
    });
  }
  if (data.termAddressSameAsPermanent === true && data.termAddress) {
    ctx.addIssue({
      code: "custom",
      path: ["termAddress"],
      message: "Term address should not be provided when it is the same as permanent address"
    });
  }
  if (data.hasUkAccommodation === false && data.ukAccommodationAddress) {
    ctx.addIssue({
      code: "custom",
      path: ["ukAccommodationAddress"],
      message: "UK accommodation address should not be provided when you do not have UK accommodation"
    });
  }
  if (data.hasUkAccommodation) {
    if (!data.ukAccommodationType) {
      ctx.addIssue({
        code: "custom",
        path: ["ukAccommodationType"],
        message: "Accomodation type is required"
      });
    }
    if (!data.ukAccommodationAddress) {
      ctx.addIssue({
        code: "custom",
        path: ["ukAccommodationAddress"],
        message: "Accomodation address is required"
      });
    }
    if (!data.ukAccommodationPhone) {
      ctx.addIssue({
        code: "custom",
        path: ["ukAccommodationPhone"],
        message: "Phone number is required"
      });
    }
  }
  if (data.contactAddress && data.contactAddress.country === "United Kingdom") {
    if (!stringHasContent(data.contactAddress.state)) {
      ctx.addIssue({
        code: "custom",
        path: ["contactAddress", "state"],
        message: "A UK county is required for the contact address"
      });
    }
  }
  if (data.residentialAddress && data.residentialAddress.country === "United Kingdom") {
    if (!stringHasContent(data.residentialAddress.state)) {
      ctx.addIssue({
        code: "custom",
        path: ["residentialAddress", "state"],
        message: "A UK county is required for the residential address"
      });
    }
  }
  if (data.ukAccommodationAddress) {
    if (!stringHasContent(data.ukAccommodationAddress.state)) {
      ctx.addIssue({
        code: "custom",
        path: ["ukAccommodationAddress", "state"],
        message: "A UK county is required for the UK accommodation address"
      });
    }
  }
  if (data.termAddress) {
    if (!stringHasContent(data.termAddress.state)) {
      ctx.addIssue({
        code: "custom",
        path: ["termAddress", "state"],
        message: "A UK county is required for the term address"
      });
    }
  }
});
var enhanceContactDetailsSchema = (schema, feeStatus) => {
  return schema.superRefine((data, ctx) => {
    if (feeStatus === "HOME" /* Home */) {
      if (data.termAddressSameAsPermanent === void 0) {
        ctx.addIssue({
          code: "custom",
          path: ["termAddressSameAsPermanent"],
          message: "Required"
        });
      }
    } else if (feeStatus && ["NOT_SURE" /* NotSure */, "OVERSEAS" /* Overseas */].includes(feeStatus)) {
      if (data.hasUkAccommodation === void 0) {
        ctx.addIssue({
          code: "custom",
          path: ["hasUkAccommodation"],
          message: "Required"
        });
      }
    }
  });
};
var VisaNotListedOption = z6.object({
  visaNotListedCustomValue: z6.string().nullish()
});
var UkStudentVisaSchema = z6.object({
  studentVisaType: z6.string().refine((val) => val in VisaType),
  levelOfStudy: z6.string().refine((val) => val in VisaLevelOfStudy),
  visaReceivedYear: z6.number().gt(1900).lte((/* @__PURE__ */ new Date()).getFullYear()),
  isCourseCompleted: z6.boolean(),
  compareCourse: z6.string().refine((val) => val in CourseCompare)
}).merge(VisaNotListedOption);
var UkNonStudentVisasSchema = z6.object({
  studentVisaType: z6.string().refine((val) => val in VisaOrPermitType),
  issuedDate: z6.string().date("Date format is DD MM YYYY").refine(
    (val) => {
      const [YYYY, MM, DD] = val.split("-");
      return DD && MM && YYYY && DD.length === 2 && MM.length === 2 && YYYY.length === 4 && parseInt(DD) <= 31 && parseInt(MM) <= 12 && parseInt(YYYY) > 1900;
    },
    { message: "Issue date is incomplete or invalid." }
  ).refine(
    (val) => {
      const now = /* @__PURE__ */ new Date();
      const issueDate = new Date(val);
      return issueDate < now && issueDate.toDateString() !== now.toDateString();
    },
    { message: "Issue date cannot be in the future or today" }
  ),
  validTill: z6.string().optional().refine(
    (val) => {
      if (!val || val.trim() === "") return true;
      const [YYYY, MM, DD] = val.split("-");
      return DD && MM && YYYY && DD.length === 2 && MM.length === 2 && YYYY.length === 4 && parseInt(DD) <= 31 && parseInt(MM) <= 12 && parseInt(YYYY) > 1900;
    },
    { message: "Valid until date is incomplete or invalid." }
  ).refine(
    (val) => {
      if (!val || val.trim() === "") return true;
      const date = new Date(val);
      const [inputYear, inputMonth, inputDay] = val.split("-").map(Number);
      return !isNaN(date.getTime()) && date.getFullYear() === inputYear && date.getMonth() + 1 === inputMonth && date.getDate() === inputDay;
    },
    { message: "Please enter a valid date." }
  )
}).merge(VisaNotListedOption).superRefine((data, ctx) => {
  const issuedDate = new Date(data.issuedDate);
  const validTill = data.validTill ? new Date(data.validTill) : null;
  if (validTill && issuedDate > validTill) {
    ctx.addIssue({
      code: "custom",
      path: ["issuedDate"],
      message: "Issued date should be less than valid till date"
    });
  }
  if (VisaOrPermitType[data.studentVisaType] === "My visa or permit are not listed" /* VisaNotListed */) {
    if (!data.visaNotListedCustomValue || data.visaNotListedCustomValue.trim().length < 1) {
      ctx.addIssue({
        code: "custom",
        path: ["visaNotListedCustomValue"],
        message: `Custom visa or permit type is required when student visa type is "${"My visa or permit are not listed" /* VisaNotListed */}"`
      });
    }
  }
});
var UkVisaRefusalSchema = z6.object({
  refusedVisaType: z6.string().refine((data) => data in RefusedVisaType),
  visaRefusalYear: z6.number({ invalid_type_error: "Must be a number" }).min(1900).max((/* @__PURE__ */ new Date()).getFullYear())
});
var NonUkVisaRefusalSchema = z6.object({
  visaRefusalCountry: z6.string(),
  isStudentVisaRefused: z6.boolean(),
  visaRefusalYear: z6.number({ invalid_type_error: "Must be a number" }).min(1900).max((/* @__PURE__ */ new Date()).getFullYear())
});
function isBritishOrIrish(nationalityForApplicationPurposes) {
  return nationalityForApplicationPurposes === "British" || nationalityForApplicationPurposes === "Irish";
}
function isEmptyOrNonExistentArray(arr) {
  return !arr || !Array.isArray(arr) || arr.length === 0;
}
var VisaHistorySchema = z6.object({
  isVisaRequired: z6.boolean().nullish(),
  //Overseas
  visaExemptionReason: z6.string().nullish(),
  //Overseas
  hasVisaForCurrentOrPreviousUkStudy: z6.boolean().nullish(),
  //Overseas
  hasStudentVisaForThisUkStudy: z6.boolean().nullish(),
  //Overseas
  ukStudentVisas: z6.array(UkStudentVisaSchema).nullish(),
  //Overseas
  hasEuEeaSwitzerlandExperience: z6.boolean().nullish(),
  //ALL (HOME AND Overseas and British or Irish)
  hasEuFamilyMember: z6.boolean().nullish(),
  //ALL (HOME AND Overseas and British or Irish)
  hasNonStudentVisaOrPermit: z6.boolean().nullish(),
  // HOME (non British or Irish) AND Overseas
  ukNonStudentVisaOrPermit: z6.array(UkNonStudentVisasSchema).nullish(),
  // HOME (non British or Irish) AND Overseas
  hasPreviousVisaRefusal: z6.boolean().nullish(),
  //Overseas
  ukVisaRefusals: z6.array(UkVisaRefusalSchema).nullish(),
  //Overseas
  hasPreviousNonUkVisaRefusal: z6.boolean().nullish(),
  //Overseas
  nonUkVisaRefusals: z6.array(NonUkVisaRefusalSchema).nullish()
  //Overseas
}).superRefine((data, ctx) => {
  const validationRules = [
    {
      condition: data.isVisaRequired === false && !data.visaExemptionReason,
      path: "visaExemptionReason",
      message: "Specify visa not required reason"
    },
    {
      condition: data.hasStudentVisaForThisUkStudy && isEmptyOrNonExistentArray(data.ukStudentVisas),
      path: "ukStudentVisas",
      message: "Specify your current or previous UK study visas"
    },
    {
      condition: data.hasNonStudentVisaOrPermit && isEmptyOrNonExistentArray(data.ukNonStudentVisaOrPermit),
      path: "ukNonStudentVisaOrPermit",
      message: "Specify your UK permit or non-student visas"
    },
    {
      condition: data.hasPreviousVisaRefusal && isEmptyOrNonExistentArray(data.ukVisaRefusals),
      path: "ukVisaRefusals",
      message: "Specify if visa is required"
    },
    {
      condition: data.hasPreviousNonUkVisaRefusal && isEmptyOrNonExistentArray(data.nonUkVisaRefusals),
      path: "nonUkVisaRefusals",
      message: "Specify your non-UK visa refusals"
    },
    {
      condition: data.hasEuEeaSwitzerlandExperience === void 0,
      path: "hasEuEeaSwitzerlandExperience",
      message: "Required"
    },
    {
      condition: data.hasEuFamilyMember === void 0,
      path: "hasEuFamilyMember",
      message: "Required"
    }
  ];
  validationRules.forEach((rule) => {
    if (rule.condition) {
      ctx.addIssue({
        code: "custom",
        path: [rule.path],
        message: rule.message
      });
    }
  });
});
function enhanceVisaHistorySchema(feeStatus, nationalityForApplicationPurposes) {
  return VisaHistorySchema.superRefine((data, ctx) => {
    if (!isBritishOrIrish(nationalityForApplicationPurposes)) {
      if (typeof data.hasNonStudentVisaOrPermit !== "boolean") {
        ctx.addIssue({
          code: "custom",
          path: ["hasNonStudentVisaOrPermit"],
          message: "Specify your UK permit or non-student visas"
        });
      }
    }
    if (feeStatus === "OVERSEAS" /* Overseas */) {
      const requiredFields = [
        "isVisaRequired",
        "hasVisaForCurrentOrPreviousUkStudy",
        "hasPreviousVisaRefusal",
        "hasPreviousNonUkVisaRefusal"
      ];
      requiredFields.forEach((field) => {
        const fieldValue = data[field];
        if (fieldValue === null || fieldValue === void 0) {
          ctx.addIssue({
            code: "custom",
            path: [field],
            message: "This field is required"
          });
        }
      });
    }
    if (data.hasVisaForCurrentOrPreviousUkStudy && typeof data.hasStudentVisaForThisUkStudy !== "boolean") {
      ctx.addIssue({
        code: "custom",
        path: ["hasStudentVisaForThisUkStudy"],
        message: "This field is required"
      });
    }
  });
}
var GradingSystemSchema = z6.object({
  id: z6.number(),
  label: z6.string()
});
var QualificationTypesSchema = z6.object({
  id: z6.number(),
  label: z6.string(),
  awardingOrganisationsVisible: z6.boolean(),
  modulesVisible: z6.boolean(),
  subjectsVisible: z6.boolean(),
  gradingSystems: z6.array(GradingSystemSchema)
});
var AwardingOrganisationSchema = z6.object({
  id: z6.number(),
  label: z6.string(),
  acronym: z6.string()
});
var StudentDuplicateSchema = z6.object({
  uni: z6.string(),
  userId: z6.string(),
  applicationId: z6.string(),
  isDuplicate: z6.boolean(),
  studentNo: z6.string().optional()
});
var ApplicantDetailsSchema = z6.object({
  givenName: z6.string().min(1, "Given name is required").max(100, "Given name is too long"),
  middleName: z6.string().optional(),
  familyName: z6.string().min(1, "Family name is required").max(100, "Family name is too long"),
  email: z6.string().email("Please enter a valid email address"),
  nationality: z6.string().min(1, "Nationality is required"),
  feeStatus: z6.nativeEnum(FeeStatus),
  highestQualificationCode: z6.string().optional(),
  agentId: z6.string().min(1, "Agent selection is required"),
  isVisaRequired: z6.boolean().optional(),
  dob: z6.string().date().refine(
    (val) => {
      const [YYYY, MM, DD] = val.split("-");
      return DD && MM && YYYY && DD.length === 2 && MM.length === 2 && YYYY.length === 4 && parseInt(DD) <= 31 && parseInt(MM) <= 12 && parseInt(YYYY) > 1900;
    },
    { message: "Date of birth is incomplete or invalid." }
  ).refine(
    (val) => {
      const now = /* @__PURE__ */ new Date();
      const dob = new Date(val);
      return dob < now && dob.toDateString() !== now.toDateString();
    },
    { message: "Date of birth cannot be in the future or today" }
  ).refine(
    (val) => {
      const [year, month, day] = val.split("-").map(Number);
      const today = /* @__PURE__ */ new Date();
      const todayMonth = today.getMonth() + 1;
      const age = today.getFullYear() - year - (todayMonth < month || todayMonth === month && today.getDate() < day ? 1 : 0);
      return age > 13;
    },
    { message: "Must be older than 13 years old." }
  ),
  phoneNumber: z6.string().includes("-").min(2).regex(/^\d+(-\d+)*$/, "Invalid phone number.")
});

// src/apply/application/index.ts
import { z as z7 } from "zod";
var FundingPlanSchema = z7.object({
  primaryFundingSource: z7.nativeEnum(FundingOption),
  otherSourceOfFunding: z7.string().nullish(),
  isSLCGrant: z7.boolean().nullish(),
  isSLCLoan: z7.boolean().nullish(),
  isPlanningToWork: z7.boolean()
});
function enhanceFundingPlanSchema(feeStatus, fieldVisibility = {}) {
  const {
    disableTuitionFeeQuestion = false,
    disableMaintenanceQuestion = false,
    disableWorkQuestion = false
  } = fieldVisibility;
  let fundingSchema = FundingPlanSchema;
  if (feeStatus === "HOME" /* Home */ && !disableTuitionFeeQuestion && !disableMaintenanceQuestion && !disableWorkQuestion) {
    fundingSchema = z7.object({
      primaryFundingSource: z7.nativeEnum(FundingOption),
      otherSourceOfFunding: z7.string().nullish(),
      isSLCGrant: z7.boolean(),
      isSLCLoan: z7.boolean(),
      isPlanningToWork: z7.boolean()
    });
  } else if (fieldVisibility.disableTuitionFeeQuestion || fieldVisibility.disableMaintenanceQuestion || fieldVisibility.disableWorkQuestion) {
    const schemaShape = {
      primaryFundingSource: z7.nativeEnum(FundingOption),
      otherSourceOfFunding: z7.string().nullish()
    };
    if (feeStatus === "HOME" /* Home */) {
      schemaShape.isSLCGrant = disableTuitionFeeQuestion ? z7.boolean().nullish() : z7.boolean();
      schemaShape.isSLCLoan = disableMaintenanceQuestion ? z7.boolean().nullish() : z7.boolean();
    } else {
      schemaShape.isSLCGrant = z7.boolean().nullish();
      schemaShape.isSLCLoan = z7.boolean().nullish();
    }
    schemaShape.isPlanningToWork = disableWorkQuestion ? z7.boolean().nullish() : z7.boolean();
    fundingSchema = z7.object(schemaShape);
  }
  return fundingSchema.superRefine((data, ctx) => {
    const { primaryFundingSource } = data;
    if (primaryFundingSource === "Other" /* Other */) {
      if (!data.otherSourceOfFunding?.trim?.()?.length) {
        ctx.addIssue({
          code: "custom",
          path: ["otherSourceOfFunding"],
          message: "Description of other source of funding is required"
        });
      }
    }
    return true;
  });
}
var PersonalStatementSchema = z7.object({
  hasPersonalStatementDocument: z7.boolean(),
  personalStatementDocument: AttachDocumentSchema.optional()
});
var PersonalStatementSchemaWithDependencies = (fileNames) => {
  return PersonalStatementSchema.superRefine((data, ctx) => {
    if (data.hasPersonalStatementDocument) {
      const hasFiles = fileNames && fileNames.length > 0;
      if (!hasFiles) {
        ctx.addIssue({
          code: z7.ZodIssueCode.custom,
          message: "Personal statement file is required.",
          path: ["fileUpload"]
        });
      }
    }
  });
};
var ResearchProposalSchema = z7.object({
  hasResearchProposalDocument: z7.boolean(),
  researchProposalDocument: AttachDocumentSchema.optional()
});
var ResearchProposalSchemaWithDependencies = (fileNames) => {
  return ResearchProposalSchema.superRefine((data, ctx) => {
    if (data.hasResearchProposalDocument) {
      const hasFiles = fileNames && fileNames.length > 0;
      if (!hasFiles) {
        ctx.addIssue({
          code: z7.ZodIssueCode.custom,
          message: "Research proposal file is required.",
          path: ["fileUpload"]
        });
      }
    }
  });
};
var createFileValidationSchema = (baseSchema, fileRequiredField, errorMessage, errorPath = ["fileUpload"]) => {
  return (fileNames) => {
    return baseSchema.superRefine((data, ctx) => {
      if (data[fileRequiredField]) {
        const hasFiles = fileNames && fileNames.length > 0;
        if (!hasFiles) {
          ctx.addIssue({
            code: z7.ZodIssueCode.custom,
            message: errorMessage,
            path: errorPath
          });
        }
      }
    });
  };
};
var RefereeSchema = AddressSchema.extend({
  name: z7.string().min(1, "Name can't be empty"),
  email: z7.string().email(),
  phone: PhoneNumberSchema,
  relationship: z7.nativeEnum(ApplicationRefereeRelation, { message: "Please provide the value" }),
  otherRelationshipDetails: z7.string().optional(),
  organisation: z7.string().min(1, "Organisation can't be empty"),
  occupation: z7.string().min(1, "Occupation can't be empty"),
  yearsKnown: z7.number()
}).superRefine((data, ctx) => {
  if (data.relationship === "Other" /* Other */ && !data.otherRelationshipDetails) {
    ctx.addIssue({
      code: "custom",
      path: ["otherRelationshipDetails"],
      message: "Other Relationship details are required"
    });
  }
  const stringHasContent = (str) => {
    return str !== void 0 && str.trim().length > 0;
  };
  if (data.addressHasSubdivision && (!stringHasContent(data.subdivisionCode) || !stringHasContent(data.state))) {
    ctx.addIssue({
      code: "custom",
      path: ["state"],
      message: "State/Province is required when the address has a subdivision"
    });
  }
  if (data.country === "United Kingdom") {
    if (!stringHasContent(data.state)) {
      ctx.addIssue({
        code: "custom",
        path: ["state"],
        message: "County is required for United Kingdom addresses"
      });
    }
  }
});
var ReferencesSchema = z7.object({
  hasReferee: z7.boolean(),
  references: z7.array(RefereeSchema).nullish(),
  referenceLetterDocument: AttachDocumentSchema.optional()
});
var ReferencesSchemaWithFiles = (_fileNames) => {
  return ReferencesSchema.superRefine((_data, _ctx) => {
  });
};
var ApplicantEmploymentSchemaWithFiles = (fileNames) => {
  return ApplicantEmploymentSchema.superRefine((data, ctx) => {
    if (data.hasCV) {
      const hasFiles = fileNames && fileNames.length > 0;
      const hasEmploymentHistory = data.employmentHistory && data.employmentHistory.length > 0;
      const hasEnteredData = hasFiles || hasEmploymentHistory;
      if (!hasEnteredData) {
        ctx.addIssue({
          code: z7.ZodIssueCode.custom,
          message: "CV file is required when CV option is selected.",
          path: ["fileUpload"]
        });
      }
    }
  });
};
var EnglishSchemaWithFiles = (_fileNames) => {
  return EnglishSchema.superRefine((_data, _ctx) => {
  });
};
var AgentSchema = z7.object({
  name: z7.string().nullish(),
  agency: z7.string().nullish(),
  email: z7.string().email().nullish()
});
var OtherPresentative = z7.object({
  relation: z7.string().nullish(),
  name: z7.string().nullish()
});
var RepresentationSchema = z7.object({
  hasRepresentative: z7.boolean({
    required_error: "Please select whether anyone is helping you submit your application"
  }),
  isHelpedByAgent: z7.boolean().optional(),
  isHelpedByFamilyMember: z7.boolean().optional(),
  isHelpedByFriend: z7.boolean().optional(),
  isHelpedBySchoolCounsellor: z7.boolean().optional(),
  isHelpedByTeacher: z7.boolean().optional(),
  isHelpedByStudent: z7.boolean().optional(),
  isHelpedByOther: z7.boolean().optional(),
  studentName: z7.string().nullish(),
  teacherName: z7.string().nullish(),
  schoolCounsellorName: z7.string().nullish(),
  friendName: z7.string().nullish(),
  familyMemberName: z7.string().nullish(),
  consent: z7.boolean().nullish(),
  agent: AgentSchema.nullish(),
  otherPresentative: OtherPresentative.nullish()
}).superRefine((data, ctx) => {
  if (data.hasRepresentative === true) {
    const helpOptions = [
      data.isHelpedByAgent,
      data.isHelpedByFamilyMember,
      data.isHelpedByFriend,
      data.isHelpedBySchoolCounsellor,
      data.isHelpedByTeacher,
      data.isHelpedByStudent,
      data.isHelpedByOther
    ];
    if (!helpOptions.some((option) => option === true)) {
      ctx.addIssue({
        code: "custom",
        path: ["representationType"],
        message: "At least one representation type must be selected"
      });
    }
    if (helpOptions.some((option) => option === true) && data?.consent === void 0) {
      ctx.addIssue({
        code: "custom",
        path: ["consent"],
        message: "Consent is required"
      });
    }
  }
  const validationRules = [
    {
      condition: data.isHelpedByAgent && !data.agent?.name,
      path: "agent.name",
      message: "Agent name is required"
    },
    {
      condition: data.isHelpedByAgent && !data.agent?.email,
      path: "agent.email",
      message: "Agent email is required"
    },
    {
      condition: data.isHelpedByAgent && !data.agent?.agency,
      path: "agent.agency",
      message: "Agent agency is required"
    },
    {
      condition: data.isHelpedByFamilyMember && !data.familyMemberName,
      path: "familyMemberName",
      message: "Family member name is required"
    },
    {
      condition: data.isHelpedByFriend && !data.friendName,
      path: "friendName",
      message: "Friend name is required"
    },
    {
      condition: data.isHelpedBySchoolCounsellor && !data.schoolCounsellorName,
      path: "schoolCounsellorName",
      message: "School counsellor name is required"
    },
    {
      condition: data.isHelpedByTeacher && !data.teacherName,
      path: "teacherName",
      message: "Teacher name is required"
    },
    {
      condition: data.isHelpedByStudent && !data.studentName,
      path: "studentName",
      message: "Student name is required"
    },
    {
      condition: data.isHelpedByOther && !data.otherPresentative?.name,
      path: "otherPresentative.name",
      message: "Other person name is required"
    },
    {
      condition: data.isHelpedByOther && !data.otherPresentative?.relation,
      path: "otherPresentative.relation",
      message: "Other person relation is required"
    }
  ];
  for (const rule of validationRules) {
    if (rule.condition) {
      ctx.addIssue({
        code: "custom",
        path: [rule.path],
        message: rule.message
      });
    }
  }
});
var RepresentationFormSchema = z7.object({
  representative: RepresentationSchema.optional()
});
var DeclarationsSchema = z7.object({
  interruptedStudy: z7.boolean(),
  criminalConvictions: z7.boolean().nullish(),
  detailedInterruptionReason: z7.string().nullish(),
  offenceDetails: z7.string().nullish()
}).superRefine((data, ctx) => {
  if (data.interruptedStudy === true) {
    if (!data.detailedInterruptionReason?.trim?.()?.length) {
      ctx.addIssue({
        code: z7.ZodIssueCode.custom,
        message: "Detailed interruption reason is required when study was interrupted",
        path: ["detailedInterruptionReason"]
      });
    }
  }
  if (data?.criminalConvictions === true) {
    if (!data.offenceDetails?.trim?.()?.length) {
      ctx.addIssue({
        code: z7.ZodIssueCode.custom,
        message: "Offence details are required when criminal convictions exist",
        path: ["offenceDetails"]
      });
    }
  }
  return true;
});
function enhanceDeclarationsSchema(fieldVisibility = {}) {
  const { disableInterruptionQuestion = false, disableConvictionQuestion = false } = fieldVisibility;
  const schemaShape = {};
  if (!disableInterruptionQuestion) {
    schemaShape.interruptedStudy = z7.boolean();
    schemaShape.detailedInterruptionReason = z7.string().nullish();
  }
  if (!disableConvictionQuestion) {
    schemaShape.criminalConvictions = z7.boolean().nullish();
    schemaShape.offenceDetails = z7.string().nullish();
  }
  const declarationsSchema = z7.object(schemaShape);
  return declarationsSchema.superRefine((data, ctx) => {
    if (!disableInterruptionQuestion && data.interruptedStudy === true) {
      if (!data.detailedInterruptionReason?.trim?.()?.length) {
        ctx.addIssue({
          code: "custom",
          path: ["detailedInterruptionReason"],
          message: "Detailed interruption reason is required when study was interrupted"
        });
      }
    }
    if (!disableConvictionQuestion && data.criminalConvictions === true) {
      if (!data.offenceDetails?.trim?.()?.length) {
        ctx.addIssue({
          code: "custom",
          path: ["offenceDetails"],
          message: "Offence details are required when criminal convictions exist"
        });
      }
    }
    return true;
  });
}
var InformationProcessingConsentSchema = z7.object({
  informationProcessingConsent: z7.boolean().refine((value) => value === true, {
    message: "You must agree to the information processing consent."
  })
});
var PrivacyPolicyConsentSchema = z7.object({
  privacyPolicyConsent: z7.boolean().refine((value) => value === true, {
    message: "You must agree to the privacy policy."
  })
});
var TermsAndConditionsConsentSchema = z7.object({
  termsAndConditionsConsent: z7.boolean().refine((value) => value === true, {
    message: "You must agree to the terms and conditions."
  })
});
var AccuracyOfDataConsentSchema = z7.object({
  accuracyOfDataConsent: z7.boolean().refine((value) => value === true, {
    message: "You must confirm the accuracy of the provided data."
  })
});
var ConsentSchema = z7.object({
  ...InformationProcessingConsentSchema.shape,
  ...PrivacyPolicyConsentSchema.shape,
  ...TermsAndConditionsConsentSchema.shape,
  ...AccuracyOfDataConsentSchema.shape
});
var StaffAssignAgentSchema = z7.object({
  agentId: z7.string()
});

// src/apply/offer/requirements.ts
var ApplyRequirementIdMapping = {
  ["Passport" /* Passport */]: "/programmes/{offerId}/passport" /* Passport */,
  ["PhotoID" /* PhotoID */]: "/programmes/{offerId}/photo-id" /* PhotoID */,
  ["AcademicResults" /* AcademicResults */]: "/programmes/{offerId}/academic-results" /* AcademicResults */,
  ["FinalAcademicResults" /* FinalAcademicResults */]: "/programmes/{offerId}/final-academic-results" /* FinalAcademicResults */,
  ["AcademicCertificate" /* AcademicCertificate */]: "/programmes/{offerId}/academic-certificate" /* AcademicCertificate */,
  ["AcademicTranscript" /* AcademicTranscript */]: "/programmes/{offerId}/academic-transcript" /* AcademicTranscript */,
  ["EnglishLanguageResults" /* EnglishLanguageResults */]: "/programmes/{offerId}/english-language-results" /* EnglishLanguageResults */,
  ["EnglishLanguageCertificate" /* EnglishLanguageCertificate */]: "/programmes/{offerId}/english-language-certificate" /* EnglishLanguageCertificate */,
  ["CV" /* CV */]: "/programmes/{offerId}/cv" /* CV */,
  ["ProofOfManagerialExperience" /* ProofOfManagerialExperience */]: "/programmes/{offerId}/proof-of-managerial-experience" /* ProofOfManagerialExperience */,
  ["ProofOfAddress" /* ProofOfAddress */]: "/programmes/{offerId}/proof-of-address" /* ProofOfAddress */,
  ["ProofOfNameChange" /* ProofOfNameChange */]: "/programmes/{offerId}/proof-of-name-change" /* ProofOfNameChange */,
  ["NameAffidavit" /* NameAffidavit */]: "/programmes/{offerId}/name-affidavit" /* NameAffidavit */,
  ["BirthCert" /* BirthCert */]: "/programmes/{offerId}/birth-cert" /* BirthCert */,
  ["ProofOfImmigrationStatus" /* ProofOfImmigrationStatus */]: "/programmes/{offerId}/proof-of-immigration-status" /* ProofOfImmigrationStatus */,
  ["Payment" /* Payment */]: "/programmes/{offerId}/requirement-payment" /* RequirementPayment */,
  ["ProofOfPayment" /* ProofOfPayment */]: "/programmes/{offerId}/requirement-proof-of-payment" /* RequirementProofOfPayment */,
  ["LetterOfRecommendation" /* LetterOfRecommendation */]: "/programmes/{offerId}/letter-of-recommendation" /* LetterOfRecommendation */,
  ["PersonalStatement" /* PersonalStatement */]: "/programmes/{offerId}/personal-statement" /* PersonalStatement */,
  ["ResearchProposal" /* ResearchProposal */]: "/programmes/{offerId}/research-proposal" /* ResearchProposal */,
  ["Portfolio" /* Portfolio */]: "/programmes/{offerId}/portfolio" /* Portfolio */,
  ["RefereeDetails" /* RefereeDetails */]: "/programmes/{offerId}/referee-details" /* RefereeDetails */,
  ["Custom" /* Custom */]: "/programmes/{offerId}/{requirementId}" /* Custom */
};
function buildRequirementSlugMap() {
  const map = {};
  for (const [taskKey, route] of Object.entries(ApplyRequirementIdMapping)) {
    if (!route) {
      continue;
    }
    const slug = route.split("/").pop();
    if (!slug || slug.includes("{")) {
      continue;
    }
    const docTypes = documentsPerRoute[route];
    if (!docTypes || docTypes.length === 0) {
      continue;
    }
    const [docType] = docTypes;
    if (map[slug]) {
      throw new Error(
        `Duplicate requirement slug mapping detected for "${slug}": existing=${map[slug].requirementId} (${map[slug].route}), new=${taskKey} (${route})`
      );
    }
    map[slug] = {
      requirementId: taskKey,
      route,
      docType,
      docKey: DocumentKey[docType] ?? `${slug}-1`
    };
  }
  return map;
}
var requirementSlugMap = buildRequirementSlugMap();

// src/apply/offer/requirements-schema.ts
import { z as z9 } from "zod";

// src/apply/offer/payment.ts
import { z as z8 } from "zod";
var DepositAmountDetailSchema = z8.object({
  depositAmount: z8.number({
    message: "Please provide the amount"
  }).min(0, "Please provide the amount"),
  paymentDate: z8.string({
    message: "Please provide the date"
  }).date()
}).superRefine((depositDetail, ctx) => {
  const { paymentDate } = depositDetail;
  const dateOfPayment = new Date(paymentDate);
  const today = /* @__PURE__ */ new Date();
  if (dateOfPayment > today) {
    ctx.addIssue({
      code: "custom",
      path: ["paymentDate"],
      message: "Payment date should not be future date"
    });
  }
});
var SponsorshipDetailSchema = z8.object({
  sponsorType: z8.nativeEnum(ApplicantOfferPaymentSponsorType, { message: "Please provide the type" }),
  sponsorName: z8.string({ message: "Please provide the name" }).min(1, "Please provide the name"),
  isSponsorOrgMultinational: z8.boolean().optional().nullish()
}).superRefine((sponsorshipDetail, ctx) => {
  const { sponsorType, isSponsorOrgMultinational } = sponsorshipDetail;
  if ([
    "InternationalOrganisation" /* InternationalOrganisation */,
    "InternationalCompany" /* InternationalCompany */
  ].includes(sponsorType) && typeof isSponsorOrgMultinational !== "boolean") {
    ctx.addIssue({
      code: "custom",
      path: ["isSponsorOrgMultinational"],
      message: "Provide sponsor global presence information"
    });
  }
});
var crnMessage = "Please enter a valid Customer Reference Number (CRN) with 11 characters";
var ssnMessage = "Please enter a valid Student Support Number (SSN) with 13 characters";
var SLCDetailSchema = z8.object({
  customerRefNumber: z8.string({ message: crnMessage }).length(11, crnMessage).regex(/^[a-zA-Z0-9]+$/, crnMessage),
  studentSupportNumber: z8.string({ message: ssnMessage }).length(13, ssnMessage).regex(/^[a-zA-Z0-9]+$/, ssnMessage)
});
var defaultRefineFn = (paymentDetail, ctx) => {
  const { paymentMethod, depositDetail, sponsorshipDetail, slcDetail } = paymentDetail;
  if (paymentMethod === "Deposit" /* Deposit */ && !depositDetail) {
    ctx.addIssue({
      code: "custom",
      path: ["depositDetail"],
      message: "Provide deposit detail"
    });
  } else if (paymentMethod === "Sponsorship" /* Sponsorship */ && !sponsorshipDetail) {
    ctx.addIssue({
      code: "custom",
      path: ["sponsorshipDetail"],
      message: "Provide sponsorship detail"
    });
  } else if (paymentMethod === "SLCFunding" /* SLCFunding */ && !slcDetail) {
    ctx.addIssue({
      code: "custom",
      path: ["slcDetail"],
      message: "Provide student loan company details"
    });
  }
};
var ProofOfPaymentSchema = z8.object({
  fileName: z8.string().nullable(),
  // Allow null for deletion, required for uploads
  s3Keys: z8.array(z8.string()).nullable(),
  // Allow null for deletion, required for uploads
  sKey: z8.string().nullable(),
  // Allow null for deletion, required for uploads
  urls: z8.array(z8.string()).optional(),
  status: z8.nativeEnum(ApplicantOfferPaymentStatus).optional().nullish(),
  statusInternalNote: z8.string().optional().nullish()
});
var ApplicantOfferPaymentSchema = z8.object({
  paymentMethod: z8.nativeEnum(ApplicantOfferPaymentMethod, { message: "Please provide the value" }),
  depositDetail: DepositAmountDetailSchema.optional().nullish(),
  sponsorshipDetail: SponsorshipDetailSchema.optional().nullish(),
  slcDetail: SLCDetailSchema.optional().nullish(),
  proofOfPayment: ProofOfPaymentSchema.optional().nullish(),
  status: z8.nativeEnum(ApplicantOfferPaymentStatus).optional().nullish(),
  statusInternalNote: z8.string().optional().nullish()
}).superRefine((paymentDetail, ctx) => {
  defaultRefineFn(paymentDetail, ctx);
});
function enhanceOfferPaymentSchema(feeStatus) {
  if (feeStatus !== "HOME" /* Home */) {
    return ApplicantOfferPaymentSchema.superRefine((data, ctx) => {
      const { paymentMethod } = data;
      defaultRefineFn(data, ctx);
      if (paymentMethod === "SLCFunding" /* SLCFunding */) {
        ctx.addIssue({
          code: "custom",
          path: ["slcDetail"],
          message: "Only home student can apply for student loan company"
        });
      }
    });
  }
  return ApplicantOfferPaymentSchema;
}
var UpdateApplicantOfferPayment = z8.object({
  status: z8.nativeEnum(ApplicantOfferPaymentStatus),
  statusInternalNote: z8.string().optional()
});

// src/apply/offer/requirements-schema.ts
var DocumentFulfilmentSchema = z9.object({
  sKey: z9.string().nullable(),
  // Allow null for deletion, required for uploads
  s3Keys: z9.array(z9.string()).nullable(),
  // Allow null for deletion, required for uploads
  urls: z9.array(z9.string()).optional(),
  linkText: z9.string().optional(),
  isDeleted: z9.boolean().optional()
});
var TextFulfilmentSchema = z9.object({
  text: z9.string().optional(),
  subtext: z9.string().optional()
});
var PassportFulfilmentSchema = DocumentFulfilmentSchema;
var OfferPassportSchema = PassportFulfilmentSchema.extend({
  passport: PassportSchema
});
var OfferPassportSchemaWithFiles = (fileNames) => {
  return OfferPassportSchema.superRefine((_data, ctx) => {
    const hasFiles = fileNames && fileNames.length > 0;
    if (!hasFiles) {
      ctx.addIssue({
        code: z9.ZodIssueCode.custom,
        message: "Passport file is required.",
        path: ["fileUpload"]
      });
    }
  });
};
var DocumentSchemaWithFiles = (fileNames, errorMessage = "File is required.") => {
  return DocumentFulfilmentSchema.superRefine((_data, ctx) => {
    const hasFiles = fileNames && fileNames.length > 0;
    if (!hasFiles) {
      ctx.addIssue({
        code: z9.ZodIssueCode.custom,
        message: errorMessage,
        path: ["fileUpload"]
      });
    }
  });
};
var AcademicResultFulfilmentSchema = z9.object({
  studyHistory: StudySchema
});
var EnglishResultsFulfilmentSchema = z9.object({
  englishTest: EnglishTestSchema
});
var RefereeDetailsFulfilmentSchema = z9.object({
  referees: z9.array(RefereeSchema).min(1, "At least one referee is required")
});
var OfferFinancePaymentFulfilmentSchema = z9.object({
  paymentMethod: z9.nativeEnum(ApplicantOfferPaymentMethod, { message: "Please provide the value" }),
  depositDetail: DepositAmountDetailSchema.optional().nullish(),
  sponsorshipDetail: SponsorshipDetailSchema.optional().nullish(),
  slcDetail: SLCDetailSchema.optional().nullish(),
  statusInternalNote: z9.string().optional().nullish()
}).superRefine((paymentDetail, ctx) => {
  defaultRefineFn(paymentDetail, ctx);
});
function enhanceOfferFinancePaymentFulfilmentSchema(feeStatus) {
  if (feeStatus !== "HOME" /* Home */) {
    return OfferFinancePaymentFulfilmentSchema.superRefine((data, ctx) => {
      const { paymentMethod } = data;
      defaultRefineFn(data, ctx);
      if (paymentMethod === "SLCFunding" /* SLCFunding */) {
        ctx.addIssue({
          code: "custom",
          path: ["slcDetail"],
          message: "Only home student can apply for student loan company"
        });
      }
    });
  }
  return OfferFinancePaymentFulfilmentSchema;
}
var InternalDocumentSchema = z9.object({
  s3Keys: z9.array(z9.string()),
  fileNames: z9.array(z9.string()).optional(),
  urls: z9.array(z9.string()).optional()
});

// src/apply/offer/schemas.ts
import { z as z10 } from "zod";
var UpdateApplicantOfferStatusSchema = z10.object({
  status: z10.nativeEnum(ApplicantOfferStatus),
  conditions: z10.array(z10.string()).optional(),
  assess: z10.array(z10.string()).optional(),
  startText: z10.string().optional(),
  endText: z10.string().optional(),
  statusReason: z10.nativeEnum(ApplicantStatusReason).optional(),
  statusInternalNote: z10.string().optional(),
  statusExplanationToApplicant: z10.string().optional(),
  notifyApplicant: z10.boolean().optional()
}).superRefine((data, ctx) => {
  const { status, conditions, statusReason } = data;
  const statusesRequiresConditions = [
    "Conditional" /* Conditional */,
    "Unconditional" /* Unconditional */
  ];
  if (statusesRequiresConditions.includes(status) && conditions === void 0) {
    ctx.addIssue({
      code: "custom",
      path: ["conditions"],
      message: `Status ${status} requires conditions`
    });
  }
  if (["Withdrawn" /* Withdrawn */, "Rejected" /* Rejected */].includes(status) && !statusReason) {
    ctx.addIssue({
      code: "custom",
      path: ["statusReason"],
      message: `Status ${status} requires status reason`
    });
  }
  return true;
});
var UpdateApplicantOfferLetterTextSchema = z10.object({
  startText: z10.string().optional(),
  endText: z10.string().optional()
}).superRefine((data, ctx) => {
  const { startText, endText } = data;
  if (!startText && !endText) {
    ctx.addIssue({
      code: "custom",
      path: ["startText", "endText"],
      message: `start text or end text is required`
    });
  }
  return true;
});
var UpdateApplicantOfferRequirementTaskStatusSchema = z10.object({
  status: z10.nativeEnum(ApplicantOfferRequirementTaskStatus),
  noteText: z10.string().nullish(),
  conditionText: z10.string().optional()
}).superRefine((data, ctx) => {
  const { status, noteText, conditionText } = data;
  if (status === "Condition" /* Condition */ && !conditionText) {
    ctx.addIssue({
      code: "custom",
      path: ["conditionText"],
      message: `ConditionText required when updating to status ${status}`
    });
  }
  const statusesRequiresNote = [];
  if (statusesRequiresNote.includes(status) && !noteText) {
    ctx.addIssue({
      code: "custom",
      path: ["noteText"],
      message: `Reason required when updating to status ${status}`
    });
  }
  return true;
});
function enhanceUpdateApplicantOfferRequirementTaskStatusSchema(previousRequirement, offerNeedsReissue) {
  return UpdateApplicantOfferRequirementTaskStatusSchema.superRefine((data, ctx) => {
    const updateCondition = data.status === "Condition" /* Condition */;
    if (offerNeedsReissue && updateCondition) {
      const previousWasCondition = previousRequirement.status === "Condition" /* Condition */;
      if (previousWasCondition && !data.noteText) {
        ctx.addIssue({
          code: "custom",
          path: ["noteText"],
          message: "Note text must be specified when resetting conditon"
        });
      }
    }
  });
}
var UpdateApplicantOfferRequirementTaskLevelSchema = z10.object({
  level: z10.nativeEnum(ApplicantOfferRequirementTaskLevel)
}).refine((data) => data.level !== "Off" /* Off */, {
  message: "Level cannot be set to Off",
  path: ["level"]
});
var ExemptApplicantOfferRequirementSchema = z10.object({
  noteText: z10.string().nullish()
});
var FixedScholarshipSchema = z10.object({
  name: z10.string(),
  type: z10.literal("FIXED" /* FIXED */),
  amount: z10.number()
});
var PercentageScholarshipSchema = z10.object({
  name: z10.string(),
  type: z10.literal("PERCENTAGE" /* PERCENTAGE */),
  percentage: z10.number()
});
var ScholarshipSchema = z10.discriminatedUnion("type", [FixedScholarshipSchema, PercentageScholarshipSchema]);
var UpdateApplicantOfferProgrammeDetailsSchema = z10.object({
  entryPoint: z10.nativeEnum(EntryPoint),
  startDate: z10.string().date(),
  endDate: z10.string().date(),
  fee: z10.number(),
  feeTotal: z10.number().optional(),
  scholarships: z10.array(ScholarshipSchema).optional(),
  campus: z10.string().optional()
});
var StaffCreateApplicantOfferSchema = UpdateApplicantOfferProgrammeDetailsSchema.extend({
  intakeId: z10.string(),
  courseId: z10.string()
});
var UpdateApplicantOfferStatusActionSchema = z10.object({
  applicantStatus: z10.nativeEnum(ApplicantOfferResponseStatus)
});
var CreateApplicantOfferRequirementTaskSchema = z10.object({
  requirementId: z10.string(),
  requirementText: z10.string().optional(),
  conditionText: z10.string().optional()
}).superRefine((data, ctx) => {
  const isCustom = !!data.requirementText;
  if (isCustom && (!data.conditionText || !data.conditionText.trim())) {
    ctx.addIssue({
      code: "custom",
      path: ["conditionText"],
      message: "conditionText is required for custom requirements"
    });
  }
});
var CreateApplicantOfferRequirementTasksSchema = z10.object({
  requirements: z10.array(CreateApplicantOfferRequirementTaskSchema)
});
var ReinstateApplicantOfferSchema = z10.object({});

// src/apply/course/index.ts
import { z as z11 } from "zod";

// src/apply/course/pg.ts
var ECoursePGKeys = /* @__PURE__ */ ((ECoursePGKeys2) => {
  ECoursePGKeys2["UNI"] = "uni";
  ECoursePGKeys2["INTAKE_ID"] = "intake_id";
  ECoursePGKeys2["COURSE_ID"] = "course_id";
  ECoursePGKeys2["NAME"] = "name";
  ECoursePGKeys2["SHORT_NAME"] = "short_name";
  ECoursePGKeys2["LEVEL"] = "level";
  ECoursePGKeys2["MODE"] = "mode";
  ECoursePGKeys2["CAMPUS"] = "campus";
  ECoursePGKeys2["ENTRY_POINT"] = "entry_point";
  ECoursePGKeys2["AVAILABLE_HOME"] = "available_home";
  ECoursePGKeys2["AVAILABLE_OVERSEAS"] = "available_overseas";
  ECoursePGKeys2["AVAILABILITY_TYPE"] = "availability_type";
  ECoursePGKeys2["ALLOWED_PARTNERS"] = "allowed_partners";
  ECoursePGKeys2["AWARD"] = "award";
  ECoursePGKeys2["RQF_LEVEL"] = "rqf_level";
  ECoursePGKeys2["EXTERNAL_ID"] = "external_id";
  ECoursePGKeys2["SHORT_ID"] = "short_id";
  ECoursePGKeys2["CATEGORY"] = "category";
  ECoursePGKeys2["FACULTY"] = "faculty";
  ECoursePGKeys2["DEPARTMENT"] = "department";
  ECoursePGKeys2["IS_HTQ"] = "is_htq";
  ECoursePGKeys2["FEE_HOME"] = "fee_home";
  ECoursePGKeys2["FEE_OVERSEAS"] = "fee_overseas";
  ECoursePGKeys2["START_DATE_HOME"] = "start_date_home";
  ECoursePGKeys2["START_DATE_OVERSEAS"] = "start_date_overseas";
  ECoursePGKeys2["END_DATE_HOME"] = "end_date_home";
  ECoursePGKeys2["END_DATE_OVERSEAS"] = "end_date_overseas";
  ECoursePGKeys2["LAST_ACCEPTANCE_DATE"] = "last_acceptance_date";
  ECoursePGKeys2["LAST_UPDATED_AT"] = "last_updated_at";
  return ECoursePGKeys2;
})(ECoursePGKeys || {});
var ICoursePGTypeMap = {
  p_key: ["string", "required"],
  ["uni" /* UNI */]: ["string", "required"],
  ["intake_id" /* INTAKE_ID */]: ["string", "required"],
  ["course_id" /* COURSE_ID */]: ["string", "required"],
  ["name" /* NAME */]: ["string", "required"],
  ["short_name" /* SHORT_NAME */]: ["string"],
  ["level" /* LEVEL */]: ["string", "required"],
  ["mode" /* MODE */]: ["string", "required"],
  ["campus" /* CAMPUS */]: ["string"],
  ["entry_point" /* ENTRY_POINT */]: ["string"],
  ["available_home" /* AVAILABLE_HOME */]: ["boolean", "required"],
  ["available_overseas" /* AVAILABLE_OVERSEAS */]: ["boolean", "required"],
  ["availability_type" /* AVAILABILITY_TYPE */]: ["string"],
  ["allowed_partners" /* ALLOWED_PARTNERS */]: ["string[]"],
  ["award" /* AWARD */]: ["string"],
  ["rqf_level" /* RQF_LEVEL */]: ["string"],
  ["external_id" /* EXTERNAL_ID */]: ["string"],
  ["short_id" /* SHORT_ID */]: ["string"],
  ["category" /* CATEGORY */]: ["string"],
  ["faculty" /* FACULTY */]: ["string"],
  ["department" /* DEPARTMENT */]: ["string"],
  ["is_htq" /* IS_HTQ */]: ["boolean"],
  ["fee_home" /* FEE_HOME */]: ["float"],
  ["fee_overseas" /* FEE_OVERSEAS */]: ["float"],
  ["start_date_home" /* START_DATE_HOME */]: ["string"],
  ["start_date_overseas" /* START_DATE_OVERSEAS */]: ["string"],
  ["end_date_home" /* END_DATE_HOME */]: ["string"],
  ["end_date_overseas" /* END_DATE_OVERSEAS */]: ["string"],
  ["last_acceptance_date" /* LAST_ACCEPTANCE_DATE */]: ["string"],
  ["last_updated_at" /* LAST_UPDATED_AT */]: ["string"]
};

// src/apply/course/index.ts
var noSpecialChars = /^[a-zA-Z0-9_ ():,&-]*$/;
var safeString = z11.string().regex(noSpecialChars, {
  message: "Only letters, numbers, _, -, :, ,, &, (,) and spaces are allowed"
});
var ApplyCourseSchema = z11.object({
  p_key: safeString.optional(),
  s_key: safeString.optional(),
  username: z11.string().optional(),
  lastModified: z11.string().optional(),
  shortId: safeString,
  name: safeString,
  shortName: safeString.optional(),
  availableHome: z11.boolean(),
  feeHome: z11.number().nonnegative().optional(),
  feeHomeTotal: z11.number().nonnegative().optional(),
  availableOverseas: z11.boolean(),
  feeOverseas: z11.number().nonnegative().optional(),
  feeOverseasTotal: z11.number().nonnegative().optional(),
  mode: safeString,
  startMonthHome: z11.string().optional(),
  duration: z11.number().nonnegative(),
  startDateHome: z11.string().date().optional(),
  endDateHome: z11.string().date().optional(),
  lastApplicationDate: z11.string().date().optional(),
  lastAcceptanceDate: z11.string().date().optional(),
  award: safeString,
  level: safeString,
  entryPoint: z11.nativeEnum(EntryPoint),
  campus: safeString.optional(),
  department: safeString.optional(),
  faculty: safeString.optional(),
  category: safeString.optional(),
  awardingBody: safeString.optional(),
  isHTQ: z11.boolean().optional(),
  hecos: z11.array(z11.object({ code: safeString, percentage: z11.number() })).optional(),
  abbreviatedTitle: safeString.optional(),
  UCASApplyCode: safeString.optional(),
  UCASFacultyCode: safeString.optional(),
  availability: z11.object({
    type: z11.nativeEnum(CourseAvailability),
    allowedPartners: z11.array(z11.string()).optional()
  }).optional()
}).refine(
  (props) => {
    return !props.lastAcceptanceDate || !props.startDateHome || props.lastAcceptanceDate >= props.startDateHome;
  },
  {
    path: ["lastAcceptanceDate"],
    message: "Last acceptance date must be after start date"
  }
).refine(
  (props) => {
    return !props.lastAcceptanceDate || !props.endDateHome || props.lastAcceptanceDate <= props.endDateHome;
  },
  {
    path: ["lastAcceptanceDate"],
    message: "Last acceptance date must be before end date"
  }
).refine(
  (props) => {
    let total = 0;
    props.hecos?.map((hecos) => {
      total += hecos.percentage;
    });
    return total === 100;
  },
  {
    path: ["hecos"],
    message: "The HECoS proportion for this course must add up to 100."
  }
).refine(
  (props) => {
    if (props.availability?.type === "limited_partners" /* LIMITED_PARTNERS */) {
      return props.availability.allowedPartners && props.availability.allowedPartners.length > 0;
    }
    return true;
  },
  {
    path: ["availability", "allowedPartners"],
    message: "At least one partner must be selected when limiting availability"
  }
);

// src/apply/config/validation.ts
import { z as z12 } from "zod";
var ApplicationTaskSchema = z12.enum([
  "EnglishLanguage",
  "Employment",
  "References",
  "PersonalStatement",
  "ResearchProposal",
  "Funding",
  "ImmigrationHistory",
  "DiversityInclusion",
  "Representation",
  "Referral",
  "Declarations"
]);
var ApplicationTaskConfigSchema = z12.record(ApplicationTaskSchema, z12.boolean()).optional();
var ApplicationTaskFlagsSchema = z12.object({
  enabled: z12.boolean().optional(),
  default: z12.boolean().optional()
});
var ApplyApplicationTaskConfigSchema = z12.record(ApplicationTaskSchema, ApplicationTaskFlagsSchema);

// src/apply/config/index.ts
var UniConfigRequirementTaskFulfilmentMethod = /* @__PURE__ */ ((UniConfigRequirementTaskFulfilmentMethod2) => {
  UniConfigRequirementTaskFulfilmentMethod2["Passport"] = "Passport";
  UniConfigRequirementTaskFulfilmentMethod2["AcademicResults"] = "AcademicResults";
  UniConfigRequirementTaskFulfilmentMethod2["FinalAcademicResults"] = "FinalAcademicResults";
  UniConfigRequirementTaskFulfilmentMethod2["AcademicTranscript"] = "AcademicTranscript";
  UniConfigRequirementTaskFulfilmentMethod2["EnglishLanguageResults"] = "EnglishLanguageResults";
  UniConfigRequirementTaskFulfilmentMethod2["EnglishLanguageCertificate"] = "EnglishLanguageCertificate";
  UniConfigRequirementTaskFulfilmentMethod2["Upload"] = "Upload";
  UniConfigRequirementTaskFulfilmentMethod2["InfoOnly"] = "InfoOnly";
  UniConfigRequirementTaskFulfilmentMethod2["CalendlyInterview"] = "CalendlyInterview";
  UniConfigRequirementTaskFulfilmentMethod2["RecordedInterview"] = "RecordedInterview";
  UniConfigRequirementTaskFulfilmentMethod2["RefereeDetails"] = "RefereeDetails";
  UniConfigRequirementTaskFulfilmentMethod2["Payment"] = "Payment";
  return UniConfigRequirementTaskFulfilmentMethod2;
})(UniConfigRequirementTaskFulfilmentMethod || {});
var RequirementTaskInternalDataMethod = /* @__PURE__ */ ((RequirementTaskInternalDataMethod2) => {
  RequirementTaskInternalDataMethod2["Upload"] = "Upload";
  return RequirementTaskInternalDataMethod2;
})(RequirementTaskInternalDataMethod || {});
var ApplicationTaskValue = ApplicationTaskSchema.enum;

// src/apply/offer-timeline/index.ts
var OfferTimelineStageType = /* @__PURE__ */ ((OfferTimelineStageType2) => {
  OfferTimelineStageType2["Applied"] = "Applied";
  OfferTimelineStageType2["Conditional"] = "Conditional";
  OfferTimelineStageType2["ConditionalReissued"] = "ConditionalReissued";
  OfferTimelineStageType2["Unconditional"] = "Unconditional";
  OfferTimelineStageType2["UnconditionalReissued"] = "UnconditionalReissued";
  OfferTimelineStageType2["Withdrawn"] = "Withdrawn";
  OfferTimelineStageType2["Rejected"] = "Rejected";
  OfferTimelineStageType2["ProgrammeCreated"] = "ProgrammeCreated";
  OfferTimelineStageType2["NewInformation"] = "NewInformation";
  OfferTimelineStageType2["ProgrammeEdited"] = "ProgrammeEdited";
  OfferTimelineStageType2["PreOfferTasksRequested"] = "PreOfferTasksRequested";
  OfferTimelineStageType2["EnrolmentTasksRequested"] = "EnrolmentTasksRequested";
  return OfferTimelineStageType2;
})(OfferTimelineStageType || {});

// src/apply/highest-study/schemas.ts
import { z as z13 } from "zod";
var HighestStudyInstitutionSchema = z13.object({
  country: z13.string().min(1, "Country can't be empty"),
  institutionName: z13.string().min(1, "The name can't be empty"),
  institutionAddress: AddressSchema.omit({ country: true }).extend({
    state: z13.string().optional()
    // Override to make state optional
  })
});
var HighestStudyQualificationTypeSelectionSchema = z13.object({
  id: z13.string().optional(),
  // unique identifier for this studyRow (to distinguish multiple rows with same qualificationType)
  qualificationType: z13.string().min(1, "Please select the qualification type"),
  // id
  qualificationTypeLabel: z13.string().optional(),
  customQualificationTypeName: z13.string().optional(),
  // required if 'Other' is selected
  gradingSystem: z13.string().min(1, "Please select the grading system"),
  gradingSystemLabel: z13.string().optional(),
  groupId: z13.string().optional(),
  // groupId to track which selections belong to the same study group
  resultStatus: z13.nativeEnum(ResultStatus).optional(),
  // Per-group result status
  taughtInEnglish: z13.boolean().optional()
  // Per-group taught in English
}).refine(
  (data) => {
    if (data.qualificationTypeLabel === "Other") {
      const customName = data.customQualificationTypeName;
      return customName && typeof customName === "string" && customName.trim().length > 0;
    }
    return true;
  },
  {
    message: "Please enter the qualification type",
    path: ["customQualificationTypeName"]
  }
);
var HighestStudyAddStudySchema = z13.object({
  country: z13.string().min(1),
  qualificationTypeSelections: z13.array(HighestStudyQualificationTypeSelectionSchema).min(1),
  resultStatus: z13.nativeEnum(ResultStatus),
  taughtInEnglish: z13.boolean().nullish()
});
function enhanceHighestStudyAddStudySchema(_gradingOptionsPerSelection, isUK) {
  const SchemaWithCountryRule = HighestStudyAddStudySchema.extend({
    taughtInEnglish: isUK ? z13.boolean().nullish() : z13.union([z13.boolean(), z13.null(), z13.undefined()]).refine((val) => typeof val === "boolean", {
      message: "Please select Yes or No"
    })
  });
  return SchemaWithCountryRule;
}
var HighestStudyAddQualificationSchema = z13.object({
  subject: z13.string().optional(),
  grade: z13.string().optional(),
  graduationDate: z13.string().optional().refine(
    (val) => {
      if (!val) return true;
      const currentDate = /* @__PURE__ */ new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;
      const MIN_YEAR = currentYear - 130;
      const [year, month] = val.split("-");
      const graduationDateYear = year && year.length === 4 ? parseInt(year, 10) : void 0;
      const graduationDateMonth = month && month.length > 0 ? parseInt(month, 10) : void 0;
      if (!graduationDateYear || graduationDateYear <= MIN_YEAR) return false;
      if (graduationDateYear > currentYear) return false;
      if (graduationDateYear === currentYear && graduationDateMonth && graduationDateMonth > currentMonth) {
        return false;
      }
      return true;
    },
    { message: "Invalid date" }
  ),
  awardingOrganisationId: z13.string().optional(),
  modules: z13.array(ModuleSchema).optional()
});
function enhanceHighestStudyAddQualificationSchema(date, _country, awardingOrgRequired, isPending, subjectVisible, resultStatus) {
  const SchemaWithConditionalRules = HighestStudyAddQualificationSchema.extend({
    subject: subjectVisible === false ? z13.string().optional() : z13.union([z13.string(), z13.undefined()]).refine(
      (val) => {
        if (!val || val.trim().length === 0) return false;
        return val.length <= 100;
      },
      (val) => {
        if (!val || val.trim().length === 0) return { message: "Subject can't be empty" };
        return { message: "Subject is too long." };
      }
    ),
    grade: isPending ? z13.string().optional() : z13.union([z13.string(), z13.undefined()]).refine(
      (val) => {
        if (!val || val.trim().length === 0) return false;
        return val.length <= 100;
      },
      (val) => {
        if (!val || val.trim().length === 0) return { message: "Grade can't be empty" };
        return { message: "Grade is too long." };
      }
    ),
    graduationDate: isPending ? z13.string().optional() : z13.union([z13.string(), z13.undefined()]).refine(
      (val) => {
        if (!val) return false;
        const currentDate = /* @__PURE__ */ new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        const MIN_YEAR = currentYear - 130;
        const [year, month] = val.split("-");
        const graduationDateYear = year && year.length === 4 ? parseInt(year, 10) : void 0;
        const graduationDateMonth = month && month.length > 0 ? parseInt(month, 10) : void 0;
        if (!graduationDateYear || graduationDateYear <= MIN_YEAR) return false;
        if (resultStatus === "InterimResults" /* InterimResults */) {
          if (graduationDateYear < currentYear) return false;
          if (graduationDateYear === currentYear && graduationDateMonth && graduationDateMonth < currentMonth) {
            return false;
          }
          return true;
        }
        if (graduationDateYear > currentYear) return false;
        if (graduationDateYear === currentYear && graduationDateMonth && graduationDateMonth > currentMonth) {
          return false;
        }
        return true;
      },
      { message: "Invalid date" }
    ),
    awardingOrganisationId: isPending || !awardingOrgRequired ? z13.string().optional() : z13.string().min(1, "Please select an awarding organisation")
  });
  return SchemaWithConditionalRules.superRefine((data, ctx) => {
    if (isPending) return;
    if (!date || !data.graduationDate) return;
    const startDate = new Date(date);
    const targetDate = new Date(data.graduationDate);
    const isDateValid = targetDate >= startDate;
    if (!isDateValid) {
      ctx.addIssue({
        code: z13.ZodIssueCode.custom,
        message: "Qualification date must be after your study start date",
        path: ["graduationDate"]
      });
    }
  });
}

// src/apply/registration/registrationForms.ts
import { z as z14 } from "zod";
var BaseRegistrationFormSchema = {
  intakeId: z14.string().min(1, "Intake is required"),
  studyLevel: z14.string().min(1, "Study level is required"),
  courseName: z14.string().min(1, "Course is required"),
  courseId: z14.string().min(1, "Course is required"),
  mode: z14.string().min(1, "Mode is required"),
  campus: z14.string().min(1, "Campus is required"),
  entryPoint: z14.string().min(1, "Entry year is required"),
  programmeChoices: z14.array(ProgrammeChoiceSchema2).optional()
};

// src/automation/enums.ts
var AutomationType = /* @__PURE__ */ ((AutomationType2) => {
  AutomationType2["MOVE_TO_STAGE"] = "MOVE_TO_STAGE";
  AutomationType2["TAG"] = "TAG";
  AutomationType2["WEBHOOK"] = "WEBHOOK";
  AutomationType2["SCHEDULED_TASKS"] = "SCHEDULED_TASKS";
  return AutomationType2;
})(AutomationType || {});
var AutomationLimit = /* @__PURE__ */ ((AutomationLimit2) => {
  AutomationLimit2["ONCE"] = "ONCE";
  AutomationLimit2["MULTIPLE"] = "MULTIPLE";
  return AutomationLimit2;
})(AutomationLimit || {});
var TriggerFieldOperator = /* @__PURE__ */ ((TriggerFieldOperator2) => {
  TriggerFieldOperator2["EQUALS"] = "EQUALS";
  TriggerFieldOperator2["NOT_EQUALS"] = "NOT_EQUALS";
  TriggerFieldOperator2["ONE_OF"] = "ONE_OF";
  TriggerFieldOperator2["NOT_ONE_OF"] = "NOT_ONE_OF";
  TriggerFieldOperator2["CONTAINS"] = "CONTAINS";
  TriggerFieldOperator2["NOT_CONTAINS"] = "NOT_CONTAINS";
  TriggerFieldOperator2["EXISTS"] = "EXISTS";
  TriggerFieldOperator2["NOT_EXISTS"] = "NOT_EXISTS";
  TriggerFieldOperator2["STARTS_WITH"] = "STARTS_WITH";
  TriggerFieldOperator2["NOT_STARTS_WITH"] = "NOT_STARTS_WITH";
  TriggerFieldOperator2["GREATER_THAN"] = "GREATER_THAN";
  TriggerFieldOperator2["LESS_THAN"] = "LESS_THAN";
  TriggerFieldOperator2["HAS_CONFLICT"] = "HAS_CONFLICT";
  TriggerFieldOperator2["NOT_HAS_CONFLICT"] = "NOT_HAS_CONFLICT";
  TriggerFieldOperator2["CONFLICT_RESOLVED"] = "CONFLICT_RESOLVED";
  return TriggerFieldOperator2;
})(TriggerFieldOperator || {});
var DocumentSectionStatus = /* @__PURE__ */ ((DocumentSectionStatus2) => {
  DocumentSectionStatus2["NOT_TRIGGERED"] = "NOT_TRIGGERED";
  DocumentSectionStatus2["NOT_STARTED"] = "NOT_STARTED";
  DocumentSectionStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  DocumentSectionStatus2["ALL_UPLOADED"] = "ALL_UPLOADED";
  DocumentSectionStatus2["APPROVED"] = "APPROVED";
  DocumentSectionStatus2["REJECTED"] = "REJECTED";
  return DocumentSectionStatus2;
})(DocumentSectionStatus || {});
var DocumentCombinedStatus = /* @__PURE__ */ ((DocumentCombinedStatus2) => {
  DocumentCombinedStatus2["NOT_REQUIRED"] = "NOT_REQUIRED";
  DocumentCombinedStatus2["REQUESTED"] = "REQUESTED";
  DocumentCombinedStatus2["UPLOADED"] = "UPLOADED";
  DocumentCombinedStatus2["APPROVED"] = "APPROVED";
  DocumentCombinedStatus2["REJECTED"] = "REJECTED";
  return DocumentCombinedStatus2;
})(DocumentCombinedStatus || {});
var TriggerFieldNames = /* @__PURE__ */ ((TriggerFieldNames2) => {
  TriggerFieldNames2["ADMISSIONS_OFFICE"] = "ADMISSIONS_OFFICE";
  TriggerFieldNames2["AGE"] = "AGE";
  TriggerFieldNames2["CITY"] = "CITY";
  TriggerFieldNames2["COUNTRY"] = "COUNTRY";
  TriggerFieldNames2["COUNTRY_OF_VISA_APPLICATION"] = "COUNTRY_OF_VISA_APPLICATION";
  TriggerFieldNames2["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
  TriggerFieldNames2["EMAIL"] = "EMAIL";
  TriggerFieldNames2["FAMILY_NAME"] = "FAMILY_NAME";
  TriggerFieldNames2["GIVEN_NAME"] = "GIVEN_NAME";
  TriggerFieldNames2["NATIONALITY"] = "NATIONALITY";
  TriggerFieldNames2["PHONE"] = "PHONE";
  TriggerFieldNames2["POSTCODE"] = "POSTCODE";
  TriggerFieldNames2["SECONDARY_STUDENT_NUMBER"] = "SECONDARY_STUDENT_NUMBER";
  TriggerFieldNames2["SERVICES"] = "SERVICES";
  TriggerFieldNames2["STUDENT_NUMBER"] = "STUDENT_NUMBER";
  TriggerFieldNames2["UCAS_ID"] = "UCAS_ID";
  TriggerFieldNames2["UNIVERSITY"] = "UNIVERSITY";
  TriggerFieldNames2["CRIMINAL_CONVICTIONS"] = "CRIMINAL_CONVICTIONS";
  TriggerFieldNames2["AGENT_NAME"] = "AGENT_NAME";
  TriggerFieldNames2["INTAKE_ID"] = "INTAKE_ID";
  TriggerFieldNames2["OFFER_ID"] = "OFFER_ID";
  TriggerFieldNames2["RISK_REGION"] = "RISK_REGION";
  TriggerFieldNames2["STAGE"] = "STAGE";
  TriggerFieldNames2["TAGS"] = "TAGS";
  TriggerFieldNames2["TUITION_DEPOSIT"] = "TUITION_DEPOSIT";
  TriggerFieldNames2["WITH_AGENT"] = "WITH_AGENT";
  TriggerFieldNames2["COURSE_ID"] = "COURSE_ID";
  TriggerFieldNames2["COURSE_LEVEL"] = "COURSE_LEVEL";
  TriggerFieldNames2["COURSE_START_DATE"] = "COURSE_START_DATE";
  TriggerFieldNames2["COURSE_TITLE"] = "COURSE_TITLE";
  TriggerFieldNames2["FACULTY"] = "FACULTY";
  TriggerFieldNames2["INNER_LONDON"] = "INNER_LONDON";
  TriggerFieldNames2["PSE_COURSE_START_DATE"] = "PSE_COURSE_START_DATE";
  TriggerFieldNames2["PSE_COURSE_TITLE"] = "PSE_COURSE_TITLE";
  TriggerFieldNames2["RECORDED_INTERVIEW_STATUS"] = "RECORDED_INTERVIEW_STATUS";
  TriggerFieldNames2["OVERALL_CONDITIONAL_STATUS"] = "OVERALL_CONDITIONAL_STATUS";
  TriggerFieldNames2["VISA_SUPPORT_OPT_IN"] = "VISA_SUPPORT_OPT_IN";
  TriggerFieldNames2["ACCEPTED"] = "ACCEPTED";
  TriggerFieldNames2["PERSONAL_INFORMATION_COMPLETE"] = "PERSONAL_INFORMATION_COMPLETE";
  TriggerFieldNames2["HISTORY_COMPLETE"] = "HISTORY_COMPLETE";
  TriggerFieldNames2["FINANCE_COMPLETE"] = "FINANCE_COMPLETE";
  TriggerFieldNames2["PREVIOUS_UK_STUDY"] = "PREVIOUS_UK_STUDY";
  TriggerFieldNames2["PREVIOUS_UK_VISAS_NON_STUDENT"] = "PREVIOUS_UK_VISAS_NON_STUDENT";
  TriggerFieldNames2["APPLIED_TO_REMAIN_IN_THE_UK"] = "APPLIED_TO_REMAIN_IN_THE_UK";
  TriggerFieldNames2["REFUSED_ENTRY_AT_UK_BORDER"] = "REFUSED_ENTRY_AT_UK_BORDER";
  TriggerFieldNames2["PREVIOUS_UK_VISA_REFUSAL"] = "PREVIOUS_UK_VISA_REFUSAL";
  TriggerFieldNames2["PREVIOUS_NON_UK_VISA_REFUSAL"] = "PREVIOUS_NON_UK_VISA_REFUSAL";
  TriggerFieldNames2["ATAS_DOCUMENT_STATUS"] = "ATAS_DOCUMENT_STATUS";
  TriggerFieldNames2["TB_DOCUMENT_STATUS"] = "TB_DOCUMENT_STATUS";
  TriggerFieldNames2["VISA_VIGNETTE_DOCUMENT_STATUS"] = "VISA_VIGNETTE_DOCUMENT_STATUS";
  TriggerFieldNames2["FINANCIAL_DOCUMENTS"] = "FINANCIAL_DOCUMENTS";
  TriggerFieldNames2["IMMIGRATION_SHARE_CODE_DOCUMENT_STATUS"] = "IMMIGRATION_SHARE_CODE_DOCUMENT_STATUS";
  TriggerFieldNames2["VISA_STATUS"] = "VISA_STATUS";
  TriggerFieldNames2["ARRIVAL_STATUS"] = "ARRIVAL_STATUS";
  TriggerFieldNames2["ACCOMMODATION_STATUS"] = "ACCOMMODATION_STATUS";
  TriggerFieldNames2["ACCOMMODATION_TYPE"] = "ACCOMMODATION_TYPE";
  TriggerFieldNames2["BRANCH_OFFICE"] = "BRANCH_OFFICE";
  TriggerFieldNames2["COUNSELLOR_EMAIL"] = "COUNSELLOR_EMAIL";
  TriggerFieldNames2["COUNSELLOR_NAME"] = "COUNSELLOR_NAME";
  TriggerFieldNames2["AGENT_FAMILY_NAME"] = "AGENT_FAMILY_NAME";
  TriggerFieldNames2["AGENT_GIVEN_NAME"] = "AGENT_GIVEN_NAME";
  TriggerFieldNames2["BRANCH_ADDRESS_LINE_1"] = "BRANCH_ADDRESS_LINE_1";
  TriggerFieldNames2["BRANCH_ADDRESS_LINE_2"] = "BRANCH_ADDRESS_LINE_2";
  TriggerFieldNames2["BRANCH_ADDRESS_LINE_3"] = "BRANCH_ADDRESS_LINE_3";
  TriggerFieldNames2["BRANCH_CITY"] = "BRANCH_CITY";
  TriggerFieldNames2["BRANCH_COUNTRY"] = "BRANCH_COUNTRY";
  TriggerFieldNames2["BRANCH_POSTCODE"] = "BRANCH_POSTCODE";
  return TriggerFieldNames2;
})(TriggerFieldNames || {});

// src/calendly-event/enums.ts
var LocationType = /* @__PURE__ */ ((LocationType2) => {
  LocationType2["InPersonMeeting"] = "physical";
  LocationType2["OutboundCall"] = "outbound_call";
  LocationType2["InboundCall"] = "inbound_call";
  LocationType2["GoogleConference"] = "google_conference";
  LocationType2["ZoomConference"] = "zoom_conference";
  LocationType2["GoToMeetingConference"] = "gotomeeting";
  LocationType2["MicrosoftTeamsConference"] = "microsoft_teams_conference";
  LocationType2["CustomLocation"] = "custom";
  LocationType2["InviteeSpecifiedLocation"] = "ask_invitee";
  return LocationType2;
})(LocationType || {});

// src/calendly-event/index.ts
var EventBookingStatus = /* @__PURE__ */ ((EventBookingStatus2) => {
  EventBookingStatus2["REQUESTED"] = "Requested";
  EventBookingStatus2["BOOKED"] = "Booked";
  EventBookingStatus2["CANCELED"] = "Canceled";
  return EventBookingStatus2;
})(EventBookingStatus || {});
var EventSystemStatus = /* @__PURE__ */ ((EventSystemStatus2) => {
  EventSystemStatus2["PASSED"] = "PASSED";
  EventSystemStatus2["FAILED"] = "FAILED";
  EventSystemStatus2["RESIT"] = "RESIT";
  EventSystemStatus2["DELETED"] = "DELETED";
  return EventSystemStatus2;
})(EventSystemStatus || {});
var EventInfoStatus = /* @__PURE__ */ ((EventInfoStatus2) => {
  EventInfoStatus2["INVITED"] = "INVITED";
  EventInfoStatus2["BOOKED"] = "BOOKED";
  EventInfoStatus2["PASSED"] = "PASSED";
  EventInfoStatus2["FAILED"] = "FAILED";
  EventInfoStatus2["RESIT"] = "RESIT";
  EventInfoStatus2["NONE"] = "NONE";
  return EventInfoStatus2;
})(EventInfoStatus || {});

// src/config/types.ts
var hecosCodes = [
  { value: "100003", label: "ceramics" },
  { value: "100005", label: "clinical engineering" },
  { value: "100033", label: "metallurgy" },
  { value: "100035", label: "musical theatre" },
  { value: "100279", label: "adult nursing" },
  { value: "100038", label: "pathobiology" },
  { value: "100258", label: "clinical physiology" },
  { value: "100046", label: "creative writing" },
  { value: "100048", label: "design" },
  { value: "100050", label: "product design" },
  { value: "100051", label: "textile design" },
  { value: "100052", label: "ergonomics" },
  { value: "100054", label: "fashion" },
  { value: "100055", label: "fashion design" },
  { value: "100057", label: "animation" },
  { value: "100058", label: "film studies" },
  { value: "100059", label: "fine art" },
  { value: "100060", label: "graphic arts" },
  { value: "100061", label: "graphic design" },
  { value: "100062", label: "illustration" },
  { value: "100063", label: "photography" },
  { value: "100065", label: "liberal arts" },
  { value: "100067", label: "acting" },
  { value: "100068", label: "dance" },
  { value: "100069", label: "drama" },
  { value: "100070", label: "music" },
  { value: "100071", label: "performing arts" },
  { value: "100104", label: "accountancy" },
  { value: "100105", label: "accounting" },
  { value: "100076", label: "public relations" },
  { value: "100840", label: "audit management" },
  { value: "100838", label: "book-keeping" },
  { value: "100845", label: "financial reporting" },
  { value: "100836", label: "management accountancy" },
  { value: "100837", label: "public accountancy" },
  { value: "100078", label: "business and management" },
  { value: "100079", label: "business studies" },
  { value: "100808", label: "European business studies" },
  { value: "100080", label: "international business" },
  { value: "100090", label: "public administration" },
  { value: "100091", label: "public services" },
  { value: "100218", label: "real estate" },
  { value: "100093", label: "logistics" },
  { value: "100095", label: "sports coaching" },
  { value: "100096", label: "sports development" },
  { value: "100106", label: "actuarial science" },
  { value: "100098", label: "sports studies" },
  { value: "100827", label: "banking" },
  { value: "100107", label: "finance" },
  { value: "100832", label: "financial management" },
  { value: "100835", label: "financial risk" },
  { value: "100830", label: "insurance" },
  { value: "100828", label: "investment" },
  { value: "100831", label: "taxation" },
  { value: "100109", label: "clothing production" },
  { value: "100110", label: "footwear production" },
  { value: "100114", label: "aeronautical engineering" },
  { value: "100115", label: "aerospace engineering" },
  { value: "100116", label: "space technology" },
  { value: "100117", label: "avionics" },
  { value: "100118", label: "satellite engineering" },
  { value: "100120", label: "architectural engineering" },
  { value: "100121", label: "architectural technology" },
  { value: "100122", label: "architecture" },
  { value: "100124", label: "landscape architecture and design" },
  { value: "100126", label: "biomechanics" },
  { value: "100127", label: "biomedical engineering" },
  { value: "100128", label: "dental technology" },
  { value: "100262", label: "physiology" },
  { value: "100130", label: "prosthetics and orthotics" },
  { value: "100131", label: "radiology" },
  { value: "100264", label: "anatomy" },
  { value: "100134", label: "biotechnology" },
  { value: "100135", label: "bioprocessing" },
  { value: "100136", label: "environmental biotechnology" },
  { value: "100137", label: "industrial biotechnology" },
  { value: "100138", label: "medical biotechnology" },
  { value: "100139", label: "plant biotechnology" },
  { value: "100141", label: "biochemical engineering" },
  { value: "100143", label: "chemical engineering" },
  { value: "100144", label: "pharmaceutical engineering" },
  { value: "100145", label: "polymer science and technology" },
  { value: "100147", label: "building services engineering" },
  { value: "100148", label: "civil engineering" },
  { value: "100149", label: "construction" },
  { value: "100150", label: "construction and the built environment" },
  { value: "100151", label: "construction management" },
  { value: "100152", label: "offshore engineering" },
  { value: "100153", label: "structural engineering" },
  { value: "100154", label: "transport engineering" },
  { value: "100155", label: "minerals technology" },
  { value: "100156", label: "highways engineering" },
  { value: "100157", label: "railway engineering" },
  { value: "100159", label: "telecommunications engineering" },
  { value: "100160", label: "computer aided engineering" },
  { value: "100162", label: "computer systems engineering" },
  { value: "100163", label: "electrical and electronic engineering" },
  { value: "100164", label: "electrical engineering" },
  { value: "100165", label: "electronic engineering" },
  { value: "100166", label: "control systems" },
  { value: "100168", label: "microelectronic engineering" },
  { value: "100169", label: "optoelectronic engineering" },
  { value: "100170", label: "mechatronics and robotics" },
  { value: "100172", label: "nuclear engineering" },
  { value: "100175", label: "energy engineering" },
  { value: "100176", label: "gas engineering" },
  { value: "100177", label: "microwave engineering" },
  { value: "100178", label: "petroleum engineering" },
  { value: "100180", label: "environmental engineering" },
  { value: "100182", label: "engineering design" },
  { value: "100183", label: "fire safety engineering" },
  { value: "100184", label: "general or integrated engineering" },
  { value: "100185", label: "safety engineering" },
  { value: "100186", label: "emergency and disaster technologies" },
  { value: "100188", label: "systems engineering" },
  { value: "100190", label: "mechanical engineering" },
  { value: "100192", label: "electromechanical engineering" },
  { value: "100193", label: "maintenance engineering" },
  { value: "100194", label: "marine technology" },
  { value: "100196", label: "housing" },
  { value: "100197", label: "planning" },
  { value: "100198", label: "transport planning" },
  { value: "100199", label: "urban and regional planning" },
  { value: "100201", label: "automotive engineering" },
  { value: "100202", label: "manufacturing engineering" },
  { value: "100203", label: "materials engineering" },
  { value: "100204", label: "mining engineering" },
  { value: "100205", label: "motorcycle engineering" },
  { value: "100206", label: "motorsport engineering" },
  { value: "100207", label: "naval architecture" },
  { value: "100209", label: "production and manufacturing engineering" },
  { value: "100210", label: "leather technology" },
  { value: "100211", label: "fabrication" },
  { value: "100212", label: "minerals processing" },
  { value: "100213", label: "quality management" },
  { value: "100214", label: "textiles technology" },
  { value: "100216", label: "building surveying" },
  { value: "100217", label: "quantity surveying" },
  { value: "100866", label: "health and safety management" },
  { value: "100219", label: "surveying" },
  { value: "100221", label: "music technology" },
  { value: "100222", label: "audio technology" },
  { value: "100223", label: "music production" },
  { value: "100225", label: "materials science" },
  { value: "100229", label: "aviation studies" },
  { value: "100230", label: "navigation" },
  { value: "100274", label: "pathology" },
  { value: "100540", label: "cellular pathology" },
  { value: "100265", label: "biomedical sciences" },
  { value: "100272", label: "neuroscience" },
  { value: "100912", label: "blood sciences" },
  { value: "101382", label: "affective neuroscience" },
  { value: "100280", label: "children's nursing" },
  { value: "100281", label: "community nursing" },
  { value: "100285", label: "general practice nursing" },
  { value: "100293", label: "school nursing" },
  { value: "100295", label: "health visiting" },
  { value: "100233", label: "acupuncture" },
  { value: "100234", label: "alternative medicines and therapies" },
  { value: "100235", label: "aromatherapy" },
  { value: "100236", label: "Chinese medical techniques" },
  { value: "100237", label: "herbal medicine" },
  { value: "100239", label: "reflexology" },
  { value: "100241", label: "chiropractic" },
  { value: "100242", label: "complementary medicines and therapies" },
  { value: "100243", label: "osteopathy" },
  { value: "100253", label: "podiatry" },
  { value: "100259", label: "genetics" },
  { value: "100739", label: "beauty therapy" },
  { value: "100261", label: "ophthalmology" },
  { value: "101241", label: "music therapy" },
  { value: "101340", label: "hypnotherapy" },
  { value: "101375", label: "spa and water-based therapies" },
  { value: "100266", label: "clinical dentistry" },
  { value: "100267", label: "clinical medicine" },
  { value: "100268", label: "dentistry" },
  { value: "100270", label: "medical sciences" },
  { value: "100271", label: "medicine" },
  { value: "100249", label: "occupational therapy" },
  { value: "100254", label: "psychotherapy" },
  { value: "100495", label: "counselling" },
  { value: "100275", label: "pre-clinical dentistry" },
  { value: "100276", label: "pre-clinical medicine" },
  { value: "101320", label: "art psychotherapy" },
  { value: "100283", label: "dental nursing" },
  { value: "100248", label: "occupational health" },
  { value: "101317", label: "environmental and public health" },
  { value: "101332", label: "drug and alcohol studies" },
  { value: "101335", label: "epidemiology" },
  { value: "100246", label: "health sciences" },
  { value: "100255", label: "speech and language therapy" },
  { value: "100273", label: "operating department practice" },
  { value: "100749", label: "paramedic science" },
  { value: "100750", label: "physician associate studies" },
  { value: "101289", label: "rehabilitation studies" },
  { value: "101291", label: "cardiovascular rehabilitation" },
  { value: "101329", label: "dementia studies" },
  { value: "100257", label: "audiology" },
  { value: "100260", label: "healthcare science" },
  { value: "100286", label: "learning disabilities nursing" },
  { value: "100129", label: "diagnostic imaging" },
  { value: "100298", label: "ancient history" },
  { value: "100299", label: "archaeology" },
  { value: "100300", label: "classical studies" },
  { value: "100301", label: "economic history" },
  { value: "100302", label: "history" },
  { value: "100306", label: "history of art" },
  { value: "100307", label: "history of science" },
  { value: "100308", label: "local history" },
  { value: "100309", label: "medieval history" },
  { value: "100310", label: "modern history" },
  { value: "100311", label: "Scottish history" },
  { value: "100312", label: "social history" },
  { value: "100314", label: "humanities" },
  { value: "100316", label: "American studies" },
  { value: "100317", label: "British Sign Language studies" },
  { value: "100318", label: "English language" },
  { value: "100319", label: "English literature" },
  { value: "100320", label: "English studies" },
  { value: "100321", label: "French language" },
  { value: "100322", label: "French studies" },
  { value: "100323", label: "German language" },
  { value: "100324", label: "German studies" },
  { value: "100325", label: "Spanish studies" },
  { value: "100326", label: "Italian language" },
  { value: "100327", label: "Italian studies" },
  { value: "100328", label: "linguistics" },
  { value: "100329", label: "modern languages" },
  { value: "100330", label: "Russian languages" },
  { value: "100331", label: "Russian and East European studies" },
  { value: "100332", label: "Spanish language" },
  { value: "100333", label: "Welsh language" },
  { value: "100335", label: "Welsh studies" },
  { value: "100337", label: "philosophy" },
  { value: "100338", label: "philosophy of science" },
  { value: "100339", label: "religious studies" },
  { value: "100340", label: "theology" },
  { value: "100343", label: "applied biology" },
  { value: "100344", label: "biochemistry" },
  { value: "100345", label: "biological sciences" },
  { value: "100346", label: "biology" },
  { value: "100347", label: "ecology" },
  { value: "100348", label: "environmental biology" },
  { value: "100350", label: "human biology" },
  { value: "100351", label: "marine biology" },
  { value: "100352", label: "medical biochemistry" },
  { value: "100353", label: "microbiology" },
  { value: "100354", label: "molecular biology" },
  { value: "100355", label: "plant sciences" },
  { value: "100356", label: "zoology" },
  { value: "100358", label: "applied computing" },
  { value: "100359", label: "artificial intelligence" },
  { value: "100360", label: "business computing" },
  { value: "100361", label: "business information systems" },
  { value: "100362", label: "business information technology" },
  { value: "100363", label: "computer animation and visual effects" },
  { value: "100365", label: "computer networks" },
  { value: "100366", label: "computer science" },
  { value: "100367", label: "computing and information technology" },
  { value: "100368", label: "creative computing" },
  { value: "100369", label: "geographical information systems" },
  { value: "100370", label: "information management" },
  { value: "100371", label: "information systems" },
  { value: "100372", label: "information technology" },
  { value: "100373", label: "internet technologies" },
  { value: "100374", label: "software engineering" },
  { value: "100375", label: "web and multimedia design" },
  { value: "100376", label: "computer and information security" },
  { value: "100379", label: "climate science" },
  { value: "100380", label: "environmental geoscience" },
  { value: "100381", label: "environmental sciences" },
  { value: "100382", label: "meteorology" },
  { value: "100384", label: "archaeological sciences" },
  { value: "100385", label: "computer forensics" },
  { value: "100386", label: "forensic biology" },
  { value: "100387", label: "forensic psychology" },
  { value: "100388", label: "forensic science" },
  { value: "100390", label: "general science" },
  { value: "100391", label: "natural sciences" },
  { value: "100392", label: "applied science" },
  { value: "100394", label: "earth sciences" },
  { value: "100395", label: "geology" },
  { value: "100396", label: "geophysics" },
  { value: "100398", label: "palaeontology" },
  { value: "100400", label: "applied mathematics" },
  { value: "100401", label: "financial mathematics" },
  { value: "100402", label: "mathematical modelling" },
  { value: "100403", label: "mathematics" },
  { value: "100404", label: "operational research" },
  { value: "100405", label: "pure mathematics" },
  { value: "100406", label: "statistics" },
  { value: "100408", label: "environmental geography" },
  { value: "100409", label: "geography" },
  { value: "100410", label: "physical geography" },
  { value: "100413", label: "analytical chemistry" },
  { value: "100414", label: "astronomy" },
  { value: "100415", label: "astrophysics" },
  { value: "100416", label: "chemical physics" },
  { value: "100417", label: "chemistry" },
  { value: "100418", label: "marine sciences" },
  { value: "100419", label: "medical physics" },
  { value: "100420", label: "medicinal chemistry" },
  { value: "100421", label: "ocean sciences" },
  { value: "100422", label: "organic chemistry" },
  { value: "100423", label: "pharmaceutical chemistry" },
  { value: "100424", label: "physical sciences" },
  { value: "100425", label: "physics" },
  { value: "100426", label: "theoretical physics" },
  { value: "100427", label: "acoustics" },
  { value: "100428", label: "aerodynamics" },
  { value: "100429", label: "dynamics" },
  { value: "100430", label: "mechanics" },
  { value: "100431", label: "thermodynamics" },
  { value: "100433", label: "sport and exercise sciences" },
  { value: "100436", label: "anthropology" },
  { value: "100437", label: "social anthropology" },
  { value: "100439", label: "broadcast journalism" },
  { value: "100440", label: "digital media" },
  { value: "100441", label: "film production" },
  { value: "100442", label: "journalism" },
  { value: "100443", label: "media production" },
  { value: "100444", label: "media and communication studies" },
  { value: "100445", label: "multimedia journalism" },
  { value: "100449", label: "business economics" },
  { value: "100450", label: "economics" },
  { value: "100451", label: "financial economics" },
  { value: "100452", label: "international economics" },
  { value: "100454", label: "adult education" },
  { value: "100455", label: "childhood and youth studies" },
  { value: "100456", label: "childhood studies" },
  { value: "100457", label: "early childhood studies" },
  { value: "100459", label: "education studies" },
  { value: "100460", label: "further education" },
  { value: "100461", label: "higher education" },
  { value: "100462", label: "learning support" },
  { value: "100463", label: "early years education" },
  { value: "100464", label: "primary education" },
  { value: "100465", label: "secondary education" },
  { value: "100466", label: "youth and community work" },
  { value: "100468", label: "countryside management" },
  { value: "100469", label: "environmental management" },
  { value: "100471", label: "social sciences" },
  { value: "100473", label: "health studies" },
  { value: "100475", label: "sports therapy" },
  { value: "100476", label: "health and social care" },
  { value: "100478", label: "human geography" },
  { value: "100482", label: "business law" },
  { value: "100483", label: "criminal justice" },
  { value: "100484", label: "criminology" },
  { value: "100485", label: "law" },
  { value: "100486", label: "policing" },
  { value: "100488", label: "international development" },
  { value: "100489", label: "international politics" },
  { value: "100490", label: "international relations" },
  { value: "100491", label: "politics" },
  { value: "100493", label: "applied psychology" },
  { value: "100494", label: "clinical psychology" },
  { value: "100132", label: "therapeutic imaging" },
  { value: "100496", label: "educational psychology" },
  { value: "100497", label: "psychology" },
  { value: "100498", label: "social psychology" },
  { value: "100499", label: "sport and exercise psychology" },
  { value: "100501", label: "social care" },
  { value: "100502", label: "social policy" },
  { value: "100503", label: "social work" },
  { value: "100505", label: "sociology" },
  { value: "100507", label: "adult education teaching" },
  { value: "100508", label: "post compulsory education and training" },
  { value: "100509", label: "higher education teaching" },
  { value: "100510", label: "early years teaching" },
  { value: "100511", label: "primary teaching" },
  { value: "100512", label: "secondary teaching" },
  { value: "100513", label: "teaching English as a foreign language" },
  { value: "100516", label: "agricultural sciences" },
  { value: "100517", label: "agriculture" },
  { value: "100518", label: "animal management" },
  { value: "100519", label: "equine studies" },
  { value: "100520", label: "forestry and arboriculture" },
  { value: "100522", label: "animal behaviour" },
  { value: "100523", label: "animal science" },
  { value: "100526", label: "food and beverage production" },
  { value: "100527", label: "food science" },
  { value: "100529", label: "horticulture" },
  { value: "100531", label: "veterinary medicine" },
  { value: "100532", label: "veterinary nursing" },
  { value: "100539", label: "broadcast engineering" },
  { value: "101330", label: "ultrasound" },
  { value: "100544", label: "marine engineering" },
  { value: "100545", label: "corrosion technology" },
  { value: "100546", label: "digital circuit engineering" },
  { value: "100548", label: "engineering surveying" },
  { value: "100549", label: "environmental impact assessment" },
  { value: "100550", label: "gemmology" },
  { value: "100551", label: "geotechnical engineering" },
  { value: "100553", label: "integrated circuit design" },
  { value: "100560", label: "musical instrument manufacture" },
  { value: "100564", label: "aerospace propulsion systems" },
  { value: "100565", label: "public health engineering" },
  { value: "100566", label: "quarrying" },
  { value: "100568", label: "ship design" },
  { value: "100572", label: "tissue engineering and regenerative medicine" },
  { value: "100573", label: "water quality control" },
  { value: "100577", label: "fluid mechanics" },
  { value: "100579", label: "structural mechanics" },
  { value: "100580", label: "acoustics and vibration" },
  { value: "100581", label: "electrical power" },
  { value: "100583", label: "architectural design" },
  { value: "100584", label: "building technology" },
  { value: "100585", label: "conservation of buildings" },
  { value: "100586", label: "property development" },
  { value: "100587", label: "drawing" },
  { value: "100588", label: "landscape studies" },
  { value: "100589", label: "painting" },
  { value: "100590", label: "garden design" },
  { value: "100592", label: "sculpture" },
  { value: "100593", label: "rural planning" },
  { value: "100594", label: "urban studies" },
  { value: "100595", label: "printmaking" },
  { value: "100597", label: "applied economics" },
  { value: "100599", label: "fine art conservation" },
  { value: "100600", label: "agricultural economics" },
  { value: "100601", label: "economic policy" },
  { value: "100604", label: "econometrics" },
  { value: "100606", label: "economic systems" },
  { value: "100609", label: "democracy" },
  { value: "100610", label: "UK government/parliamentary studies" },
  { value: "100612", label: "European Union politics" },
  { value: "100616", label: "strategic studies" },
  { value: "100617", label: "war and peace studies" },
  { value: "100618", label: "comparative politics" },
  { value: "100619", label: "applied sociology" },
  { value: "100621", label: "gender studies" },
  { value: "100622", label: "women's studies" },
  { value: "100623", label: "men's studies" },
  { value: "100624", label: "ethnicity" },
  { value: "100625", label: "disability studies" },
  { value: "100626", label: "religion in society" },
  { value: "100627", label: "socio-economics" },
  { value: "100628", label: "social theory" },
  { value: "100629", label: "political sociology" },
  { value: "100630", label: "typography" },
  { value: "100631", label: "sociology of science and technology" },
  { value: "100632", label: "visual communication" },
  { value: "100633", label: "furniture design and making" },
  { value: "100636", label: "interactive and electronic design" },
  { value: "100637", label: "musicianship and performance studies" },
  { value: "100639", label: "instrumental or vocal performance" },
  { value: "100642", label: "music education and teaching" },
  { value: "100643", label: "music and arts management" },
  { value: "101049", label: "health risk" },
  { value: "100645", label: "international social policy" },
  { value: "100647", label: "public policy" },
  { value: "100648", label: "health policy" },
  { value: "100649", label: "welfare policy" },
  { value: "100650", label: "conducting" },
  { value: "100651", label: "education policy" },
  { value: "100652", label: "security policy" },
  { value: "100653", label: "health and welfare" },
  { value: "100654", label: "child care" },
  { value: "100655", label: "community work" },
  { value: "100656", label: "jazz performance" },
  { value: "100657", label: "popular music performance" },
  { value: "100658", label: "careers guidance" },
  { value: "100659", label: "community justice" },
  { value: "100661", label: "historical performance practice" },
  { value: "100662", label: "probation/after-care" },
  { value: "100663", label: "physical and biological anthropology" },
  { value: "100664", label: "history of music" },
  { value: "100665", label: "economic geography" },
  { value: "100666", label: "urban geography" },
  { value: "100667", label: "musicology" },
  { value: "100668", label: "political geography" },
  { value: "100669", label: "transport geography" },
  { value: "100670", label: "environmental history" },
  { value: "100671", label: "cultural geography" },
  { value: "100674", label: "ethnomusicology and world music" },
  { value: "100676", label: "English law" },
  { value: "100677", label: "Northern Irish law" },
  { value: "100678", label: "Scots law" },
  { value: "100680", label: "European Union law" },
  { value: "100681", label: "public international law" },
  { value: "100683", label: "comparative law" },
  { value: "100684", label: "public law" },
  { value: "100685", label: "criminal law" },
  { value: "100686", label: "private law" },
  { value: "100689", label: "property law" },
  { value: "100690", label: "torts" },
  { value: "100691", label: "jurisprudence" },
  { value: "100692", label: "legal practice" },
  { value: "100693", label: "medical law" },
  { value: "100695", label: "music composition" },
  { value: "100697", label: "directing for theatre" },
  { value: "100698", label: "theatre studies" },
  { value: "100700", label: "theatre production" },
  { value: "100702", label: "technical theatre studies" },
  { value: "100703", label: "stage management" },
  { value: "100704", label: "technical stage management" },
  { value: "100705", label: "theatrical wardrobe design" },
  { value: "100706", label: "hair and make-up" },
  { value: "100707", label: "circus arts" },
  { value: "100708", label: "stage design" },
  { value: "100710", label: "community theatre" },
  { value: "100711", label: "choreography" },
  { value: "100712", label: "dance performance" },
  { value: "100714", label: "history of photography" },
  { value: "100716", label: "cinematography" },
  { value: "100717", label: "visual and audio effects" },
  { value: "100721", label: "metal work" },
  { value: "100724", label: "glass crafts" },
  { value: "100725", label: "silversmithing and goldsmithing" },
  { value: "100726", label: "clock and watchmaking" },
  { value: "100728", label: "surface decoration" },
  { value: "100729", label: "scriptwriting" },
  { value: "100730", label: "poetry writing" },
  { value: "100731", label: "professional writing" },
  { value: "100734", label: "computer architectures" },
  { value: "100735", label: "operating systems" },
  { value: "100736", label: "human-computer interaction" },
  { value: "100737", label: "multimedia computing science" },
  { value: "100738", label: "e-business" },
  { value: "100287", label: "mental health nursing" },
  { value: "100741", label: "high performance computing" },
  { value: "100085", label: "human resource management" },
  { value: "100288", label: "midwifery" },
  { value: "100290", label: "nursing" },
  { value: "100247", label: "nutrition" },
  { value: "100748", label: "cardiology" },
  { value: "100744", label: "dietetics" },
  { value: "100036", label: "optometry" },
  { value: "100751", label: "information modelling" },
  { value: "100753", label: "systems analysis and design" },
  { value: "100754", label: "databases" },
  { value: "100755", label: "data management" },
  { value: "100756", label: "systems auditing" },
  { value: "100757", label: "intelligent systems" },
  { value: "100758", label: "British history" },
  { value: "100759", label: "Irish history" },
  { value: "100760", label: "Welsh history" },
  { value: "100761", label: "English history" },
  { value: "100762", label: "European history" },
  { value: "100763", label: "German history" },
  { value: "100764", label: "Italian history" },
  { value: "100765", label: "Iberian studies" },
  { value: "100766", label: "Russian history" },
  { value: "100767", label: "American history" },
  { value: "100768", label: "USA history" },
  { value: "100769", label: "Latin American history" },
  { value: "100771", label: "Chinese history" },
  { value: "100772", label: "South Asian history" },
  { value: "100773", label: "South East Asian history" },
  { value: "100774", label: "Byzantine studies" },
  { value: "100777", label: "world history" },
  { value: "100778", label: "international history" },
  { value: "100779", label: "family history" },
  { value: "100780", label: "history of religions" },
  { value: "100781", label: "intellectual history" },
  { value: "100782", label: "history of architecture" },
  { value: "100783", label: "history of design" },
  { value: "100784", label: "history of mathematics" },
  { value: "100785", label: "history of medicine" },
  { value: "100786", label: "military history" },
  { value: "100787", label: "Egyptology" },
  { value: "100791", label: "mental philosophy" },
  { value: "100792", label: "social philosophy" },
  { value: "100793", label: "ethics" },
  { value: "100794", label: "theology and religious studies" },
  { value: "100795", label: "Christian studies" },
  { value: "100796", label: "Islamic studies" },
  { value: "100797", label: "Judaism" },
  { value: "100798", label: "buddhism" },
  { value: "100799", label: "divinity" },
  { value: "100800", label: "religious writings" },
  { value: "100801", label: "biblical studies" },
  { value: "100802", label: "pastoral studies" },
  { value: "100803", label: "comparative religious studies" },
  { value: "100805", label: "heritage studies" },
  { value: "100807", label: "heritage management" },
  { value: "100861", label: "staff development" },
  { value: "100813", label: "change management" },
  { value: "100811", label: "creative management" },
  { value: "100823", label: "emergency and disaster management" },
  { value: "101308", label: "facilities management" },
  { value: "100815", label: "institutional management" },
  { value: "100819", label: "land management" },
  { value: "100088", label: "leadership" },
  { value: "100817", label: "management and organisation of education" },
  { value: "100089", label: "management studies" },
  { value: "100821", label: "requirements engineering" },
  { value: "100822", label: "cell biology" },
  { value: "100814", label: "organisational development" },
  { value: "100825", label: "property valuation and auctioneering" },
  { value: "100826", label: "parasitology" },
  { value: "100812", label: "project management" },
  { value: "100820", label: "property management" },
  { value: "100829", label: "behavioural biology" },
  { value: "100092", label: "retail management" },
  { value: "101040", label: "risk management" },
  { value: "100896", label: "salon management" },
  { value: "100834", label: "developmental biology" },
  { value: "100810", label: "strategic management" },
  { value: "100074", label: "advertising" },
  { value: "100856", label: "corporate image" },
  { value: "101215", label: "food marketing" },
  { value: "100853", label: "international marketing" },
  { value: "100841", label: "popular music" },
  { value: "100842", label: "film music and screen music" },
  { value: "100843", label: "jazz" },
  { value: "100844", label: "sacred music" },
  { value: "100846", label: "market research" },
  { value: "100075", label: "marketing" },
  { value: "100847", label: "reproductive biology" },
  { value: "100848", label: "aquatic biology" },
  { value: "100849", label: "freshwater biology" },
  { value: "100850", label: "population biology" },
  { value: "100644", label: "music marketing" },
  { value: "100855", label: "promotion and advertising" },
  { value: "100854", label: "community music" },
  { value: "100851", label: "sales management" },
  { value: "100868", label: "office administration" },
  { value: "100858", label: "evolution" },
  { value: "101409", label: "shorthand and shorthand transcription" },
  { value: "100862", label: "sonic arts" },
  { value: "100864", label: "ecosystem ecology and land use" },
  { value: "100865", label: "biometry" },
  { value: "100743", label: "systems thinking" },
  { value: "100867", label: "electronic music" },
  { value: "100083", label: "event management" },
  { value: "100869", label: "bioinformatics" },
  { value: "100870", label: "jazz composition" },
  { value: "100872", label: "mycology" },
  { value: "100873", label: "plant cell science" },
  { value: "100874", label: "plant pathology" },
  { value: "100891", label: "hospitality" },
  { value: "100880", label: "applied zoology" },
  { value: "100881", label: "cell zoology" },
  { value: "100882", label: "entomology" },
  { value: "100883", label: "marine zoology" },
  { value: "100884", label: "pest management" },
  { value: "100885", label: "ballet" },
  { value: "100886", label: "contemporary dance" },
  { value: "100887", label: "moving image techniques" },
  { value: "100888", label: "film directing" },
  { value: "100890", label: "film and sound recording" },
  { value: "100084", label: "hospitality management" },
  { value: "100087", label: "international hospitality management" },
  { value: "100893", label: "recreation and leisure studies" },
  { value: "100895", label: "crafts" },
  { value: "100894", label: "spa management" },
  { value: "100898", label: "human genetics" },
  { value: "100899", label: "medical genetics" },
  { value: "100900", label: "molecular genetics" },
  { value: "100901", label: "genomics" },
  { value: "100902", label: "population genetics" },
  { value: "100906", label: "applied microbiology" },
  { value: "100907", label: "medical microbiology" },
  { value: "100908", label: "veterinary microbiology" },
  { value: "100909", label: "bacteriology" },
  { value: "100910", label: "virology" },
  { value: "100911", label: "immunology" },
  { value: "100037", label: "orthoptics" },
  { value: "100913", label: "librarianship" },
  { value: "100914", label: "curatorial studies" },
  { value: "100915", label: "archives and records management" },
  { value: "100916", label: "information services" },
  { value: "100918", label: "museum studies" },
  { value: "100919", label: "publicity studies" },
  { value: "100920", label: "television studies" },
  { value: "100921", label: "radio studies" },
  { value: "100922", label: "paper-based media studies" },
  { value: "100923", label: "television production" },
  { value: "100924", label: "radio production" },
  { value: "100925", label: "publishing" },
  { value: "100926", label: "electronic publishing" },
  { value: "100927", label: "online publishing" },
  { value: "100932", label: "plant biochemistry" },
  { value: "100936", label: "animal health" },
  { value: "100937", label: "animal physiology" },
  { value: "100938", label: "veterinary pathology" },
  { value: "100939", label: "veterinary pharmacology" },
  { value: "100940", label: "animal nutrition" },
  { value: "100941", label: "veterinary pharmacy" },
  { value: "100942", label: "veterinary public health" },
  { value: "100945", label: "crop protection" },
  { value: "100946", label: "crop nutrition" },
  { value: "100947", label: "crop production" },
  { value: "100948", label: "biomolecular science" },
  { value: "100949", label: "biophysical science" },
  { value: "100950", label: "occupational psychology" },
  { value: "100952", label: "developmental psychology" },
  { value: "100953", label: "child psychology" },
  { value: "100954", label: "business psychology" },
  { value: "100956", label: "programming" },
  { value: "100958", label: "psychology of ageing" },
  { value: "100959", label: "research methods in psychology" },
  { value: "100960", label: "object-oriented programming" },
  { value: "100961", label: "natural language processing" },
  { value: "100962", label: "research skills" },
  { value: "100963", label: "knowledge and information systems" },
  { value: "100966", label: "neural computing" },
  { value: "100968", label: "computer vision" },
  { value: "100970", label: "applied linguistics" },
  { value: "100971", label: "phonetics and phonology" },
  { value: "100972", label: "phonetics" },
  { value: "100973", label: "phonology" },
  { value: "100974", label: "livestock" },
  { value: "100976", label: "aquaculture" },
  { value: "100977", label: "rural estate management" },
  { value: "100978", label: "farm management" },
  { value: "100979", label: "game keeping management" },
  { value: "100985", label: "health psychology" },
  { value: "100986", label: "water resource management" },
  { value: "100989", label: "cognitive modelling" },
  { value: "100990", label: "land management for recreation" },
  { value: "100992", label: "machine learning" },
  { value: "100993", label: "cognitive psychology" },
  { value: "100994", label: "health informatics" },
  { value: "100998", label: "sustainable agriculture and landscape development" },
  { value: "101001", label: "international agriculture" },
  { value: "101003", label: "psychology of religion" },
  { value: "101004", label: "organic farming" },
  { value: "101006", label: "agricultural technology" },
  { value: "101010", label: "agricultural machinery" },
  { value: "101013", label: "timber engineering" },
  { value: "101014", label: "community forestry" },
  { value: "101016", label: "sociolinguistics" },
  { value: "101017", label: "food and beverage studies" },
  { value: "101018", label: "food safety" },
  { value: "101019", label: "computer games graphics" },
  { value: "101020", label: "computer games programming" },
  { value: "101021", label: "baking technology management" },
  { value: "101022", label: "brewing" },
  { value: "101024", label: "agricultural chemistry" },
  { value: "101025", label: "agricultural botany" },
  { value: "101027", label: "numerical analysis" },
  { value: "101028", label: "engineering and industrial mathematics" },
  { value: "101029", label: "computational mathematics" },
  { value: "101030", label: "applied statistics" },
  { value: "101031", label: "medical statistics" },
  { value: "101032", label: "probability" },
  { value: "101033", label: "stochastic processes" },
  { value: "101034", label: "statistical modelling" },
  { value: "101035", label: "psycholinguistics" },
  { value: "101037", label: "comparative literary studies" },
  { value: "101038", label: "applied chemistry" },
  { value: "100097", label: "sports management" },
  { value: "101041", label: "industrial chemistry" },
  { value: "101042", label: "colour chemistry" },
  { value: "101043", label: "inorganic chemistry" },
  { value: "101044", label: "crystallography" },
  { value: "101045", label: "environmental chemistry" },
  { value: "101046", label: "marine chemistry" },
  { value: "101048", label: "environmental risk" },
  { value: "100875", label: "tourism" },
  { value: "101050", label: "physical chemistry" },
  { value: "101053", label: "polymer chemistry" },
  { value: "101054", label: "oil and gas chemistry" },
  { value: "101056", label: "remote sensing" },
  { value: "101058", label: "mapping science" },
  { value: "101060", label: "applied physics" },
  { value: "101061", label: "engineering physics" },
  { value: "101064", label: "geomorphology" },
  { value: "101065", label: "maritime geography" },
  { value: "101067", label: "soil science" },
  { value: "101068", label: "atmospheric physics" },
  { value: "101070", label: "climate change" },
  { value: "101071", label: "computational physics" },
  { value: "101072", label: "pollution control" },
  { value: "101073", label: "hydrography" },
  { value: "101074", label: "radiation physics" },
  { value: "101075", label: "photonics and optical physics" },
  { value: "101076", label: "laser physics" },
  { value: "101077", label: "nuclear and particle physics" },
  { value: "101078", label: "applied environmental sciences" },
  { value: "101079", label: "hydrology" },
  { value: "101081", label: "volcanology" },
  { value: "101082", label: "geological hazards" },
  { value: "101083", label: "geochemistry" },
  { value: "101084", label: "exploration geophysics" },
  { value: "101085", label: "specialist teaching" },
  { value: "101086", label: "geological oceanography" },
  { value: "101087", label: "special needs teaching" },
  { value: "101088", label: "research and study skills in education" },
  { value: "101089", label: "hydrogeology" },
  { value: "101090", label: "study skills" },
  { value: "101091", label: "quaternary studies" },
  { value: "101093", label: "exploration geology" },
  { value: "101094", label: "English literature 1200 - 1700" },
  { value: "101095", label: "English literature 1700 - 1900" },
  { value: "101102", label: "space science" },
  { value: "101103", label: "planetary science" },
  { value: "101104", label: "applied geology" },
  { value: "101105", label: "petroleum geology" },
  { value: "101106", label: "engineering geology" },
  { value: "101107", label: "Shakespeare studies" },
  { value: "101108", label: "colonial and post-colonial literature" },
  { value: "101109", label: "English as a second language" },
  { value: "101111", label: "Scottish literature" },
  { value: "101112", label: "ancient Middle Eastern languages" },
  { value: "101113", label: "ancient Egyptian studies" },
  { value: "101114", label: "classical Arabic" },
  { value: "101115", label: "Sanskrit studies" },
  { value: "101117", label: "ancient Hebrew language" },
  { value: "101118", label: "Celtic studies" },
  { value: "101120", label: "Gaelic language" },
  { value: "101121", label: "Irish language" },
  { value: "101124", label: "Latin studies" },
  { value: "101125", label: "Latin literature" },
  { value: "101126", label: "classical Greek studies" },
  { value: "101129", label: "classical reception" },
  { value: "101130", label: "translation studies" },
  { value: "101132", label: "French literature" },
  { value: "101133", label: "French society and culture" },
  { value: "101134", label: "German literature" },
  { value: "101135", label: "German society and culture" },
  { value: "101136", label: "Italian society and culture" },
  { value: "101137", label: "Italian literature" },
  { value: "101138", label: "Spanish society and culture" },
  { value: "101139", label: "Spanish literature" },
  { value: "101141", label: "Portuguese studies" },
  { value: "101142", label: "Portuguese language" },
  { value: "101143", label: "Brazilian studies" },
  { value: "101144", label: "Portuguese society and culture" },
  { value: "101145", label: "Scandinavian studies" },
  { value: "101148", label: "Swedish language" },
  { value: "101149", label: "Norwegian language" },
  { value: "101150", label: "Finnish language" },
  { value: "101151", label: "Russian studies" },
  { value: "101152", label: "Polish studies" },
  { value: "101153", label: "Polish language" },
  { value: "101155", label: "Czech language" },
  { value: "101157", label: "Russian literature" },
  { value: "101158", label: "Russian and East European society and culture" },
  { value: "101159", label: "European studies" },
  { value: "101161", label: "Dutch studies" },
  { value: "101163", label: "Welsh literature" },
  { value: "101164", label: "Chinese studies" },
  { value: "101165", label: "Chinese languages" },
  { value: "101166", label: "Chinese literature" },
  { value: "101167", label: "Chinese society and culture studies" },
  { value: "101168", label: "Japanese studies" },
  { value: "101169", label: "Japanese languages" },
  { value: "101170", label: "Japanese literature" },
  { value: "101171", label: "Japanese society and culture studies" },
  { value: "101172", label: "South Asian studies" },
  { value: "101174", label: "Hindi language" },
  { value: "101175", label: "Urdu language" },
  { value: "101177", label: "Bengali language" },
  { value: "101179", label: "Indian society and culture studies" },
  { value: "101180", label: "Asian studies" },
  { value: "101184", label: "African studies" },
  { value: "101185", label: "African languages" },
  { value: "101188", label: "African literature" },
  { value: "101189", label: "African society and culture studies" },
  { value: "101190", label: "modern Middle Eastern studies" },
  { value: "101191", label: "modern Middle Eastern languages" },
  { value: "101192", label: "Arabic languages" },
  { value: "101193", label: "Persian languages" },
  { value: "101194", label: "Israeli studies" },
  { value: "101195", label: "Turkish studies" },
  { value: "101196", label: "modern Middle Eastern literature" },
  { value: "101197", label: "modern Middle Eastern society and culture studies" },
  { value: "101198", label: "Arab society and culture studies" },
  { value: "101199", label: "Latin American studies" },
  { value: "101201", label: "Latin American literature" },
  { value: "101202", label: "Latin American society and culture studies" },
  { value: "101203", label: "North American literature studies" },
  { value: "101204", label: "North American society and culture studies" },
  { value: "101205", label: "Canadian studies" },
  { value: "101206", label: "Australasian studies" },
  { value: "101207", label: "Caribbean studies" },
  { value: "101210", label: "biomaterials" },
  { value: "101212", label: "Korean studies" },
  { value: "101214", label: "cinematics" },
  { value: "100100", label: "tourism management" },
  { value: "101216", label: "bioelectronics" },
  { value: "101217", label: "composite materials" },
  { value: "101218", label: "forensic anthropology" },
  { value: "101219", label: "forensic archaeology" },
  { value: "101220", label: "veterinary epidemiology" },
  { value: "101221", label: "enterprise and entrepreneurship" },
  { value: "101222", label: "crime scene investigation" },
  { value: "101223", label: "condensed matter physics" },
  { value: "101233", label: "cultural studies" },
  { value: "101234", label: "nanotechnology" },
  { value: "101511", label: "ophthalmic dispensing" },
  { value: "101243", label: "bioengineering" },
  { value: "101246", label: "professional practice in education" },
  { value: "101248", label: "French history" },
  { value: "101258", label: "Thai language" },
  { value: "101261", label: "maritime archaeology" },
  { value: "101267", label: "computer games" },
  { value: "101268", label: "computer games design" },
  { value: "101269", label: "modern Hebrew language" },
  { value: "101271", label: "East Asian studies" },
  { value: "101273", label: "combined studies" },
  { value: "101274", label: "general studies" },
  { value: "101275", label: "negotiated studies" },
  { value: "101276", label: "work placement experience (personal learning)" },
  { value: "101277", label: "work-based learning" },
  { value: "101278", label: "employability skills (personal learning)" },
  { value: "101279", label: "advice and guidance (personal learning)" },
  { value: "101288", label: "international studies" },
  { value: "100282", label: "critical care nursing" },
  { value: "100284", label: "emergency nursing" },
  { value: "100289", label: "neonatal nursing" },
  { value: "101294", label: "coaching psychology" },
  { value: "101300", label: "quantum theory and applications" },
  { value: "101307", label: "applied social science" },
  { value: "100101", label: "travel and tourism" },
  { value: "101309", label: "obstetrics and gynaecology" },
  { value: "101311", label: "Hungarian studies" },
  { value: "101312", label: "Czech studies" },
  { value: "101315", label: "Irish studies" },
  { value: "101316", label: "interior design and architecture" },
  { value: "100291", label: "older people nursing" },
  { value: "101318", label: "biodiversity conservation" },
  { value: "101319", label: "exercise for health" },
  { value: "100292", label: "palliative care nursing" },
  { value: "101322", label: "mentorship" },
  { value: "101323", label: "dispute resolution" },
  { value: "101324", label: "orthopaedics" },
  { value: "101325", label: "paediatrics" },
  { value: "101326", label: "gerontology" },
  { value: "101327", label: "oncology" },
  { value: "100294", label: "theatre nursing" },
  { value: "100746", label: "clinical practice nursing" },
  { value: "101331", label: "gastroenterology" },
  { value: "100747", label: "medical nursing" },
  { value: "101333", label: "epilepsy care" },
  { value: "101334", label: "allergy" },
  { value: "100250", label: "pharmacology" },
  { value: "101336", label: "anaesthesia" },
  { value: "101337", label: "endocrinology" },
  { value: "101338", label: "diabetes" },
  { value: "101339", label: "dermatology" },
  { value: "100251", label: "pharmacy" },
  { value: "101341", label: "psychology of communication" },
  { value: "101342", label: "psychology of memory and learning" },
  { value: "101343", label: "transpersonal psychology" },
  { value: "101344", label: "psychobiology" },
  { value: "101345", label: "evolutionary psychology" },
  { value: "101347", label: "veterinary dentistry" },
  { value: "101348", label: "exotic plants and crops" },
  { value: "101351", label: "atmosphere-ocean interactions" },
  { value: "101352", label: "biogeography" },
  { value: "101353", label: "electrical power generation" },
  { value: "101354", label: "electrical power distribution" },
  { value: "101355", label: "cybernetics" },
  { value: "101356", label: "paper technology" },
  { value: "101357", label: "nationalism" },
  { value: "101358", label: "development in Africa" },
  { value: "101359", label: "development in the Americas" },
  { value: "101360", label: "African history" },
  { value: "101361", label: "creative arts and design" },
  { value: "101362", label: "calligraphy" },
  { value: "101363", label: "psychology of music" },
  { value: "101366", label: "Swahili and other Bantu languages" },
  { value: "101367", label: "Hausa language" },
  { value: "101368", label: "Indonesian language" },
  { value: "101369", label: "Vietnamese language" },
  { value: "101371", label: "Nepali language" },
  { value: "101372", label: "South East Asian studies" },
  { value: "101373", label: "hair and beauty sciences" },
  { value: "101374", label: "hair services" },
  { value: "100252", label: "physiotherapy" },
  { value: "101376", label: "applied botany" },
  { value: "101377", label: "transcriptomics" },
  { value: "101378", label: "genetic engineering" },
  { value: "101379", label: "sport technology" },
  { value: "101380", label: "metabolic biochemistry" },
  { value: "101381", label: "cognitive neuroscience" },
  { value: "101290", label: "neurological rehabilitation" },
  { value: "101383", label: "psychometrics" },
  { value: "101384", label: "pre-clinical veterinary medicine" },
  { value: "101385", label: "agricultural irrigation and drainage" },
  { value: "101387", label: "meat science" },
  { value: "101388", label: "cereal science" },
  { value: "101389", label: "organometallic chemistry" },
  { value: "101390", label: "marine physics" },
  { value: "101391", label: "electromagnetism" },
  { value: "101394", label: "glaciology and cryospheric systems" },
  { value: "101396", label: "solid mechanics" },
  { value: "101397", label: "turbine technology" },
  { value: "101398", label: "rail vehicle engineering" },
  { value: "101399", label: "analogue circuit engineering" },
  { value: "101400", label: "parallel computing" },
  { value: "101401", label: "microeconomics" },
  { value: "101402", label: "macroeconomics" },
  { value: "101403", label: "feminism" },
  { value: "101404", label: "anarchism" },
  { value: "101405", label: "victimology" },
  { value: "101406", label: "transport policy" },
  { value: "101407", label: "agricultural geography" },
  { value: "101408", label: "human demography" },
  { value: "100102", label: "travel management" },
  { value: "101410", label: "historical linguistics" },
  { value: "101412", label: "Scots language" },
  { value: "101413", label: "Irish language literature" },
  { value: "101414", label: "Coptic language" },
  { value: "101415", label: "Akkadian language" },
  { value: "101416", label: "Sumerian language" },
  { value: "101417", label: "Aramaic language" },
  { value: "101419", label: "Breton language" },
  { value: "101420", label: "Latin language" },
  { value: "101421", label: "medieval Latin language" },
  { value: "101422", label: "classical church Greek" },
  { value: "101423", label: "classical Greek literature" },
  { value: "101424", label: "Danish language" },
  { value: "101425", label: "Scandinavian literature" },
  { value: "101426", label: "Estonian language" },
  { value: "101427", label: "Hungarian language" },
  { value: "101428", label: "south Slavonic languages" },
  { value: "101429", label: "Ukrainian language" },
  { value: "101430", label: "Indian literature studies" },
  { value: "101431", label: "Turkish languages" },
  { value: "101432", label: "Arabic literature" },
  { value: "101433", label: "Persian literature studies" },
  { value: "101434", label: "Turkish literature" },
  { value: "101435", label: "oral history" },
  { value: "101436", label: "crime history" },
  { value: "101437", label: "Stone Age" },
  { value: "101438", label: "Bronze Age" },
  { value: "101439", label: "Iron Age" },
  { value: "101440", label: "classical art and archaeology" },
  { value: "101441", label: "metaphysics" },
  { value: "101442", label: "epistemology" },
  { value: "101443", label: "scholastic philosophy" },
  { value: "101444", label: "hinduism" },
  { value: "101445", label: "the Qur'an and Islamic texts" },
  { value: "101446", label: "the Torah and Judaic texts" },
  { value: "101447", label: "folk music" },
  { value: "101448", label: "opera" },
  { value: "101449", label: "music theory and analysis" },
  { value: "101450", label: "applied music and musicianship" },
  { value: "101451", label: "popular music composition" },
  { value: "101452", label: "body awareness" },
  { value: "101453", label: "dance and culture" },
  { value: "101454", label: "community dance" },
  { value: "101455", label: "stone crafts" },
  { value: "101457", label: "community ecology" },
  { value: "101458", label: "population ecology" },
  { value: "101459", label: "ecotoxicology" },
  { value: "101460", label: "plant physiology" },
  { value: "101461", label: "veterinary biochemistry" },
  { value: "101462", label: "quantitative psychology" },
  { value: "101463", label: "qualitative psychology" },
  { value: "101464", label: "psychopharmacology" },
  { value: "101465", label: "sociology of law" },
  { value: "101467", label: "Ruskin studies" },
  { value: "101468", label: "John Donne studies" },
  { value: "101469", label: "T.S. Eliot studies" },
  { value: "101470", label: "Thomas Hardy studies" },
  { value: "101471", label: "Oscar Wilde studies" },
  { value: "101472", label: "Chaucer studies" },
  { value: "101473", label: "Bront\xEBs studies" },
  { value: "101474", label: "Thomas Pynchon studies" },
  { value: "101475", label: "Philip Larkin studies" },
  { value: "101476", label: "D.H. Lawrence studies" },
  { value: "101477", label: "Charles Dickens studies" },
  { value: "101478", label: "Jane Austen studies" },
  { value: "101479", label: "James Joyce studies" },
  { value: "101480", label: "Margaret Atwood studies" },
  { value: "101481", label: "Samuel Beckett studies" },
  { value: "101482", label: "Wilkie Collins studies" },
  { value: "101483", label: "Byron studies" },
  { value: "101484", label: "Shelley studies" },
  { value: "101485", label: "Milton studies" },
  { value: "101486", label: "J. M. Coetzee studies" },
  { value: "101487", label: "Christopher Marlowe studies" },
  { value: "101488", label: "Walter Scott studies" },
  { value: "101489", label: "Robert Louis Stevenson studies" },
  { value: "101490", label: "Robert Burns studies" },
  { value: "101491", label: "Virginia Woolf studies" },
  { value: "101492", label: "Bob Dylan studies" },
  { value: "101493", label: "Dylan Thomas studies" },
  { value: "101494", label: "W. B. Yeats studies" },
  { value: "101495", label: "Joseph Conrad studies" },
  { value: "101496", label: "Salman Rushdie studies" },
  { value: "101497", label: "Gaelic literature" },
  { value: "101498", label: "Scandinavian history" },
  { value: "101499", label: "Russian society and culture" },
  { value: "101500", label: "Polish society and culture" },
  { value: "101501", label: "Czech society and culture" },
  { value: "101503", label: "Persian society and culture studies" },
  { value: "101504", label: "Turkish society and culture studies" },
  { value: "101505", label: "carpentry and joinery" },
  { value: "101506", label: "liberalism" },
  { value: "101507", label: "conservatism" },
  { value: "101508", label: "socialism" },
  { value: "101509", label: "fascism" },
  { value: "101510", label: "environmentalism" },
  { value: "100277", label: "toxicology" }
];
var awards = [
  { value: "CertHE", label: "CertHE" },
  { value: "HNC", label: "HNC" },
  { value: "DipHE", label: "DipHE" },
  { value: "FdA", label: "FdA" },
  { value: "FdSc", label: "FdSc" },
  { value: "HND", label: "HND" },
  { value: "BA", label: "BA" },
  { value: "BA (Hons)", label: "BA (Hons)" },
  { value: "BArch", label: "BArch" },
  { value: "BArch (Hons)", label: "BArch (Hons)" },
  { value: "BBA", label: "BBA" },
  { value: "BBA (Hons)", label: "BBA (Hons)" },
  { value: "BDS", label: "BDS" },
  { value: "BEd", label: "BEd" },
  { value: "BEd (Hons)", label: "BEd (Hons)" },
  { value: "BEng", label: "BEng" },
  { value: "BEng (Hons)", label: "BEng (Hons)" },
  { value: "BFA", label: "BFA" },
  { value: "BFA (Hons)", label: "BFA (Hons)" },
  { value: "BMid (Hons)", label: "BMid (Hons)" },
  { value: "BMid", label: "BMid" },
  { value: "BMus", label: "BMus" },
  { value: "BMus (Hons)", label: "BMus (Hons)" },
  { value: "BSc", label: "BSc" },
  { value: "BSc (Hons)", label: "BSc (Hons)" },
  { value: "BVetMed", label: "BVetMed" },
  { value: "BVetMed (Hons)", label: "BVetMed (Hons)" },
  { value: "GradCert ", label: "GradCert " },
  { value: "GradDip", label: "GradDip" },
  { value: "LLB", label: "LLB" },
  { value: "LLB (Hons)", label: "LLB (Hons)" },
  { value: "LLM", label: "LLM" },
  { value: "MA", label: "MA" },
  { value: "MArch", label: "MArch" },
  { value: "MBA", label: "MBA" },
  { value: "MBBS", label: "MBBS" },
  { value: "MEd", label: "MEd" },
  { value: "MEng", label: "MEng" },
  { value: "MFA", label: "MFA" },
  { value: "MLitt", label: "MLitt" },
  { value: "MMath", label: "MMath" },
  { value: "MPharm", label: "MPharm" },
  { value: "MPharm (Hons)", label: "MPharm (Hons)" },
  { value: "MPhil", label: "MPhil" },
  { value: "MRes", label: "MRes" },
  { value: "MSc", label: "MSc" },
  { value: "MSci", label: "MSci" },
  { value: "MSt", label: "MSt" },
  { value: "MTh", label: "MTh" },
  { value: "PGCE", label: "PGCE" },
  { value: "PGCert", label: "PGCert" },
  { value: "PGDip", label: "PGDip" },
  { value: "DBA", label: "DBA" },
  { value: "DClinPsy", label: "DClinPsy" },
  { value: "DEng", label: "DEng" },
  { value: "DLitt", label: "DLitt" },
  { value: "DMus", label: "DMus" },
  { value: "DPhil", label: "DPhil" },
  { value: "DProf", label: "DProf" },
  { value: "DSc", label: "DSc" },
  { value: "EdD", label: "EdD" },
  { value: "EngD", label: "EngD" },
  { value: "MBChB", label: "MBChB" },
  { value: "MD", label: "MD" },
  { value: "PhD", label: "PhD" },
  { value: "ThD", label: "ThD" }
];
var studyModes = [
  { value: "Full-time", label: "Full-time" },
  { value: "Other full time", label: "Other full time" },
  { value: "Accelerated full time", label: "Accelerated full time" },
  { value: "Thick sandwich", label: "Thick sandwich" },
  { value: "Thin sandwich", label: "Thin sandwich" },
  { value: "Option of thick or thin sandwich", label: "Option of thick or thin sandwich" },
  { value: "Other sandwich", label: "Other sandwich" },
  { value: "Distance learning", label: "Distance learning" },
  { value: "Blended learning", label: "Blended learning" }
];
var entryPoints = [
  { value: "Year 0", label: "Year 0" },
  { value: "Year 1", label: "Year 1" },
  { value: "Year 2", label: "Year 2" },
  { value: "Year 3", label: "Year 3" },
  { value: "Year 4", label: "Year 4" },
  { value: "Year 5", label: "Year 5" },
  { value: "Year 6", label: "Year 6" }
];
var startMonths = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" }
];

// src/config/index.ts
var MaxPathwayAccess = /* @__PURE__ */ ((MaxPathwayAccess2) => {
  MaxPathwayAccess2["Full"] = "Full";
  MaxPathwayAccess2["Partial"] = "Partial";
  return MaxPathwayAccess2;
})(MaxPathwayAccess || {});
var TabCategories = /* @__PURE__ */ ((TabCategories2) => {
  TabCategories2["NOT_INVITED"] = "isNotInvited";
  TabCategories2["INVITED"] = "isInvited";
  TabCategories2["SUBMITTED"] = "isSubmitted";
  TabCategories2["NOT_SUBMITTED"] = "isNotSubmitted";
  TabCategories2["ASSESSED"] = "isAssessed";
  return TabCategories2;
})(TabCategories || {});
var ConfigEmailStatus = /* @__PURE__ */ ((ConfigEmailStatus2) => {
  ConfigEmailStatus2["ACTIVE"] = "ACTIVE";
  ConfigEmailStatus2["INACTIVE"] = "INACTIVE";
  return ConfigEmailStatus2;
})(ConfigEmailStatus || {});
var DocumentRetentionType = /* @__PURE__ */ ((DocumentRetentionType2) => {
  DocumentRetentionType2["STANDARD"] = "Standard Retention";
  DocumentRetentionType2["UKVI"] = "UK VI Retention";
  return DocumentRetentionType2;
})(DocumentRetentionType || {});
var SitsAuthMethod = /* @__PURE__ */ ((SitsAuthMethod2) => {
  SitsAuthMethod2["Basic"] = "Basic";
  SitsAuthMethod2["OAuth"] = "OAuth";
  SitsAuthMethod2["HeaderToken"] = "Header/Token";
  return SitsAuthMethod2;
})(SitsAuthMethod || {});
var EllucianAuthMethod = /* @__PURE__ */ ((EllucianAuthMethod2) => {
  EllucianAuthMethod2["Basic"] = "Basic";
  EllucianAuthMethod2["OAuth"] = "OAuth";
  EllucianAuthMethod2["SecretToken"] = "SecretToken";
  return EllucianAuthMethod2;
})(EllucianAuthMethod || {});
var InsightsAccessLevel = /* @__PURE__ */ ((InsightsAccessLevel2) => {
  InsightsAccessLevel2["NO"] = "0";
  InsightsAccessLevel2["YES_STANDARD"] = "1";
  InsightsAccessLevel2["YES_STANDARD_AND_HECOS"] = "2";
  return InsightsAccessLevel2;
})(InsightsAccessLevel || {});

// src/conflict-history/index.ts
var AGENT_DETAIL_CONFLICT_KEYS = [
  "agentDisplayName",
  "agentFamilyName",
  "agentGivenName",
  "branchAddressLine1",
  "branchAddressLine2",
  "branchAddressLine3",
  "branchCity",
  "branchCountry",
  "branchPostcode"
];
var AGENT_CONFLICT_SUMMARY_KEYS = [...AGENT_DETAIL_CONFLICT_KEYS];

// src/dao/apply/psql.ts
var EApplicantStudentNumberLogTableName = "apply_student_numbers_log";
var EApplicantStudentNumberLogPGKeys = /* @__PURE__ */ ((EApplicantStudentNumberLogPGKeys2) => {
  EApplicantStudentNumberLogPGKeys2["INTAKE"] = "intake_id";
  EApplicantStudentNumberLogPGKeys2["UNI"] = "uni";
  EApplicantStudentNumberLogPGKeys2["USER_ID"] = "user_id";
  EApplicantStudentNumberLogPGKeys2["EVENT"] = "event";
  EApplicantStudentNumberLogPGKeys2["LAST_UPDATED"] = "last_updated";
  EApplicantStudentNumberLogPGKeys2["WHO"] = "who";
  return EApplicantStudentNumberLogPGKeys2;
})(EApplicantStudentNumberLogPGKeys || {});
var EApplicantStudentNumberTableName = "apply_student_numbers";
var EApplicantStudentNumberPGKeys = /* @__PURE__ */ ((EApplicantStudentNumberPGKeys2) => {
  EApplicantStudentNumberPGKeys2["COMPOSITE"] = "composite_key";
  EApplicantStudentNumberPGKeys2["INTAKE"] = "intake_id";
  EApplicantStudentNumberPGKeys2["UNI"] = "uni";
  EApplicantStudentNumberPGKeys2["USER_ID"] = "user_id";
  EApplicantStudentNumberPGKeys2["STUDENT_NUM"] = "apply_student_number";
  EApplicantStudentNumberPGKeys2["LAST_UPDATED"] = "last_updated";
  EApplicantStudentNumberPGKeys2["WHO"] = "who";
  EApplicantStudentNumberPGKeys2["ACTION"] = "action";
  return EApplicantStudentNumberPGKeys2;
})(EApplicantStudentNumberPGKeys || {});
var EApplicantOfferPGKeys = /* @__PURE__ */ ((EApplicantOfferPGKeys2) => {
  EApplicantOfferPGKeys2["COURSE_ID"] = "course_id";
  EApplicantOfferPGKeys2["COURSE_NAME"] = "course_name";
  EApplicantOfferPGKeys2["MODE"] = "course_mode";
  EApplicantOfferPGKeys2["ENTRY_POINT"] = "course_entry_point";
  EApplicantOfferPGKeys2["KNOWN_BY"] = "known_by";
  EApplicantOfferPGKeys2["GIVEN_NAME"] = "given_name";
  EApplicantOfferPGKeys2["FAMILY_NAME"] = "family_name";
  EApplicantOfferPGKeys2["EMAIL"] = "email";
  EApplicantOfferPGKeys2["NATIONALITY"] = "nationality";
  EApplicantOfferPGKeys2["POSTCODE"] = "postcode";
  EApplicantOfferPGKeys2["CITY"] = "city";
  EApplicantOfferPGKeys2["BIRTH_COUNTRY"] = "birth_country";
  EApplicantOfferPGKeys2["RESIDENCE_COUNTRY"] = "residence_country";
  EApplicantOfferPGKeys2["APPLICATION_COUNTRY"] = "application_country";
  EApplicantOfferPGKeys2["OFFER_ID"] = "offer_id";
  EApplicantOfferPGKeys2["APPLICATION_ID"] = "application_id";
  EApplicantOfferPGKeys2["FEE_STATUS"] = "fee_status";
  EApplicantOfferPGKeys2["STATUS"] = "status";
  EApplicantOfferPGKeys2["INTAKE_ID"] = "intake_id";
  EApplicantOfferPGKeys2["UNI"] = "uni";
  EApplicantOfferPGKeys2["USER_ID"] = "user_id";
  EApplicantOfferPGKeys2["APPLIED_DATE"] = "applied_date";
  EApplicantOfferPGKeys2["ISSUE_DATE"] = "issue_date";
  EApplicantOfferPGKeys2["CONDITION_TYPE"] = "condition_type";
  EApplicantOfferPGKeys2["APPLICANT_STATUS"] = "applicant_status";
  EApplicantOfferPGKeys2["PENDING_CHANGES"] = "pending_changes";
  EApplicantOfferPGKeys2["REQUIREMENTS_IN_ASSESSMENT"] = "requirements_in_assessment";
  EApplicantOfferPGKeys2["REQUIREMENTS_WITH_CONDITION"] = "requirements_with_condition";
  EApplicantOfferPGKeys2["APPLICANT_LAST_UPDATED_AT"] = "applicant_last_updated_at";
  EApplicantOfferPGKeys2["STAGE_CHANGE_DATE"] = "stage_change_date";
  EApplicantOfferPGKeys2["NEW_DOCUMENTS_COUNT"] = "new_documents_count";
  EApplicantOfferPGKeys2["AGENT_ID"] = "agent_id";
  EApplicantOfferPGKeys2["AGENT_NAME"] = "agent_name";
  EApplicantOfferPGKeys2["TAGS"] = "tags";
  EApplicantOfferPGKeys2["AGENT_ACCESS_STATUS"] = "agent_access_status";
  EApplicantOfferPGKeys2["STUDENT_NUMBER"] = "student_number";
  EApplicantOfferPGKeys2["PARTNERS"] = "partners";
  EApplicantOfferPGKeys2["STATUS_REASON"] = "status_reason";
  EApplicantOfferPGKeys2["HIGHEST_QUALIFICATION"] = "highest_qualification";
  EApplicantOfferPGKeys2["SCHOLARSHIPS_APPLIED"] = "scholarships_applied";
  EApplicantOfferPGKeys2["POTENTIAL_DUPLICATE"] = "potential_duplicate";
  EApplicantOfferPGKeys2["PHONE_NO"] = "phone_number";
  EApplicantOfferPGKeys2["DOB"] = "dob";
  EApplicantOfferPGKeys2["STUDY_LEVEL"] = "study_level";
  return EApplicantOfferPGKeys2;
})(EApplicantOfferPGKeys || {});
var IApplicantOfferPGTypeMap = {
  p_key: ["string", "required"],
  ["uni" /* UNI */]: ["string", "required"],
  ["user_id" /* USER_ID */]: ["string", "required"],
  ["offer_id" /* OFFER_ID */]: ["string", "required"],
  ["intake_id" /* INTAKE_ID */]: ["string", "required"],
  ["application_id" /* APPLICATION_ID */]: ["string", "required"],
  ["status" /* STATUS */]: ["string", "required"],
  ["email" /* EMAIL */]: ["string", "required"],
  ["known_by" /* KNOWN_BY */]: ["string", "required"],
  ["given_name" /* GIVEN_NAME */]: ["string"],
  ["family_name" /* FAMILY_NAME */]: ["string"],
  ["fee_status" /* FEE_STATUS */]: ["string"],
  ["nationality" /* NATIONALITY */]: ["string"],
  ["postcode" /* POSTCODE */]: ["string"],
  ["city" /* CITY */]: ["string"],
  ["birth_country" /* BIRTH_COUNTRY */]: ["string"],
  ["application_country" /* APPLICATION_COUNTRY */]: ["string"],
  ["residence_country" /* RESIDENCE_COUNTRY */]: ["string"],
  ["course_id" /* COURSE_ID */]: ["string"],
  ["course_name" /* COURSE_NAME */]: ["string"],
  ["course_mode" /* MODE */]: ["string"],
  ["course_entry_point" /* ENTRY_POINT */]: ["string"],
  ["applied_date" /* APPLIED_DATE */]: ["string"],
  ["issue_date" /* ISSUE_DATE */]: ["string"],
  ["condition_type" /* CONDITION_TYPE */]: ["string"],
  ["applicant_status" /* APPLICANT_STATUS */]: ["jsonb"],
  ["pending_changes" /* PENDING_CHANGES */]: ["boolean"],
  ["requirements_in_assessment" /* REQUIREMENTS_IN_ASSESSMENT */]: ["integer"],
  ["requirements_with_condition" /* REQUIREMENTS_WITH_CONDITION */]: ["integer"],
  ["applicant_last_updated_at" /* APPLICANT_LAST_UPDATED_AT */]: ["string"],
  ["stage_change_date" /* STAGE_CHANGE_DATE */]: ["string"],
  ["new_documents_count" /* NEW_DOCUMENTS_COUNT */]: ["integer"],
  ["agent_id" /* AGENT_ID */]: ["string"],
  ["agent_name" /* AGENT_NAME */]: ["string"],
  ["tags" /* TAGS */]: ["jsonb"],
  ["student_number" /* STUDENT_NUMBER */]: ["string"],
  ["agent_access_status" /* AGENT_ACCESS_STATUS */]: ["string"],
  ["partners" /* PARTNERS */]: ["string[]"],
  ["status_reason" /* STATUS_REASON */]: ["string"],
  ["highest_qualification" /* HIGHEST_QUALIFICATION */]: ["string"],
  ["scholarships_applied" /* SCHOLARSHIPS_APPLIED */]: ["float"],
  ["potential_duplicate" /* POTENTIAL_DUPLICATE */]: ["boolean"],
  ["phone_number" /* PHONE_NO */]: ["string"],
  ["dob" /* DOB */]: ["string"],
  ["study_level" /* STUDY_LEVEL */]: ["string"]
};
var ApplicantOfferPGFilterMap = Object.freeze({
  ["nationality" /* NATIONALITY */]: "nationality" /* NATIONALITY */,
  ["birthCountry" /* BIRTH_COUNTRY */]: "birth_country" /* BIRTH_COUNTRY */,
  ["applicationCountry" /* APPLICATION_COUNTRY */]: "application_country" /* APPLICATION_COUNTRY */,
  ["country" /* COUNTRY */]: "residence_country" /* RESIDENCE_COUNTRY */,
  ["feeStatus" /* FEE_STATUS */]: "fee_status" /* FEE_STATUS */,
  ["offerStatus" /* OFFER_STATUS */]: "status" /* STATUS */,
  ["course" /* COURSE */]: "course_name" /* COURSE_NAME */,
  ["tag" /* TAG */]: "tags" /* TAGS */
});
var EApplicationPGKeys = /* @__PURE__ */ ((EApplicationPGKeys2) => {
  EApplicationPGKeys2["COURSE_ID"] = "course_id";
  EApplicationPGKeys2["COURSE_NAME"] = "course_name";
  EApplicationPGKeys2["KNOWN_BY"] = "known_by";
  EApplicationPGKeys2["GIVEN_NAME"] = "given_name";
  EApplicationPGKeys2["FAMILY_NAME"] = "family_name";
  EApplicationPGKeys2["EMAIL"] = "email";
  EApplicationPGKeys2["NATIONALITY"] = "nationality";
  EApplicationPGKeys2["BIRTH_COUNTRY"] = "birth_country";
  EApplicationPGKeys2["RESIDENCE_COUNTRY"] = "residence_country";
  EApplicationPGKeys2["APPLICATION_COUNTRY"] = "application_country";
  EApplicationPGKeys2["POSTCODE"] = "postcode";
  EApplicationPGKeys2["CITY"] = "city";
  EApplicationPGKeys2["APPLICATION_ID"] = "application_id";
  EApplicationPGKeys2["FEE_STATUS"] = "fee_status";
  EApplicationPGKeys2["STATUS"] = "application_status";
  EApplicationPGKeys2["INTAKE_ID"] = "intake_id";
  EApplicationPGKeys2["UNI"] = "uni";
  EApplicationPGKeys2["USER_ID"] = "user_id";
  EApplicationPGKeys2["DOB"] = "dob";
  EApplicationPGKeys2["PHONE_NO"] = "phone_number";
  EApplicationPGKeys2["UCAS"] = "ucas_id";
  EApplicationPGKeys2["GENDER"] = "gender";
  EApplicationPGKeys2["STUDY_LEVEL"] = "intended_level_of_study";
  EApplicationPGKeys2["AGENT_ID"] = "agent_id";
  EApplicationPGKeys2["AGENT_NAME"] = "agent_name";
  EApplicationPGKeys2["AGENT_ACCESS_STATUS"] = "agent_access_status";
  EApplicationPGKeys2["PARTNERS"] = "partners";
  EApplicationPGKeys2["HIGHEST_QUALIFICATION"] = "highest_qualification";
  EApplicationPGKeys2["POTENTIAL_DUPLICATE"] = "potential_duplicate";
  EApplicationPGKeys2["APPLICANT_LAST_UPDATED_AT"] = "applicant_last_updated_at";
  EApplicationPGKeys2["STAGE_CHANGE_DATE"] = "stage_change_date";
  return EApplicationPGKeys2;
})(EApplicationPGKeys || {});
var IApplicationPGTypeMap = {
  p_key: ["string", "required"],
  ["uni" /* UNI */]: ["string", "required"],
  ["user_id" /* USER_ID */]: ["string", "required"],
  ["application_id" /* APPLICATION_ID */]: ["string", "required"],
  ["email" /* EMAIL */]: ["string", "required"],
  ["known_by" /* KNOWN_BY */]: ["string", "required"],
  ["given_name" /* GIVEN_NAME */]: ["string"],
  ["family_name" /* FAMILY_NAME */]: ["string"],
  ["fee_status" /* FEE_STATUS */]: ["string"],
  ["nationality" /* NATIONALITY */]: ["string"],
  ["postcode" /* POSTCODE */]: ["string"],
  ["city" /* CITY */]: ["string"],
  ["birth_country" /* BIRTH_COUNTRY */]: ["string"],
  ["application_country" /* APPLICATION_COUNTRY */]: ["string"],
  ["residence_country" /* RESIDENCE_COUNTRY */]: ["string"],
  ["dob" /* DOB */]: ["string"],
  ["phone_number" /* PHONE_NO */]: ["string"],
  ["ucas_id" /* UCAS */]: ["string"],
  ["gender" /* GENDER */]: ["string"],
  ["application_status" /* STATUS */]: ["string"],
  ["intake_id" /* INTAKE_ID */]: ["string"],
  ["intended_level_of_study" /* STUDY_LEVEL */]: ["string"],
  ["course_id" /* COURSE_ID */]: ["string"],
  ["course_name" /* COURSE_NAME */]: ["string"],
  ["agent_id" /* AGENT_ID */]: ["string"],
  ["agent_name" /* AGENT_NAME */]: ["string"],
  ["agent_access_status" /* AGENT_ACCESS_STATUS */]: ["string"],
  ["partners" /* PARTNERS */]: ["string[]"],
  ["highest_qualification" /* HIGHEST_QUALIFICATION */]: ["string"],
  ["potential_duplicate" /* POTENTIAL_DUPLICATE */]: ["boolean"],
  ["stage_change_date" /* STAGE_CHANGE_DATE */]: ["string"],
  ["applicant_last_updated_at" /* APPLICANT_LAST_UPDATED_AT */]: ["string"]
};
var applicationPGKeys = Object.keys(IApplicationPGTypeMap);
var ApplicationPGFilterMap = Object.freeze({
  ["nationality" /* NATIONALITY */]: "nationality" /* NATIONALITY */,
  ["birthCountry" /* BIRTH_COUNTRY */]: "birth_country" /* BIRTH_COUNTRY */,
  ["applicationCountry" /* APPLICATION_COUNTRY */]: "application_country" /* APPLICATION_COUNTRY */,
  ["country" /* COUNTRY */]: "residence_country" /* RESIDENCE_COUNTRY */,
  ["course" /* COURSE */]: "course_name" /* COURSE_NAME */,
  ["feeStatus" /* FEE_STATUS */]: "fee_status" /* FEE_STATUS */,
  ["offerStatus" /* OFFER_STATUS */]: "application_status" /* STATUS */
});

// src/dao/offices/attributes.ts
var EStudentImportAttributeFieldNames = /* @__PURE__ */ ((EStudentImportAttributeFieldNames2) => {
  EStudentImportAttributeFieldNames2["ADDRESS_LINE_1"] = "addressLine1";
  EStudentImportAttributeFieldNames2["ADDRESS_LINE_2"] = "addressLine2";
  EStudentImportAttributeFieldNames2["ADDRESS_LINE_3"] = "addressLine3";
  EStudentImportAttributeFieldNames2["AGENT_COMPANY"] = "agentCompany";
  EStudentImportAttributeFieldNames2["AGENT_COMPANY_EMAIL"] = "agentCompanyEmail";
  EStudentImportAttributeFieldNames2["AGENT_EMAIL"] = "agentEmail";
  EStudentImportAttributeFieldNames2["AGENT_NAME"] = "agentName";
  EStudentImportAttributeFieldNames2["AGENT_OFFICE"] = "agentOffice";
  EStudentImportAttributeFieldNames2["APPLICATION_DATE"] = "applicationDate";
  EStudentImportAttributeFieldNames2["APPLICATION_ID"] = "applicationId";
  EStudentImportAttributeFieldNames2["BRANCH_OFFICE"] = "branchOffice";
  EStudentImportAttributeFieldNames2["CITY"] = "city";
  EStudentImportAttributeFieldNames2["CONFIRMED"] = "confirmed";
  EStudentImportAttributeFieldNames2["COUNSELLOR_EMAIL"] = "counsellorEmail";
  EStudentImportAttributeFieldNames2["COUNSELLOR_NAME"] = "counsellorName";
  EStudentImportAttributeFieldNames2["COUNTRY"] = "country";
  EStudentImportAttributeFieldNames2["COUNTRY_OF_BIRTH"] = "countryOfBirth";
  EStudentImportAttributeFieldNames2["CRIMINAL_CONVICTIONS"] = "criminalConvictions";
  EStudentImportAttributeFieldNames2["DOB"] = "dob";
  EStudentImportAttributeFieldNames2["EMAIL"] = "email";
  EStudentImportAttributeFieldNames2["ENGLISH_LEVEL_ATTAINED"] = "englishLevelAttained";
  EStudentImportAttributeFieldNames2["ENGLISH_TEST_PROVIDER"] = "englishTestProvider";
  EStudentImportAttributeFieldNames2["FAMILY_NAME"] = "familyName";
  EStudentImportAttributeFieldNames2["GENDER"] = "gender";
  EStudentImportAttributeFieldNames2["GIVEN_NAME"] = "givenName";
  EStudentImportAttributeFieldNames2["NATIONALITY"] = "nationality";
  EStudentImportAttributeFieldNames2["OTHER_NAME"] = "otherName";
  EStudentImportAttributeFieldNames2["PASSPORT_EXPIRY"] = "passportExpiry";
  EStudentImportAttributeFieldNames2["PASSPORT_NUMBER"] = "passportNumber";
  EStudentImportAttributeFieldNames2["PHONE"] = "phone";
  EStudentImportAttributeFieldNames2["PLACE_OF_BIRTH"] = "placeOfBirth";
  EStudentImportAttributeFieldNames2["POSTCODE"] = "postcode";
  EStudentImportAttributeFieldNames2["PREVIOUS_COURSE_COMPLETION"] = "previousCourseCompletion";
  EStudentImportAttributeFieldNames2["PREV_UK_STUDY"] = "prevUKStudy";
  EStudentImportAttributeFieldNames2["SELT_LISTENING"] = "seltListening";
  EStudentImportAttributeFieldNames2["SELT_READING"] = "seltReading";
  EStudentImportAttributeFieldNames2["SELT_SPEAKING"] = "seltSpeaking";
  EStudentImportAttributeFieldNames2["SELT_WRITING"] = "seltWriting";
  EStudentImportAttributeFieldNames2["STUDENT_NO"] = "studentNo";
  EStudentImportAttributeFieldNames2["UCAS_ID"] = "ucasId";
  EStudentImportAttributeFieldNames2["WITH_AGENT"] = "withAgent";
  EStudentImportAttributeFieldNames2["ADMISSIONS_OFFICE"] = "admissionsOffice";
  EStudentImportAttributeFieldNames2["SERVICES_ASSIGNED"] = "servicesAssigned";
  EStudentImportAttributeFieldNames2["TAGS_ASSIGNED"] = "tagsAssigned";
  EStudentImportAttributeFieldNames2["STAGE"] = "stage";
  EStudentImportAttributeFieldNames2["AGE"] = "age";
  EStudentImportAttributeFieldNames2["VISA_APPLICATION_COUNTRY"] = "visaApplicationCountry";
  EStudentImportAttributeFieldNames2["RISK_REGION"] = "riskRegion";
  EStudentImportAttributeFieldNames2["COURSE_FEE_PAID_TO_DATE"] = "courseFeePaidToDate";
  EStudentImportAttributeFieldNames2["ACCOM_FEE_PAID_TO_DATE"] = "accomFeePaidToDate";
  EStudentImportAttributeFieldNames2["IS_SELT_REQD"] = "isSELTReqd";
  EStudentImportAttributeFieldNames2["REASON_SELT_NOT_REQD"] = "reasonSELTNotReqd";
  EStudentImportAttributeFieldNames2["PREVIOUS_COURSE_LEVEL"] = "previousCourseLevel";
  EStudentImportAttributeFieldNames2["COURSE_PROGRESSION"] = "courseProgression";
  EStudentImportAttributeFieldNames2["PROGRESSION_TEXT"] = "progressionText";
  EStudentImportAttributeFieldNames2["DOCS_USED_TO_OBTAIN_OFFER"] = "docsUsedToObtainOffer";
  EStudentImportAttributeFieldNames2["IS_ACCOM_PROVIDED"] = "isAccomProvided";
  EStudentImportAttributeFieldNames2["IS_ACCOM_INCLUDED_COURSE_FEE"] = "isAccomIncludedCourseFee";
  EStudentImportAttributeFieldNames2["IS_WORK_PLACEMENT"] = "isWorkPlacement";
  EStudentImportAttributeFieldNames2["WORK_PLACEMENT_PERC"] = "workPlacementPerc";
  EStudentImportAttributeFieldNames2["WORK_PLACEMENT_TEXT"] = "workPlacementText";
  EStudentImportAttributeFieldNames2["WORK_PLACEMENT_ADDRESS_LINE_1"] = "workPlacementAddressLine1";
  EStudentImportAttributeFieldNames2["WORK_PLACEMENT_ADDRESS_LINE_2"] = "workPlacementAddressLine2";
  EStudentImportAttributeFieldNames2["WORK_PLACEMENT_ADDRESS_LINE_3"] = "workPlacementAddressLine3";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_ID"] = "offers_courses_id";
  EStudentImportAttributeFieldNames2["OFFERS_PRESESSIONAL_TITLE"] = "offers_presessional_title";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_TITLE"] = "offers_courses_title";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CONDITIONAL"] = "offers_courses_conditional";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_DECLINED"] = "offers_courses_declined";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CAH3"] = "offers_courses_cah3";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_LEVEL"] = "offers_courses_level";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_SECONDARY_LEVEL"] = "offers_courses_secondaryLevel";
  EStudentImportAttributeFieldNames2["OFFERS_PRESESSIONAL_START_DATE"] = "offers_presessional_start_date";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_START_DATE"] = "offers_courses_start_date";
  EStudentImportAttributeFieldNames2["OFFERS_PRESESSIONAL_END_DATE"] = "offers_presessional_end_date";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_END_DATE"] = "offers_courses_end_date";
  EStudentImportAttributeFieldNames2["OFFERS_PRESESSIONAL_FEE"] = "offers_presessional_fee";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_FEE"] = "offers_courses_fee";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_SCHOLARSHIP_AMOUNT1"] = "offers_courses_scholarshipAmount1";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_SCHOLARSHIP_TITLE1"] = "offers_courses_scholarshipTitle1";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_INNER_LONDON"] = "offers_courses_inner_london";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_LAST_ACCEPTANCE_DATE"] = "offers_courses_lastAcceptanceDate";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_IS_FULL_TIME"] = "offers_courses_isFullTime";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_HOURS_PER_WEEK"] = "offers_courses_hoursPerWeek";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_ATAS"] = "offers_courses_atas";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CONDITIONS_TEXT1"] = "offers_courses_conditions_text1";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CONDITIONS_TEXT2"] = "offers_courses_conditions_text2";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CONDITIONS_TEXT3"] = "offers_courses_conditions_text3";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CONDITIONS_TEXT4"] = "offers_courses_conditions_text4";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CONDITIONS_TEXT5"] = "offers_courses_conditions_text5";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CONDITIONS_TEXT6"] = "offers_courses_conditions_text6";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CONDITIONS_TEXT7"] = "offers_courses_conditions_text7";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CONDITIONS_TEXT8"] = "offers_courses_conditions_text8";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_CONDITIONS_TEXT9"] = "offers_courses_conditions_text9";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_FACULTY"] = "offers_courses_faculty";
  EStudentImportAttributeFieldNames2["MAIN_STUDY_ADDRESS_LINE_1"] = "mainStudyAddressLine1";
  EStudentImportAttributeFieldNames2["MAIN_STUDY_ADDRESS_LINE_2"] = "mainStudyAddressLine2";
  EStudentImportAttributeFieldNames2["MAIN_STUDY_ADDRESS_LINE_3"] = "mainStudyAddressLine3";
  EStudentImportAttributeFieldNames2["MAIN_STUDY_ADDRESS_CITY"] = "mainStudyAddressCity";
  EStudentImportAttributeFieldNames2["MAIN_STUDY_ADDRESS_COUNTRY"] = "mainStudyAddressCountry";
  EStudentImportAttributeFieldNames2["MAIN_STUDY_ADDRESS_POSTCODE"] = "mainStudyAddressPostcode";
  EStudentImportAttributeFieldNames2["WORK_PLACEMENT_ADDRESS_CITY"] = "workPlacementAddressCity";
  EStudentImportAttributeFieldNames2["WORK_PLACEMENT_ADDRESS_COUNTRY"] = "workPlacementAddressCountry";
  EStudentImportAttributeFieldNames2["WORK_PLACEMENT_ADDRESS_POSTCODE"] = "workPlacementAddressPostcode";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_OFFER_EVIDENCE"] = "offers_courses_offerEvidence";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_ACCEPTED"] = "offers_courses_accepted";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_HECOS1"] = "offers_courses_qual_hecos1";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_HECOS2"] = "offers_courses_qual_hecos2";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_HECOS3"] = "offers_courses_qual_hecos3";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_HECOS4"] = "offers_courses_qual_hecos4";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_HECOS5"] = "offers_courses_qual_hecos5";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_PROPORTION1"] = "offers_courses_qual_proportion1";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_PROPORTION2"] = "offers_courses_qual_proportion2";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_PROPORTION3"] = "offers_courses_qual_proportion3";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_PROPORTION4"] = "offers_courses_qual_proportion4";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_PROPORTION5"] = "offers_courses_qual_proportion5";
  EStudentImportAttributeFieldNames2["OFFERS_COURSES_QUAL_CAT"] = "offers_courses_qual_cat";
  EStudentImportAttributeFieldNames2["OFFER_ID"] = "offerId";
  EStudentImportAttributeFieldNames2["INTAKE_ID"] = "intakeId";
  EStudentImportAttributeFieldNames2["UNI_PARTNER_ID"] = "uniPartnerId";
  EStudentImportAttributeFieldNames2["UNI"] = "uni";
  EStudentImportAttributeFieldNames2["PATHWAY"] = "pathway";
  EStudentImportAttributeFieldNames2["EXTERNAL_CAS_STATUS"] = "externalCasStatus";
  EStudentImportAttributeFieldNames2["OFFERS_DURATION_MONTHS"] = "offersDurationMonths";
  EStudentImportAttributeFieldNames2["TUITION_DEPOSIT"] = "tuitionDeposit";
  EStudentImportAttributeFieldNames2["DEPOSIT_AMOUNT"] = "depositAmount";
  EStudentImportAttributeFieldNames2["AGENT_FAMILY_NAME"] = "agentFamilyName";
  EStudentImportAttributeFieldNames2["AGENT_GIVEN_NAME"] = "agentGivenName";
  EStudentImportAttributeFieldNames2["BRANCH_ADDRESS_LINE_1"] = "branchAddressLine1";
  EStudentImportAttributeFieldNames2["BRANCH_ADDRESS_LINE_2"] = "branchAddressLine2";
  EStudentImportAttributeFieldNames2["BRANCH_ADDRESS_LINE_3"] = "branchAddressLine3";
  EStudentImportAttributeFieldNames2["BRANCH_CITY"] = "branchCity";
  EStudentImportAttributeFieldNames2["BRANCH_COUNTRY"] = "branchCountry";
  EStudentImportAttributeFieldNames2["BRANCH_POSTCODE"] = "branchPostcode";
  return EStudentImportAttributeFieldNames2;
})(EStudentImportAttributeFieldNames || {});

// src/dao/offices/psql.ts
var ApplicantOfferOfficesConditionMap = Object.freeze({
  ["countryOfBirth" /* COUNTRY_OF_BIRTH */]: "birth_country" /* BIRTH_COUNTRY */,
  ["nationality" /* NATIONALITY */]: "nationality" /* NATIONALITY */,
  ["country" /* COUNTRY */]: "application_country" /* APPLICATION_COUNTRY */,
  ["intakeId" /* INTAKE_ID */]: "intake_id" /* INTAKE_ID */,
  ["uni" /* UNI */]: "uni" /* UNI */,
  ["offers_courses_id" /* OFFERS_COURSES_ID */]: "course_id" /* COURSE_ID */,
  ["offers_courses_title" /* OFFERS_COURSES_TITLE */]: "course_name" /* COURSE_NAME */,
  ["stage" /* STAGE */]: "status" /* STATUS */,
  ["tagsAssigned" /* TAGS_ASSIGNED */]: "tags" /* TAGS */
});
var ApplicationOfficesConditionMap = Object.freeze({
  ["country" /* COUNTRY */]: "application_country" /* APPLICATION_COUNTRY */,
  ["nationality" /* NATIONALITY */]: "nationality" /* NATIONALITY */,
  ["intakeId" /* INTAKE_ID */]: "intake_id" /* INTAKE_ID */,
  ["uni" /* UNI */]: "uni" /* UNI */,
  ["offers_courses_id" /* OFFERS_COURSES_ID */]: "course_id" /* COURSE_ID */,
  ["offers_courses_title" /* OFFERS_COURSES_TITLE */]: "course_name" /* COURSE_NAME */,
  ["stage" /* STAGE */]: "application_status" /* STATUS */
});

// src/email/enums.ts
var BounceType = /* @__PURE__ */ ((BounceType2) => {
  BounceType2["Permanent"] = "Permanent";
  BounceType2["Transient"] = "Transient";
  return BounceType2;
})(BounceType || {});

// src/emails/index.ts
var EmailTemplates = /* @__PURE__ */ ((EmailTemplates2) => {
  EmailTemplates2["WELCOME"] = "welcomeEmail";
  EmailTemplates2["CAS_BYPASS_WELCOME"] = "casBypassWelcome";
  EmailTemplates2["STUDENT_DETAILS"] = "studentResumePersonalInfo";
  EmailTemplates2["HISTORY"] = "studentResumeHistory";
  EmailTemplates2["FINANCE"] = "studentResumeFinancePlan";
  EmailTemplates2["OUTSTANDING_DOCUMENTS"] = "resumeOutstandingDocumentsEmail";
  EmailTemplates2["OUTSTANDING_FOLLOWUP_DOCUMENTS"] = "resumeOutstandingFollowupDocumentsEmail";
  EmailTemplates2["PRECAS_INTERVIEW"] = "studentResumeQuestionnaire";
  EmailTemplates2["INTERVIEWS"] = "studentResumeInterview";
  EmailTemplates2["DEPOSIT"] = "studentResumeDeposit";
  EmailTemplates2["PASSPORT"] = "studentResumePassport";
  EmailTemplates2["COURSE_DELETION_REPORT"] = "courseDeletionReportEmail";
  EmailTemplates2["PATHWAY_REVIEW_STUDENTS_FOR_UNI_REPORT"] = "pathwayReviewStudentsForUniReportEmail";
  EmailTemplates2["CONFLICT_EXCEPTION_REPORT"] = "conflictExceptionReportEmail";
  EmailTemplates2["ARRIVAL_1"] = "arrivalEmail1";
  EmailTemplates2["ARRIVAL_2"] = "arrivalEmail2";
  EmailTemplates2["ARRIVAL_3"] = "arrivalEmail3";
  EmailTemplates2["ARRIVAL_4"] = "arrivalEmail4";
  EmailTemplates2["VISA_1"] = "studentStatusVisa1";
  EmailTemplates2["VISA_1_LATE"] = "studentStatusVisa1Late";
  EmailTemplates2["VISA_2"] = "studentStatusVisa2";
  EmailTemplates2["VISA_2_LATE"] = "studentStatusVisa2Late";
  EmailTemplates2["READY_FOR_CAS"] = "readyForCASEmail";
  EmailTemplates2["DEFERRAL"] = "deferralEmail";
  EmailTemplates2["NEW_INTERVIEWS"] = "studentResumeInterviewNew";
  return EmailTemplates2;
})(EmailTemplates || {});
var ApplicantReminderEmailTemplates = /* @__PURE__ */ ((ApplicantReminderEmailTemplates2) => {
  ApplicantReminderEmailTemplates2["VERIFY_REMINDER_1"] = "applicantVerifyReminder1";
  ApplicantReminderEmailTemplates2["VERIFY_REMINDER_2"] = "applicantVerifyReminder2";
  ApplicantReminderEmailTemplates2["VERIFY_REMINDER_3"] = "applicantVerifyReminder3";
  ApplicantReminderEmailTemplates2["VERIFY_REMINDER_4"] = "applicantVerifyReminder4";
  ApplicantReminderEmailTemplates2["REGISTER_INTEREST_1"] = "applicantRegisterInterestReminder1";
  ApplicantReminderEmailTemplates2["REGISTER_INTEREST_2"] = "applicantRegisterInterestReminder2";
  ApplicantReminderEmailTemplates2["REGISTER_INTEREST_3"] = "applicantRegisterInterestReminder3";
  ApplicantReminderEmailTemplates2["REGISTER_INTEREST_4"] = "applicantRegisterInterestReminder4";
  ApplicantReminderEmailTemplates2["START_APPLICATION_1"] = "applicantStartApplicationReminder1";
  ApplicantReminderEmailTemplates2["START_APPLICATION_2"] = "applicantStartApplicationReminder2";
  ApplicantReminderEmailTemplates2["START_APPLICATION_3"] = "applicantStartApplicationReminder3";
  ApplicantReminderEmailTemplates2["START_APPLICATION_4"] = "applicantStartApplicationReminder4";
  ApplicantReminderEmailTemplates2["CONTINUE_APPLICATION_1"] = "applicantContinueApplicationReminder1";
  ApplicantReminderEmailTemplates2["CONTINUE_APPLICATION_2"] = "applicantContinueApplicationReminder2";
  ApplicantReminderEmailTemplates2["CONTINUE_APPLICATION_3"] = "applicantContinueApplicationReminder3";
  ApplicantReminderEmailTemplates2["CONTINUE_APPLICATION_4"] = "applicantContinueApplicationReminder4";
  ApplicantReminderEmailTemplates2["SUBMIT_APPLICATION_1"] = "applicantSubmitApplicationReminder1";
  ApplicantReminderEmailTemplates2["SUBMIT_APPLICATION_2"] = "applicantSubmitApplicationReminder2";
  ApplicantReminderEmailTemplates2["SUBMIT_APPLICATION_3"] = "applicantSubmitApplicationReminder3";
  ApplicantReminderEmailTemplates2["SUBMIT_APPLICATION_4"] = "applicantSubmitApplicationReminder4";
  ApplicantReminderEmailTemplates2["UPDATE_PROGRAMME_CHOICES_1"] = "applicantUpdateProgrammeChoices1";
  ApplicantReminderEmailTemplates2["UPDATE_PROGRAMME_CHOICES_2"] = "applicantUpdateProgrammeChoices2";
  ApplicantReminderEmailTemplates2["UPDATE_PROGRAMME_CHOICES_3"] = "applicantUpdateProgrammeChoices3";
  ApplicantReminderEmailTemplates2["UPDATE_PROGRAMME_CHOICES_4"] = "applicantUpdateProgrammeChoices4";
  ApplicantReminderEmailTemplates2["ACCEPT_YOUR_OFFER_1"] = "applicantAcceptOfferReminder1";
  ApplicantReminderEmailTemplates2["ACCEPT_YOUR_OFFER_2"] = "applicantAcceptOfferReminder2";
  ApplicantReminderEmailTemplates2["SATISFY_OFFER_CONDITION_1"] = "applicantSatisfyOfferConditionReminder1";
  ApplicantReminderEmailTemplates2["SATISFY_OFFER_CONDITION_2"] = "applicantSatisfyOfferConditionReminder2";
  ApplicantReminderEmailTemplates2["CONFIRM_PAYMENT_1"] = "applicantConfirmPaymentReminder1";
  ApplicantReminderEmailTemplates2["CONFIRM_PAYMENT_2"] = "applicantConfirmPaymentReminder2";
  return ApplicantReminderEmailTemplates2;
})(ApplicantReminderEmailTemplates || {});
var applicantTemplateToEmailTemplateMap = {
  ["applicantRegisterInterestReminder1" /* REGISTER_INTEREST_1 */]: "applicantYourInformationReminder",
  ["applicantRegisterInterestReminder2" /* REGISTER_INTEREST_2 */]: "applicantYourInformationReminder",
  ["applicantRegisterInterestReminder3" /* REGISTER_INTEREST_3 */]: "applicantYourInformationReminder",
  ["applicantRegisterInterestReminder4" /* REGISTER_INTEREST_4 */]: "applicantYourInformationReminder",
  ["applicantVerifyReminder1" /* VERIFY_REMINDER_1 */]: "applicantEmailVerifyReminder",
  ["applicantVerifyReminder2" /* VERIFY_REMINDER_2 */]: "applicantEmailVerifyReminder",
  ["applicantVerifyReminder3" /* VERIFY_REMINDER_3 */]: "applicantEmailVerifyReminder",
  ["applicantVerifyReminder4" /* VERIFY_REMINDER_4 */]: "applicantEmailVerifyReminder",
  ["applicantStartApplicationReminder1" /* START_APPLICATION_1 */]: "applicantApplicationStart",
  ["applicantStartApplicationReminder2" /* START_APPLICATION_2 */]: "applicantApplicationStart",
  ["applicantStartApplicationReminder3" /* START_APPLICATION_3 */]: "applicantApplicationStart",
  ["applicantStartApplicationReminder4" /* START_APPLICATION_4 */]: "applicantApplicationStart",
  ["applicantContinueApplicationReminder1" /* CONTINUE_APPLICATION_1 */]: "applicantApplicationContinue",
  ["applicantContinueApplicationReminder2" /* CONTINUE_APPLICATION_2 */]: "applicantApplicationContinue",
  ["applicantContinueApplicationReminder3" /* CONTINUE_APPLICATION_3 */]: "applicantApplicationContinue",
  ["applicantContinueApplicationReminder4" /* CONTINUE_APPLICATION_4 */]: "applicantApplicationContinue",
  ["applicantSubmitApplicationReminder1" /* SUBMIT_APPLICATION_1 */]: "applicantApplicationSubmit",
  ["applicantSubmitApplicationReminder2" /* SUBMIT_APPLICATION_2 */]: "applicantApplicationSubmit",
  ["applicantSubmitApplicationReminder3" /* SUBMIT_APPLICATION_3 */]: "applicantApplicationSubmit",
  ["applicantSubmitApplicationReminder4" /* SUBMIT_APPLICATION_4 */]: "applicantApplicationSubmit",
  ["applicantUpdateProgrammeChoices1" /* UPDATE_PROGRAMME_CHOICES_1 */]: "applicantUpdateStudyPlans",
  ["applicantUpdateProgrammeChoices2" /* UPDATE_PROGRAMME_CHOICES_2 */]: "applicantUpdateStudyPlans",
  ["applicantUpdateProgrammeChoices3" /* UPDATE_PROGRAMME_CHOICES_3 */]: "applicantUpdateStudyPlans",
  ["applicantUpdateProgrammeChoices4" /* UPDATE_PROGRAMME_CHOICES_4 */]: "applicantUpdateStudyPlans",
  ["applicantAcceptOfferReminder1" /* ACCEPT_YOUR_OFFER_1 */]: "applicantOfferAcceptReminder",
  ["applicantAcceptOfferReminder2" /* ACCEPT_YOUR_OFFER_2 */]: "applicantOfferAcceptReminder",
  ["applicantConfirmPaymentReminder1" /* CONFIRM_PAYMENT_1 */]: "applicantPaymentReminder",
  ["applicantConfirmPaymentReminder2" /* CONFIRM_PAYMENT_2 */]: "applicantPaymentReminder",
  ["applicantSatisfyOfferConditionReminder1" /* SATISFY_OFFER_CONDITION_1 */]: "applicantOfferTasks",
  ["applicantSatisfyOfferConditionReminder2" /* SATISFY_OFFER_CONDITION_2 */]: "applicantOfferTasks"
};

// src/enrolment-status/index.ts
var TravelStatusEnum = /* @__PURE__ */ ((TravelStatusEnum2) => {
  TravelStatusEnum2["None"] = "None";
  TravelStatusEnum2["Booked"] = "Booked";
  TravelStatusEnum2["AlreadyInUk"] = "Already in UK";
  TravelStatusEnum2["NoBookingYet"] = "No Booking Yet";
  TravelStatusEnum2["TravelCancelled"] = "Travel Cancelled";
  TravelStatusEnum2["TravelPrevented"] = "Travel Prevented";
  TravelStatusEnum2["Arrived"] = "Arrived";
  TravelStatusEnum2["Defer"] = "Defer";
  TravelStatusEnum2["Withdraw"] = "Withdraw";
  return TravelStatusEnum2;
})(TravelStatusEnum || {});
var AccommodationArrangedStatusEnum = /* @__PURE__ */ ((AccommodationArrangedStatusEnum2) => {
  AccommodationArrangedStatusEnum2["NONE"] = "None";
  AccommodationArrangedStatusEnum2["ARRANGED"] = "Arranged";
  AccommodationArrangedStatusEnum2["NOT_ARRANGED"] = "Not arranged";
  return AccommodationArrangedStatusEnum2;
})(AccommodationArrangedStatusEnum || {});
var AccommodationTypeStatusEnum = /* @__PURE__ */ ((AccommodationTypeStatusEnum2) => {
  AccommodationTypeStatusEnum2["NONE"] = "None";
  AccommodationTypeStatusEnum2["UNIVERSITY_ACCOMMODATION"] = "University accommodation";
  AccommodationTypeStatusEnum2["PRIVATE_STUDENT_ACCOMMODATION"] = "Private student accommodation";
  AccommodationTypeStatusEnum2["PRIVATE_RENTAL"] = "Private rental";
  AccommodationTypeStatusEnum2["STAYING_WITH_FAMILY"] = "Staying with family";
  AccommodationTypeStatusEnum2["HOMESTAY"] = "Homestay";
  AccommodationTypeStatusEnum2["OTHER"] = "Other";
  AccommodationTypeStatusEnum2["I_DONT_KNOW"] = "I don't know yet";
  return AccommodationTypeStatusEnum2;
})(AccommodationTypeStatusEnum || {});

// src/external-map/index.ts
var EXTERNAL_MAP_DOC_TYPE = "EXTERNAL_MAP";
var ExternalMapTarget = /* @__PURE__ */ ((ExternalMapTarget2) => {
  ExternalMapTarget2["ApplyCalendlyReq"] = "APPLY_CALENDLY_REQ";
  ExternalMapTarget2["CasShieldCalendlyReq"] = "CAS_SHIELD_CALENDLY_REQ";
  return ExternalMapTarget2;
})(ExternalMapTarget || {});

// src/filters/enums.ts
var FilterType = /* @__PURE__ */ ((FilterType2) => {
  FilterType2["SELECT_MANY"] = "SELECT_MANY";
  FilterType2["SELECT_ONE"] = "SELECT_ONE";
  FilterType2["NUMBER_RANGE"] = "NUMBER_RANGE";
  return FilterType2;
})(FilterType || {});
var FilterKey = /* @__PURE__ */ ((FilterKey2) => {
  FilterKey2["ACTIVITY_STATUS"] = "filter_activityStatus";
  FilterKey2["COMPLETE"] = "filter_complete";
  FilterKey2["INCOMPLETE"] = "filter_incomplete";
  FilterKey2["INTERVIEW"] = "filter_interview";
  FilterKey2["RECORDED_INTERVIEW"] = "filter_recordedInterview";
  FilterKey2["FUNDS_MATURITY"] = "filter_fundsMaturity";
  FilterKey2["CONDITIONAL_STATUS"] = "filter_conditionalStatus";
  FilterKey2["COURSE_CONDITIONAL_STATUS"] = "filter_courseConditionalStatus";
  FilterKey2["COURSE"] = "filter_course";
  FilterKey2["FACULTY"] = "filter_faculty";
  FilterKey2["UNIVERSITY"] = "filter_university";
  FilterKey2["IMMIGRATION_PROVIDERS"] = "filter_immigrationProviders";
  FilterKey2["PROGRAMMABLE_TAGS"] = "filter_programmableTags";
  FilterKey2["SERVICES"] = "filter_services";
  FilterKey2["TAGS"] = "filter_tags";
  FilterKey2["VISA_STATUS"] = "filter_visaStatus";
  FilterKey2["AGENT_NAME"] = "filter_agentName";
  FilterKey2["APPLICATION_COUNTRY"] = "filter_applicationCountry";
  FilterKey2["CONFIDENCE"] = "filter_confidence";
  FilterKey2["COUNTRY_OF_RESIDENCE"] = "filter_countryOfResidence";
  FilterKey2["EVIDENCE_REQUIREMENTS"] = "filter_evidenceRequirements";
  FilterKey2["MARKET"] = "filter_market";
  FilterKey2["NATIONALITY"] = "filter_nationality";
  FilterKey2["RISK_REGION"] = "filter_riskRegion";
  FilterKey2["IDLE_DAYS"] = "filter_idle_days";
  FilterKey2["MINIMUM_DAYS_IDLE"] = "filter_minimum_days_idle";
  FilterKey2["MAXIMUM_DAYS_IDLE"] = "filter_maximum_days_idle";
  FilterKey2["DEPENDANTS"] = "filter_dependants";
  FilterKey2["STUDENT_NUMBER"] = "filter_student_number";
  FilterKey2["GIVEN_NAME"] = "filter_given_name";
  FilterKey2["FAMILY_NAME"] = "filter_surname";
  FilterKey2["FEE_STATUS"] = "filter_feeStatus";
  FilterKey2["OFFER_STATUS"] = "filter_offerStatus";
  FilterKey2["SHARE_CODE"] = "filter_shareCode";
  return FilterKey2;
})(FilterKey || {});
var FilterKeyValues = Object.values(FilterKey);
var FilterKeyMap = Object.freeze({
  ["filter_activityStatus" /* ACTIVITY_STATUS */]: "activityStatus" /* ACTIVITY_STATUS */,
  ["filter_complete" /* COMPLETE */]: "complete" /* COMPLETE */,
  ["filter_incomplete" /* INCOMPLETE */]: "incomplete" /* INCOMPLETE */,
  ["filter_interview" /* INTERVIEW */]: "interview" /* INTERVIEW */,
  ["filter_recordedInterview" /* RECORDED_INTERVIEW */]: "recordedInterview" /* RECORDED_INTERVIEW */,
  ["filter_fundsMaturity" /* FUNDS_MATURITY */]: "fundsMaturity" /* FUNDS_MATURITY */,
  ["filter_conditionalStatus" /* CONDITIONAL_STATUS */]: "conditionalStatus" /* CONDITIONAL_STATUS */,
  ["filter_courseConditionalStatus" /* COURSE_CONDITIONAL_STATUS */]: "courseConditionalStatus" /* COURSE_CONDITIONAL_STATUS */,
  ["filter_course" /* COURSE */]: "course" /* COURSE */,
  ["filter_faculty" /* FACULTY */]: "faculty" /* FACULTY */,
  ["filter_university" /* UNIVERSITY */]: "uni" /* UNI */,
  ["filter_immigrationProviders" /* IMMIGRATION_PROVIDERS */]: "immigrationProviders" /* IMMIGRATION_PROVIDERS */,
  ["filter_programmableTags" /* PROGRAMMABLE_TAGS */]: "programmableTag" /* PROGRAMMABLE_TAG */,
  ["filter_services" /* SERVICES */]: "services" /* SERVICES */,
  ["filter_tags" /* TAGS */]: "tag" /* TAG */,
  ["filter_visaStatus" /* VISA_STATUS */]: "visaStatus" /* VISA_STATUS */,
  ["filter_agentName" /* AGENT_NAME */]: "agent" /* AGENT */,
  ["filter_applicationCountry" /* APPLICATION_COUNTRY */]: "applicationCountry" /* APPLICATION_COUNTRY */,
  ["filter_confidence" /* CONFIDENCE */]: "confidence" /* CONFIDENCE */,
  ["filter_countryOfResidence" /* COUNTRY_OF_RESIDENCE */]: "country" /* COUNTRY */,
  ["filter_evidenceRequirements" /* EVIDENCE_REQUIREMENTS */]: "evidenceRequirements" /* EVIDENCE_REQUIREMENTS */,
  ["filter_market" /* MARKET */]: "market" /* MARKET */,
  ["filter_nationality" /* NATIONALITY */]: "nationality" /* NATIONALITY */,
  ["filter_riskRegion" /* RISK_REGION */]: "region" /* REGION */,
  ["filter_idle_days" /* IDLE_DAYS */]: "idle" /* IDLE */,
  ["filter_minimum_days_idle" /* MINIMUM_DAYS_IDLE */]: "idleFrom" /* IDLE_FROM */,
  ["filter_maximum_days_idle" /* MAXIMUM_DAYS_IDLE */]: "idleTo" /* IDLE_TO */,
  ["filter_dependants" /* DEPENDANTS */]: null,
  ["filter_student_number" /* STUDENT_NUMBER */]: "studentNo" /* STUDENT_NO */,
  ["filter_given_name" /* GIVEN_NAME */]: "givenName" /* GIVEN_NAME */,
  ["filter_surname" /* FAMILY_NAME */]: "surname" /* SURNAME */,
  ["filter_feeStatus" /* FEE_STATUS */]: "feeStatus" /* FEE_STATUS */,
  ["filter_offerStatus" /* OFFER_STATUS */]: "offerStatus" /* OFFER_STATUS */,
  ["filter_shareCode" /* SHARE_CODE */]: "shareCode" /* SHARE_CODE */
});

// src/finance/enums.ts
var PartnerVisaStatus = /* @__PURE__ */ ((PartnerVisaStatus2) => {
  PartnerVisaStatus2["APPLYING_DEPENDANT"] = "APPLYING_DEPENDANT";
  PartnerVisaStatus2["APPLYING_DIFFERENT"] = "APPLYING_DIFFERENT";
  PartnerVisaStatus2["READY_TO_TRAVEL_VALID"] = "READY_TO_TRAVEL_VALID";
  PartnerVisaStatus2["ALREADY_IN_UK_VALID"] = "ALREADY_IN_UK_VALID";
  PartnerVisaStatus2["NONE"] = "NONE";
  return PartnerVisaStatus2;
})(PartnerVisaStatus || {});
var OrgType = /* @__PURE__ */ ((OrgType2) => {
  OrgType2["UK_GOV"] = "UK Government";
  OrgType2["BRITISH_GOV"] = "British Council";
  OrgType2["YOUR_GOV"] = "Your Government";
  OrgType2["INT_ORG"] = "International Organisation";
  OrgType2["INT_COMP"] = "International Company";
  return OrgType2;
})(OrgType || {});
var FamilySponsorType = /* @__PURE__ */ ((FamilySponsorType2) => {
  FamilySponsorType2["STANDARD"] = "STANDARD";
  FamilySponsorType2["TERM_DEPOSIT"] = "TERM_DEPOSIT";
  FamilySponsorType2["SAVINGS"] = "SAVINGS";
  FamilySponsorType2["INVESTMENT"] = "INVESTMENT";
  FamilySponsorType2["PENSION"] = "PENSION";
  return FamilySponsorType2;
})(FamilySponsorType || {});
var LoanType = /* @__PURE__ */ ((LoanType2) => {
  LoanType2["NATIONAL_GOV"] = "NATIONAL_GOV";
  LoanType2["STATE_GOV"] = "STATE_GOV";
  LoanType2["LOAN_COMP"] = "LOAN_COMP";
  LoanType2["LOAN_SCHEME"] = "LOAN_SCHEME";
  LoanType2["UNKNOWN"] = "UNKNOWN";
  LoanType2["OTHER"] = "OTHER";
  return LoanType2;
})(LoanType || {});

// src/finance-documents/enums.ts
var EmploymentStatus = /* @__PURE__ */ ((EmploymentStatus2) => {
  EmploymentStatus2["COMPANY_EMP"] = "Employed by a company/business";
  EmploymentStatus2["SELF_EMP"] = "Self-Employed";
  EmploymentStatus2["WITHIN_5_YRS_EMP"] = "Employed within the past 5 years";
  EmploymentStatus2["OVER_5_YRS_EMP"] = "Employed over 5 years ago";
  EmploymentStatus2["NEVER_EMP"] = "Never employed";
  EmploymentStatus2["RETIED"] = "Retired";
  return EmploymentStatus2;
})(EmploymentStatus || {});

// src/follow-up-documents/enums.ts
var IFollowUpArea = /* @__PURE__ */ ((IFollowUpArea2) => {
  IFollowUpArea2["BEFORE_TRAVEL"] = "beforeTravel";
  IFollowUpArea2["AFTER_ARRIVAL"] = "afterArrival";
  return IFollowUpArea2;
})(IFollowUpArea || {});
var RefusalGrounds = /* @__PURE__ */ ((RefusalGrounds2) => {
  RefusalGrounds2["FINANCE"] = "Financial requirements/documents";
  RefusalGrounds2["ENGLISH"] = "English language proficiency";
  RefusalGrounds2["CREDIBILITY"] = "Credibility or interview";
  RefusalGrounds2["CAS"] = "Incorrect details on my CAS";
  RefusalGrounds2["COURSE_OR_QUALIFICATIONS"] = "Issues with my course or qualifications";
  RefusalGrounds2["OTHER"] = "Other";
  return RefusalGrounds2;
})(RefusalGrounds || {});
var AppliedAdminReviewStatus = /* @__PURE__ */ ((AppliedAdminReviewStatus2) => {
  AppliedAdminReviewStatus2["YES"] = "Yes";
  AppliedAdminReviewStatus2["NO"] = "No";
  AppliedAdminReviewStatus2["NONE"] = "I don't know";
  return AppliedAdminReviewStatus2;
})(AppliedAdminReviewStatus || {});

// src/import-data/index.ts
var ImportFieldTypes = /* @__PURE__ */ ((ImportFieldTypes2) => {
  ImportFieldTypes2["GENERAL"] = "general student";
  ImportFieldTypes2["OFFER"] = "offer";
  ImportFieldTypes2["COURSE"] = "course";
  return ImportFieldTypes2;
})(ImportFieldTypes || {});
var TExternalCasStatus = /* @__PURE__ */ ((TExternalCasStatus2) => {
  TExternalCasStatus2["ASSIGNED"] = "ASSIGNED";
  TExternalCasStatus2["WITHDRAWN"] = "WITHDRAWN";
  TExternalCasStatus2["EXPIRED"] = "EXPIRED";
  TExternalCasStatus2["USED"] = "USED";
  TExternalCasStatus2["CANCELLED"] = "CANCELLED";
  return TExternalCasStatus2;
})(TExternalCasStatus || {});
var ImportSource = /* @__PURE__ */ ((ImportSource2) => {
  ImportSource2["CSV"] = "CSV";
  ImportSource2["SFTP"] = "SFTP";
  ImportSource2["SITS"] = "SITS";
  ImportSource2["APPLY"] = "APPLY";
  return ImportSource2;
})(ImportSource || {});

// src/integrations/ellucian/index.ts
import { z as z15 } from "zod";
var EllucianHeaderMediaTypes = /* @__PURE__ */ ((EllucianHeaderMediaTypes2) => {
  EllucianHeaderMediaTypes2["JSON"] = "application/json";
  EllucianHeaderMediaTypes2["V6"] = "application/vnd.hedtech.integration.v6+json";
  EllucianHeaderMediaTypes2["V7"] = "application/vnd.hedtech.integration.v7+json";
  EllucianHeaderMediaTypes2["V15"] = "application/vnd.hedtech.integration.v15+json";
  EllucianHeaderMediaTypes2["V16"] = "application/vnd.hedtech.integration.v16+json";
  EllucianHeaderMediaTypes2["V16_1_0"] = "application/vnd.hedtech.integration.v16.1.0+json";
  EllucianHeaderMediaTypes2["V1_0_0"] = "application/vnd.hedtech.integration.v1.0.0+json";
  EllucianHeaderMediaTypes2["V1"] = "application/vnd.hedtech.integration.v1+json";
  EllucianHeaderMediaTypes2["V11"] = "application/vnd.hedtech.integration.v11+json";
  EllucianHeaderMediaTypes2["V12"] = "application/vnd.hedtech.integration.v12+json";
  EllucianHeaderMediaTypes2["V1_Admission_Application"] = "application/vnd.hedtech.integration.admission-applications-submissions.v1+json";
  return EllucianHeaderMediaTypes2;
})(EllucianHeaderMediaTypes || {});
var EllucianEndPoint = /* @__PURE__ */ ((EllucianEndPoint2) => {
  EllucianEndPoint2["PERSON_FIND_OR_CREATE"] = "person-find-or-create-requests";
  EllucianEndPoint2["ETHNICITIES"] = "ethnicities";
  EllucianEndPoint2["CITIZENSHIP_STATUSES"] = "citizenship-statuses";
  EllucianEndPoint2["ADMISSION_APPLICATION"] = "admission-applications";
  EllucianEndPoint2["ADMISSION_POPULATION"] = "admission-populations";
  EllucianEndPoint2["RESIDENCY_TYPES"] = "residency-types";
  EllucianEndPoint2["SITES"] = "sites";
  EllucianEndPoint2["ACADEMIC_PROGRAMS"] = "x-uog-adtx-programme-courses";
  EllucianEndPoint2["COUNTRIES"] = "countries";
  EllucianEndPoint2["ACADEMIC_PERIODS"] = "academic-periods";
  EllucianEndPoint2["ADMISSION_APPLICATION_ERRORS"] = "x-uog-adtx-errors";
  EllucianEndPoint2["PERSON_RECORD"] = "persons";
  EllucianEndPoint2["MEDICAL_CODES"] = "medical-codes";
  EllucianEndPoint2["DISABILITY_TYPES"] = "disability-types";
  EllucianEndPoint2["ADD_MEDICAL_DETAILS"] = "medical-details/batches";
  EllucianEndPoint2["GET_ASSESSMENT_IDS"] = "aptitude-assessments";
  EllucianEndPoint2["CREATE_GRADES"] = "student-aptitude-assessments";
  EllucianEndPoint2["GET_TADM_CODE"] = "test-score-administration-type-codes";
  EllucianEndPoint2["ACCOMMODATION_PORTAL_URL"] = "x-uog-accommodation-portal";
  return EllucianEndPoint2;
})(EllucianEndPoint || {});
var EllucianCitizenCategory = /* @__PURE__ */ ((EllucianCitizenCategory2) => {
  EllucianCitizenCategory2["CITIZEN"] = "citizen";
  EllucianCitizenCategory2["NON_CITIZEN"] = "nonCitizen";
  return EllucianCitizenCategory2;
})(EllucianCitizenCategory || {});
var EllucianMatchingStatus = /* @__PURE__ */ ((EllucianMatchingStatus2) => {
  EllucianMatchingStatus2["NEW"] = "NEW";
  EllucianMatchingStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  EllucianMatchingStatus2["VALIDATION_DONE"] = "VALIDATION_DONE";
  EllucianMatchingStatus2["MATCHING"] = "MATCHING";
  EllucianMatchingStatus2["MATCHING_DONE"] = "MATCHING_DONE";
  EllucianMatchingStatus2["VERIFYING"] = "VERIFYING";
  EllucianMatchingStatus2["VERIFIED"] = "VERIFIED";
  EllucianMatchingStatus2["COMPLETED"] = "COMPLETED";
  return EllucianMatchingStatus2;
})(EllucianMatchingStatus || {});
var EllucianAdmissionPopulation = /* @__PURE__ */ ((EllucianAdmissionPopulation2) => {
  EllucianAdmissionPopulation2["UNDECLARED"] = "0";
  EllucianAdmissionPopulation2["NEW"] = "N";
  EllucianAdmissionPopulation2["CONTINUING"] = "C";
  EllucianAdmissionPopulation2["DIRECT_ENTRY"] = "D";
  EllucianAdmissionPopulation2["REPEATER"] = "R";
  EllucianAdmissionPopulation2["CONT_INTERMEDIATE_STANDING"] = "I";
  return EllucianAdmissionPopulation2;
})(EllucianAdmissionPopulation || {});
var EllucianResidencyType = /* @__PURE__ */ ((EllucianResidencyType2) => {
  EllucianResidencyType2["UNDECLARED"] = "0";
  EllucianResidencyType2["HOME_ASSESSED"] = "H";
  EllucianResidencyType2["NOT_ASSESSED_HOME"] = "N";
  EllucianResidencyType2["OVERSEAS_ASSESSED"] = "O";
  EllucianResidencyType2["UNKNOWN_RESIDENCY_DEFAULT"] = "U";
  EllucianResidencyType2["NOT_ASSESSED_OVERSEAS"] = "X";
  return EllucianResidencyType2;
})(EllucianResidencyType || {});
var EllucianIntegrationSchema = z15.object({
  ellucianEnabled: z15.boolean(),
  ellucianAuthMethod: z15.enum(Object.values(EllucianAuthMethod)),
  ellucianUrl: z15.string().url({ message: "Invalid URL" }).optional(),
  ellucianUrlBasePath: z15.string().optional(),
  ellucianUserName: z15.string().optional(),
  ellucianPassword: z15.string().optional(),
  ellucianClientId: z15.string().optional(),
  ellucianSecret: z15.string().optional(),
  ellucianToken: z15.string().optional(),
  ellucianOAuthScope: z15.string().optional(),
  ellucianValueMappings: z15.array(z15.object({ fieldType: z15.string(), values: z15.array(z15.object({ source: z15.string(), target: z15.string() })) })).optional(),
  ellucianFeatures: z15.record(
    z15.object({
      label: z15.string(),
      enable: z15.boolean()
    })
  ).default({})
}).superRefine((data, ctx) => {
  if (!data.ellucianEnabled) {
    return;
  }
  if (data.ellucianEnabled) {
    if (!data.ellucianUrl) {
      ctx.addIssue({
        code: z15.ZodIssueCode.custom,
        path: ["ellucianUrl"],
        message: "Ellucian Base URL is required"
      });
    }
    if (!data.ellucianUrlBasePath) {
      ctx.addIssue({
        code: z15.ZodIssueCode.custom,
        path: ["ellucianUrlBasePath"],
        message: "Ellucian URL Base Path is required"
      });
    }
  }
  if (data.ellucianAuthMethod === "Basic" /* Basic */) {
    if (!data.ellucianUserName) {
      ctx.addIssue({
        code: z15.ZodIssueCode.custom,
        path: ["ellucianUserName"],
        message: "Username is required for Basic authentication"
      });
    }
    if (!data.ellucianPassword) {
      ctx.addIssue({
        code: z15.ZodIssueCode.custom,
        path: ["ellucianPassword"],
        message: "Password is required for Basic authentication"
      });
    }
  }
  if (data.ellucianAuthMethod === "OAuth" /* OAuth */) {
    if (!data.ellucianClientId) {
      ctx.addIssue({
        code: z15.ZodIssueCode.custom,
        path: ["ellucianClientId"],
        message: "Client ID is required for OAuth authentication"
      });
    }
    if (!data.ellucianSecret) {
      ctx.addIssue({
        code: z15.ZodIssueCode.custom,
        path: ["ellucianSecret"],
        message: "Secret is required for OAuth authentication"
      });
    }
    if (!data.ellucianOAuthScope) {
      ctx.addIssue({
        code: z15.ZodIssueCode.custom,
        path: ["ellucianOAuthScope"],
        message: "OAuth Scope is required for OAuth authentication"
      });
    }
  }
  if (data.ellucianAuthMethod === "SecretToken" /* SecretToken */) {
    if (!data.ellucianToken) {
      ctx.addIssue({
        code: z15.ZodIssueCode.custom,
        path: ["ellucianToken"],
        message: "Ellucian Secret Token is required for authentication"
      });
    }
  }
});
var ReferenceDataType = /* @__PURE__ */ ((ReferenceDataType2) => {
  ReferenceDataType2["SITE"] = "SITE";
  ReferenceDataType2["ETHNICITY"] = "ETHNICITY";
  ReferenceDataType2["CITIZENSHIP_STATUS"] = "CITIZENSHIP_STATUS";
  ReferenceDataType2["ACADEMIC_PERIOD"] = "ACADEMIC_PERIOD";
  ReferenceDataType2["ADMISSION_POPULATION"] = "ADMISSION_POPULATION";
  ReferenceDataType2["RESIDENCY_TYPE"] = "RESIDENCY_TYPE";
  ReferenceDataType2["ACADEMIC_PROGRAM"] = "ACADEMIC_PROGRAM";
  ReferenceDataType2["DISABILITY_TYPE"] = "DISABILITY_TYPE";
  ReferenceDataType2["APTITUDE_ASSESSMENT"] = "APTITUDE_ASSESSMENT";
  ReferenceDataType2["MEDICAL_CODES"] = "MEDICAL_CODES";
  return ReferenceDataType2;
})(ReferenceDataType || {});
var EllucianCare = /* @__PURE__ */ ((EllucianCare2) => {
  EllucianCare2["YES"] = "1";
  EllucianCare2["NO"] = "2";
  EllucianCare2["UNANSWERED"] = "7";
  return EllucianCare2;
})(EllucianCare || {});
var EllucianParentsEd = /* @__PURE__ */ ((EllucianParentsEd2) => {
  EllucianParentsEd2["YES"] = "1";
  EllucianParentsEd2["NO"] = "2";
  EllucianParentsEd2["No Response Given"] = "7";
  EllucianParentsEd2["Don't Know"] = "8";
  EllucianParentsEd2["Information Refused"] = "9";
  return EllucianParentsEd2;
})(EllucianParentsEd || {});
var EllucianMedicalDesc = /* @__PURE__ */ ((EllucianMedicalDesc2) => {
  EllucianMedicalDesc2["NO_DISABILITY"] = "No disability";
  EllucianMedicalDesc2["DISABILITY_NOT_LISTED"] = "Disability not listed";
  return EllucianMedicalDesc2;
})(EllucianMedicalDesc || {});
var EllucianDisabilityTitle = /* @__PURE__ */ ((EllucianDisabilityTitle2) => {
  EllucianDisabilityTitle2["NO_KNOWN_DISABILITY"] = "No known disability";
  EllucianDisabilityTitle2["DISABLED_NO_DSA"] = "Disabled - no DSA";
  EllucianDisabilityTitle2["DISABLED_DSA_STATUS_UNKNOWN"] = "Disabled - DSA status unknown";
  return EllucianDisabilityTitle2;
})(EllucianDisabilityTitle || {});

// src/integrations/generics-integration/index.ts
var generics_integration_exports = {};
__export(generics_integration_exports, {
  EntryPointNumber: () => EntryPointNumber,
  IntegrationDeliveryKeys: () => IntegrationDeliveryKeys,
  Integrations: () => Integrations
});
var IntegrationDeliveryKeys = /* @__PURE__ */ ((IntegrationDeliveryKeys2) => {
  IntegrationDeliveryKeys2["ORACLE_OUTBOUND"] = "ORACLE_OUTBOUND";
  IntegrationDeliveryKeys2["SITS_OUTBOUND"] = "SITS_OUTBOUND";
  IntegrationDeliveryKeys2["ELLUCIAN_OUTBOUND"] = "ELLUCIAN_OUTBOUND";
  return IntegrationDeliveryKeys2;
})(IntegrationDeliveryKeys || {});
var Integrations = /* @__PURE__ */ ((Integrations2) => {
  Integrations2["ORACLE"] = "oracle";
  Integrations2["SITS"] = "sits";
  Integrations2["ELLUCIAN"] = "ellucian";
  return Integrations2;
})(Integrations || {});
var EntryPointNumber = {
  ["Year 0" /* Year0 */]: 0,
  ["Year 1" /* Year1 */]: 1,
  ["Year 2" /* Year2 */]: 2,
  ["Year 3" /* Year3 */]: 3,
  ["Year 4" /* Year4 */]: 4,
  ["Year 5" /* Year5 */]: 5,
  ["Year 6" /* Year6 */]: 6
};

// src/offer/enums.ts
var CoreStatus = /* @__PURE__ */ ((CoreStatus2) => {
  CoreStatus2["WAITING_FOR_INTAKE"] = "Waiting for Intake";
  CoreStatus2["NOT_TRIGGERED"] = "Not-Triggered";
  CoreStatus2["NOT_READY"] = "Not Ready";
  CoreStatus2["PRE_DEPOSIT"] = "Pre-Deposit";
  CoreStatus2["POST_DEPOSIT"] = "Post-Deposit";
  CoreStatus2["DRAFT_CAS"] = "Draft CAS";
  CoreStatus2["PATHWAY_REVIEW"] = "Pathway Review";
  CoreStatus2["READY_FOR_CAS"] = "Ready for CAS";
  CoreStatus2["CAS_ISSUED"] = "CAS Issued";
  CoreStatus2["VISA_ISSUED"] = "Visa Issued";
  CoreStatus2["VISA_REFUSED"] = "Visa Refused";
  CoreStatus2["DEFERRED"] = "Deferred";
  CoreStatus2["CLOSED_LOST"] = "Closed Lost";
  CoreStatus2["CLOSED_OTHER"] = "Closed Other";
  CoreStatus2["AWAITING_INFO"] = "Awaiting Info";
  CoreStatus2["COMPLIANCE_CHECK"] = "Compliance Check";
  return CoreStatus2;
})(CoreStatus || {});
var CoreStatusExtended = /* @__PURE__ */ ((CoreStatusExtended2) => {
  CoreStatusExtended2["WAITING_FOR_INTAKE"] = "Waiting for Intake";
  CoreStatusExtended2["NOT_TRIGGERED"] = "Not-Triggered";
  CoreStatusExtended2["NOT_READY"] = "Not Ready";
  CoreStatusExtended2["PRE_DEPOSIT"] = "Pre-Deposit";
  CoreStatusExtended2["POST_DEPOSIT"] = "Post-Deposit";
  CoreStatusExtended2["DRAFT_CAS"] = "Draft CAS";
  CoreStatusExtended2["PATHWAY_REVIEW"] = "Pathway Review";
  CoreStatusExtended2["READY_FOR_CAS"] = "Ready for CAS";
  CoreStatusExtended2["CAS_ISSUED"] = "CAS Issued";
  CoreStatusExtended2["VISA_ISSUED"] = "Visa Issued";
  CoreStatusExtended2["VISA_REFUSED"] = "Visa Refused";
  CoreStatusExtended2["DEFERRED"] = "Deferred";
  CoreStatusExtended2["CLOSED_LOST"] = "Closed Lost";
  CoreStatusExtended2["CLOSED_OTHER"] = "Closed Other";
  CoreStatusExtended2["AWAITING_INFO"] = "Awaiting Info";
  CoreStatusExtended2["INTERVIEW"] = "Interview";
  CoreStatusExtended2["COMPLIANCE_CHECK"] = "Compliance Check";
  return CoreStatusExtended2;
})(CoreStatusExtended || {});
var IntakeStatus = /* @__PURE__ */ ((IntakeStatus2) => {
  IntakeStatus2["FUTURE"] = "Future";
  IntakeStatus2["ACTIVE"] = "Active";
  IntakeStatus2["CLOSED"] = "Closed";
  IntakeStatus2["ARCHIVED"] = "Archived";
  return IntakeStatus2;
})(IntakeStatus || {});
var NotReadyReason = /* @__PURE__ */ ((NotReadyReason2) => {
  NotReadyReason2["NOT_PROCESSED"] = "Not Processed";
  NotReadyReason2["UNKNOWN_INTAKE"] = "Unknown Intake";
  NotReadyReason2["INACTIVE_INTAKE"] = "Inactive Intake";
  NotReadyReason2["ALL_COURSES_DECLINED"] = "All Courses Declined";
  NotReadyReason2["INVALID_EMAIL"] = "Invalid Email";
  NotReadyReason2["BOUNCED_EMAIL"] = "Bounced Email";
  NotReadyReason2["DUPLICATE_EMAIL"] = "Duplicate Email";
  return NotReadyReason2;
})(NotReadyReason || {});
var VisaStatus = /* @__PURE__ */ ((VisaStatus2) => {
  VisaStatus2["NONE"] = "None";
  VisaStatus2["CAS_NOT_RECEIVED"] = "CAS not received";
  VisaStatus2["CAS_RECEIVED"] = "CAS received";
  VisaStatus2["VISA_APPLIED"] = "Visa applied";
  VisaStatus2["AWAITING_VISA_RESPONSE"] = "Awaiting visa response";
  VisaStatus2["UKVI_REQUEST_MORE_INFO"] = "UKVI request more info";
  VisaStatus2["VISA_RECEIVED"] = "Visa received";
  VisaStatus2["VISA_REFUSAL"] = "Visa refusal";
  VisaStatus2["INTENDS_TO_DEFER"] = "Intends to defer";
  VisaStatus2["INTENDS_TO_WITHDRAW"] = "Intends to withdraw";
  return VisaStatus2;
})(VisaStatus || {});
var OfferStatus = /* @__PURE__ */ ((OfferStatus2) => {
  OfferStatus2["FOR_REVIEW"] = "For review";
  OfferStatus2["DECLINED"] = "Declined";
  OfferStatus2["REMOVED"] = "Removed";
  OfferStatus2["NOT_RESOLVED"] = "Not resolved";
  OfferStatus2["UNCONDITIONAL"] = "Unconditional";
  OfferStatus2["CONDITIONAL"] = "Conditional";
  return OfferStatus2;
})(OfferStatus || {});
var CourseLevelOfferStatus = /* @__PURE__ */ ((CourseLevelOfferStatus2) => {
  CourseLevelOfferStatus2["DECLINED"] = "Declined";
  CourseLevelOfferStatus2["REMOVED"] = "Removed";
  CourseLevelOfferStatus2["UNCONDITIONAL"] = "Unconditional";
  CourseLevelOfferStatus2["CONDITIONAL"] = "Conditional";
  return CourseLevelOfferStatus2;
})(CourseLevelOfferStatus || {});
var PersonalInfoPages = /* @__PURE__ */ ((PersonalInfoPages2) => {
  PersonalInfoPages2["STEP1"] = "pi-step1";
  PersonalInfoPages2["STEP2"] = "pi-step2";
  PersonalInfoPages2["STEP3"] = "pi-step3";
  PersonalInfoPages2["STEP4"] = "pi-step4";
  PersonalInfoPages2["STEP5"] = "pi-step5";
  PersonalInfoPages2["STEP5_1"] = "pi-step5_1";
  PersonalInfoPages2["STEP6"] = "pi-step6";
  PersonalInfoPages2["STEP7"] = "pi-step7";
  PersonalInfoPages2["STEP8"] = "pi-step8";
  PersonalInfoPages2["STEP9"] = "pi-step9";
  PersonalInfoPages2["STEP10"] = "pi-step10";
  return PersonalInfoPages2;
})(PersonalInfoPages || {});
var HistoryPages = /* @__PURE__ */ ((HistoryPages2) => {
  HistoryPages2["STEP1"] = "h-step1";
  HistoryPages2["STEP2"] = "h-step2";
  HistoryPages2["STEP3"] = "h-step3";
  return HistoryPages2;
})(HistoryPages || {});
var ConsentsPages = /* @__PURE__ */ ((ConsentsPages2) => {
  ConsentsPages2["STEP1"] = "c-step1";
  ConsentsPages2["STEP2"] = "c-step2";
  ConsentsPages2["STEP3"] = "c-step3";
  ConsentsPages2["STEP4"] = "c-step4";
  return ConsentsPages2;
})(ConsentsPages || {});
var InterviewPages = /* @__PURE__ */ ((InterviewPages2) => {
  InterviewPages2["STEP1"] = "pc-step1";
  InterviewPages2["STEP2"] = "pc-step2";
  InterviewPages2["STEP3"] = "pc-step3";
  InterviewPages2["STEP4"] = "pc-step4";
  return InterviewPages2;
})(InterviewPages || {});
var VisaPrepPages = /* @__PURE__ */ ((VisaPrepPages2) => {
  VisaPrepPages2["STEP1"] = "v-step1";
  VisaPrepPages2["STEP1_2"] = "v-step1-2";
  VisaPrepPages2["STEP2_1"] = "v-step2-1";
  VisaPrepPages2["STEP2_2"] = "v-step2-2";
  VisaPrepPages2["STEP2_3"] = "v-step2-3";
  VisaPrepPages2["STEP2_4"] = "v-step2-4";
  VisaPrepPages2["STEP2_5"] = "v-step2-5";
  VisaPrepPages2["STEP2_6"] = "v-step2-6";
  VisaPrepPages2["STEP2_7"] = "v-step2-7";
  VisaPrepPages2["STEP2_8"] = "v-step2-8";
  VisaPrepPages2["STEP3_1"] = "v-step3-1";
  VisaPrepPages2["STEP3_2"] = "v-step3-2";
  VisaPrepPages2["STEP3_3"] = "v-step3-3";
  VisaPrepPages2["STEP3_4"] = "v-step3-4";
  VisaPrepPages2["STEP3_5"] = "v-step3-5";
  VisaPrepPages2["STEP4"] = "v-step4";
  VisaPrepPages2["STEP5"] = "v-step5";
  VisaPrepPages2["STEP6"] = "v-step6";
  VisaPrepPages2["STEP7_1"] = "v-step7-1";
  VisaPrepPages2["STEP7_2"] = "v-step7-2";
  VisaPrepPages2["STEP7_3"] = "v-step7-3";
  VisaPrepPages2["STEP8"] = "v-step8";
  return VisaPrepPages2;
})(VisaPrepPages || {});

// src/offer/index.ts
var CLEARED_AGENT_DETAIL_FIELDS = {
  branchOffice: null,
  counsellorEmail: null,
  counsellorName: null,
  agentFamilyName: null,
  agentGivenName: null,
  branchAddressLine1: null,
  branchAddressLine2: null,
  branchAddressLine3: null,
  branchCity: null,
  branchCountry: null,
  branchPostcode: null
};
var AGENT_DETAIL_FIELD_KEYS = Object.keys(CLEARED_AGENT_DETAIL_FIELDS);
var AGENT_DETAIL_FIELD_LABELS = {
  agentFamilyName: "Key Contact Family Name",
  agentGivenName: "Key Contact Given Name",
  branchOffice: "Branch Office",
  counsellorEmail: "Counsellor Email",
  counsellorName: "Counsellor Name",
  branchAddressLine1: "Branch Address Line 1",
  branchAddressLine2: "Branch Address Line 2",
  branchAddressLine3: "Branch Address Line 3",
  branchCity: "Branch City",
  branchCountry: "Branch Country",
  branchPostcode: "Branch Postcode"
};

// src/partner/enums.ts
var Partners = /* @__PURE__ */ ((Partners2) => {
  Partners2["ENROLY_AT"] = "EnrolyAT";
  Partners2["ENROLY_CT"] = "EnrolyCT";
  Partners2["ENROLY_BC"] = "EnrolyBC";
  Partners2["ENROLY_IA"] = "EnrolyIA";
  Partners2["ENROLY_VT"] = "EnrolyVT";
  return Partners2;
})(Partners || {});

// src/partner/serviceProviderType.ts
var partnerCodeToServiceProviderType = {
  ["EnrolyIA" /* ENROLY_IA */]: "IA",
  ["EnrolyVT" /* ENROLY_VT */]: "VT",
  ["EnrolyAT" /* ENROLY_AT */]: "AT",
  ["EnrolyCT" /* ENROLY_CT */]: "CT",
  ["EnrolyBC" /* ENROLY_BC */]: "BC"
};
var getServiceProviderType = (partnerCode) => {
  if (!partnerCode) return void 0;
  return partnerCodeToServiceProviderType[partnerCode];
};

// src/personal-info/enums.ts
var EUSSStatus = /* @__PURE__ */ ((EUSSStatus2) => {
  EUSSStatus2["SETTLED"] = "Settled";
  EUSSStatus2["PRE_SETTLED"] = "Pre-Settled";
  return EUSSStatus2;
})(EUSSStatus || {});
var AppliedEUSSStatus = /* @__PURE__ */ ((AppliedEUSSStatus2) => {
  AppliedEUSSStatus2["GRANTED"] = "Yes";
  AppliedEUSSStatus2["APPLIED"] = "No, but I have applied for it";
  AppliedEUSSStatus2["WILL_APPLY"] = "No, but I will apply for it";
  AppliedEUSSStatus2["NO"] = "No";
  return AppliedEUSSStatus2;
})(AppliedEUSSStatus || {});

// src/pre-signed-url/index.ts
import { z as z16 } from "zod";
var VALID_EXTENSIONS_GENERAL = ["pdf", "jpg", "jpeg", "png", "gif", "bmp", "webp"];
var VALID_EXTENSIONS_APPLICANT = [...VALID_EXTENSIONS_GENERAL];
var VALID_TYPES_GENERAL = ["application/pdf", "image/jpeg", "image/png", "image/gif", "image/bmp", "image/webp"];
var VALID_TYPES_APPLICANT = [...VALID_TYPES_GENERAL];
var ApplicantDocUploadRequestSchema = z16.object({
  docType: z16.string(),
  // .refine(value => VALID_DOCUMENT_TYPES_APPLICANT.includes(value), {
  //   message: `Unsupported document type!`
  // })
  // .optional()
  // .nullable(),
  fileName: z16.string().transform((value) => {
    const lastDotIndex = value.lastIndexOf(".");
    if (lastDotIndex === -1) return value;
    const baseName = value.substring(0, lastDotIndex);
    const extension = value.substring(lastDotIndex).toLowerCase();
    return baseName + extension;
  }).refine((value) => VALID_EXTENSIONS_APPLICANT.some((ext) => value.endsWith(`.${ext}`)), {
    message: `Unsupported file type!`
  }),
  fileType: z16.string().refine((value) => VALID_TYPES_APPLICANT.includes(value), {
    message: `Unsupported file type!`
  }),
  docKey: z16.string(),
  studyId: z16.string().optional()
});

// src/programmable-tag/index.ts
var ProgrammableTagStatus = /* @__PURE__ */ ((ProgrammableTagStatus2) => {
  ProgrammableTagStatus2["APPLIED"] = "APPLIED";
  ProgrammableTagStatus2["REMOVED"] = "REMOVED";
  return ProgrammableTagStatus2;
})(ProgrammableTagStatus || {});

// src/recorded-interview/enums.ts
var RecordedInterviewSystemStatus = /* @__PURE__ */ ((RecordedInterviewSystemStatus2) => {
  RecordedInterviewSystemStatus2["PASSED"] = "PASSED";
  RecordedInterviewSystemStatus2["FAILED"] = "FAILED";
  RecordedInterviewSystemStatus2["RESIT"] = "RESIT";
  RecordedInterviewSystemStatus2["DELETED"] = "DELETED";
  RecordedInterviewSystemStatus2["RECORDED"] = "RECORDED";
  RecordedInterviewSystemStatus2["INVITED"] = "INVITED";
  RecordedInterviewSystemStatus2["ATTEMPTED"] = "ATTEMPTED";
  RecordedInterviewSystemStatus2["EXCEEDED"] = "EXCEEDED";
  RecordedInterviewSystemStatus2["NONE"] = "NONE";
  return RecordedInterviewSystemStatus2;
})(RecordedInterviewSystemStatus || {});
var ThinkingTimeEnum = /* @__PURE__ */ ((ThinkingTimeEnum2) => {
  ThinkingTimeEnum2[ThinkingTimeEnum2["15s"] = 15] = "15s";
  ThinkingTimeEnum2[ThinkingTimeEnum2["30s"] = 30] = "30s";
  ThinkingTimeEnum2[ThinkingTimeEnum2["45s"] = 45] = "45s";
  ThinkingTimeEnum2[ThinkingTimeEnum2["1m"] = 60] = "1m";
  ThinkingTimeEnum2[ThinkingTimeEnum2["1.5m"] = 90] = "1.5m";
  ThinkingTimeEnum2[ThinkingTimeEnum2["2m"] = 120] = "2m";
  ThinkingTimeEnum2[ThinkingTimeEnum2["3m"] = 180] = "3m";
  ThinkingTimeEnum2[ThinkingTimeEnum2["4m"] = 240] = "4m";
  ThinkingTimeEnum2[ThinkingTimeEnum2["Unlimited"] = 0] = "Unlimited";
  return ThinkingTimeEnum2;
})(ThinkingTimeEnum || {});
var RecordingTimeEnum = /* @__PURE__ */ ((RecordingTimeEnum2) => {
  RecordingTimeEnum2[RecordingTimeEnum2["15s"] = 15] = "15s";
  RecordingTimeEnum2[RecordingTimeEnum2["30s"] = 30] = "30s";
  RecordingTimeEnum2[RecordingTimeEnum2["40s"] = 40] = "40s";
  RecordingTimeEnum2[RecordingTimeEnum2["45s"] = 45] = "45s";
  RecordingTimeEnum2[RecordingTimeEnum2["50s"] = 50] = "50s";
  RecordingTimeEnum2[RecordingTimeEnum2["1m"] = 60] = "1m";
  RecordingTimeEnum2[RecordingTimeEnum2["1.5m"] = 90] = "1.5m";
  RecordingTimeEnum2[RecordingTimeEnum2["2m"] = 120] = "2m";
  RecordingTimeEnum2[RecordingTimeEnum2["3m"] = 180] = "3m";
  RecordingTimeEnum2[RecordingTimeEnum2["4m"] = 240] = "4m";
  RecordingTimeEnum2[RecordingTimeEnum2["5m"] = 300] = "5m";
  RecordingTimeEnum2[RecordingTimeEnum2["10m"] = 600] = "10m";
  return RecordingTimeEnum2;
})(RecordingTimeEnum || {});
var RetakesEnum = /* @__PURE__ */ ((RetakesEnum2) => {
  RetakesEnum2[RetakesEnum2["Zero"] = 0] = "Zero";
  RetakesEnum2[RetakesEnum2["One"] = 1] = "One";
  RetakesEnum2[RetakesEnum2["Two"] = 2] = "Two";
  RetakesEnum2[RetakesEnum2["Three"] = 3] = "Three";
  RetakesEnum2[RetakesEnum2["Four"] = 4] = "Four";
  RetakesEnum2[RetakesEnum2["Five"] = 5] = "Five";
  return RetakesEnum2;
})(RetakesEnum || {});
var QuestionTypeEnum = /* @__PURE__ */ ((QuestionTypeEnum2) => {
  QuestionTypeEnum2["Standard"] = "standard";
  QuestionTypeEnum2["Trap"] = "trap";
  return QuestionTypeEnum2;
})(QuestionTypeEnum || {});
var RecordedInterviewAssessmentDecision = /* @__PURE__ */ ((RecordedInterviewAssessmentDecision2) => {
  RecordedInterviewAssessmentDecision2["None"] = "None";
  RecordedInterviewAssessmentDecision2["Pass"] = "Pass";
  RecordedInterviewAssessmentDecision2["Fail"] = "Fail";
  RecordedInterviewAssessmentDecision2["Resit"] = "Resit";
  return RecordedInterviewAssessmentDecision2;
})(RecordedInterviewAssessmentDecision || {});
var ScoreTypeEnum = /* @__PURE__ */ ((ScoreTypeEnum2) => {
  ScoreTypeEnum2["Score"] = "Score";
  ScoreTypeEnum2["Audio"] = "Audio";
  ScoreTypeEnum2["Language"] = "Language";
  return ScoreTypeEnum2;
})(ScoreTypeEnum || {});
var ResitAction = /* @__PURE__ */ ((ResitAction2) => {
  ResitAction2["RESIT_REQUESTED"] = "Resit Requested";
  ResitAction2["STATUS_UPDATED"] = "Status Updated";
  ResitAction2["STATUS_RESCINDED"] = "Status Rescinded";
  return ResitAction2;
})(ResitAction || {});

// src/region-config/enums.ts
var RegionConfigType = /* @__PURE__ */ ((RegionConfigType2) => {
  RegionConfigType2["DEFAULT"] = "DEFAULT";
  RegionConfigType2["CUSTOM"] = "CUSTOM";
  RegionConfigType2["CITY_OVERRIDE"] = "CITY_OVERRIDE";
  RegionConfigType2["POSTCODE_OVERRIDE"] = "POSTCODE_OVERRIDE";
  RegionConfigType2["ONSHORE"] = "ONSHORE";
  RegionConfigType2["AGENCIES_OVERRIDE"] = "AGENCIES_OVERRIDE";
  RegionConfigType2["EUSS_OVERRIDE"] = "EUSS_OVERRIDE";
  return RegionConfigType2;
})(RegionConfigType || {});
var SectionStatusType = /* @__PURE__ */ ((SectionStatusType2) => {
  SectionStatusType2["ACTIVE"] = "ACTIVE";
  SectionStatusType2["INACTIVE"] = "INACTIVE";
  return SectionStatusType2;
})(SectionStatusType || {});
var OptionStatusType = /* @__PURE__ */ ((OptionStatusType2) => {
  OptionStatusType2["ACTIVE"] = "ACTIVE";
  OptionStatusType2["INACTIVE"] = "INACTIVE";
  OptionStatusType2["MANDATORY_DIRECT"] = "MANDATORY";
  OptionStatusType2["MANDATORY_ALL"] = "MANDATORY_ALL";
  return OptionStatusType2;
})(OptionStatusType || {});
var FollowUpDocStatusType = /* @__PURE__ */ ((FollowUpDocStatusType2) => {
  FollowUpDocStatusType2["REQUIRED"] = "REQUIRED";
  FollowUpDocStatusType2["NOT_REQUIRED"] = "NOT_REQUIRED";
  FollowUpDocStatusType2["STAFF_ONLY"] = "STAFF_ONLY";
  FollowUpDocStatusType2["AGENT_ONLY"] = "AGENT_ONLY";
  return FollowUpDocStatusType2;
})(FollowUpDocStatusType || {});
var DocStatusType = /* @__PURE__ */ ((DocStatusType2) => {
  DocStatusType2["INFO_ONLY"] = "INFO_ONLY";
  DocStatusType2["REQUIRED"] = "REQUIRED";
  DocStatusType2["NOT_REQUIRED"] = "NOT_REQUIRED";
  DocStatusType2["STAFF_ONLY"] = "STAFF_ONLY";
  DocStatusType2["AGENT_ONLY"] = "AGENT_ONLY";
  return DocStatusType2;
})(DocStatusType || {});

// src/region-config/index.ts
var CountryCategory = /* @__PURE__ */ ((CountryCategory2) => {
  CountryCategory2["APPENDIX_H"] = "AppendixH";
  CountryCategory2["NON_APPENDIX_H"] = "NonAppendixH";
  CountryCategory2["STANDARD"] = "Standard";
  CountryCategory2["DIFFERENTIAL"] = "Differential (Low Risk)";
  CountryCategory2["EUSS"] = "EUSS";
  return CountryCategory2;
})(CountryCategory || {});

// src/region-office/index.ts
var RegionOfficeType = /* @__PURE__ */ ((RegionOfficeType2) => {
  RegionOfficeType2["DEFAULT"] = "DEFAULT";
  RegionOfficeType2["STANDARD"] = "STANDARD";
  RegionOfficeType2["CITY_OVERRIDE"] = "CITY_OVERRIDE";
  RegionOfficeType2["POSTCODE_OVERRIDE"] = "POSTCODE_OVERRIDE";
  return RegionOfficeType2;
})(RegionOfficeType || {});

// src/sits/index.ts
var sits_exports = {};

// src/special-map/enums.ts
var SMapWhen = /* @__PURE__ */ ((SMapWhen2) => {
  SMapWhen2["ALWAYS"] = "ALWAYS";
  SMapWhen2["CONDITION"] = "CONDITION";
  SMapWhen2["EXCLUDE_CONDITION"] = "EXCLUDE_CONDITION";
  return SMapWhen2;
})(SMapWhen || {});
var SMapStatus = /* @__PURE__ */ ((SMapStatus2) => {
  SMapStatus2["ACTIVE"] = "ACTIVE";
  SMapStatus2["INACTIVE"] = "INACTIVE";
  return SMapStatus2;
})(SMapStatus || {});
var SMapConditionLogic = /* @__PURE__ */ ((SMapConditionLogic2) => {
  SMapConditionLogic2["AND"] = "AND";
  SMapConditionLogic2["OR"] = "OR";
  return SMapConditionLogic2;
})(SMapConditionLogic || {});
var SMapFieldFormat = /* @__PURE__ */ ((SMapFieldFormat2) => {
  SMapFieldFormat2["STRING"] = "STRING";
  SMapFieldFormat2["NUMBER"] = "NUMBER";
  SMapFieldFormat2["BOOLEAN"] = "BOOLEAN";
  SMapFieldFormat2["FORMULA"] = "FORMULA";
  SMapFieldFormat2["DATE_RANGE"] = "DATE_RANGE";
  return SMapFieldFormat2;
})(SMapFieldFormat || {});
var SMapFormulaType = /* @__PURE__ */ ((SMapFormulaType2) => {
  SMapFormulaType2["MULTIPLICATION"] = "MULTIPLICATION";
  SMapFormulaType2["DIVISION"] = "DIVISION";
  return SMapFormulaType2;
})(SMapFormulaType || {});
var SMapFieldAction = /* @__PURE__ */ ((SMapFieldAction2) => {
  SMapFieldAction2["OVERWRITE_ALWAYS"] = "OVERWRITE_ALWAYS";
  SMapFieldAction2["OVERWRITE_IF_EMPTY"] = "OVERWRITE_IF_EMPTY";
  SMapFieldAction2["CLEAR_FIELD"] = "CLEAR_FIELD";
  SMapFieldAction2["PASSTHROUGH_VALUE"] = "PASSTHROUGH_VALUE";
  SMapFieldAction2["DO_NOTHING"] = "DO_NOTHING";
  return SMapFieldAction2;
})(SMapFieldAction || {});
var SMapMatch = /* @__PURE__ */ ((SMapMatch2) => {
  SMapMatch2["EQUALS"] = "EQUALS";
  SMapMatch2["NOT_EQUALS"] = "NOT_EQUALS";
  SMapMatch2["CONTAINS"] = "CONTAINS";
  SMapMatch2["NOT_CONTAINS"] = "NOT_CONTAINS";
  SMapMatch2["STARTS_WITH"] = "STARTS_WITH";
  SMapMatch2["NOT_STARTS_WITH"] = "NOT_STARTS_WITH";
  SMapMatch2["ENDS_WITH"] = "ENDS_WITH";
  SMapMatch2["NOT_ENDS_WITH"] = "NOT_ENDS_WITH";
  SMapMatch2["EXISTS"] = "EXISTS";
  SMapMatch2["NOT_EXISTS"] = "NOT_EXISTS";
  SMapMatch2["ONE_OF"] = "ONE_OF";
  SMapMatch2["NOT_ONE_OF"] = "NOT_ONE_OF";
  SMapMatch2["GREATER_THAN"] = "GREATER_THAN";
  SMapMatch2["LESS_THAN"] = "LESS_THAN";
  SMapMatch2["REGEX"] = "REGEX";
  SMapMatch2["CONFLICTS"] = "CONFLICTS";
  SMapMatch2["NOT_CONFLICTS"] = "NOT_CONFLICTS";
  return SMapMatch2;
})(SMapMatch || {});
var ImportProcessingType = /* @__PURE__ */ ((ImportProcessingType2) => {
  ImportProcessingType2["SPECIAL_MAP"] = "Special Map";
  ImportProcessingType2["SPECIAL_DATA_RULE"] = "Special Data Rule";
  return ImportProcessingType2;
})(ImportProcessingType || {});

// src/summary/index.ts
var SummaryPostgresMapOfTypes = {
  p_key: ["string", "required"],
  uni: ["string", "required"],
  student_no: ["string", "required"],
  intake_id: ["string", "required"],
  course_name: ["string"],
  offer_id: ["string", "required"],
  offer_status: ["string"],
  pathway: ["string"],
  student_details_required: ["integer", "required"],
  history_required: ["integer", "required"],
  finance_required: ["integer", "required"],
  consents_required: ["integer", "required"],
  agent_details_required: ["integer", "required"],
  student_details_complete: ["integer", "required"],
  history_complete: ["integer", "required"],
  finance_complete: ["integer", "required"],
  consents_complete: ["integer", "required"],
  agent_details_complete: ["integer", "required"],
  total_perc_complete: ["string", "required"],
  docs_uploaded: ["integer", "required"],
  docs_outstanding: ["integer"],
  docs_and_fin_docs_total: ["integer"],
  docs_total: ["integer", "required"],
  fin_docs_uploaded: ["integer", "required"],
  fin_docs_total: ["integer", "required"],
  agent_docs_uploaded: ["integer", "required"],
  agent_docs_total: ["integer", "required"],
  new_docs_uploaded: ["boolean", "required"],
  new_fin_docs_uploaded: ["boolean", "required"],
  new_message: ["boolean", "required"],
  follow_up_docs_uploaded: ["integer", "required"],
  follow_up_docs_total: ["integer", "required"],
  updated_at: ["integer", "required"],
  unread_messages_uni: ["integer", "required"],
  unread_messages_student: ["integer", "required"],
  unread_messages_uni_to_agent: ["integer", "required"],
  unread_messages_student_to_agent: ["integer", "required"],
  unread_messages_agent_to_uni: ["integer", "required"],
  unread_messages_uni_secure: ["integer", "required"],
  unread_messages_student_secure: ["integer", "required"],
  unread_messages_uni_by_agent: ["integer", "required"],
  unread_messages_uni_by_admin: ["integer", "required"],
  unread_messages_uni_by_partner: ["integer", "required"],
  unread_messages_uni_to_student_by_admin: ["integer", "required"],
  unread_messages_uni_to_student_by_partner: ["integer", "required"],
  unread_messages_uni_to_agent_by_admin: ["integer", "required"],
  unread_messages_student_to_agent_by_admin: ["integer", "required"],
  unread_messages_student_by_uni: ["integer", "required"],
  unread_messages_uni_by_immigration_provider: ["integer", "required"],
  agent_access: ["string"],
  visa_status: ["string", "required"],
  risk_rating: ["integer", "required"],
  partners: ["string[]"],
  immigration_providers: ["string[]"],
  cas_status: ["string", "required"],
  cas_status_updated_at: ["integer", "required"],
  is_student_details_complete: ["boolean", "required"],
  is_history_complete: ["boolean", "required"],
  is_consents_complete: ["boolean", "required"],
  is_finance_complete: ["boolean", "required"],
  is_docs_complete: ["boolean", "required"],
  is_fin_docs_complete: ["boolean", "required"],
  finance_document_status: ["string"],
  is_pre_cas_complete: ["boolean", "required"],
  is_deposit_complete: ["boolean", "required"],
  is_finance_sponsors_valid: ["boolean", "required"],
  is_tasks_complete: ["boolean", "required"],
  tasks_complete_at: ["integer", "required"],
  // tasks_complete_at_before_reopening: ['integer'],
  pathway_uni: ["string"],
  lived_in_uk_last12_months: ["boolean", "required"],
  applied_for_eusss: ["string"],
  region_config_id: ["string"],
  with_agent: ["boolean"],
  country: ["string"],
  city: ["string"],
  postcode: ["string"],
  nationality: ["string"],
  agent_name: ["string"],
  agent_name_remapped: ["string"],
  import_agent_name: ["string"],
  import_agent_email: ["string"],
  last_agent_assignment_date: ["string"],
  criminal_convictions: ["boolean"],
  dob: ["string"],
  email: ["string"],
  surname: ["string"],
  given_name: ["string"],
  phone: ["string"],
  ucas_id: ["string"],
  country_of_visa_application: ["string"],
  admissions_office: ["string"],
  age: ["integer"],
  uni_partner_id: ["string"],
  calendly_interviews_info_status: ["string"],
  funds_matured: ["jsonb"],
  tags: ["jsonb"],
  courses: ["jsonb"],
  intakes: ["jsonb"],
  calendly_interviews: ["jsonb"],
  deposit_date: ["string"],
  conditions: ["string[]"],
  travel_status: ["string"],
  travel_status_booked_date: ["string"],
  travel_status_arrival_date: ["string"],
  start_date: ["date"],
  external_cas_status: ["string"],
  id: ["string"],
  level: ["string"],
  faculty: ["string"],
  market: ["string"],
  market_array: ["string[]"],
  funds_maturity_statuses: ["string[]"],
  evidence_requirements: ["string"],
  activity_status: ["boolean", "required"],
  unread_messages: ["jsonb"],
  visa_support: ["boolean", "required"],
  completed_statuses: ["string[]"],
  recorded_interview_system_status: ["string"],
  tag_ids: ["string[]"],
  programmatic_tag_ids: ["string[]"],
  accommodation_arranged_status: ["string"],
  accommodation_type_status: ["string"],
  last_touch: ["integer"],
  is_new_docs: ["boolean"],
  recorded_interviews: ["jsonb"],
  accommodation_arranged_status_sort: ["integer"],
  accommodation_type_status_sort: ["integer"],
  visa_status_sort: ["integer"],
  travel_status_sort: ["integer"],
  offer_status_sort: ["integer"],
  recorded_interview_system_status_sort: ["integer"],
  calendly_interviews_info_status_sort: ["integer"],
  funds_maturity_statuses_sort: ["integer"],
  docs_completed_perc: ["integer"],
  agent_docs_completed_perc: ["integer"],
  follow_up_docs_completed_perc: ["integer"],
  total_percentage_complete: ["integer", "required"],
  last_touch_by_student_or_agent: ["integer"],
  deposit_amount: ["float"],
  student_deposit_amount: ["float"],
  course_fee: ["float"],
  scholarships_applied: ["float"],
  fee_after_scholarships: ["float"],
  course_fee_discount: ["string"],
  course_fee_paid_to_date: ["float"],
  conflicts: ["jsonb"],
  dependants: ["jsonb"],
  latest_course_start_date: ["string"],
  travel_status_updated_at: ["integer"],
  deposit_paid: ["boolean"],
  is_pre_cas_required: ["boolean"],
  passport_expected_date: ["string"],
  visa_status_updated_at: ["integer"],
  send_reminder_emails: ["boolean"],
  calendly_interview_start_date: ["integer"],
  calendly_interview_end_date: ["integer"],
  recorded_interview_timestamp: ["integer"],
  immigration_status_share_code: ["string"],
  share_code_detail: ["jsonb"]
};

// src/tag/index.ts
var TagType = /* @__PURE__ */ ((TagType2) => {
  TagType2["OVER_12_MONTHS_UK"] = "OVER_12_MONTHS_UK";
  TagType2["UNDER_12_MONTHS_UK"] = "UNDER_12_MONTHS_UK";
  TagType2["PATHWAY"] = "PATHWAY";
  TagType2["OVER_28_DAYS_VISA_GAP"] = "OVER_28_DAYS_VISA_GAP";
  TagType2["UNDER_28_DAYS_VISA_GAP"] = "UNDER_28_DAYS_VISA_GAP";
  TagType2["EUSS_GRANTED"] = "EUSS_GRANTED";
  TagType2["EUSS_PENDING"] = "EUSS_PENDING";
  TagType2["PROGRAMMABLE"] = "PROGRAMMABLE";
  TagType2["MULTI_INTAKE"] = "MULTI_INTAKE";
  TagType2["MANUAL_CAS"] = "MANUAL_CAS";
  TagType2["AUTOMATION"] = "AUTOMATION";
  TagType2["TRANSFERMATE"] = "TRANSFERMATE";
  return TagType2;
})(TagType || {});
var TagAction = /* @__PURE__ */ ((TagAction2) => {
  TagAction2["REMOVE"] = "REMOVE";
  TagAction2["ADD"] = "ADD";
  TagAction2["UPDATE"] = "UPDATE";
  return TagAction2;
})(TagAction || {});

// src/transfer-mate/index.ts
var TransactionStatus = /* @__PURE__ */ ((TransactionStatus2) => {
  TransactionStatus2["Registered"] = "Registered";
  TransactionStatus2["Pending"] = "Pending";
  TransactionStatus2["Paid"] = "Paid";
  TransactionStatus2["Inactive"] = "Inactive";
  return TransactionStatus2;
})(TransactionStatus || {});
var TransferMateResponseContext = /* @__PURE__ */ ((TransferMateResponseContext2) => {
  TransferMateResponseContext2["REFUND"] = "REFUND";
  TransferMateResponseContext2["3RDPTY"] = "3RDPTY";
  TransferMateResponseContext2["TRANSACTION"] = "TRANSACTION";
  return TransferMateResponseContext2;
})(TransferMateResponseContext || {});

// src/user/index.ts
var Platform = /* @__PURE__ */ ((Platform2) => {
  Platform2["Apply"] = "Apply";
  Platform2["CasShield"] = "CasShield";
  return Platform2;
})(Platform || {});
var IUserRole = /* @__PURE__ */ ((IUserRole2) => {
  IUserRole2["Admin"] = "Admin";
  IUserRole2["Enroly"] = "Enroly";
  IUserRole2["UniAdmin"] = "UniAdmin";
  IUserRole2["Uni"] = "Uni";
  IUserRole2["UniSecure"] = "UniSecure";
  IUserRole2["UniLite"] = "UniLite";
  IUserRole2["Agent"] = "Agent";
  IUserRole2["AgencyAdmin"] = "AgencyAdmin";
  IUserRole2["Partner"] = "Partner";
  IUserRole2["ImmigrationProvider"] = "ImmigrationProvider";
  IUserRole2["Student"] = "Student";
  IUserRole2["Applicant"] = "Applicant";
  IUserRole2["TempApplicant"] = "TempApplicant";
  return IUserRole2;
})(IUserRole || {});
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["NEW"] = "NEW";
  UserStatus2["CONFIRMED"] = "CONFIRMED";
  UserStatus2["PASSWORD_RESET"] = "PASSWORD_RESET";
  return UserStatus2;
})(UserStatus || {});
var PathwayAccess = /* @__PURE__ */ ((PathwayAccess2) => {
  PathwayAccess2["Full"] = "Full";
  PathwayAccess2["Partial"] = "Partial";
  PathwayAccess2["None"] = "None";
  return PathwayAccess2;
})(PathwayAccess || {});
var MfaMethod = /* @__PURE__ */ ((MfaMethod2) => {
  MfaMethod2["TOTP"] = "totp";
  MfaMethod2["SMS"] = "sms";
  MfaMethod2["EMAIL"] = "email";
  return MfaMethod2;
})(MfaMethod || {});
var UserErrorMessages = /* @__PURE__ */ ((UserErrorMessages2) => {
  UserErrorMessages2["USER_WITH_EMAIL_ALREADY_EXISTS"] = "User with this email already exists";
  UserErrorMessages2["FAILED_TO_REGISTER_NEW_USER"] = "Failed to register new user";
  UserErrorMessages2["FAILED_TO_LOCATE_USERPOOL"] = "Failed to locate userpool";
  UserErrorMessages2["FAILED_TO_CREATE_APPLICANT_DETAILS"] = "Failed to create applicant details";
  UserErrorMessages2["FAILED_TO_CREATE_APPLICATION"] = "Failed to create application";
  return UserErrorMessages2;
})(UserErrorMessages || {});

// src/webhooks/index.ts
var TWebHookAuthType = /* @__PURE__ */ ((TWebHookAuthType2) => {
  TWebHookAuthType2["UNAUTHED"] = "unauthed";
  TWebHookAuthType2["PASSWORD"] = "password";
  TWebHookAuthType2["TOKEN"] = "token";
  TWebHookAuthType2["KEY"] = "key";
  return TWebHookAuthType2;
})(TWebHookAuthType || {});
var ALL_DB_DOC_TYPES = [
  "CORE",
  "OFFER",
  "AUDITLOG",
  "FINANCE",
  "HISTORY",
  "IMPORT_DATA",
  "PRECAS",
  "EMAIL",
  "MESSAGE",
  "STUDENT_DETAILS",
  "RISKS",
  "SUMMARY",
  "ENROLMENT_STATUS",
  "CONFLICT_HISTORY",
  "DOCUMENT",
  "FINANCE_DOCUMENT",
  "FOLLOW_UP_DOCUMENT",
  "RECORDED_INTERVIEW"
];

// src/websocket/index.ts
var CHANNEL = /* @__PURE__ */ ((CHANNEL2) => {
  CHANNEL2["STUDENT_LIST"] = "STUDENT_LIST";
  CHANNEL2["STUDENT"] = "STUDENT";
  return CHANNEL2;
})(CHANNEL || {});
var TOPIC = /* @__PURE__ */ ((TOPIC2) => {
  TOPIC2["OPEN_STUDENT"] = "OPEN_STUDENT";
  TOPIC2["CALENDLY_INTERVIEWS"] = "CALENDLY_INTERVIEWS";
  TOPIC2["RECORDED_INTERVIEWS"] = "RECORDED_INTERVIEWS";
  TOPIC2["MESSAGES"] = "MESSAGES";
  TOPIC2["STUDENT_CORE"] = "STUDENT_CORE";
  TOPIC2["STUDENT_DETAILS"] = "STUDENT_DETAILS";
  TOPIC2["STUDENT_HISTORY"] = "STUDENT_HISTORY";
  TOPIC2["STUDENT_FINANCE"] = "STUDENT_FINANCE";
  TOPIC2["STUDENT_SUMMARY"] = "STUDENT_SUMMARY";
  TOPIC2["CALENDLY_INTERVIEW_DOCS"] = "CALENDLY_INTERVIEW_DOCS";
  TOPIC2["RECORDED_INTERVIEW_DOCS"] = "RECORDED_INTERVIEW_DOCS";
  TOPIC2["DOCUMENTS"] = "DOCUMENTS";
  TOPIC2["FINANACE_DOCUMENTS"] = "FINANACE_DOCUMENTS";
  TOPIC2["FOLLOW_UP_DOCUMENTS"] = "FOLLOW_UP_DOCUMENTS";
  return TOPIC2;
})(TOPIC || {});
var TYPE = /* @__PURE__ */ ((TYPE2) => {
  TYPE2["RECEIVED"] = "RECEIVED";
  TYPE2["SENT"] = "SENT";
  return TYPE2;
})(TYPE || {});

// src/zod-validation/cas-import-schemas.ts
import { z as z17 } from "zod";
var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var dateRegex = /^\d{4}-\d{2}-\d{2}$/;
var dateStringSchema = (fieldName) => z17.string().regex(dateRegex, `${fieldName} must be in YYYY-MM-DD format`).refine((date) => {
  const parsed = new Date(date);
  return !isNaN(parsed.getTime());
}, `Invalid ${fieldName}`).optional();
var MAX_STRING_LENGTH = 1e3;
var PERCENTAGE_MAX = 100;
var sanitizedStringSchema = z17.string().transform((val) => val.trim()).transform((val) => val.replace(/[\x00-\x1F\x7F]/g, "")).transform((val) => val.substring(0, MAX_STRING_LENGTH)).transform((val) => val || void 0);
var phoneNumberSchema = z17.string().transform((val) => val.replace(/[^\d+-]/g, "")).transform((val) => val || void 0).optional();
var ImportCourseSchema = z17.object({
  title: z17.string().min(1, "Course title is required"),
  level: sanitizedStringSchema.optional(),
  conditional: z17.boolean().optional(),
  startDate: dateStringSchema("Start date").optional(),
  endDate: dateStringSchema("End date").optional(),
  isFullTime: z17.boolean().optional(),
  hoursPerWeek: z17.number().min(0).optional(),
  isATASRequired: z17.boolean().optional(),
  courseFeeFirstYear: z17.number().min(0, "Course fee cannot be negative").optional(),
  courseScholarshipTitle1: sanitizedStringSchema.optional(),
  courseScholarshipAmount1: z17.number().min(0).optional(),
  coursesAccepted: z17.boolean().optional(),
  // Conditional offer fields
  conditionText1: sanitizedStringSchema.optional(),
  conditionText2: sanitizedStringSchema.optional(),
  conditionText3: sanitizedStringSchema.optional(),
  conditionText4: sanitizedStringSchema.optional(),
  conditionText5: sanitizedStringSchema.optional(),
  // Study address fields
  studyAddressLine1: sanitizedStringSchema.optional(),
  studyAddressLine2: sanitizedStringSchema.optional(),
  studyCity: sanitizedStringSchema.optional(),
  studyCountry: sanitizedStringSchema.optional(),
  studyPostcode: sanitizedStringSchema.optional(),
  // Work placement fields
  isWorkPlacement: z17.boolean().optional(),
  workPlacementPerc: z17.number().min(0).max(PERCENTAGE_MAX).optional(),
  workPlacementText: sanitizedStringSchema.optional()
}).superRefine((course, ctx) => {
  if (course.startDate && course.endDate) {
    const start = new Date(course.startDate);
    const end = new Date(course.endDate);
    if (start >= end) {
      ctx.addIssue({
        code: "custom",
        path: ["endDate"],
        message: "End date must be after start date"
      });
    }
  }
  if (course.courseScholarshipTitle1 && !course.courseScholarshipAmount1) {
    ctx.addIssue({
      code: "custom",
      path: ["courseScholarshipAmount1"],
      message: `Scholarship amount required for "${course.courseScholarshipTitle1}"`
    });
  }
});
var ImportOfferSchema = z17.object({
  intakeId: z17.string().min(1, "Intake ID is required"),
  offerId: z17.string().min(1, "Offer ID is required"),
  courses: z17.array(ImportCourseSchema).min(1, "At least one course is required"),
  // Optional fields
  withAgent: z17.boolean().optional(),
  agentName: sanitizedStringSchema.optional(),
  agentCompany: sanitizedStringSchema.optional(),
  scholarshipTitle: sanitizedStringSchema.optional(),
  scholarshipAmount: z17.number().min(0).optional(),
  courseCode: sanitizedStringSchema.optional(),
  courseId: sanitizedStringSchema.optional(),
  courseName: sanitizedStringSchema.optional()
}).superRefine((offer, ctx) => {
  if (offer.withAgent && !offer.agentName) {
    ctx.addIssue({
      code: "custom",
      path: ["agentName"],
      message: "Agent name required when withAgent is true"
    });
  }
  if (offer.scholarshipTitle && !offer.scholarshipAmount) {
    ctx.addIssue({
      code: "custom",
      path: ["scholarshipAmount"],
      message: `Scholarship amount required for "${offer.scholarshipTitle}"`
    });
  }
});
var ImportDataSchema = z17.object({
  // Required fields
  studentNo: z17.string({ required_error: "Student number is required" }).min(1, "Student number is required"),
  email: z17.string({ required_error: "Email is required" }).regex(emailRegex, "Invalid email format"),
  familyName: z17.string({ required_error: "Family name is required" }).min(1, "Family name is required"),
  givenName: z17.string({ required_error: "Given name is required" }).min(1, "Given name is required"),
  // Optional fields
  uni: z17.string().optional(),
  source: z17.nativeEnum(ImportSource).optional(),
  otherName: sanitizedStringSchema.optional(),
  dob: dateStringSchema("Date of birth").optional(),
  phone: phoneNumberSchema,
  nationality: sanitizedStringSchema.optional(),
  placeOfBirth: sanitizedStringSchema.optional(),
  countryOfBirth: sanitizedStringSchema.optional(),
  gender: sanitizedStringSchema.optional(),
  // Address fields
  addressLine1: sanitizedStringSchema.optional(),
  addressLine2: sanitizedStringSchema.optional(),
  addressLine3: sanitizedStringSchema.optional(),
  city: sanitizedStringSchema.optional(),
  country: sanitizedStringSchema.optional(),
  postcode: sanitizedStringSchema.optional(),
  // Passport fields
  passportNumber: sanitizedStringSchema.optional(),
  passportExpiry: dateStringSchema("Passport expiry").optional(),
  // Academic fields
  ucasId: sanitizedStringSchema.optional(),
  applicationId: sanitizedStringSchema.optional(),
  englishLevelAttained: sanitizedStringSchema.optional(),
  englishTestProvider: sanitizedStringSchema.optional(),
  prevUKStudy: z17.boolean().optional(),
  criminalConvictions: z17.boolean().optional(),
  // Agent fields
  withAgent: z17.boolean().optional(),
  agentName: sanitizedStringSchema.optional(),
  agentCompany: sanitizedStringSchema.optional(),
  // Offers
  offers: z17.array(ImportOfferSchema).default([])
});
var ApplicantDetailsValidationSchema = z17.object({
  email: z17.string().optional(),
  passport: z17.object({
    passportNo: z17.string().optional(),
    dateOfExpiry: z17.string().optional(),
    dateOfIssue: z17.string().optional(),
    passportIssuingAuthority: z17.string().optional()
  }).optional().nullable(),
  englishTest: z17.object({
    type: z17.string().optional(),
    typeOther: z17.string().optional(),
    score: z17.string().optional(),
    date: z17.string().optional(),
    referenceNo: z17.string().optional(),
    validUntil: z17.string().optional()
  }).optional().nullable(),
  reasonNotReqd: z17.string().optional().nullable(),
  ukStudentVisas: z17.array(
    z17.object({
      type: z17.string().optional(),
      startDate: z17.string().optional(),
      endDate: z17.string().optional()
    })
  ).optional().nullable()
});
var ApplicationValidationSchema = z17.object({
  userId: z17.string(),
  applicationId: z17.string(),
  intakeId: z17.string().optional(),
  email: z17.string().email("Invalid email format"),
  familyName: z17.string().min(1, "Family name is required"),
  givenName: z17.string().min(1, "Given name is required"),
  otherNames: z17.array(
    z17.object({
      givenName: z17.string().optional(),
      familyName: z17.string().optional()
    })
  ).optional().nullable(),
  dob: z17.string().optional(),
  phoneNumber: z17.string().optional(),
  nationality: z17.string().optional(),
  countryOfBirth: z17.string().optional(),
  gender: z17.string().optional(),
  contactAddress: z17.object({
    addressLine1: z17.string().optional(),
    addressLine2: z17.string().optional(),
    city: z17.string().optional(),
    postcode: z17.string().optional(),
    country: z17.string().optional()
  }).optional().nullable(),
  ucasId: z17.string().optional(),
  criminalConvictions: z17.boolean().optional(),
  hasAgent: z17.string().optional(),
  agent: z17.string().optional().nullable(),
  feeStatus: z17.nativeEnum(FeeStatus)
});
var RequiredDocumentsSchema = z17.object({
  application: ApplicationValidationSchema,
  applicantDetails: ApplicantDetailsValidationSchema.nullable()
});

// src/shared-types.ts
import { z as z18 } from "zod";
var FileSchema = z18.object({
  label: z18.string(),
  isPdfFile: z18.boolean().optional(),
  noOfPages: z18.number().optional(),
  isProcessing: z18.boolean().optional(),
  fileName: z18.string(),
  fileSize: z18.number().optional(),
  // KB size
  fileType: z18.string().optional(),
  s3Key: z18.string().optional()
});
var DocAccessType = /* @__PURE__ */ ((DocAccessType2) => {
  DocAccessType2["STAFF_ONLY"] = "STAFF_ONLY";
  DocAccessType2["AGENT_ONLY"] = "AGENT_ONLY";
  return DocAccessType2;
})(DocAccessType || {});
var DocStatus = /* @__PURE__ */ ((DocStatus2) => {
  DocStatus2["AWAITING"] = "AWAITING";
  DocStatus2["UPLOADED_OK"] = "UPLOADED_OK";
  DocStatus2["UPLOADED_WITH_ERROR"] = "UPLOADED_WITH_ERROR";
  DocStatus2["REJECTED"] = "REJECTED";
  DocStatus2["REJECTED_WITHOUT_ALTERNATIVE"] = "REJECTED_WITHOUT_ALTERNATIVE";
  DocStatus2["APPROVED"] = "APPROVED";
  DocStatus2["REPLACED"] = "REPLACED";
  DocStatus2["DELETED"] = "DELETED";
  DocStatus2["SKIPPED"] = "SKIPPED";
  DocStatus2["INFO_ONLY"] = "INFO_ONLY";
  DocStatus2["NOT_ACKNOWLEDGED"] = "NOT_ACKNOWLEDGED";
  DocStatus2["ACKNOWLEDGED"] = "ACKNOWLEDGED";
  return DocStatus2;
})(DocStatus || {});
var UploadedBy = /* @__PURE__ */ ((UploadedBy2) => {
  UploadedBy2["ADMIN"] = "Admin";
  UploadedBy2["AGENT"] = "Agent";
  UploadedBy2["UNIVERSITY"] = "University";
  UploadedBy2["ENROLY"] = "Enroly";
  UploadedBy2["SITS"] = "SITS";
  return UploadedBy2;
})(UploadedBy || {});
var DocumentStatusSchema = z18.nativeEnum(DocStatus);
var UploadedBySchema = z18.union([
  z18.literal(""),
  z18.literal("Admin" /* ADMIN */),
  z18.literal("Agent" /* AGENT */),
  z18.literal("University" /* UNIVERSITY */),
  z18.literal("Enroly" /* ENROLY */),
  z18.literal("SITS" /* SITS */)
]);
var DocumentSchema = z18.object({
  label: z18.string(),
  status: DocumentStatusSchema,
  prevStatus: DocumentStatusSchema.optional(),
  fileNames: z18.array(z18.string()),
  // refactor this out after STM-392
  files: z18.array(FileSchema).optional(),
  reason: z18.string().optional(),
  signedUrls: z18.array(z18.string()).optional(),
  uploadedBy: UploadedBySchema.optional(),
  userAccess: z18.nativeEnum(DocAccessType).optional(),
  isProcessingPdf: z18.boolean().optional(),
  eTags: z18.array(z18.string()).optional(),
  // eTags from s3 fro faster lookups
  s3Keys: z18.array(z18.string()).optional(),
  fileLabels: z18.array(z18.string()).optional(),
  // Original user-facing filenames (fileNames may contain S3-mangled names)
  /** If a document is a stub after TTL deletion, it should have `deletedByTTL = true`  */
  deletedByTTL: z18.boolean().optional()
});
var TypeOfInterviewUpdate = /* @__PURE__ */ ((TypeOfInterviewUpdate2) => {
  TypeOfInterviewUpdate2["BULK"] = "BULK";
  TypeOfInterviewUpdate2["MANUAL"] = "MANUAL";
  TypeOfInterviewUpdate2["AUTO"] = "AUTO";
  return TypeOfInterviewUpdate2;
})(TypeOfInterviewUpdate || {});
export {
  AGENT_CONFLICT_SUMMARY_KEYS,
  AGENT_DETAIL_CONFLICT_KEYS,
  AGENT_DETAIL_FIELD_KEYS,
  AGENT_DETAIL_FIELD_LABELS,
  ALL_DB_DOC_TYPES,
  AcademicResultFulfilmentSchema,
  AccommodationArrangedStatusEnum,
  AccommodationTypeStatusEnum,
  AccuracyOfDataConsentSchema,
  AddUpdateStudyHistorySchema,
  AdditionalApiFilterKeys,
  AdditionalStudentApiFilterKeys,
  AddressSchema,
  Agent,
  AgentApplicantAuthorisationStatus,
  AgentFormKeyNames,
  AgentRegistrationSchema,
  AgentSchema,
  ApiFilterKeys,
  ApplicantChangePasswordSchema,
  ApplicantDashboardRowSchema,
  ApplicantDetailsSchema,
  ApplicantDetailsValidationSchema,
  ApplicantDocUploadRequestSchema,
  ApplicantEmploymentSchema,
  ApplicantEmploymentSchemaWithFiles,
  ApplicantIdentitySchema,
  ApplicantIdentityValidationSchema,
  ApplicantIdentityValidationWithFiles,
  ApplicantLoginSchema,
  ApplicantNewPasswordSchema,
  ApplicantOfferConditionType,
  ApplicantOfferOfficesConditionMap,
  ApplicantOfferPGFilterMap,
  ApplicantOfferPaymentMethod,
  ApplicantOfferPaymentSchema,
  ApplicantOfferPaymentSponsorType,
  ApplicantOfferPaymentStatus,
  ApplicantOfferRequirement,
  ApplicantOfferRequirementTask,
  ApplicantOfferRequirementTaskActionStatus,
  ApplicantOfferRequirementTaskLevel,
  ApplicantOfferRequirementTaskStatus,
  ApplicantOfferResponseStatus,
  ApplicantOfferStatus,
  ApplicantReferralSchema,
  ApplicantRegistrationSchema,
  ApplicantReminderEmailTemplates,
  ApplicantRequirementTasks,
  ApplicantStatus,
  ApplicantStatusObjName,
  ApplicantStatusReason,
  ApplicationOfficesConditionMap,
  ApplicationPGFilterMap,
  ApplicationRefereeRelation,
  ApplicationStatus,
  ApplicationTaskGroupLabel,
  ApplicationTaskLabel,
  ApplicationTaskRoute,
  ApplicationTaskValue,
  ApplicationValidationSchema,
  AppliedAdminReviewStatus,
  AppliedEUSSStatus,
  ApplyCourseSchema,
  ApplyDocTypes,
  ApplyRequirementIdMapping,
  AttachDocumentSchema,
  AutomationLimit,
  AutomationType,
  AwardingOrganisationSchema,
  BaseRegistrationFormSchema,
  BasicApplicantExternalRegistrationSchema,
  BounceType,
  CHANNEL,
  CLEARED_AGENT_DETAIL_FIELDS,
  ConfigEmailStatus,
  ConfirmationOptions,
  ConsentSchema,
  ConsentsPages,
  ContactDetailsSchema,
  ContactInformationSchema,
  CoreStatus,
  CoreStatusExtended,
  CountryCategory,
  CourseAvailability,
  CourseCompare,
  CourseLevelOfferStatus,
  CreateApplicantOfferRequirementTaskSchema,
  CreateApplicantOfferRequirementTasksSchema,
  DeclarationsSchema,
  DepositAmountDetailSchema,
  DisabilityType,
  DisabilityTypeDescription,
  DisiblityTypeSchema,
  DiversitySchema,
  DocAccessType,
  DocStatus,
  DocStatusType,
  DocumentCombinedStatus,
  DocumentFulfilmentSchema,
  DocumentKey,
  DocumentRetentionType,
  DocumentSchema,
  DocumentSchemaWithFiles,
  DocumentSectionStatus,
  DocumentStatusSchema,
  DocumentType,
  EApplicantOfferPGKeys,
  EApplicantStudentNumberLogPGKeys,
  EApplicantStudentNumberLogTableName,
  EApplicantStudentNumberPGKeys,
  EApplicantStudentNumberTableName,
  EApplicationPGKeys,
  ECoursePGKeys,
  EStudentImportAttributeFieldNames,
  EUSSStatus,
  EXTERNAL_MAP_DOC_TYPE,
  EllucianAdmissionPopulation,
  EllucianAuthMethod,
  EllucianCare,
  EllucianCitizenCategory,
  EllucianDisabilityTitle,
  EllucianEndPoint,
  EllucianHeaderMediaTypes,
  EllucianIntegrationSchema,
  EllucianMatchingStatus,
  EllucianMedicalDesc,
  EllucianParentsEd,
  EllucianResidencyType,
  EmailStatus,
  EmailTemplates,
  EmploymentHistorySchema,
  EmploymentStatus,
  EmploymentType,
  EnglishResultsFulfilmentSchema,
  EnglishSchema,
  EnglishSchemaWithFiles,
  EnglishTestNotReqdReason,
  EnglishTestNotTakenSchema,
  EnglishTestSchema,
  EnglishTestTakenSchema,
  EnglishTestType,
  EntryPoint,
  Ethnicity,
  EventBookingStatus,
  EventInfoStatus,
  EventSystemStatus,
  ExemptApplicantOfferRequirementSchema,
  ExternalMapTarget,
  FamilySponsorType,
  FeeStatus,
  FeeStatusSchema,
  FileSchema,
  FilterKey,
  FilterKeyMap,
  FilterKeyValues,
  FilterType,
  FingerStatus,
  FirstApplicationStatus,
  FollowUpDocStatusType,
  FundingOption,
  FundingPlanSchema,
  Gender,
  GenderIdentity,
  generics_integration_exports as GenericsIntegration,
  GradeLevel,
  GradeSystem,
  GradingSystemSchema,
  HelpingSubmit,
  HighestQualificationSchema,
  HighestStudyAddQualificationSchema,
  HighestStudyAddStudySchema,
  HighestStudyInstitutionSchema,
  HighestStudyQualificationTypeSelectionSchema,
  HistoryPages,
  IApplicantOfferPGTypeMap,
  IApplicationPGTypeMap,
  ICoursePGTypeMap,
  IDType,
  IFollowUpArea,
  IUserRole,
  ImportCourseSchema,
  ImportDataSchema,
  ImportFieldTypes,
  ImportOfferSchema,
  ImportProcessingType,
  ImportSource,
  InformationProcessingConsentSchema,
  InsightsAccessLevel,
  IntakeStatus,
  InternalDocumentSchema,
  InterviewPages,
  LoanType,
  LocationType,
  MAX_PROGRAMME_CHOICES,
  MaxPathwayAccess,
  MfaMethod,
  ModuleSchema,
  NationalitySchema,
  NonUkVisaRefusalSchema,
  NotReadyReason,
  OfferFinancePaymentFulfilmentSchema,
  OfferPassportSchema,
  OfferPassportSchemaWithFiles,
  OfferStatus,
  OfferTaskGroupLabel,
  OfferTaskLabel,
  OfferTaskRoute,
  OfferTimelineStageType,
  OptionStatusType,
  OrgType,
  OtherNamePayloadSchema,
  OtherNameSchema,
  OtherNamesSchema,
  OtherNationalitySchema,
  OtherPresentative,
  OtherResidenceEntrySchema,
  PROGRAMME_CHOICES_ERROR_MESSAGES,
  PartnerFormKeyNames,
  PartnerVisaStatus,
  Partners,
  PassportFulfilmentSchema,
  PassportSchema,
  PathwayAccess,
  PersonalInfoPages,
  PersonalStatementSchema,
  PersonalStatementSchemaWithDependencies,
  PhoneNumberSchema,
  Platform,
  PreviousStudyLevel,
  PrivacyPolicyConsentSchema,
  ProgrammableTagStatus,
  ProgrammeChoiceSchema2 as ProgrammeChoiceSchema,
  ProgrammeChoicesSchema,
  ProgrammeChoicesSchemaWithMax,
  ProofOfPaymentSchema,
  ProviderRegistrationSchema,
  QualificationSchema,
  QualificationStep3Schema,
  QualificationTypesSchema,
  QuestionTypeEnum,
  ROUTE_STATUS_TO_INDEX,
  RecordedInterviewAssessmentDecision,
  RecordedInterviewSystemStatus,
  RecordingTimeEnum,
  RefereeDetailsFulfilmentSchema,
  RefereeSchema,
  ReferenceDataType,
  ReferencesSchema,
  ReferencesSchemaWithFiles,
  ReferralSource,
  RefusalGrounds,
  RefusedVisaType,
  RegionConfigType,
  RegionOfficeType,
  ReinstateApplicantOfferSchema,
  RepresentationFormSchema,
  RepresentationHelpedBy,
  RepresentationSchema,
  RequiredDocumentsSchema,
  RequirementTaskInternalDataMethod,
  ResearchProposalSchema,
  ResearchProposalSchemaWithDependencies,
  ResidenceEntrySchema,
  ResidentialCategoryOptions,
  ResitAction,
  ResultStatus,
  RetakesEnum,
  RouteStatus,
  SLCDetailSchema,
  SMapConditionLogic,
  SMapFieldAction,
  SMapFieldFormat,
  SMapFormulaType,
  SMapMatch,
  SMapStatus,
  SMapWhen,
  ScholarshipType,
  SchoolType,
  ScoreTypeEnum,
  SectionLabel,
  SectionRoute,
  SectionStatusType,
  SharedFormKeyNames,
  sits_exports as Sits,
  SitsAuthMethod,
  SponsorshipDetailSchema,
  StaffAssignAgentSchema,
  StaffCreateApplicantOfferSchema,
  StatusColor,
  StudentAuthoriseAgentSchema,
  StudentDuplicateSchema,
  StudyHistorySchema,
  StudyLevel,
  StudyMode,
  StudySchema,
  SummaryPostgresMapOfTypes,
  SummaryTypeId,
  TExternalCasStatus,
  TOPIC,
  TWebHookAuthType,
  TYPE,
  TabCategories,
  TagAction,
  TagType,
  TermsAndConditionsConsentSchema,
  TextFulfilmentSchema,
  ThinkingTimeEnum,
  ThirdParty,
  TransactionStatus,
  TransferMateResponseContext,
  TravelStatusEnum,
  TriggerFieldNames,
  TriggerFieldOperator,
  TypeOfInterviewUpdate,
  UkAccommodationType,
  UkAreaOptions,
  UkNonStudentVisasSchema,
  UkStudentVisaSchema,
  UkVisaRefusalSchema,
  UniConfigRequirementTaskFulfilmentMethod,
  UniRegistrationSchema,
  UniStaffFormKeyNames,
  UniStaffRegistrationSchema,
  UpdateApplicantOfferLetterTextSchema,
  UpdateApplicantOfferPayment,
  UpdateApplicantOfferProgrammeDetailsSchema,
  UpdateApplicantOfferRequirementTaskLevelSchema,
  UpdateApplicantOfferRequirementTaskStatusSchema,
  UpdateApplicantOfferStatusActionSchema,
  UpdateApplicantOfferStatusSchema,
  UpdateVisaSupportAction,
  UploadedBy,
  UploadedBySchema,
  UserErrorMessages,
  UserStatus,
  VisaHistorySchema,
  VisaLevelOfStudy,
  VisaNotListedOption,
  VisaOrPermitStatus,
  VisaOrPermitType,
  VisaPrepPages,
  VisaRequiredSchema,
  VisaStatus,
  VisaType,
  WorkflowAccessLevel,
  Workflows,
  YourInformationTaskGroupLabel,
  YourInformationTaskLabel,
  YourInformationTaskRoute,
  applicantTemplateToEmailTemplateMap,
  applicationPGKeys,
  awards,
  createFileValidationSchema,
  defaultRefineFn,
  digitSchema,
  documentsPerRoute,
  emailValidationSchema,
  employmentAddressSchema,
  endpointToRequirementTaskEnum,
  enhanceContactDetailsSchema,
  enhanceDeclarationsSchema,
  enhanceFundingPlanSchema,
  enhanceHighestStudyAddQualificationSchema,
  enhanceHighestStudyAddStudySchema,
  enhanceOfferFinancePaymentFulfilmentSchema,
  enhanceOfferPaymentSchema,
  enhanceQualificationSchema,
  enhanceQualificationStep3Schema,
  enhanceUpdateApplicantOfferRequirementTaskStatusSchema,
  enhanceVisaHistorySchema,
  entryPoints,
  getDiversityValidationSchema,
  getOfferScopedDocKey,
  getProgrammeFieldError,
  getServiceProviderType,
  hecosCodes,
  intakeIdValidator,
  isDuplicateProgramme,
  jsonParser,
  letterSchema,
  maxLengthSchema,
  minLengthSchema,
  noDuplicateArraySchema,
  noUndefinedStringArraySchema,
  noWhitespaceSchema,
  partnerCodeToServiceProviderType,
  passwordSchema,
  percentageArraySchema,
  requirementSlugMap,
  specialCharSchema,
  startMonths,
  studyModes,
  validateProgrammeChoices
};
